import { get, omit, isEqual, isBoolean, isEmpty, each, isUndefined, includes, map, keys, lowerCase, clone, reduce, every, filter, toNumber, isNaN, forEach, set, isFunction, memoize, values, isString, toString, isNil, isArray, isNumber, trim, last, max, size, isObject, flatten as flatten$1, merge, pickBy, first, clamp, findLast, find, differenceWith, mergeWith, compact, assign, pick, some, noop, concat, uniq, mapKeys, toUpper, has, endsWith, cond, matches, constant, stubTrue, findIndex, difference, head, range, inRange, throttle, debounce, forIn, once, identity, min, unset, orderBy, intersection, maxBy } from 'lodash';
import { Shape, Group, Canvas } from '@antv/g-canvas';
import { GM, Wheel } from '@antv/g-gesture';
import EE from '@antv/event-emitter';
import { interpolateArray } from 'd3-interpolate';
import * as d3Timer from 'd3-timer';

var InteractionEvent;
(function (InteractionEvent) {
    InteractionEvent["DATA_CELL_CLICK_EVENT"] = "interaction:data-cell-click";
    InteractionEvent["MERGED_CELLS_CLICK_EVENT"] = "interaction:merged-cells-click";
    InteractionEvent["CORNER_TEXT_CLICK_EVENT"] = "interaction:corner-cell-text-click";
    InteractionEvent["ROW_COLUMN_CLICK_EVENT"] = "interaction:row-column-click";
    InteractionEvent["ROW_TEXT_CLICK_EVENT"] = "interaction:row-text-click";
    InteractionEvent["HOVER_EVENT"] = "interaction:hover";
    InteractionEvent["TREND_ICON_CLICK"] = "interaction:trend-icon-click";
})(InteractionEvent || (InteractionEvent = {}));

var OriginEventType;
(function (OriginEventType) {
    OriginEventType["MOUSE_DOWN"] = "mousedown";
    OriginEventType["MOUSE_MOVE"] = "mousemove";
    OriginEventType["MOUSE_OUT"] = "mouseout";
    OriginEventType["MOUSE_LEAVE"] = "mouseleave";
    OriginEventType["MOUSE_UP"] = "mouseup";
    OriginEventType["KEY_DOWN"] = "keydown";
    OriginEventType["KEY_UP"] = "keyup";
    OriginEventType["CLICK"] = "click";
    OriginEventType["HOVER"] = "hover";
    OriginEventType["DOUBLE_CLICK"] = "dblclick";
    OriginEventType["CONTEXT_MENU"] = "contextmenu";
})(OriginEventType || (OriginEventType = {}));

var S2Event;
(function (S2Event) {
    /** ================ Row Cell ================  */
    S2Event["ROW_CELL_HOVER"] = "row-cell:hover";
    S2Event["ROW_CELL_CLICK"] = "row-cell:click";
    S2Event["ROW_CELL_DOUBLE_CLICK"] = "row-cell:double-click";
    S2Event["ROW_CELL_MOUSE_DOWN"] = "row-cell:mouse-down";
    S2Event["ROW_CELL_MOUSE_UP"] = "row-cell:mouse-up";
    S2Event["ROW_CELL_MOUSE_MOVE"] = "row-cell:mouse-move";
    S2Event["ROW_CELL_COLLAPSE_TREE_ROWS"] = "row-cell:collapsed-tree-rows";
    /** ================ Col Cell ================  */
    S2Event["COL_CELL_HOVER"] = "col-cell:hover";
    S2Event["COL_CELL_CLICK"] = "col-cell:click";
    S2Event["COL_CELL_DOUBLE_CLICK"] = "col-cell:double-click";
    S2Event["COL_CELL_MOUSE_DOWN"] = "col-cell:mouse-down";
    S2Event["COL_CELL_MOUSE_UP"] = "col-cell:mouse-up";
    S2Event["COL_CELL_MOUSE_MOVE"] = "col-cell:mouse-move";
    /** ================ Data Cell ================  */
    S2Event["DATA_CELL_HOVER"] = "data-cell:hover";
    S2Event["DATA_CELL_CLICK"] = "data-cell:click";
    S2Event["DATA_CELL_DOUBLE_CLICK"] = "data-cell:double-click";
    S2Event["DATA_CELL_MOUSE_UP"] = "data-cell:mouse-up";
    S2Event["DATA_CELL_MOUSE_DOWN"] = "data-cell:mouse-down";
    S2Event["DATA_CELL_MOUSE_MOVE"] = "data-cell:mouse-move";
    S2Event["DATA_CELL_TREND_ICON_CLICK"] = "data-cell:trend-icon-click";
    S2Event["DATE_CELL_BRUSH_SELECTION"] = "data-cell:brush-selection";
    /** ================ Corner Cell ================  */
    S2Event["CORNER_CELL_HOVER"] = "corner-cell:hover";
    S2Event["CORNER_CELL_CLICK"] = "corner-cell:click";
    S2Event["CORNER_CELL_DOUBLE_CLICK"] = "corner-cell:double-click";
    S2Event["CORNER_CELL_MOUSE_DOWN"] = "corner-cell:mouse-down";
    S2Event["CORNER_CELL_MOUSE_UP"] = "corner-cell:mouse-up";
    S2Event["CORNER_CELL_MOUSE_MOVE"] = "corner-cell:mouse-move";
    /** ================ Merged Cells ================  */
    S2Event["MERGED_CELLS_HOVER"] = "merged-cells:hover";
    S2Event["MERGED_CELLS_CLICK"] = "merged-cells:click";
    S2Event["MERGED_CELLS_DOUBLE_CLICK"] = "merged-cells:double-click";
    S2Event["MERGED_CELLS_MOUSE_DOWN"] = "merged-cells:mouse-down";
    S2Event["MERGED_CELLS_MOUSE_UP"] = "merged-cells:mouse-up";
    S2Event["MERGED_CELLS_MOUSE_MOVE"] = "merged-cells:mouse-move";
    /** ================ Sort ================  */
    S2Event["RANGE_SORT"] = "sort:range-sort";
    S2Event["RANGE_SORTED"] = "sort:range-sorted";
    /** ================ Table Filter ================  */
    S2Event["RANGE_FILTER"] = "filter:range-filter";
    S2Event["RANGE_FILTERED"] = "filter:range-filtered";
    /** ================ Table Layout ================  */
    S2Event["LAYOUT_AFTER_HEADER_LAYOUT"] = "layout:after-header-layout";
    S2Event["LAYOUT_CELL_SCROLL"] = "layout:cell-scroll";
    S2Event["LAYOUT_PAGINATION"] = "layout:pagination";
    S2Event["LAYOUT_COLLAPSE_ROWS"] = "layout:collapsed-rows";
    S2Event["LAYOUT_AFTER_COLLAPSE_ROWS"] = "layout:after-collapsed-rows";
    S2Event["LAYOUT_TREE_ROWS_COLLAPSE_ALL"] = "layout:toggle-collapse-all";
    S2Event["LAYOUT_TABLE_COL_EXPANDED"] = "layout:table-col-expanded";
    S2Event["LAYOUT_TABLE_COL_HIDDEN"] = "layout:table-col-hidden";
    S2Event["LAYOUT_AFTER_RENDER"] = "layout:after-render";
    S2Event["LAYOUT_BEFORE_RENDER"] = "layout:before-render";
    S2Event["LAYOUT_DESTROY"] = "layout:destroy";
    /** ================ Table Layout Resize ================  */
    S2Event["LAYOUT_RESIZE"] = "layout:resize";
    S2Event["LAYOUT_RESIZE_SERIES_WIDTH"] = "layout:resize-series-width";
    S2Event["LAYOUT_RESIZE_ROW_WIDTH"] = "layout:resize-row-width";
    S2Event["LAYOUT_RESIZE_ROW_HEIGHT"] = "layout:resize-row-height";
    S2Event["LAYOUT_RESIZE_COL_WIDTH"] = "layout:resize-column-width";
    S2Event["LAYOUT_RESIZE_COL_HEIGHT"] = "layout:resize-column-height";
    S2Event["LAYOUT_RESIZE_TREE_WIDTH"] = "layout:resize-tree-width";
    S2Event["LAYOUT_RESIZE_MOUSE_DOWN"] = "layout:resize:mouse-down";
    S2Event["LAYOUT_RESIZE_MOUSE_MOVE"] = "layout:resize:mouse-move";
    S2Event["LAYOUT_RESIZE_MOUSE_UP"] = "layout:resize-mouse-up";
    /** ================ Global ================  */
    S2Event["GLOBAL_KEYBOARD_DOWN"] = "global:keyboard-down";
    S2Event["GLOBAL_KEYBOARD_UP"] = "global:keyboard-up";
    S2Event["GLOBAL_COPIED"] = "global:copied";
    S2Event["GLOBAL_MOUSE_UP"] = "global:mouse-up";
    S2Event["GLOBAL_ACTION_ICON_CLICK"] = "global:action-icon-click";
    S2Event["GLOBAL_ACTION_ICON_HOVER"] = "global:action-icon-hover";
    S2Event["GLOBAL_CONTEXT_MENU"] = "global:context-menu";
    S2Event["GLOBAL_SELECTED"] = "global:selected";
    S2Event["GLOBAL_HOVER"] = "global:hover";
    S2Event["GLOBAL_RESET"] = "global:reset";
    S2Event["GLOBAL_LINK_FIELD_JUMP"] = "global:link-field-jump";
})(S2Event || (S2Event = {}));

// 值字段的 id 是固定的！
var VALUE_FIELD = '$$value$$';
var EXTRA_FIELD = '$$extra$$';
var TOTAL_VALUE = '$$total$$';
var SERIES_NUMBER_FIELD = '$$series_number$$';
// export const COLUMN_FIELD_KEY = '$$column_key$$';
var BACK_GROUND_GROUP_CONTAINER_Z_INDEX = 0;
// foregroundGroup 上的 children 层叠顺序
var FRONT_GROUND_GROUP_CONTAINER_Z_INDEX = 3; // 约定这个 z-index 为 0 的 container 作为基准
var FRONT_GROUND_GROUP_COL_SCROLL_Z_INDEX = 3;
var FRONT_GROUND_GROUP_COL_FROZEN_Z_INDEX = 4;
var FRONT_GROUND_GROUP_RESIZE_AREA_Z_INDEX = 5;
var FRONT_GROUND_GROUP_BRUSH_SELECTION_Z_INDEX = 5;
// panelGroup 上的 children 层叠顺序
var PANEL_GROUP_GROUP_CONTAINER_Z_INDEX = 1;
var PANEL_GROUP_SCROLL_GROUP_Z_INDEX = 1;
var PANEL_GROUP_FROZEN_GROUP_Z_INDEX = 2;
var PANEL_GROUP_HOVER_BOX_GROUP_Z_INDEX = 1;
// group's key
var KEY_GROUP_BACK_GROUND = 'backGroundGroup';
var KEY_GROUP_FORE_GROUND = 'foreGroundGroup';
var KEY_GROUP_PANEL_GROUND = 'panelGroup';
var KEY_GROUP_PANEL_SCROLL = 'panelScrollGroup';
var KEY_GROUP_PANEL_FROZEN_ROW = 'frozenRowGroup';
var KEY_GROUP_PANEL_FROZEN_COL = 'frozenColGroup';
var KEY_GROUP_PANEL_FROZEN_TRAILING_ROW = 'frozenTrailingRowGroup';
var KEY_GROUP_PANEL_FROZEN_TRAILING_COL = 'frozenTrailingColGroup';
var KEY_GROUP_PANEL_FROZEN_TOP = 'frozenTopGroup';
var KEY_GROUP_PANEL_FROZEN_BOTTOM = 'frozenBottomGroup';
var KEY_GROUP_ROW_RESIZE_AREA = 'rowResizeAreaGroup';
var KEY_GROUP_FROZEN_ROW_RESIZE_AREA = 'rowFrozenResizeAreaGroup';
var KEY_GROUP_ROW_INDEX_RESIZE_AREA = 'rowIndexResizeAreaGroup';
var KEY_GROUP_CORNER_RESIZE_AREA = 'cornerResizeAreaGroup';
var KEY_GROUP_COL_RESIZE_AREA = 'colResizeAreaGroup';
var KEY_GROUP_FROZEN_COL_RESIZE_AREA = 'colFrozenResizeAreaGroup';
var KEY_GROUP_COL_HORIZONTAL_RESIZE_AREA = 'colHorizontalResizeAreaGroup';
var KEY_GROUP_COL_SCROLL = 'colScrollGroup';
var KEY_GROUP_COL_FROZEN = 'colFrozenGroup';
var KEY_GROUP_COL_FROZEN_TRAILING = 'colFrozenTrailingGroup';
// key of series number node in corner header
var KEY_SERIES_NUMBER_NODE = 'series-number-node';
var HORIZONTAL_RESIZE_AREA_KEY_PRE = 'horizontal-resize-area-';
var TABLE_COL_HORIZONTAL_RESIZE_AREA_KEY = 'table-col-horizontal-resize-area';
var KEY_COL_REAL_WIDTH_INFO = 'col-real-width-info';
var ROOT_ID = 'root';
var ID_SEPARATOR = '[&]';
var EMPTY_PLACEHOLDER = '-';
var PADDING_TOP = 0;
var PADDING_RIGHT = 1;
var PADDING_DOWN = 2;
var PADDING_LEFT = 3;
var MIN_CELL_WIDTH = 28;
var MIN_CELL_HEIGHT = 16;
// data precision
var PRECISION = 16;
var ROOT_BEGINNING_REGEX = /^root\[&\]*/;
var IMAGE = 'image';
// 角头最大占整个容器的比例 (0-1)
var CORNER_MAX_WIDTH_RATIO = 0.5;

var S2_PREFIX_CLS = 'antv-s2';

var VALUE_RANGES_KEY = 'valueRanges';
var DEFAULT_VALUE_RANGES = {};

var DEFAULT_DATA_CONFIG = {
    data: [],
    totalData: [],
    fields: {
        rows: [],
        columns: [],
        values: [],
        customTreeItems: [],
        valueInCols: true,
    },
    meta: [],
    sortParams: [],
    filterParams: [],
};

var _a;
var FrozenCellType;
(function (FrozenCellType) {
    FrozenCellType["ROW"] = "row";
    FrozenCellType["COL"] = "col";
    FrozenCellType["TRAILING_ROW"] = "trailingRow";
    FrozenCellType["TRAILING_COL"] = "trailingCol";
    FrozenCellType["SCROLL"] = "scroll";
    FrozenCellType["TOP"] = "top";
    FrozenCellType["BOTTOM"] = "bottom";
})(FrozenCellType || (FrozenCellType = {}));
var FrozenCellGroupMap = (_a = {},
    _a[FrozenCellType.ROW] = 'frozenRowGroup',
    _a[FrozenCellType.COL] = 'frozenColGroup',
    _a[FrozenCellType.TRAILING_COL] = 'frozenTrailingColGroup',
    _a[FrozenCellType.TRAILING_ROW] = 'frozenTrailingRowGroup',
    _a[FrozenCellType.SCROLL] = 'panelScrollGroup',
    _a[FrozenCellType.TOP] = 'frozenTopGroup',
    _a[FrozenCellType.BOTTOM] = 'frozenBottomGroup',
    _a);

var InteractionName;
(function (InteractionName) {
    InteractionName["DATA_CELL_CLICK"] = "dataCellClick";
    InteractionName["MERGED_CELLS_CLICK"] = "mergedCellsClick";
    InteractionName["ROW_COLUMN_CLICK"] = "rowColumnClick";
    InteractionName["ROW_TEXT_CLICK"] = "rowTextClick";
    InteractionName["HOVER"] = "hover";
    InteractionName["BRUSH_SELECTION"] = "brushSelection";
    InteractionName["COL_ROW_RESIZE"] = "rowColResize";
    InteractionName["DATA_CELL_MULTI_SELECTION"] = "dataCellMultiSelection";
    InteractionName["RANGE_SELECTION"] = "rangeSelection";
    InteractionName["SELECTED_CELL_MOVE"] = "selectedCellMove";
})(InteractionName || (InteractionName = {}));
var InteractionStateName;
(function (InteractionStateName) {
    InteractionStateName["ALL_SELECTED"] = "allSelected";
    InteractionStateName["SELECTED"] = "selected";
    InteractionStateName["UNSELECTED"] = "unselected";
    InteractionStateName["HOVER"] = "hover";
    InteractionStateName["HOVER_FOCUS"] = "hoverFocus";
    InteractionStateName["PREPARE_SELECT"] = "prepareSelect";
})(InteractionStateName || (InteractionStateName = {}));
var CellTypes;
(function (CellTypes) {
    CellTypes["DATA_CELL"] = "dataCell";
    CellTypes["HEADER_CELL"] = "headerCell";
    CellTypes["ROW_CELL"] = "rowCell";
    CellTypes["COL_CELL"] = "colCell";
    CellTypes["CORNER_CELL"] = "cornerCell";
    CellTypes["MERGED_CELL"] = "mergedCell";
})(CellTypes || (CellTypes = {}));
var HOVER_FOCUS_TIME = 800;
// 主题配置和canvas属性的映射
var SHAPE_STYLE_MAP = {
    textOpacity: 'fillOpacity',
    backgroundOpacity: 'fillOpacity',
    backgroundColor: 'fill',
    borderOpacity: 'strokeOpacity',
    borderColor: 'stroke',
    borderWidth: 'lineWidth',
    opacity: 'opacity',
};
// 设置属性的时候实际对应改变的shape映射
var SHAPE_ATTRS_MAP = {
    textShape: ['textOpacity'],
    linkFieldShape: ['opacity'],
    interactiveBgShape: ['backgroundColor', 'backgroundOpacity'],
    interactiveBorderShape: ['borderColor', 'borderOpacity', 'borderWidth'],
};
var INTERACTION_STATE_INFO_KEY = 'interactionStateInfo';
var InteractionBrushSelectionStage;
(function (InteractionBrushSelectionStage) {
    InteractionBrushSelectionStage["CLICK"] = "click";
    InteractionBrushSelectionStage["UN_DRAGGED"] = "unDragged";
    InteractionBrushSelectionStage["DRAGGED"] = "dragged";
})(InteractionBrushSelectionStage || (InteractionBrushSelectionStage = {}));
var InteractionKeyboardKey;
(function (InteractionKeyboardKey) {
    InteractionKeyboardKey["SHIFT"] = "Shift";
    InteractionKeyboardKey["COPY"] = "c";
    InteractionKeyboardKey["ESC"] = "Escape";
    InteractionKeyboardKey["META"] = "Meta";
    InteractionKeyboardKey["ARROW_UP"] = "ArrowUp";
    InteractionKeyboardKey["ARROW_DOWN"] = "ArrowDown";
    InteractionKeyboardKey["ARROW_LEFT"] = "ArrowLeft";
    InteractionKeyboardKey["ARROW_RIGHT"] = "ArrowRight";
})(InteractionKeyboardKey || (InteractionKeyboardKey = {}));
var SortMethodType;
(function (SortMethodType) {
    SortMethodType["ASC"] = "ASC";
    SortMethodType["DESC"] = "DESC";
})(SortMethodType || (SortMethodType = {}));
var InterceptType;
(function (InterceptType) {
    InterceptType["HOVER"] = "hover";
    InterceptType["CLICK"] = "click";
    InterceptType["BRUSH_SELECTION"] = "brushSelection";
    InterceptType["MULTI_SELECTION"] = "multiSelection";
    InterceptType["RESIZE"] = "resize";
})(InterceptType || (InterceptType = {}));
var ScrollbarPositionType;
(function (ScrollbarPositionType) {
    ScrollbarPositionType["CONTENT"] = "content";
    ScrollbarPositionType["CANVAS"] = "canvas";
})(ScrollbarPositionType || (ScrollbarPositionType = {}));

var RESIZE_START_GUIDE_LINE_ID = 'RESIZE_START_GUIDE_LINE';
var RESIZE_END_GUIDE_LINE_ID = 'RESIZE_END_GUIDE_LINE';
var RESIZE_MASK_ID = 'RESIZE_MASK';
// resize时鼠标移动方向类型
var ResizeDirectionType;
(function (ResizeDirectionType) {
    ResizeDirectionType["Horizontal"] = "col";
    ResizeDirectionType["Vertical"] = "row";
})(ResizeDirectionType || (ResizeDirectionType = {}));
var ResizeAreaEffect;
(function (ResizeAreaEffect) {
    ResizeAreaEffect["Field"] = "field";
    ResizeAreaEffect["Cell"] = "cell";
    ResizeAreaEffect["Tree"] = "tree";
    ResizeAreaEffect["Series"] = "series";
})(ResizeAreaEffect || (ResizeAreaEffect = {}));
var ResizeType;
(function (ResizeType) {
    ResizeType["ALL"] = "all";
    ResizeType["CURRENT"] = "current";
})(ResizeType || (ResizeType = {}));

var MIN_DEVICE_PIXEL_RATIO = 1;
var LayoutWidthTypes;
(function (LayoutWidthTypes) {
    LayoutWidthTypes["Adaptive"] = "adaptive";
    LayoutWidthTypes["ColAdaptive"] = "colAdaptive";
    LayoutWidthTypes["Compact"] = "compact";
})(LayoutWidthTypes || (LayoutWidthTypes = {}));
var DEFAULT_STYLE = {
    layoutWidthType: LayoutWidthTypes.Adaptive,
    treeRowsWidth: 120,
    collapsedRows: {},
    collapsedCols: {},
    cellCfg: {
        width: 96,
        height: 30,
    },
    rowCfg: {
        width: 96,
        widthByField: {},
        heightByField: {},
    },
    colCfg: {
        height: 30,
        widthByFieldValue: {},
        heightByField: {},
    },
    device: 'pc',
};
var DEFAULT_OPTIONS = {
    width: 600,
    height: 480,
    debug: false,
    hierarchyType: 'grid',
    conditions: {},
    totals: {},
    tooltip: {
        showTooltip: false,
        autoAdjustBoundary: 'body',
        operation: {
            hiddenColumns: false,
            trend: false,
            sort: false,
            menus: [],
        },
    },
    interaction: {
        linkFields: [],
        hiddenColumnFields: [],
        selectedCellsSpotlight: false,
        hoverHighlight: true,
        hoverFocus: true,
        scrollSpeedRatio: {
            horizontal: 1,
            vertical: 1,
        },
        autoResetSheetStyle: true,
        brushSelection: true,
        multiSelection: true,
        rangeSelection: true,
        scrollbarPosition: ScrollbarPositionType.CONTENT,
        resize: {
            rowCellVertical: true,
            cornerCellHorizontal: true,
            colCellHorizontal: true,
            colCellVertical: true,
            rowResizeType: ResizeType.ALL,
        },
    },
    showSeriesNumber: false,
    customSVGIcons: [],
    showDefaultHeaderActionIcon: false,
    headerActionIcons: [],
    style: DEFAULT_STYLE,
    frozenRowHeader: true,
    frozenRowCount: 0,
    frozenColCount: 0,
    frozenTrailingRowCount: 0,
    frozenTrailingColCount: 0,
    hdAdapter: true,
    cornerText: '',
    placeholder: EMPTY_PLACEHOLDER,
    supportCSSTransform: false,
    devicePixelRatio: window.devicePixelRatio,
};

// 滚动条最小高度
var MIN_SCROLL_BAR_HEIGHT = 32;

var paletteColorful = {
    // --------- basic colors -----------
    basicColors: [
        '#FFFFFF',
        '#F4F7FE',
        '#DDE7FD',
        '#3471F9',
        '#2C60D3',
        '#2C60D3',
        '#0000EE',
        '#326EF4',
        '#FFFFFF',
        '#E0E9FE',
        '#5286F9',
        '#5286F9',
        '#3471F9',
        '#282B33',
        '#121826',
    ],
    // ---------- semantic colors ----------
    semanticColors: {
        red: '#FF4D4F',
        green: '#29A294',
    },
};

var paletteDefault = {
    // --------- basic colors -----------
    basicColors: [
        '#000000',
        '#f7faff',
        '#E1EAFE',
        '#E1EAFE',
        '#CCDBFD',
        '#2C60D3',
        '#0000EE',
        '#326EF4',
        '#FFFFFF',
        '#EBF2FF',
        '#D6E3FE',
        '#3471F9',
        '#3471F9',
        '#282B33',
        '#121826',
    ],
    // ---------- semantic colors ----------
    semanticColors: {
        red: '#FF4D4F',
        green: '#29A294',
    },
};

var paletteGray = {
    // --------- basic colors -----------
    basicColors: [
        '#000000',
        '#FcFcFd',
        '#F4F5F7',
        '#F3F4F6',
        '#E7E8EA',
        '#CECFD1',
        '#A9AAAB',
        '#616162',
        '#FFFFFF',
        '#F2F2F2',
        '#E8E6E6',
        '#D1D4DC',
        '#BEC2CB',
        '#282B33',
        '#121826',
    ],
    // ---------- semantic colors ----------
    semanticColors: {
        red: '#FF4D4F',
        green: '#29A294',
    },
};

// Map of the theme
var PALETTE_MAP = {
    default: paletteDefault,
    colorful: paletteColorful,
    gray: paletteGray,
};
var FONT_FAMILY = 'Roboto, PingFangSC, BlinkMacSystemFont, Microsoft YaHei, Arial, sans-serif';
var MINI_BAR_CHART_HEIGHT = 12;

var ZH_CN = {
    小计: '小计',
    总计: '总计',
    总和: '总和',
    项: '项',
    已选择: '已选择',
    序号: '序号',
    度量: '所选项',
    数值: '数值',
    共计: '共计',
    条: '条',
    选择分析信息: '选择分析信息',
    切换指标: '切换指标',
    确定: '确定',
    取消: '取消',
    重置: '重置',
    请输入关键字搜索: '请输入关键字搜索',
    搜索: '搜索',
    恢复: '恢复',
    趋势: '趋势',
    '已选 {} 项': '已选 {} 项',
    所选项: '所选项',
    组内升序: '组内升序',
    升序: '升序',
    降序: '降序',
    组内降序: '组内降序',
    不排序: '不排序',
    选择下钻维度: '选择下钻维度',
    恢复默认: '恢复默认',
    搜索字段: '搜索字段',
    // switcher
    行列切换: '行列切换',
    行头: '行头',
    列头: '列头',
    值: '值',
    展开子项: '展开子项',
    首字母: '首字母',
    手动排序: '手动排序',
    其他字段: '其他字段',
    高级排序: '高级排序',
    设置顺序: '设置顺序',
    可选字段: '可选字段',
    '按以下规则进行排序（优先级由低到高）': '按以下规则进行排序（优先级由低到高）',
    按: '按',
};

var EN_US = {
    小计: 'Total',
    总计: 'Total',
    总和: 'SUM',
    项: 'items',
    已选择: 'selected',
    序号: 'Index',
    度量: 'Measure',
    数值: 'Measure',
    共计: 'Total',
    条: '',
    选择分析信息: 'Select Analysis Information',
    切换指标: 'Switch indicator',
    确定: 'Ok',
    取消: 'Cancel',
    重置: 'Rest',
    请输入关键字搜索: 'Please enter a keyword search',
    搜索: 'Search',
    恢复: 'Recover',
    趋势: 'Trend',
    '已选 {} 项': 'selected {} item',
    所选项: 'selected items',
    组内升序: 'Group ASC',
    组内降序: 'Group DESC',
    升序: 'ASC',
    降序: 'DESC',
    不排序: 'No order',
    选择下钻维度: 'Select drill down dimension',
    恢复默认: 'Restore default',
    搜索字段: 'Search field',
    // switcher
    行列切换: 'Switch Dimensions',
    行头: 'Rows',
    列头: 'Cols',
    值: 'Values',
    展开子项: 'Expand Children',
    首字母: 'Alphabetical order',
    手动排序: 'Custom order',
    其他字段: 'Other field',
    高级排序: 'Advanced order',
    设置顺序: 'SetManual',
    可选字段: 'Fields',
    '按以下规则进行排序（优先级由低到高）': 'Order according to the following rules (from low to high priority)',
    按: 'By',
};

var Lang = 'zh_CN';
var Locale = ZH_CN;
var isEnUS = function (l) { return l.indexOf('en') === 0; };
/**
 * 设置语言
 * @param lang
 */
var setEVALocale = function (lang) {
    Lang = isEnUS(lang) ? 'en_US' : 'zh_CN';
    Locale = isEnUS(lang) ? EN_US : ZH_CN;
};
/**
 * 国际化方法
 * 国际化是 eva 整个整体设置，不跟着实例走！默认认为同一页面，不可能出现中文和英文两种语言
 *
 */
var i18n = function (key, defaultValue) {
    if (defaultValue === void 0) { defaultValue = key; }
    return get(Locale, key, defaultValue);
};

var TOOLTIP_PREFIX_CLS = "".concat(S2_PREFIX_CLS, "-tooltip");
var TOOLTIP_CONTAINER_CLS = "".concat(TOOLTIP_PREFIX_CLS, "-container");
var TOOLTIP_OPERATION_PREFIX_CLS = "".concat(TOOLTIP_PREFIX_CLS, "-operation");
var TOOLTIP_POSITION_OFFSET = {
    x: 15,
    y: 10,
};
var TOOLTIP_OPERATOR_HIDDEN_COLUMNS_MENU = {
    key: 'hiddenColumns',
    text: i18n('隐藏'),
    icon: 'EyeOutlined',
};
var TOOLTIP_OPERATOR_TREND_MENU = {
    key: 'trend',
    text: i18n('趋势'),
    icon: 'Trend',
};
var TOOLTIP_OPERATOR_SORT_MENUS = [
    {
        key: 'asc',
        icon: 'groupAsc',
        text: i18n('组内升序'),
    },
    {
        key: 'desc',
        icon: 'groupDesc',
        text: i18n('组内降序'),
    },
    {
        key: 'none',
        text: i18n('不排序'),
    },
];
var TOOLTIP_OPERATOR_TABLE_SORT_MENUS = [
    {
        key: 'asc',
        icon: 'groupAsc',
        text: i18n('升序'),
    },
    {
        key: 'desc',
        icon: 'groupDesc',
        text: i18n('降序'),
    },
    {
        key: 'none',
        text: i18n('不排序'),
    },
];

/*
 * 判断是否是移动端。
 * 兼容场景：pc端但是使用mobile配置。
 */
function isMobile(device) {
    if (device === 'mobile') {
        return true;
    }
    return /(iPhone|iPad|SymbianOS|Windows Phone|iPod|iOS|Android)/i.test(navigator.userAgent);
}
function isIPhoneX() {
    // eslint-disable-next-line no-restricted-globals
    return (/iPhone/gi.test(navigator.userAgent) &&
        window.screen.height === 812 &&
        window.screen.width === 375);
}
function isWindows() {
    return /windows/i.test(navigator.userAgent);
}

/**
 * 获取当前的主题色板
 * @param type 主题名
 */
var getPalette = function (type) {
    var themeName = type || 'default';
    var platte = PALETTE_MAP[themeName.toLowerCase()];
    return platte;
};

/**
 * @describe generate the theme according to the type
 * @param  name
 */
var getTheme = function (themeCfg) {
    var _a;
    var themePalette = (themeCfg === null || themeCfg === void 0 ? void 0 : themeCfg.palette) || getPalette(themeCfg === null || themeCfg === void 0 ? void 0 : themeCfg.name);
    var basicColors = themePalette.basicColors, semanticColors = themePalette.semanticColors;
    var isTable = (_a = themeCfg === null || themeCfg === void 0 ? void 0 : themeCfg.spreadsheet) === null || _a === void 0 ? void 0 : _a.isTableMode();
    return {
        // ------------- Headers -------------------
        cornerCell: {
            bolderText: {
                fontFamily: FONT_FAMILY,
                fontSize: 12,
                fontWeight: isWindows() ? 'bold' : 500,
                fill: basicColors[0],
                opacity: 1,
                textAlign: isTable ? 'center' : 'left',
                textBaseline: 'middle',
            },
            text: {
                fontFamily: FONT_FAMILY,
                fontSize: 12,
                fontWeight: 'normal',
                fill: basicColors[0],
                opacity: 1,
                textAlign: isTable ? 'center' : 'left',
                textBaseline: 'middle',
            },
            cell: {
                // ----------- background color -----------
                backgroundColor: basicColors[3],
                backgroundColorOpacity: 1,
                // ----------- border color --------------
                horizontalBorderColor: basicColors[10],
                horizontalBorderColorOpacity: 1,
                verticalBorderColor: basicColors[10],
                verticalBorderColorOpacity: 1,
                // ----------- border width --------------
                horizontalBorderWidth: 1,
                verticalBorderWidth: 1,
                // -------------- layout -----------------
                padding: {
                    top: 0,
                    right: 8,
                    bottom: 0,
                    left: 8,
                },
            },
            icon: {
                fill: basicColors[0],
                size: 10,
                margin: {
                    right: 4,
                    left: 4,
                },
            },
        },
        rowCell: {
            bolderText: {
                fontFamily: FONT_FAMILY,
                fontSize: 12,
                fontWeight: isWindows() ? 'bold' : 520,
                fill: basicColors[14],
                linkTextFill: basicColors[14],
                opacity: 1,
                textAlign: isTable ? 'center' : 'left',
                textBaseline: 'middle',
            },
            text: {
                fontFamily: FONT_FAMILY,
                fontSize: 12,
                fontWeight: 'normal',
                fill: basicColors[14],
                linkTextFill: basicColors[6],
                opacity: 1,
                textBaseline: 'middle',
                textAlign: isTable ? 'center' : 'left', // default align center for row cell in table mode
            },
            cell: {
                // ----------- background color -----------
                backgroundColor: basicColors[1],
                backgroundColorOpacity: 1,
                // ----------- bottom border color --------------
                horizontalBorderColor: basicColors[9],
                horizontalBorderColorOpacity: 1,
                verticalBorderColor: basicColors[9],
                verticalBorderColorOpacity: 1,
                // ----------- bottom border width --------------
                horizontalBorderWidth: 1,
                verticalBorderWidth: 1,
                // -------------- layout -----------------
                padding: {
                    top: 0,
                    right: 10,
                    bottom: 0,
                    left: 10,
                },
                /* ---------- interaction state ----------- */
                interactionState: {
                    // -------------- hover -------------------
                    hover: {
                        backgroundColor: basicColors[2],
                        backgroundOpacity: 0.6,
                    },
                    // -------------- selected -------------------
                    selected: {
                        backgroundColor: basicColors[2],
                        backgroundOpacity: 0.6,
                    },
                    // -------------- unselected -------------------
                    unselected: {
                        backgroundOpacity: 0.3,
                        textOpacity: 0.3,
                        opacity: 0.3,
                    },
                },
            },
            icon: {
                fill: basicColors[0],
                size: 10,
                margin: {
                    right: 4,
                    left: 4,
                },
            },
            seriesNumberWidth: 80,
        },
        colCell: {
            bolderText: {
                fontFamily: FONT_FAMILY,
                fontSize: 12,
                fontWeight: isWindows() ? 'bold' : 520,
                fill: basicColors[0],
                opacity: 1,
                textAlign: 'center',
                textBaseline: 'middle',
            },
            text: {
                fontFamily: FONT_FAMILY,
                fontSize: 12,
                fontWeight: 'normal',
                fill: basicColors[0],
                opacity: 1,
                textAlign: 'center',
                textBaseline: 'middle',
            },
            cell: {
                // ----------- background color -----------
                backgroundColor: basicColors[3],
                backgroundColorOpacity: 1,
                // ----------- border color --------------
                horizontalBorderColor: basicColors[10],
                horizontalBorderColorOpacity: 1,
                verticalBorderColor: basicColors[10],
                verticalBorderColorOpacity: 1,
                // ----------- border width --------------
                horizontalBorderWidth: 1,
                verticalBorderWidth: 1,
                // -------------- layout -----------------
                padding: {
                    top: 0,
                    right: 8,
                    bottom: 0,
                    left: 8,
                },
                /* ---------- interaction state ----------- */
                interactionState: {
                    // -------------- hover -------------------
                    hover: {
                        backgroundColor: basicColors[4],
                        backgroundOpacity: 0.6,
                    },
                    // -------------- selected -------------------
                    selected: {
                        backgroundColor: basicColors[4],
                        backgroundOpacity: 0.6,
                    },
                    // -------------- unselected -------------------
                    unselected: {
                        backgroundOpacity: 0.3,
                        textOpacity: 0.3,
                        opacity: 0.3,
                    },
                },
            },
            icon: {
                fill: basicColors[0],
                size: 10,
                margin: {
                    top: 6,
                    right: 4,
                    bottom: 6,
                    left: 4,
                },
            },
        },
        // ------------- DataCell -------------------
        dataCell: {
            bolderText: {
                fontFamily: FONT_FAMILY,
                fontSize: 12,
                fontWeight: isWindows() ? 'bold' : 520,
                fill: basicColors[13],
                opacity: 1,
                textAlign: 'right',
                textBaseline: 'middle',
            },
            text: {
                fontFamily: FONT_FAMILY,
                fontSize: 12,
                fontWeight: 'normal',
                fill: basicColors[13],
                opacity: 1,
                textAlign: 'right',
                textBaseline: 'middle',
            },
            cell: {
                // ----------- background color -----------
                crossBackgroundColor: basicColors[1],
                backgroundColor: basicColors[8],
                backgroundColorOpacity: 1,
                // ----------- border color --------------
                horizontalBorderColor: basicColors[9],
                horizontalBorderColorOpacity: 1,
                verticalBorderColor: basicColors[9],
                verticalBorderColorOpacity: 1,
                // ----------- border width --------------
                horizontalBorderWidth: 1,
                verticalBorderWidth: 1,
                // -------------- layout -----------------
                padding: {
                    top: 0,
                    right: 8,
                    bottom: 0,
                    left: 8,
                },
                /* ---------- interaction state ----------- */
                interactionState: {
                    // -------------- hover -------------------
                    hover: {
                        backgroundColor: basicColors[2],
                        backgroundOpacity: 0.6,
                    },
                    // -------------- keep hover -------------------
                    hoverFocus: {
                        backgroundColor: basicColors[2],
                        backgroundOpacity: 0.6,
                        borderColor: basicColors[14],
                        borderWidth: 1,
                        borderOpacity: 1,
                    },
                    // -------------- selected -------------------
                    selected: {
                        backgroundColor: basicColors[2],
                        backgroundOpacity: 0.6,
                    },
                    // -------------- unselected -------------------
                    unselected: {
                        backgroundOpacity: 0.3,
                        textOpacity: 0.3,
                        opacity: 0.3,
                    },
                    // -------------- prepare select --------------
                    prepareSelect: {
                        borderColor: basicColors[14],
                        borderOpacity: 1,
                        borderWidth: 1,
                    },
                },
                // ------------- mini chart ---------------
                miniBarChartHeight: MINI_BAR_CHART_HEIGHT,
                miniBarChartFillColor: basicColors[7],
            },
            icon: {
                fill: basicColors[0],
                downIconColor: semanticColors.red,
                upIconColor: semanticColors.green,
                size: 10,
                margin: {
                    right: 4,
                    left: 4,
                },
            },
        },
        // resize active area
        resizeArea: {
            size: 3,
            background: basicColors[7],
            backgroundOpacity: 0,
            guideLineColor: basicColors[7],
            guideLineDash: [3, 3],
            /* ---------- interaction state ----------- */
            interactionState: {
                hover: {
                    backgroundColor: basicColors[7],
                    backgroundOpacity: 1,
                },
            },
        },
        // ------------- scrollBar -------------------
        scrollBar: {
            trackColor: 'rgba(0,0,0,0.01)',
            thumbHoverColor: 'rgba(0,0,0,0.25)',
            thumbColor: 'rgba(0,0,0,0.15)',
            size: isMobile() ? 3 : 6,
            hoverSize: isMobile() ? 4 : 8,
            lineCap: 'round',
        },
        // ------------- split line -----------------
        splitLine: {
            horizontalBorderColor: basicColors[12],
            horizontalBorderColorOpacity: 0.2,
            horizontalBorderWidth: 2,
            verticalBorderColor: basicColors[11],
            verticalBorderColorOpacity: 0.25,
            verticalBorderWidth: 2,
            showShadow: true,
            shadowWidth: 8,
            shadowColors: {
                left: 'rgba(0,0,0,0.1)',
                right: 'rgba(0,0,0,0)',
            },
        },
        // ------------- prepareSelectMask -----------------
        prepareSelectMask: {
            backgroundColor: basicColors[5],
            backgroundOpacity: 0.3,
        },
        // ------------- canvas background
        background: {
            color: basicColors[8],
            opacity: 1,
        },
    };
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * Node for cornerHeader, colHeader, rowHeader
 */
var Node = /** @class */ (function () {
    function Node(cfg) {
        // node top-left x-coordinate
        this.x = 0;
        // node top-left y-coordinate
        this.y = 0;
        // node width
        this.width = 0;
        // node height
        this.height = 0;
        // cell index in layout list(TODO What's use for?)
        this.colIndex = -1;
        // node's level in tree hierarchy
        this.level = 0;
        // check if node is leaf(the max level in tree)
        this.isLeaf = false;
        // node's children
        this.children = [];
        // node width adaptive mode need paddingLeft = paddingRight
        this.padding = 0;
        var id = cfg.id, key = cfg.key, value = cfg.value, label = cfg.label, parent = cfg.parent, level = cfg.level, rowIndex = cfg.rowIndex, isTotals = cfg.isTotals, isGrandTotals = cfg.isGrandTotals, isSubTotals = cfg.isSubTotals, isCollapsed = cfg.isCollapsed, hierarchy = cfg.hierarchy, isPivotMode = cfg.isPivotMode, seriesNumberWidth = cfg.seriesNumberWidth, field = cfg.field, spreadsheet = cfg.spreadsheet, query = cfg.query, belongsCell = cfg.belongsCell, inCollapseNode = cfg.inCollapseNode, isTotalMeasure = cfg.isTotalMeasure, isLeaf = cfg.isLeaf, extra = cfg.extra;
        this.id = id;
        this.key = key;
        this.value = value;
        this.label = label || value;
        this.parent = parent;
        this.level = level;
        this.rowIndex = rowIndex;
        this.isTotals = isTotals;
        this.isCollapsed = isCollapsed;
        this.hierarchy = hierarchy;
        this.isPivotMode = isPivotMode;
        this.seriesNumberWidth = seriesNumberWidth;
        this.field = field;
        this.spreadsheet = spreadsheet;
        this.query = query;
        this.belongsCell = belongsCell;
        this.inCollapseNode = inCollapseNode;
        this.isTotalMeasure = isTotalMeasure;
        this.isLeaf = isLeaf;
        this.isGrandTotals = isGrandTotals;
        this.isSubTotals = isSubTotals;
        this.config = {
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            colIndex: -1,
            children: [],
            padding: 0,
            id: '',
            key: '',
            value: '',
            label: '',
        };
        this.extra = extra;
    }
    /**
     * Get node's field path
     * eg: node.id = root[&]东北[&]黑龙江
     * => [area, province]
     * @param node
     */
    Node.getFieldPath = function (node, isDrillDown) {
        if ((node && !node.isTotals) || (node && isDrillDown)) {
            // total nodes don't need rows from node self except in drill down mode
            var parent_1 = node.parent;
            var fieldPath = [node.field];
            while (parent_1 && parent_1.id !== ROOT_ID) {
                fieldPath.push(parent_1.field);
                parent_1 = parent_1.parent;
            }
            return fieldPath.reverse();
        }
        return [];
    };
    /**
     * Get all leaves in this node branch, eg:
     *        c1
     *    b1〈
     *        c2
     * a〈
     *        c3
     *    b2〈
     *        c4
     * get a branch's all leaves(c1~c4)
     * @param node
     */
    Node.getAllLeavesOfNode = function (node) {
        var leaves = [];
        if (node.isLeaf) {
            return [node];
        }
        // current root node children
        var nodes = __spreadArray([], __read(node.children), false);
        var current = nodes.shift();
        while (current) {
            if (current.isLeaf) {
                leaves.push(current);
            }
            else {
                nodes.unshift.apply(nodes, __spreadArray([], __read(current.children), false));
            }
            current = nodes.shift();
        }
        return leaves;
    };
    /**
     * Get all children nodes in this node branch, eg:
     *        c1
     *    b1〈
     *        c2
     * a〈
     *        c3
     *    b2〈
     *        c4
     * get a branch's all nodes(c1~c4, b1, b2)
     * @param node
     */
    Node.getAllChildrenNode = function (node) {
        var all = [];
        if (node.isLeaf) {
            return [node];
        }
        // current root node children
        var nodes = __spreadArray([], __read((node.children || [])), false);
        var current = nodes.shift();
        while (current) {
            all.push(current);
            nodes.unshift.apply(nodes, __spreadArray([], __read(current.children), false));
            current = nodes.shift();
        }
        return all;
    };
    /**
     * Get all children branch in this node branch, eg:
     *        c1
     *    b1〈
     *        c2
     * a〈
     *        c3
     *    b2〈
     *        c4
     * get all branch [[b1,c1],[b1,c2],[b2,c3],[b2,c4]]
     * @param parent
     */
    Node.getAllBranch = function (parent) {
        var all = [];
        var leaves = this.getAllLeavesOfNode(parent);
        var current = leaves.shift();
        var tempBranch = [];
        while (current) {
            tempBranch.unshift(current);
            var pa = current.parent;
            while (pa) {
                if (!isEqual(pa, parent)) {
                    tempBranch.unshift(pa);
                }
                else {
                    break;
                }
                pa = pa.parent;
            }
            all.push(tempBranch);
            current = leaves.shift();
            tempBranch = [];
        }
        return all;
    };
    Node.blankNode = function () {
        return new Node({
            id: '',
            key: '',
            value: '',
        });
    };
    Node.rootNode = function () {
        return new Node({
            id: 'root',
            key: '',
            value: '',
        });
    };
    Node.prototype.toJSON = function () {
        return omit(this, ['config', 'hierarchy', 'parent', 'spreadsheet']);
    };
    return Node;
}());

/**
 * Row and Column hierarchy to handle all contained nodes
 */
var Hierarchy = /** @class */ (function () {
    function Hierarchy() {
        // the full width contains all nodes
        this.width = 0;
        // the full height contains all nodes
        this.height = 0;
        // just a mark to get node from each level
        this.maxLevel = -1;
        // each level's first node
        this.sampleNodesForAllLevels = [];
        // last level's first node
        this.sampleNodeForLastLevel = null;
        // all nodes in this hierarchy
        this.allNodesWithoutRoot = [];
        // all nodes in the lastLevel
        this.indexNode = [];
    }
    // get all leaf nodes
    Hierarchy.prototype.getLeaves = function () {
        return this.allNodesWithoutRoot.filter(function (value) { return value.isLeaf; });
    };
    /**
     * Get all or level-related nodes in hierarchy
     * @param level
     */
    Hierarchy.prototype.getNodes = function (level) {
        if (level !== undefined) {
            return this.allNodesWithoutRoot.filter(function (value) { return value.level === level; });
        }
        return this.allNodesWithoutRoot;
    };
    /**
     * Get all or less than level-related nodes in hierarchy
     * @param lessThanLevel
     */
    Hierarchy.prototype.getNodesLessThanLevel = function (lessThanLevel) {
        return this.allNodesWithoutRoot.filter(function (value) { return value.level <= lessThanLevel; });
    };
    /**
     * Add new node
     * @param value
     * @param insetIndex
     */
    Hierarchy.prototype.pushNode = function (value, insetIndex) {
        if (insetIndex === void 0) { insetIndex = -1; }
        if (insetIndex === -1) {
            this.allNodesWithoutRoot.push(value);
        }
        else {
            this.allNodesWithoutRoot.splice(insetIndex, 0, value);
        }
    };
    Hierarchy.prototype.pushIndexNode = function (value) {
        this.indexNode.push(value);
    };
    Hierarchy.prototype.getIndexNodes = function () {
        return this.indexNode;
    };
    return Hierarchy;
}());

/**
 * Class to mark '小计' & '总计'
 */
var TotalClass = /** @class */ (function () {
    function TotalClass(label, isSubTotals, isGrandTotals) {
        if (isSubTotals === void 0) { isSubTotals = false; }
        if (isGrandTotals === void 0) { isGrandTotals = false; }
        this.label = label;
        this.isSubTotals = isSubTotals;
        this.isGrandTotals = isGrandTotals;
    }
    return TotalClass;
}());

var TotalMeasure = /** @class */ (function () {
    function TotalMeasure(label) {
        this.label = label;
    }
    return TotalMeasure;
}());

/**
 * Row and column header node id generator.
 * @param parentId
 * @param value
 */
var generateId = function (parentId, value) {
    return "".concat(parentId).concat(ID_SEPARATOR).concat(value);
};

/**
 * re-arrange field values by custom arrange hooks
 * @param fieldValues
 * @param facetCfg
 * @param parent
 * @param field
 */
var layoutArrange = function (fieldValues, facetCfg, parent, field) {
    if (facetCfg.layoutArrange) {
        return facetCfg.layoutArrange(facetCfg.spreadsheet, parent, field, fieldValues);
    }
    return fieldValues;
};
/**
 * Push node directly or custom push according to Hierarchy Hooks
 * @param facetCfg
 * @param parentNode
 * @param currentNode
 * @param hierarchy
 */
var layoutHierarchy = function (facetCfg, parentNode, currentNode, hierarchy) {
    var expandCurrentNode = true;
    var addNode = function (node, insetIndex, hierarchyIndex) {
        if (insetIndex === void 0) { insetIndex = -1; }
        if (hierarchyIndex === void 0) { hierarchyIndex = -1; }
        if (insetIndex === -1) {
            // add in parent
            parentNode.children.push(node);
            hierarchy.pushNode(node);
        }
        else {
            parentNode.children.splice(insetIndex, 0, node);
            hierarchy.pushNode(node, hierarchyIndex);
        }
    };
    if (facetCfg.layoutHierarchy) {
        var facetLayoutHierarchy = facetCfg.layoutHierarchy(facetCfg.spreadsheet, currentNode);
        if (facetLayoutHierarchy) {
            var deleteNode = !isBoolean(facetLayoutHierarchy === null || facetLayoutHierarchy === void 0 ? void 0 : facetLayoutHierarchy.delete)
                ? false
                : facetLayoutHierarchy === null || facetLayoutHierarchy === void 0 ? void 0 : facetLayoutHierarchy.delete;
            expandCurrentNode = !deleteNode;
            var pushNodes = facetLayoutHierarchy.push, unshiftNodes = facetLayoutHierarchy.unshift;
            var currentIndex = parentNode.children.length;
            var hierarchyIndex = hierarchy.getNodes().length;
            if (!isEmpty(unshiftNodes)) {
                each(unshiftNodes, function (v) {
                    addNode(v);
                });
                currentIndex = parentNode.children.length;
                hierarchyIndex = hierarchy.getNodes().length;
            }
            if (!isEmpty(pushNodes)) {
                each(pushNodes, function (v) {
                    addNode(v);
                });
            }
            if (!deleteNode) {
                addNode(currentNode, currentIndex, hierarchyIndex);
            }
        }
        else {
            addNode(currentNode);
        }
    }
    else {
        addNode(currentNode);
    }
    return expandCurrentNode;
};
/**
 * custom control every header node's coordinates
 * @param facetCfg
 * @param rowNode
 * @param colNode
 */
var layoutCoordinate = function (facetCfg, rowNode, colNode) {
    if (facetCfg === null || facetCfg === void 0 ? void 0 : facetCfg.layoutCoordinate) {
        // only leaf node's coordinates can be modified
        if ((rowNode === null || rowNode === void 0 ? void 0 : rowNode.isLeaf) || (colNode === null || colNode === void 0 ? void 0 : colNode.isLeaf)) {
            facetCfg === null || facetCfg === void 0 ? void 0 : facetCfg.layoutCoordinate(facetCfg.spreadsheet, rowNode, colNode);
        }
    }
};
/**
 * Custom position cell's data
 * @param facetCfg
 * @param layoutResult
 */
var layoutDataPosition = function (facetCfg, layoutResult) {
    var dataPosition = facetCfg === null || facetCfg === void 0 ? void 0 : facetCfg.layoutDataPosition;
    if (dataPosition) {
        var getCellMeta = layoutResult.getCellMeta;
        var handledGetCellMeta = dataPosition(facetCfg.spreadsheet, getCellMeta);
        return __assign(__assign({}, layoutResult), { getCellMeta: handledGetCellMeta });
    }
    return layoutResult;
};

function getDimsCondition(parent, force) {
    var cond = {};
    var p = parent;
    while (p && p.key) {
        /**
         * 当为表格布局时，小计行的内容是“小计”不需要作为筛选条件
         * 当为树状布局时，force可以强行指定小计行，即父类目作为筛选条件
         */
        if (!p.isTotals || force) {
            cond[p.key] = p.value;
        }
        p = p.parent;
    }
    return cond;
}

var addTotals$1 = function (params) {
    var _a;
    var isFirstField = params.isFirstField, currentField = params.currentField, fieldValues = params.fieldValues, spreadsheet = params.spreadsheet, lastField = params.lastField;
    var totalsConfig = spreadsheet.getTotalsConfig(isFirstField ? currentField : lastField);
    var action;
    var totalValue;
    if ((totalsConfig === null || totalsConfig === void 0 ? void 0 : totalsConfig.showGrandTotals) && isFirstField) {
        // check to see if grand total is added
        action = totalsConfig.reverseLayout ? 'unshift' : 'push';
        totalValue = new TotalClass(totalsConfig.label, false, true);
    }
    else if ((totalsConfig === null || totalsConfig === void 0 ? void 0 : totalsConfig.showSubTotals) && currentField !== EXTRA_FIELD) {
        action = totalsConfig.reverseSubLayout ? 'unshift' : 'push';
        totalValue = new TotalClass(totalsConfig.subLabel, true);
    }
    (_a = fieldValues[action]) === null || _a === void 0 ? void 0 : _a.call(fieldValues, totalValue);
};

var hideMeasureColumn = function (fieldValues, field, cfg) {
    var e_1, _a;
    var _b, _c;
    var hideMeasure = (_c = (_b = cfg.colCfg) === null || _b === void 0 ? void 0 : _b.hideMeasureColumn) !== null && _c !== void 0 ? _c : false;
    var valueInCol = cfg.dataSet.fields.valueInCols;
    try {
        for (var fieldValues_1 = __values(fieldValues), fieldValues_1_1 = fieldValues_1.next(); !fieldValues_1_1.done; fieldValues_1_1 = fieldValues_1.next()) {
            var value = fieldValues_1_1.value;
            if (hideMeasure && valueInCol && field === EXTRA_FIELD) {
                fieldValues.splice(fieldValues.indexOf(value), 1);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (fieldValues_1_1 && !fieldValues_1_1.done && (_a = fieldValues_1.return)) _a.call(fieldValues_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
/**
 * Build grid hierarchy in rows or columns
 *
 * @param params
 */
var buildGridHierarchy = function (params) {
    var _a;
    var addTotalMeasureInTotal = params.addTotalMeasureInTotal, addMeasureInTotalQuery = params.addMeasureInTotalQuery, parentNode = params.parentNode, currentField = params.currentField, fields = params.fields, facetCfg = params.facetCfg, hierarchy = params.hierarchy;
    var index = fields.indexOf(currentField);
    var dataSet = facetCfg.dataSet, values = facetCfg.values, spreadsheet = facetCfg.spreadsheet;
    var fieldValues = [];
    var query = {};
    if (parentNode.isTotals) {
        // add total measures
        if (addTotalMeasureInTotal) {
            query = getDimsCondition(parentNode.parent, true);
            // add total measures
            fieldValues.push.apply(fieldValues, __spreadArray([], __read(values.map(function (v) { return new TotalMeasure(v); })), false));
        }
    }
    else {
        // field(dimension)'s all values
        query = getDimsCondition(parentNode, true);
        var dimValues = dataSet.getDimensionValues(currentField, query);
        var arrangedValues = layoutArrange(dimValues, facetCfg, parentNode, currentField);
        fieldValues.push.apply(fieldValues, __spreadArray([], __read((arrangedValues || [])), false));
        // add skeleton for empty data
        var fieldName = dataSet.getFieldName(currentField);
        if (isEmpty(fieldValues)) {
            if (currentField === EXTRA_FIELD) {
                fieldValues.push.apply(fieldValues, __spreadArray([], __read((_a = dataSet.fields) === null || _a === void 0 ? void 0 : _a.values), false));
            }
            else {
                fieldValues.push(fieldName);
            }
        }
        // hide measure in columns
        hideMeasureColumn(fieldValues, currentField, facetCfg);
        // add totals if needed
        addTotals$1({
            currentField: currentField,
            lastField: fields[index - 1],
            isFirstField: index === 0,
            fieldValues: fieldValues,
            spreadsheet: spreadsheet,
        });
    }
    var hiddenColumnsDetail = spreadsheet.store.get('hiddenColumnsDetail');
    var displayFieldValues = fieldValues.filter(function (value) {
        // 去除多余的节点
        if (isUndefined(value)) {
            return false;
        }
        if (isEmpty(hiddenColumnsDetail)) {
            return true;
        }
        return hiddenColumnsDetail.every(function (detail) {
            return detail.hideColumnNodes.every(function (node) {
                // 有数值字段 (hideMeasureColumn: true) 隐藏父节点
                if (node.field === EXTRA_FIELD) {
                    return (node.parent.id !== parentNode.id && node.parent.value !== value);
                }
                // 没有数值字段 (hideMeasureColumn: false) 隐藏自己即可
                return node.value !== value;
            });
        });
    });
    generateHeaderNodes({
        currentField: currentField,
        fields: fields,
        fieldValues: displayFieldValues,
        facetCfg: facetCfg,
        hierarchy: hierarchy,
        parentNode: parentNode,
        level: index,
        query: query,
        addMeasureInTotalQuery: addMeasureInTotalQuery,
        addTotalMeasureInTotal: addTotalMeasureInTotal,
    });
};

var generateHeaderNodes = function (params) {
    var e_1, _a, _b, _c, _d, _e;
    var _f, _g, _h;
    var currentField = params.currentField, fields = params.fields, fieldValues = params.fieldValues, facetCfg = params.facetCfg, hierarchy = params.hierarchy, parentNode = params.parentNode, level = params.level, query = params.query, addMeasureInTotalQuery = params.addMeasureInTotalQuery, addTotalMeasureInTotal = params.addTotalMeasureInTotal;
    var spreadsheet = facetCfg.spreadsheet, collapsedCols = facetCfg.collapsedCols, colCfg = facetCfg.colCfg;
    try {
        for (var _j = __values(fieldValues.entries()), _k = _j.next(); !_k.done; _k = _j.next()) {
            var _l = __read(_k.value, 2), index = _l[0], fieldValue = _l[1];
            var isTotals = fieldValue instanceof TotalClass;
            var isTotalMeasure = fieldValue instanceof TotalMeasure;
            var value = void 0;
            var nodeQuery = void 0;
            var isLeaf = false;
            var isGrandTotals = false;
            var isSubTotals = false;
            var adjustedField = currentField;
            if (isTotals) {
                var totalClass = fieldValue;
                isGrandTotals = totalClass.isGrandTotals;
                isSubTotals = totalClass.isSubTotals;
                value = i18n(fieldValue.label);
                if (addMeasureInTotalQuery) {
                    // root[&]四川[&]总计 => {province: '四川', EXTRA_FIELD: 'price'}
                    nodeQuery = __assign(__assign({}, query), (_b = {}, _b[EXTRA_FIELD] = (_f = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.dataSet) === null || _f === void 0 ? void 0 : _f.fields.values[0], _b));
                    isLeaf = true;
                }
                else {
                    // root[&]四川[&]总计 => {province: '四川'}
                    nodeQuery = query;
                    if (!addTotalMeasureInTotal) {
                        isLeaf = true;
                    }
                }
            }
            else if (isTotalMeasure) {
                value = i18n(fieldValue.label);
                // root[&]四川[&]总计[&]price => {province: '四川',EXTRA_FIELD: 'price' }
                nodeQuery = __assign(__assign({}, query), (_c = {}, _c[EXTRA_FIELD] = value, _c));
                adjustedField = EXTRA_FIELD;
                isLeaf = true;
            }
            else if (spreadsheet.isTableMode()) {
                value = fieldValue;
                adjustedField = fields[index];
                nodeQuery = __assign(__assign({}, query), (_d = {}, _d[adjustedField] = value, _d));
                isLeaf = true;
            }
            else {
                value = fieldValue;
                // root[&]四川[&]成都 => {province: '四川', city: '成都' }
                nodeQuery = __assign(__assign({}, query), (_e = {}, _e[currentField] = value, _e));
                var isValueInCols = (_h = (_g = spreadsheet.dataCfg.fields) === null || _g === void 0 ? void 0 : _g.valueInCols) !== null && _h !== void 0 ? _h : true;
                var isHideMeasure = (colCfg === null || colCfg === void 0 ? void 0 : colCfg.hideMeasureColumn) &&
                    isValueInCols &&
                    includes(fields, EXTRA_FIELD);
                var extraSize = isHideMeasure ? 2 : 1;
                isLeaf = level === fields.length - extraSize;
            }
            var uniqueId = generateId(parentNode.id, value);
            if (!uniqueId)
                return;
            // TODO need merge with collapsedRows
            var isCollapsed = isBoolean(collapsedCols === null || collapsedCols === void 0 ? void 0 : collapsedCols[uniqueId])
                ? collapsedCols === null || collapsedCols === void 0 ? void 0 : collapsedCols[uniqueId]
                : false;
            // create new header nodes
            var node = new Node({
                id: uniqueId,
                key: adjustedField,
                value: value,
                level: level,
                field: adjustedField,
                parent: parentNode,
                isTotals: isTotals,
                isGrandTotals: isGrandTotals,
                isSubTotals: isSubTotals,
                isTotalMeasure: isTotalMeasure,
                isCollapsed: isCollapsed,
                hierarchy: hierarchy,
                query: nodeQuery,
                spreadsheet: spreadsheet,
                isLeaf: isLeaf || isCollapsed,
            });
            var expandCurrentNode = layoutHierarchy(facetCfg, parentNode, node, hierarchy);
            // omit the the whole column or row of the grandTotal or subTotals
            if (level > hierarchy.maxLevel &&
                !isGrandTotals &&
                !parentNode.isGrandTotals &&
                !parentNode.isSubTotals &&
                !node.isSubTotals) {
                hierarchy.sampleNodesForAllLevels.push(node);
                hierarchy.sampleNodeForLastLevel = node;
                hierarchy.maxLevel = level;
            }
            var isLeafNode = isLeaf || isCollapsed || !expandCurrentNode;
            if (isLeafNode) {
                node.isLeaf = true;
                hierarchy.pushIndexNode(node);
                node.rowIndex = hierarchy.getIndexNodes().length - 1;
            }
            else {
                buildGridHierarchy({
                    addTotalMeasureInTotal: addTotalMeasureInTotal,
                    addMeasureInTotalQuery: addMeasureInTotalQuery,
                    parentNode: node,
                    currentField: fields[level + 1],
                    fields: fields,
                    facetCfg: facetCfg,
                    hierarchy: hierarchy,
                });
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_k && !_k.done && (_a = _j.return)) _a.call(_j);
        }
        finally { if (e_1) throw e_1.error; }
    }
};

var buildTableHierarchy = function (params) {
    var facetCfg = params.facetCfg, hierarchy = params.hierarchy, parentNode = params.parentNode;
    var columns = facetCfg.columns, spreadsheet = facetCfg.spreadsheet, dataSet = facetCfg.dataSet;
    var hiddenColumnsDetail = spreadsheet.store.get('hiddenColumnsDetail');
    var showSeriesNumber = facetCfg === null || facetCfg === void 0 ? void 0 : facetCfg.showSeriesNumber;
    var displayedColumns = columns.filter(function (column) {
        if (!hiddenColumnsDetail) {
            return true;
        }
        return hiddenColumnsDetail.every(function (detail) {
            return detail.hideColumnNodes.every(function (node) {
                return node.field !== column;
            });
        });
    });
    var fields = __spreadArray([], __read(displayedColumns), false);
    var fieldValues = map(displayedColumns, function (val) { return dataSet.getFieldName(val); });
    if (showSeriesNumber) {
        fields.unshift(SERIES_NUMBER_FIELD);
        fieldValues.unshift(i18n('序号'));
    }
    generateHeaderNodes({
        currentField: displayedColumns[0],
        fields: fields,
        fieldValues: fieldValues,
        facetCfg: facetCfg,
        hierarchy: hierarchy,
        parentNode: parentNode,
        level: 0,
        query: {},
        addMeasureInTotalQuery: false,
        addTotalMeasureInTotal: false,
    });
};

/* eslint-disable no-console */
var DEBUG_TRANSFORM_DATA = 'Transform Data';
var DEBUG_HEADER_LAYOUT = 'Header Layout';
var DEBUG_VIEW_RENDER = 'Data Cell Render';
var DebuggerUtil = /** @class */ (function () {
    function DebuggerUtil() {
        var _this = this;
        this.debug = false;
        this.debugCallback = function (info, callback) {
            if (_this.debug) {
                var start = performance.now();
                callback();
                var end = performance.now();
                console.log(info, "".concat(end - start, " ms"));
            }
            else {
                callback();
            }
        };
        this.logger = function (info) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            if (_this.debug) {
                console.log.apply(console, __spreadArray([info], __read(params), false));
            }
        };
    }
    DebuggerUtil.getInstance = function () {
        if (!DebuggerUtil.instance) {
            DebuggerUtil.instance = new DebuggerUtil();
        }
        return DebuggerUtil.instance;
    };
    DebuggerUtil.prototype.setDebug = function (debug) {
        this.debug = debug;
    };
    return DebuggerUtil;
}());

// 不本地直接引用svg文件，避免下游无依赖
var ArrowDown = "\n<svg width=\"10px\" height=\"10px\" viewBox=\"0 0 10 10\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n<g id=\"\u9875\u9762-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" font-family=\"Roboto, PingFangSC, BlinkMacSystemFont, Microsoft YaHei, Arial, sans-serif\" font-size=\"12\" font-weight=\"bold\">\n    <text id=\"\u2193\" fill=\"#29A294\">\n        <tspan x=\"-0.225097656\" y=\"8.5\">\u2193</tspan>\n    </text>\n</g>\n</svg>";
var ArrowUp = "<svg width=\"10px\" height=\"10px\" viewBox=\"0 0 10 10\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n<g id=\"\u9875\u9762-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" font-family=\"Roboto, PingFangSC, BlinkMacSystemFont, Microsoft YaHei, Arial, sans-serif\" font-size=\"12\" font-weight=\"bold\">\n    <text id=\"\u2191\" fill=\"#FF4D4F\">\n        <tspan x=\"-0.225097656\" y=\"8.5\">\u2191</tspan>\n    </text>\n</g>\n</svg>\n";
var CellDown = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"7px\" height=\"9px\" viewBox=\"0 0 7 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 58 (84663) - https://sketch.com -->\n    <title>down</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"\u4E00\u671F\u5F00\u53D1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <polygon id=\"down\" fill=\"#58AE57\" transform=\"translate(3.500000, 4.500000) scale(1, -1) translate(-3.500000, -4.500000) \" points=\"3.5 0 7 9 0 9\"></polygon>\n    </g>\n</svg>";
var CellUp = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"7px\" height=\"9px\" viewBox=\"0 0 7 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 58 (84663) - https://sketch.com -->\n    <title>up</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"\u4E00\u671F\u5F00\u53D1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <polygon id=\"up\" fill=\"#F46649\" points=\"3.5 0 7 9 0 9\"></polygon>\n    </g>\n</svg> ";
var GlobalAsc = "<svg t=\"1557124621626\" class=\"icon\" style=\"\" viewBox=\"0 0 1024 1024\" version=\"1.1\"\nxmlns=\"http://www.w3.org/2000/svg\" p-id=\"17452\"\nxmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"14\" height=\"14\">\n<defs>\n  <style type=\"text/css\"></style>\n</defs>\n<path d=\"M182.272 167.04a8 8 0 0 0-12.544 0L57.728 309.056A8 8 0 0 0 64 321.984h76.032v530.048c0 4.352 3.584 7.936 7.936 7.936h56.064a8 8 0 0 0 7.936-7.936V321.92H288a8 8 0 0 0 6.272-12.992l-112-141.888z m209.728 626.944h176c4.416 0 8 3.584 8 8v56a8 8 0 0 1-8 8h-176A8 8 0 0 1 384 857.984v-56c0-4.416 3.584-8 8-8z m0-424h368c4.416 0 8 3.648 8 8v56a8 8 0 0 1-8 8h-368A8 8 0 0 1 384 433.984v-56c0-4.352 3.584-8 8-8z m528-139.968h-528A8 8 0 0 1 384 222.016v-56c0-4.416 3.584-8 8-8h528c4.416 0 8 3.584 8 8v56a8 8 0 0 1-8 8z m-256 424h-272A8 8 0 0 1 384 646.016v-56c0-4.416 3.584-8 8-8h272c4.416 0 8 3.584 8 8v56a8 8 0 0 1-8 8z\" p-id=\"17453\"></path>\n</svg>";
var GlobalDesc = "<svg t=\"1557124685600\" class=\"icon\" style=\"\" viewBox=\"0 0 1024 1024\" version=\"1.1\"\n  xmlns=\"http://www.w3.org/2000/svg\" p-id=\"17561\"\n  xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"14\" height=\"14\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path d=\"M182.272 856.96a8 8 0 0 1-12.544 0l-112-141.952A8 8 0 0 1 64 702.08h76.032V172.032c0-4.416 3.584-8 7.936-8h56.064c4.352 0 7.936 3.584 7.936 8v529.984H288c6.72 0 10.496 7.808 6.272 12.992l-112 141.888z m209.728-626.944h176A8 8 0 0 0 576 222.016v-56a8 8 0 0 0-8-8h-176A8 8 0 0 0 384 166.016v56c0 4.416 3.584 8 8 8z m0 424h368a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8h-368A8 8 0 0 0 384 590.016v56c0 4.416 3.584 8 8 8z m528 139.968h-528a8 8 0 0 0-8 8v56c0 4.416 3.584 8 8 8h528a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z m-256-424h-272A8 8 0 0 0 384 377.984v56c0 4.416 3.584 8 8 8h272a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z\" p-id=\"17562\"></path>\n</svg>";
var GroupAsc = "<svg t=\"1557124695786\" class=\"icon\" style=\"\" viewBox=\"0 0 1024 1024\" version=\"1.1\"\n  xmlns=\"http://www.w3.org/2000/svg\" p-id=\"17670\"\n  xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"14\" height=\"14\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path d=\"M182.272 167.04a8 8 0 0 0-12.544 0L57.728 309.056A8 8 0 0 0 64 321.984h76.032v530.048c0 4.352 3.584 7.936 7.936 7.936h56.064a8 8 0 0 0 7.936-7.936V321.92H288a8 8 0 0 0 6.272-12.992l-112-141.888z m209.728 62.976h304A8 8 0 0 0 704 222.016v-56a8 8 0 0 0-8-8h-304A8 8 0 0 0 384 166.016v56c0 4.416 3.584 8 8 8z m0 424h304a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8h-304A8 8 0 0 0 384 590.016v56c0 4.416 3.584 8 8 8z m528 139.968h-528a8 8 0 0 0-8 8v56c0 4.416 3.584 8 8 8h528a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z m0-424h-528A8 8 0 0 0 384 377.984v56c0 4.416 3.584 8 8 8h528a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z\" p-id=\"17671\"></path>\n</svg>";
var GroupDesc = "<svg t=\"1557124710652\" class=\"icon\" style=\"\" viewBox=\"0 0 1024 1024\" version=\"1.1\"\n  xmlns=\"http://www.w3.org/2000/svg\" p-id=\"17779\"\n  xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"14\" height=\"14\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path d=\"M182.272 856.96a8 8 0 0 1-12.544 0l-112-141.952A8 8 0 0 1 64 702.08h76.032V172.032c0-4.416 3.584-8 7.936-8h56.064c4.352 0 7.936 3.584 7.936 8v529.984H288c6.72 0 10.496 7.808 6.272 12.992l-112 141.888z m209.728-626.944h304A8 8 0 0 0 704 222.016v-56a8 8 0 0 0-8-8h-304A8 8 0 0 0 384 166.016v56c0 4.416 3.584 8 8 8z m0 424h304a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8h-304A8 8 0 0 0 384 590.016v56c0 4.416 3.584 8 8 8z m528 139.968h-528a8 8 0 0 0-8 8v56c0 4.416 3.584 8 8 8h528a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z m0-424h-528A8 8 0 0 0 384 377.984v56c0 4.416 3.584 8 8 8h528a8 8 0 0 0 8-8v-56a8 8 0 0 0-8-8z\" p-id=\"17780\"></path>\n</svg>";
var GroupNone = "<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n<g id=\"\u8BBE\u8BA1\u8F93\u51FA\" stroke=\"none\" stroke-width=\"1\" fill-opacity=\"0.25\" fill-rule=\"evenodd\">\n    <g id=\"\u8BBE\u8BA1\u8F93\u51FA-\u79FB\u52A8\u7AEF\u6307\u6807\u8BE6\u60C5\u9875-\u9605\u8BFB\u7AEF\" transform=\"translate(-3275.000000, -724.000000)\" fill-rule=\"nonzero\">\n        <g id=\"\u7F16\u7EC4-39\" transform=\"translate(3064.500000, 667.000000)\">\n            <g id=\"\u7F16\u7EC4-36\" transform=\"translate(80.500000, 44.000000)\">\n                <g id=\"\u4E0D\u6392\u5E8F\" transform=\"translate(130.000000, 13.000000)\">\n                    <path d=\"M12.0009375,12.40625 C12.0696875,12.40625 12.1259375,12.4625 12.1259375,12.53125 L12.1259375,12.53125 L12.1259375,13.40625 C12.1259375,13.475 12.0696875,13.53125 12.0009375,13.53125 L12.0009375,13.53125 L6.25093747,13.53125 C6.18218747,13.53125 6.12593747,13.475 6.12593747,13.40625 L6.12593747,13.40625 L6.12593747,12.53125 C6.12593747,12.4625 6.18218747,12.40625 6.25093747,12.40625 L6.25093747,12.40625 Z M2.93949997,2.5801875 L2.97437497,2.6109375 L4.72437497,4.828125 C4.78062497,4.89776786 4.74503823,4.99725765 4.66779698,5.02426203 L4.62593747,5.03125 L3.438,5.03089062 L3.43843747,10.9691406 L4.62593747,10.9691406 C4.73062497,10.9691406 4.78999997,11.0910156 4.72437497,11.1722656 L2.97437497,13.3894531 C2.92437497,13.4535156 2.82749997,13.4535156 2.77749997,13.3894531 L1.02749997,11.1722656 C0.961874969,11.0894531 1.02124997,10.9691406 1.12593747,10.9691406 L2.31343747,10.9691406 L2.313,5.03089062 L1.12593747,5.03125 C1.03620533,5.03125 0.979764,4.94285714 1.00679571,4.8654519 L1.02749997,4.828125 L2.77749997,2.6109375 C2.81749997,2.5596875 2.88749997,2.5494375 2.93949997,2.5801875 Z M10.5009375,9.09375 C10.5696875,9.09375 10.6259375,9.15 10.6259375,9.21875 L10.6259375,9.21875 L10.6259375,10.09375 C10.6259375,10.1625 10.5696875,10.21875 10.5009375,10.21875 L10.5009375,10.21875 L6.25093747,10.21875 C6.18218747,10.21875 6.12593747,10.1625 6.12593747,10.09375 L6.12593747,10.09375 L6.12593747,9.21875 C6.12593747,9.15 6.18218747,9.09375 6.25093747,9.09375 L6.25093747,9.09375 Z M14.5009375,5.78125 C14.5696875,5.78125 14.6259375,5.8375 14.6259375,5.90625 L14.6259375,5.90625 L14.6259375,6.78125 C14.6259375,6.85 14.5696875,6.90625 14.5009375,6.90625 L14.5009375,6.90625 L6.25093747,6.90625 C6.18218747,6.90625 6.12593747,6.85 6.12593747,6.78125 L6.12593747,6.78125 L6.12593747,5.90625 C6.12593747,5.8375 6.18218747,5.78125 6.25093747,5.78125 L6.25093747,5.78125 Z M9.00093747,2.46875 C9.06968747,2.46875 9.12593747,2.525 9.12593747,2.59375 L9.12593747,2.59375 L9.12593747,3.46875 C9.12593747,3.5375 9.06968747,3.59375 9.00093747,3.59375 L9.00093747,3.59375 L6.25093747,3.59375 C6.18218747,3.59375 6.12593747,3.5375 6.12593747,3.46875 L6.12593747,3.46875 L6.12593747,2.59375 C6.12593747,2.525 6.18218747,2.46875 6.25093747,2.46875 L6.25093747,2.46875 Z\" id=\"\u5F62\u72B6\u7ED3\u5408\"></path>\n                </g>\n            </g>\n        </g>\n    </g>q\n</g>\n</svg>";
var InfoCircle = "<?xml version=\"1.0\" standalone=\"no\"?><!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\"><svg t=\"1590389330617\" class=\"icon\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" p-id=\"19656\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"200\" height=\"200\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64c-247.4 0-448 200.6-448 448s200.6 448 448 448 448-200.6 448-448-200.6-448-448-448z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z\" fill=\"\" p-id=\"19657\"></path><path d=\"M464 336c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zM536 448h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-272c0-4.4-3.6-8-8-8z\" fill=\"\" p-id=\"19658\"></path></svg>";
var ExpandColIcon = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"23px\" height=\"12px\" viewBox=\"0 0 23 12\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <title>\u7F16\u7EC4 8\u5907\u4EFD 3</title>\n    <g id=\"----\u9690\u85CF\u5217\u6807\u6CE8\uFF01\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"\u9690\u85CF\u5217\u6807\u6CE8\" transform=\"translate(-275.000000, -824.000000)\">\n            <rect fill=\"#FFFFFF\" x=\"0\" y=\"0\" width=\"1333\" height=\"1167\"></rect>\n            <g id=\"\u7F16\u7EC4-8\u5907\u4EFD-3\" transform=\"translate(275.000000, 824.000000)\">\n                <rect id=\"\u77E9\u5F62\" stroke-opacity=\"0.25\" stroke=\"#000000\" fill=\"#F7F7F7\" x=\"0.5\" y=\"0.5\" width=\"11\" height=\"11\"></rect>\n                <rect id=\"\u77E9\u5F62\u5907\u4EFD-9\" stroke-opacity=\"0.25\" stroke=\"#000000\" fill=\"#F7F7F7\" x=\"11.5\" y=\"0.5\" width=\"11\" height=\"11\"></rect>\n                <g id=\"7.Icon/arrow/15.down/fill\" transform=\"translate(6.000000, 6.000000) rotate(90.000000) translate(-6.000000, -6.000000) \" fill=\"#000000\" fill-rule=\"nonzero\" opacity=\"0.65\">\n                    <path d=\"M7.25020811,6.37218077 L4.91348936,8.20968077 C4.82677061,8.27764952 4.69903624,8.21671202 4.69903624,8.10655577 L4.69903624,4.43272764 C4.69903624,4.32257139 4.82677061,4.26046202 4.91348936,4.32960264 L7.25020811,6.16593077 C7.31700499,6.21866514 7.31700499,6.31944639 7.25020811,6.37218077 Z\" id=\"fill\" transform=\"translate(5.999671, 6.269385) rotate(90.000000) translate(-5.999671, -6.269385) \"></path>\n                </g>\n                <g id=\"7.Icon/arrow/15.down/fill\" transform=\"translate(17.000000, 6.000000) rotate(270.000000) translate(-17.000000, -6.000000) translate(11.000000, 0.000000)\" fill=\"#000000\" fill-rule=\"nonzero\" opacity=\"0.65\">\n                    <path d=\"M7.25020811,6.37218077 L4.91348936,8.20968077 C4.82677061,8.27764952 4.69903624,8.21671202 4.69903624,8.10655577 L4.69903624,4.43272764 C4.69903624,4.32257139 4.82677061,4.26046202 4.91348936,4.32960264 L7.25020811,6.16593077 C7.31700499,6.21866514 7.31700499,6.31944639 7.25020811,6.37218077 Z\" id=\"fill\" transform=\"translate(5.999671, 6.269385) rotate(90.000000) translate(-5.999671, -6.269385) \"></path>\n                </g>\n            </g>\n            <line x1=\"286.5\" y1=\"813\" x2=\"286.5\" y2=\"864.5\" id=\"\u8DEF\u5F84-2\u5907\u4EFD-3\" stroke=\"#000000\" opacity=\"0.25\"></line>\n        </g>\n    </g>\n</svg>";
var Minus = "<svg t=\"1557140120188\" class=\"icon\" style=\"\" viewBox=\"0 0 1024 1024\" version=\"1.1\"\nxmlns=\"http://www.w3.org/2000/svg\" p-id=\"16909\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\nwidth=\"200\" height=\"200\">\n\t<defs>\n\t\t<style type=\"text/css\">\n\t\t</style>\n\t</defs>\n\t<path d=\"M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z\"\n\tp-id=\"16910\">\n\t</path>\n\t<path d=\"M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z\"\n\tp-id=\"16911\">\n\t</path>\n</svg>";
var Plus = "<svg t=\"1557140186692\" class=\"icon\" style=\"\" viewBox=\"0 0 1024 1024\" version=\"1.1\"\nxmlns=\"http://www.w3.org/2000/svg\" p-id=\"17025\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\nwidth=\"200\" height=\"200\">\n\t<defs>\n\t\t<style type=\"text/css\">\n\t\t</style>\n\t</defs>\n\t<path d=\"M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z\"\n\tp-id=\"17026\">\n\t</path>\n\t<path d=\"M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z\"\n\tp-id=\"17027\">\n\t</path>\n</svg>";
var SortDownSelected = "<svg t=\"1565940955886\" class=\"icon\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\n     p-id=\"17472\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"200\" height=\"200\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path\n    d=\"M948 392.992l-403.008 488.99200001Q532 896 512.992 896t-32-14.016L76 392.992q-18.016-20.992-7.008-46.016T108 321.98400001L916 321.98400001q28 0 39.008 24.99199999T948 392.992z\"\n    p-id=\"17473\" data-spm-anchor-id=\"a313x.7781069.0.i2\" class=\"selected\"></path>\n</svg>\n";
var SortDown = "<svg t=\"1565940955886\" class=\"icon\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\n     p-id=\"17472\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"200\" height=\"200\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path\n    fill-opacity=\"0.45\"\n    d=\"M948 392.992l-403.008 488.99200001Q532 896 512.992 896t-32-14.016L76 392.992q-18.016-20.992-7.008-46.016T108 321.98400001L916 321.98400001q28 0 39.008 24.99199999T948 392.992z\"\n    p-id=\"17473\" data-spm-anchor-id=\"a313x.7781069.0.i2\" class=\"selected\"></path>\n</svg>\n";
var SortUpSelected = "<svg t=\"1565940979768\" class=\"icon\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\np-id=\"17620\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"200\" height=\"200\">\n<defs>\n<style type=\"text/css\"></style>\n</defs>\n<path\nd=\"M76 631.008l403.008-488.99200001Q492 128 511.008 128t32 14.016L948 631.008q18.016 20.992 7.008 46.016T916 702.01599999L108 702.01599999q-28 0-39.008-24.99199999T76 631.008z\"\np-id=\"17621\"></path>\n</svg>\n";
var SortUp = "<svg t=\"1565940979768\" class=\"icon\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\n     p-id=\"17620\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"200\" height=\"200\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path\n    fill-opacity=\"0.45\"\n    d=\"M76 631.008l403.008-488.99200001Q492 128 511.008 128t32 14.016L948 631.008q18.016 20.992 7.008 46.016T916 702.01599999L108 702.01599999q-28 0-39.008-24.99199999T76 631.008z\"\n    p-id=\"17621\"></path>\n</svg>\n";
var Trend = "<?xml version=\"1.0\" standalone=\"no\"?><!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\"><svg t=\"1596433821690\" class=\"icon\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" p-id=\"20229\" width=\"16\" height=\"16\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><style type=\"text/css\"></style></defs><path d=\"M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6c-3.1-3.1-8.2-3.1-11.3 0l-230 229.9L461.4 404c-3.1-3.1-8.2-3.1-11.3 0L266.3 586.7c-3.1 3.1-3.1 8.2 0 11.3l39.5 39.7z\" p-id=\"20230\"></path></svg>";
var DrillDownIcon = "<?xml version=\"1.0\" standalone=\"no\"?><!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\"><svg t=\"1608030723688\" class=\"icon\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" p-id=\"21482\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"16\" height=\"16\"><defs><style type=\"text/css\"></style></defs><path d=\"M547.648 696a32 32 0 0 1 31.488 26.24l0.512 5.76v151.68l145.216-144.512a32 32 0 0 1 40.832-3.648l4.416 3.712a32 32 0 0 1 3.584 40.832l-3.712 4.48-203.072 202.24a32 32 0 0 1-40.768 3.648l-4.416-3.712-202.24-202.24a32 32 0 0 1 40.832-48.96l4.416 3.712 150.912 150.912v-158.144a32 32 0 0 1 32-32z m194.56-529.28l4.928 3.072 233.792 180.224a32 32 0 0 1 1.728 49.28l-4.864 3.52-409.792 245.568a32 32 0 0 1-27.328 2.624l-5.184-2.432-422.4-245.568a32 32 0 0 1-7.552-49.28l4.544-4.032 242.816-180.288a32 32 0 0 1 42.432 47.552l-4.288 3.84-203.84 151.296 364.16 211.648 353.28-211.712-196.608-151.552a32 32 0 0 1-8.896-40l3.136-4.864a32 32 0 0 1 40-8.96zM547.712 28.672a32 32 0 0 1 31.488 26.24l0.512 5.76v396.992a32 32 0 0 1-63.488 5.76l-0.512-5.76V60.736a32 32 0 0 1 32-32z\" p-id=\"21483\" fill=\"currentColor\"></path></svg>\n";
var EyeOutlined = "<svg viewBox=\"64 64 896 896\" focusable=\"false\" data-icon=\"eye\" width=\"1em\" height=\"1em\" fill=\"currentColor\" aria-hidden=\"true\"><path d=\"M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z\"></path></svg>";

// 不本地直接引用svg，避免下游无依赖

var InternalSvgIcons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ArrowDown: ArrowDown,
  ArrowUp: ArrowUp,
  CellDown: CellDown,
  CellUp: CellUp,
  GlobalAsc: GlobalAsc,
  GlobalDesc: GlobalDesc,
  GroupAsc: GroupAsc,
  GroupDesc: GroupDesc,
  GroupNone: GroupNone,
  Minus: Minus,
  Plus: Plus,
  SortDown: SortDown,
  SortUp: SortUp,
  SortDownSelected: SortDownSelected,
  SortUpSelected: SortUpSelected,
  InfoCircle: InfoCircle,
  ExpandColIcon: ExpandColIcon,
  Trend: Trend,
  DrillDownIcon: DrillDownIcon,
  EyeOutlined: EyeOutlined
});

// 所有的 Icon 缓存
var SVGMap = {};
var registerIcon = function (name, svg) {
    SVGMap[lowerCase(name)] = svg;
};
var getIcon = function (name) {
    return SVGMap[lowerCase(name)];
};
// 缓存内置 Icon 信息
keys(InternalSvgIcons).forEach(function (name) {
    registerIcon(name, InternalSvgIcons[name]);
});

var STYLE_PLACEHOLDER = '<svg';
// Image 缓存
var ImageCache = {};
/**
 * 使用 iconfont 上的 svg 来创建 Icon
 */
var GuiIcon = /** @class */ (function (_super) {
    __extends(GuiIcon, _super);
    function GuiIcon(cfg) {
        var _this = _super.call(this, cfg) || this;
        _this.hasSupportSuffix = function (image) {
            return ['.png', '.jpg', '.gif', '.svg'].some(function (suffix) {
                return image === null || image === void 0 ? void 0 : image.endsWith(suffix);
            });
        };
        _this.render();
        return _this;
    }
    // 获取 Image 实例，使用缓存，以避免滚动时因重复的 new Image() 耗时导致的闪烁问题
    /* 异步获取 image 实例 */
    GuiIcon.prototype.getImage = function (name, cacheKey, fill) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var img = new Image();
            // 成功
            img.onload = function () {
                ImageCache[cacheKey] = img;
                resolve(img);
            };
            // 失败
            img.onerror = function (e) {
                reject(e);
            };
            var svg = getIcon(name);
            // 兼容三种情况
            // 1、base 64
            // 2、svg本地文件（兼容老方式，可以改颜色）
            // 3、线上支持的图片地址
            if (svg &&
                (svg.includes('data:image/svg+xml') || _this.hasSupportSuffix(svg))) {
                // 传入 base64 字符串
                // 或者 online 链接
                img.src = svg;
            }
            else if (svg) {
                // 传入 svg 字符串（支持颜色fill）
                if (fill) {
                    // 如果有fill，移除原来的 fill
                    // 这里有一个潜在的问题，不同的svg里面的schema不尽相同，导致这个正则考虑不全
                    // 1、fill='' 2、fill 3、fill-***(不需要处理)
                    // eslint-disable-next-line no-useless-escape
                    svg = svg.replace(/fill=[\'\"]#?\w+[\'\"]/g, ''); // 移除 fill="red|#fff"
                    svg = svg.replace(/fill>/g, '>'); // fill> 替换为 >
                }
                // https://www.chromestatus.com/features/5656049583390720
                // # 井号不能当做svg的body，这个bug在chrome72已经修复.
                svg = svg
                    .replace(STYLE_PLACEHOLDER, "".concat(STYLE_PLACEHOLDER, " fill=\"").concat(fill, "\""))
                    .replace(/#/g, '%23');
                img.src = "data:image/svg+xml;utf-8,".concat(svg);
            }
        });
    };
    GuiIcon.prototype.render = function () {
        var _this = this;
        var _a = this.cfg, name = _a.name, fill = _a.fill;
        var attrs = clone(this.cfg);
        var image = new Shape.Image({
            attrs: omit(attrs, 'fill'),
        });
        var cacheKey = "".concat(name, "-").concat(fill);
        var img = ImageCache[cacheKey];
        if (img) {
            // already in cache
            image.attr('img', img);
            this.addShape('image', image);
        }
        else {
            this.getImage(name, cacheKey, fill)
                .then(function (value) {
                image.attr('img', value);
                _this.addShape('image', image);
            })
                .catch(function (err) {
                // eslint-disable-next-line no-console
                console.warn("GuiIcon ".concat(name, " load error"), err);
            });
        }
        this.image = image;
    };
    return GuiIcon;
}(Group));

var CellBorderPosition;
(function (CellBorderPosition) {
    CellBorderPosition["TOP"] = "TOP";
    CellBorderPosition["BOTTOM"] = "BOTTOM";
    CellBorderPosition["LEFT"] = "LEFT";
    CellBorderPosition["RIGHT"] = "RIGHT";
})(CellBorderPosition || (CellBorderPosition = {}));
var EAggregation;
(function (EAggregation) {
    EAggregation["SUM"] = "SUM";
})(EAggregation || (EAggregation = {}));

// 角头 node 类型
var CornerNodeType;
(function (CornerNodeType) {
    CornerNodeType["Row"] = "row";
    CornerNodeType["Col"] = "col";
    CornerNodeType["Series"] = "series";
})(CornerNodeType || (CornerNodeType = {}));

/**
 * Store something in {@link SpreadSheet} temporary along with it's lifecycle
 * All the keys need be declare in {@see StoreKey} first
 */
var Store = /** @class */ (function () {
    function Store() {
        this.store = new Map();
    }
    Store.prototype.set = function (key, value) {
        this.store.set(key, value);
    };
    Store.prototype.get = function (key, defaultValue) {
        var _a;
        var value = this.store.get(key);
        return (_a = value) !== null && _a !== void 0 ? _a : defaultValue;
    };
    Store.prototype.clear = function () {
        this.store.clear();
    };
    Store.prototype.size = function () {
        return this.store.size;
    };
    return Store;
}());

var getListBySorted = function (list, sorted) {
    return list.sort(function (a, b) {
        var ia = sorted.indexOf(a);
        var ib = sorted.indexOf(b);
        if (ia === -1 && ib === -1) {
            return 0;
        }
        if (ia === -1) {
            return 1;
        }
        if (ib === -1) {
            return -1;
        }
        return ia - ib;
    });
};
var filterUndefined = function (values) {
    return filter(values, function (t) { return !isUndefined(t) && t !== 'undefined'; });
};
var flattenDeep = function (data) {
    var _a;
    return (_a = keys(data)) === null || _a === void 0 ? void 0 : _a.reduce(function (pre, next) {
        var item = get(data, next);
        if (Array.isArray(item)) {
            pre = pre.concat(flattenDeep(item));
        }
        else {
            pre === null || pre === void 0 ? void 0 : pre.push(item);
        }
        return pre;
    }, []);
};
var flatten = function (data) {
    var _a;
    var result = [];
    if (Array.isArray(data)) {
        (_a = keys(data)) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
            var _a, _b;
            var current = get(data, item);
            if ((_a = keys(current)) === null || _a === void 0 ? void 0 : _a.includes('undefined')) {
                (_b = keys(current)) === null || _b === void 0 ? void 0 : _b.forEach(function (ki) {
                    result.push(current[ki]);
                });
            }
            else {
                result = result.concat(current);
            }
        });
    }
    else {
        result = result.concat(data);
    }
    return result;
};
var isEveryUndefined = function (data) {
    return data === null || data === void 0 ? void 0 : data.every(function (item) { return isUndefined(item); });
};
var getFieldKeysByDimensionValues = function (dimensionValues, dimensions) {
    var result = [];
    dimensionValues === null || dimensionValues === void 0 ? void 0 : dimensionValues.forEach(function (item, index) {
        if (item === undefined) {
            if (dimensions[index]) {
                result.push(dimensions[index]);
            }
        }
    });
    return result;
};
/**
 * arr1包含arr2，将arr2排到最后
 *
 */
var sortByItems = function (arr1, arr2) {
    var _a;
    return (_a = arr1 === null || arr1 === void 0 ? void 0 : arr1.filter(function (item) { return !(arr2 === null || arr2 === void 0 ? void 0 : arr2.includes(item)); })) === null || _a === void 0 ? void 0 : _a.concat(arr2);
};
/**
 * 判断是普通单元格数据还是总计或小计
 * @param ids
 * @param data
 * @returns
 */
var isTotalData = function (ids, data) {
    return !every(ids, function (id) { return data[id]; });
};
/**
 * split total data from origin list data.
 */
function splitTotal(rawData, fields) {
    var rows = fields.rows, columns = fields.columns;
    return reduce(rawData, function (result, data) {
        if (isTotalData([].concat(rows).concat(columns), data)) {
            result.push(data);
        }
        return result;
    }, []);
}
function getAggregationAndCalcFuncByQuery(totalsStatus, totalsOptions) {
    var isRowTotal = totalsStatus.isRowTotal, isRowSubTotal = totalsStatus.isRowSubTotal, isColTotal = totalsStatus.isColTotal, isColSubTotal = totalsStatus.isColSubTotal;
    var _a = totalsOptions || {}, row = _a.row, col = _a.col;
    var _b = row || {}, _c = _b.calcTotals, rowCalcTotals = _c === void 0 ? {} : _c, _d = _b.calcSubTotals, rowCalcSubTotals = _d === void 0 ? {} : _d;
    var _e = col || {}, _f = _e.calcTotals, colCalcTotals = _f === void 0 ? {} : _f, _g = _e.calcSubTotals, colCalcSubTotals = _g === void 0 ? {} : _g;
    var getCalcTotals = function (dimensionTotals, totalType) {
        if ((dimensionTotals.aggregation || dimensionTotals.calcFunc) &&
            totalType) {
            return {
                aggregation: dimensionTotals.aggregation,
                calcFunc: dimensionTotals.calcFunc,
            };
        }
    };
    // 优先级: 列总计/小计 > 行总计/小计
    return (getCalcTotals(colCalcTotals, isColTotal) ||
        getCalcTotals(colCalcSubTotals, isColSubTotal) ||
        getCalcTotals(rowCalcTotals, isRowTotal) ||
        getCalcTotals(rowCalcSubTotals, isRowSubTotal));
}

var FORMATTERS = {
    en_US: ['KMBTP'.split(''), [1e3, 1e3, 1e3, 1e3, 1e3]],
    zh_CN: [
        ['万', '亿'],
        [10000, 1e4],
    ],
};
/**
 * 自动格式化
 * 规则
 *  1，小于1w，使用逗号分割，例如 3,459
 *  2，大于1w，使用语义化，例如 3.2万，3.4亿 2,234万
 * @param v
 * @param fixed
 * @param formatter
 */
var auto = function (v, fixed, formatter) {
    if (fixed === void 0) { fixed = 2; }
    if (formatter === void 0) { formatter = FORMATTERS[Lang] || FORMATTERS.zh_CN; }
    if (typeof v !== 'number' || isNaN(v)) {
        return '';
    }
    // let n = Math.abs(v); // abs什么鬼。
    var n = v;
    // 语义化
    var _a = __read(formatter, 2), texts = _a[0], powers = _a[1];
    var loop = 0;
    var power;
    var running = true;
    while (running) {
        power = powers[loop];
        if (n >= power && loop < texts.length) {
            n /= power;
        }
        else {
            running = false;
        }
        loop += 1;
    }
    // parseFloat 解决 toFixed 出现很多 0 结尾。
    // 举例：123.toFixed(2) = '123.00'，需要返回 '123'
    n = parseFloat(n.toFixed(fixed));
    // 千分位
    var output = n >= 1000 ? n.toLocaleString('en') : "".concat(n);
    // 加上最后的单位
    return loop === 0 ? output : "".concat(output, " ").concat(texts[loop - 1]);
};
// 简单处理小数精度误差，保持和Spreadsheet统一逻辑
// 技术细节：https://juejin.im/post/5ce373d651882532e409ea96
var parseNumberWithPrecision = function (value) {
    return Number.parseFloat((toNumber(value) || 0).toPrecision(PRECISION));
};

var transformCustomTreeItems = function (itemConfig) {
    if (itemConfig) {
        return itemConfig.map(function (config) {
            return {
                key: config.key,
                title: config.title,
                children: transformCustomTreeItems(config.children),
                collapsed: config.collapsed,
                description: config.description,
            };
        });
    }
    return [];
};

function renderRect(group, attrs) {
    var _a;
    return (_a = group === null || group === void 0 ? void 0 : group.addShape) === null || _a === void 0 ? void 0 : _a.call(group, 'rect', {
        zIndex: 1,
        attrs: attrs,
    });
}
function renderPolygon(group, attrs) {
    var _a;
    return (_a = group === null || group === void 0 ? void 0 : group.addShape) === null || _a === void 0 ? void 0 : _a.call(group, 'polygon', {
        attrs: attrs,
    });
}
function renderText(group, shapes, x, y, text, textStyle, extraStyle) {
    var _a;
    if (!isEmpty(shapes) && group) {
        forEach(shapes, function (shape) {
            if (group.contain(shape))
                group.removeChild(shape, true);
        });
    }
    return (_a = group === null || group === void 0 ? void 0 : group.addShape) === null || _a === void 0 ? void 0 : _a.call(group, 'text', {
        attrs: __assign(__assign({ x: x, y: y, text: text }, textStyle), extraStyle),
    });
}
function renderLine(group, coordinate, lineStyle) {
    var _a;
    return (_a = group === null || group === void 0 ? void 0 : group.addShape) === null || _a === void 0 ? void 0 : _a.call(group, 'line', {
        zIndex: 100,
        attrs: __assign(__assign({}, coordinate), lineStyle),
    });
}
function updateShapeAttr(shape, attribute, value) {
    if (shape) {
        set(shape, "attrs.".concat(attribute), value);
    }
}
function updateFillOpacity(shape, opacity) {
    updateShapeAttr(shape, 'fillOpacity', opacity);
}
function updateStrokeOpacity(shape, opacity) {
    updateShapeAttr(shape, 'strokeOpacity', opacity);
}
function renderIcon(group, iconCfg) {
    var iconShape = new GuiIcon(iconCfg);
    group === null || group === void 0 ? void 0 : group.add(iconShape);
    return iconShape;
}
function renderTreeIcon(group, area, fill, isCollapse, onClick) {
    var icon = new GuiIcon(__assign(__assign({ name: isCollapse ? 'Plus' : 'Minus' }, area), { fill: fill }));
    if (isFunction(onClick)) {
        icon.on('click', onClick);
    }
    group === null || group === void 0 ? void 0 : group.add(icon);
    return icon;
}

var canvas = document.createElement('canvas');
var ctx = canvas.getContext('2d');
/**
 * 计算文本在画布中的宽度
 */
var measureTextWidth = memoize(function (text, font) {
    if (text === void 0) { text = ''; }
    if (!font) {
        return 0;
    }
    var _a = font, fontSize = _a.fontSize, fontFamily = _a.fontFamily, fontWeight = _a.fontWeight, fontStyle = _a.fontStyle, fontVariant = _a.fontVariant;
    // copy G 里面的处理逻辑
    ctx.font = [fontStyle, fontVariant, fontWeight, "".concat(fontSize, "px"), fontFamily]
        .join(' ')
        .trim();
    return ctx.measureText("".concat(text)).width;
}, function (text, font) { return __spreadArray([text], __read(values(font)), false).join(''); });
/**
 * 获取文本的 ... 文本。
 * 算法（减少每次 measureText 的长度，measureText 的性能跟字符串时间相关）：
 * 1. 先通过 STEP 逐步计算，找到最后一个小于 maxWidth 的字符串
 * 2. 然后对最后这个字符串二分计算
 * @param text 需要计算的文本, 由于历史原因 除了支持string，还支持空值,number和数组等
 * @param maxWidth
 * @param font
 */
var getEllipsisTextInner = function (text, maxWidth, font) {
    var STEP = 16; // 每次 16，调参工程师
    var DOT_WIDTH = measureTextWidth('...', font);
    var leftText;
    if (!isString(text)) {
        leftText = toString(text);
    }
    else {
        leftText = text;
    }
    var leftWidth = maxWidth;
    var r = []; // 最终的分段字符串
    var currentText;
    var currentWidth;
    if (measureTextWidth(text, font) <= maxWidth) {
        return text;
    }
    var runningStep1 = true;
    // 首先通过 step 计算，找出最大的未超出长度的
    while (runningStep1) {
        // 更新字符串
        currentText = leftText.substr(0, STEP);
        // 计算宽度
        currentWidth = measureTextWidth(currentText, font);
        // 超出剩余宽度，则停止
        if (currentWidth + DOT_WIDTH > leftWidth) {
            if (currentWidth > leftWidth) {
                runningStep1 = false;
                break;
            }
        }
        r.push(currentText);
        // 没有超出，则计算剩余宽度
        leftWidth -= currentWidth;
        leftText = leftText.substr(STEP);
        // 字符串整体没有超出
        if (!leftText) {
            return r.join('');
        }
    }
    var runningStep2 = true;
    // 最下的最后一个 STEP，使用 1 递增（用二分效果更高）
    while (runningStep2) {
        // 更新字符串
        currentText = leftText.substr(0, 1);
        // 计算宽度
        currentWidth = measureTextWidth(currentText, font);
        // 超出剩余宽度，则停止
        if (currentWidth + DOT_WIDTH > leftWidth) {
            runningStep2 = false;
            break;
        }
        r.push(currentText);
        // 没有超出，则计算剩余宽度
        leftWidth -= currentWidth;
        leftText = leftText.substr(1);
        if (!leftText) {
            return r.join('');
        }
    }
    return "".concat(r.join(''), "...");
};
/**
 * 追求性能，粗略的计算文本的宽高！
 *
 * 算法逻辑：
 * 计算一个字符串中，符号[0-255]，中文（其他）的个数
 * 然后分别乘以中文、符号的宽度
 * @param text
 * @param font
 */
var measureTextWidthRoughly = function (text, font) {
    var e_1, _a;
    if (font === void 0) { font = {}; }
    var alphaWidth = measureTextWidth('a', font);
    var chineseWidth = measureTextWidth('蚂', font);
    var w = 0;
    if (!text) {
        return w;
    }
    try {
        // eslint-disable-next-line no-restricted-syntax
        for (var text_1 = __values(text), text_1_1 = text_1.next(); !text_1_1.done; text_1_1 = text_1.next()) {
            var char = text_1_1.value;
            var code = char.charCodeAt(0);
            // /[\u0000-\u00ff]/
            w += code >= 0 && code <= 255 ? alphaWidth : chineseWidth;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (text_1_1 && !text_1_1.done && (_a = text_1.return)) _a.call(text_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return w;
};
/**
 * @desc 改良版 获取文本的 ... 文本（可传入 优先文本片段）
 * @param text 需要计算的文本
 * @param maxWidth
 * @param font optional 文本字体 或 优先显示的文本
 * @param priority optional 优先显示的文本
 */
var getEllipsisText = function (_a) {
    var text = _a.text, maxWidth = _a.maxWidth, fontParam = _a.fontParam, priorityParam = _a.priorityParam, placeholder = _a.placeholder;
    var font = {};
    var empty = placeholder !== null && placeholder !== void 0 ? placeholder : EMPTY_PLACEHOLDER;
    // [null, undefined, ''] will return empty
    var finalText = isNil(text) || text === '' ? empty : "".concat(text);
    var priority = priorityParam;
    if (fontParam && isArray(fontParam)) {
        priority = fontParam;
    }
    else {
        font = fontParam || {};
    }
    if (!priority || !priority.length) {
        return getEllipsisTextInner(finalText, maxWidth, font);
    }
    var leftSubTexts = [];
    var subTexts = [finalText];
    priority.forEach(function (priorityItem) {
        subTexts.forEach(function (tempSubText, index) {
            // 处理 leftText
            var startIdx = -1;
            var matched = tempSubText.match(new RegExp(priorityItem));
            if (matched) {
                var matchedText = matched[0];
                startIdx = matched.index;
                leftSubTexts.push(matchedText);
                var endIdx = startIdx + matchedText.length;
                var left = tempSubText.slice(0, startIdx);
                var right = tempSubText.slice(endIdx);
                var tmp = [left, right].filter(function (v) { return !!v; });
                subTexts.splice.apply(subTexts, __spreadArray([index, 1], __read(tmp), false));
            }
        });
    });
    // original text is split into serval texts by priority
    subTexts = leftSubTexts.concat(subTexts);
    var result = finalText;
    var DOT_WIDTH = measureTextWidth('...', font);
    var remainWidth = maxWidth;
    subTexts.forEach(function (subText) {
        if (remainWidth <= 0) {
            var originIdx = result.indexOf(subText);
            var prev = result.slice(originIdx - 3, originIdx);
            if (prev && prev !== '...') {
                var subWidth = measureTextWidth(subText, font);
                // fix-边界处理: when subWidth <= DOT_WIDTH 不做 ... 处理
                result = result.replace(subText, subWidth > DOT_WIDTH ? '...' : subText);
            }
            else {
                result = result.replace(subText, '');
            }
            remainWidth -= DOT_WIDTH;
        }
        else {
            var subWidth = measureTextWidth(subText, font);
            // fix-边界处理: when subWidth <= DOT_WIDTH 不做 ... 处理
            if (remainWidth < subWidth && subWidth > DOT_WIDTH) {
                var ellipsis = getEllipsisTextInner(subText, remainWidth, font);
                result = result.replace(subText, ellipsis);
                remainWidth = 0;
            }
            else {
                remainWidth -= subWidth;
            }
        }
    });
    return result;
};
/**
 * To decide whether the data is positive or negative.
 * Two cases needed to be considered since  the derived value could be number or string.
 * @param value
 * @param font
 */
var isUpDataValue = function (value) {
    if (isNumber(value)) {
        return value >= 0;
    }
    return !!value && !trim(value).startsWith('-');
};
var calX = function (x, paddingRight, total) {
    var extra = total || 0;
    return x + paddingRight / 2 + extra;
};
var getTextStyle = function (rowIndex, colIndex, meta, data, dataCellTheme, textCondition) {
    var isTotals = meta.isTotals;
    var textStyle = isTotals ? dataCellTheme.bolderText : dataCellTheme.text;
    var fill = textStyle.fill;
    if (textCondition === null || textCondition === void 0 ? void 0 : textCondition.mapping) {
        fill = textCondition === null || textCondition === void 0 ? void 0 : textCondition.mapping(data, {
            rowIndex: rowIndex,
            colIndex: colIndex,
        }).fill;
    }
    return __assign(__assign({}, textStyle), { fill: fill });
};
/**
 * @desc draw text shape of object
 * @param cell
 * @multiData 自定义文本内容
 * @disabledConditions 是否禁用条件格式
 */
var drawObjectText = function (cell, multiData, disabledConditions) {
    var _a;
    var _b = cell.getContentArea(), x = _b.x, y = _b.y, height = _b.height, width = _b.width;
    var text = multiData || cell.getMeta().fieldValue;
    var valuesCfg = (cell === null || cell === void 0 ? void 0 : cell.getMeta().spreadsheet.options.style.cellCfg).valuesCfg;
    var textCondition = disabledConditions ? null : (_a = valuesCfg === null || valuesCfg === void 0 ? void 0 : valuesCfg.conditions) === null || _a === void 0 ? void 0 : _a.text;
    var widthPercentCfg = valuesCfg === null || valuesCfg === void 0 ? void 0 : valuesCfg.widthPercentCfg;
    var dataCellStyle = cell.getStyle(CellTypes.DATA_CELL);
    var padding = dataCellStyle.cell.padding;
    var totalTextWidth = width - padding.left - padding.right;
    var totalTextHeight = height - padding.top - padding.top;
    var realHeight = totalTextHeight / (text.values.length + 1);
    var labelHeight = 0;
    // 绘制单元格主标题
    if (text === null || text === void 0 ? void 0 : text.label) {
        labelHeight = realHeight / 2;
        var labelStyle = dataCellStyle.bolderText;
        renderText(cell, [], calX(x, padding.right), y + labelHeight, getEllipsisText({
            text: text.label,
            maxWidth: width - padding.left,
            fontParam: labelStyle,
        }), labelStyle);
    }
    // 绘制指标
    var textValues = text.values;
    var curText;
    var curX;
    var curY = y + realHeight / 2;
    var curWidth;
    var totalWidth = 0;
    for (var i = 0; i < textValues.length; i += 1) {
        curY = y + realHeight * (i + 1) + labelHeight; // 加上label的高度
        totalWidth = 0;
        for (var j = 0; j < textValues[i].length; j += 1) {
            curText = textValues[i][j];
            var curStyle = getTextStyle(i, j, cell === null || cell === void 0 ? void 0 : cell.getMeta(), curText, dataCellStyle, textCondition);
            curWidth = !isEmpty(widthPercentCfg)
                ? totalTextWidth * (widthPercentCfg[j] / 100)
                : totalTextWidth / text.values[0].length; // 指标个数相同，任取其一即可
            curX = calX(x, padding.right, totalWidth);
            totalWidth += curWidth;
            renderText(cell, [], curX, curY, getEllipsisText({
                text: curText,
                maxWidth: curWidth,
                fontParam: curStyle,
                placeholder: cell === null || cell === void 0 ? void 0 : cell.getMeta().spreadsheet.options.placeholder,
            }), curStyle);
        }
    }
};
/**
 * 根据 cellCfg 配置获取当前单元格宽度
 */
var getCellWidth = function (cellCfg) {
    var width = cellCfg.width;
    var cellWidth = width;
    // TODO 根据当前列的指标个数返回列宽
    return cellWidth;
};
var safeJsonParse = function (val) {
    try {
        return JSON.parse(val);
    }
    catch (err) {
        return false;
    }
};

function getCsvString(v) {
    if (!v)
        return v;
    if (typeof v === 'string') {
        var out = v;
        // 需要替换", https://en.wikipedia.org/wiki/Comma-separated_values#Example
        return "\"".concat(out.replace(/"/g, '""'), "\"");
    }
    return "\"".concat(v, "\"");
}

var copyToClipboardByExecCommand = function (str) {
    return new Promise(function (resolve, reject) {
        var textarea = document.createElement('textarea');
        textarea.value = str;
        document.body.appendChild(textarea);
        textarea.select();
        var success = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (success) {
            resolve();
        }
        else {
            reject();
        }
    });
};
var copyToClipboardByClipboard = function (str) {
    return navigator.clipboard.writeText(str);
};
var copyToClipboard = function (str) {
    if (!navigator.clipboard) {
        return copyToClipboardByExecCommand(str);
    }
    return copyToClipboardByClipboard(str);
};
var download = function (str, fileName) {
    try {
        var link = document.createElement('a');
        link.download = "".concat(fileName, ".csv");
        // Avoid errors in Chinese encoding.
        var dataBlob = new Blob(["\uFEFF".concat(str)], {
            type: 'text/csv;charset=utf-8',
        });
        link.href = URL.createObjectURL(dataBlob);
        link.click();
        URL.revokeObjectURL(link.href);
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
/*
 * Process the multi-measure with multi-lines
 * For Grid-analysis-sheet
 * use the ' ' to divide different measures in the same line
 * use the '$' to divide different lines
 */
var processObjectValueInCol = function (data) {
    var tempCells = (data === null || data === void 0 ? void 0 : data.label) ? [data === null || data === void 0 ? void 0 : data.label] : [];
    var values = data === null || data === void 0 ? void 0 : data.values;
    if (!isEmpty(values)) {
        forEach(values, function (value) {
            tempCells.push(value.join(' '));
        });
    }
    return tempCells.join('$');
};
/*
 * Process the multi-measure with single-lines
 * For StrategySheet
 */
var processObjectValueInRow = function (data, isFormat) {
    var _a, _b, _c, _d;
    if (!isFormat) {
        return (_b = (_a = data === null || data === void 0 ? void 0 : data.originalValues) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : (_c = data === null || data === void 0 ? void 0 : data.values) === null || _c === void 0 ? void 0 : _c[0];
    }
    return (_d = data === null || data === void 0 ? void 0 : data.values) === null || _d === void 0 ? void 0 : _d[0];
};
/* Process the data in detail mode. */
var processValueInDetail = function (sheetInstance, split, isFormat) {
    var e_1, _a;
    var _b;
    var data = sheetInstance.dataSet.getDisplayDataSet();
    var columns = ((_b = sheetInstance.dataCfg) === null || _b === void 0 ? void 0 : _b.fields).columns;
    var res = [];
    var _loop_1 = function (index, record) {
        var tempRows = [];
        if (!isFormat) {
            tempRows = columns.map(function (v) { return getCsvString(record[v]); });
        }
        else {
            tempRows = columns.map(function (v) {
                var mainFormatter = sheetInstance.dataSet.getFieldFormatter(v);
                return getCsvString(mainFormatter(record[v], record));
            });
        }
        if (sheetInstance.options.showSeriesNumber) {
            tempRows = [getCsvString(index + 1)].concat(tempRows);
        }
        res.push(tempRows.join(split));
    };
    try {
        for (var _c = __values(data.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var _e = __read(_d.value, 2), index = _e[0], record = _e[1];
            _loop_1(index, record);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return res;
};
/* Process the data when the value position is on the columns.  */
var processValueInCol = function (viewMeta, sheetInstance, isFormat) {
    if (!viewMeta) {
        // If the meta equals null, replacing it with blank line.
        return '';
    }
    var fieldValue = viewMeta.fieldValue, valueField = viewMeta.valueField, data = viewMeta.data;
    if (isObject(fieldValue)) {
        return processObjectValueInCol(fieldValue);
    }
    if (!isFormat) {
        return "".concat(fieldValue);
    }
    var mainFormatter = sheetInstance.dataSet.getFieldFormatter(valueField);
    return mainFormatter(fieldValue, data);
};
/* Process the data when the value position is on the rows. */
var processValueInRow = function (viewMeta, sheetInstance, isFormat) {
    var tempCells = [];
    if (viewMeta) {
        var fieldValue = viewMeta.fieldValue, valueField = viewMeta.valueField, data = viewMeta.data;
        if (isObject(fieldValue)) {
            tempCells = processObjectValueInRow(fieldValue, isFormat);
            return tempCells;
        }
        // The main measure.
        if (!isFormat) {
            tempCells.push(fieldValue);
        }
        else {
            var mainFormatter = sheetInstance.dataSet.getFieldFormatter(valueField);
            tempCells.push(mainFormatter(fieldValue, data));
        }
    }
    else {
        // If the meta equals null then it will be replaced by '-'.
        tempCells.push(sheetInstance.options.placeholder);
    }
    return tempCells.join('    ');
};
/* Get the label name for the header. */
var getHeaderLabel = function (val) {
    var label = safeJsonParse(val);
    if (isArray(label)) {
        return label;
    }
    return val;
};
/**
 * 当列头label存在数组情况，需要将其他层级补齐空格
 * eg [ ['数值', '环比'], '2021'] => [ ['数值', '环比'], ['2021', '']
 */
var processColHeaders = function (headers, arrayLength) {
    var result = headers.map(function (header) {
        return header.map(function (item) {
            return isArray(item) ? item : __spreadArray([item], __read(new Array(arrayLength - 1)), false);
        });
    });
    return result;
};
/**
 * Copy data
 * @param sheetInstance
 * @param isFormat
 * @param split
 */
var copyData = function (sheetInstance, split, isFormat) {
    var e_2, _a, e_3, _b;
    var _c;
    var _d = (_c = sheetInstance === null || sheetInstance === void 0 ? void 0 : sheetInstance.facet) === null || _c === void 0 ? void 0 : _c.layoutResult, rowsHierarchy = _d.rowsHierarchy, rowLeafNodes = _d.rowLeafNodes, colLeafNodes = _d.colLeafNodes, getCellMeta = _d.getCellMeta;
    var maxLevel = rowsHierarchy.maxLevel;
    var valueInCols = sheetInstance.dataCfg.fields.valueInCols;
    // Generate the table header.
    var rowsHeader = rowsHierarchy.sampleNodesForAllLevels.map(function (item) {
        return sheetInstance.dataSet.getFieldName(item.key);
    });
    // get max query property length
    var rowLength = rowLeafNodes.reduce(function (pre, cur) {
        var length = cur.query ? Object.keys(cur.query).length : 0;
        return length > pre ? length : pre;
    }, 0);
    // Generate the table body.
    var detailRows = [];
    var maxRowLength = 0;
    if (!sheetInstance.isPivotMode()) {
        detailRows = processValueInDetail(sheetInstance, split, isFormat);
    }
    else {
        // Filter out the related row head leaf nodes.
        var caredRowLeafNodes = rowLeafNodes.filter(function (row) { return row.height !== 0; });
        try {
            for (var caredRowLeafNodes_1 = __values(caredRowLeafNodes), caredRowLeafNodes_1_1 = caredRowLeafNodes_1.next(); !caredRowLeafNodes_1_1.done; caredRowLeafNodes_1_1 = caredRowLeafNodes_1.next()) {
                var rowNode = caredRowLeafNodes_1_1.value;
                // Removing the space at the beginning of the line of the label.
                rowNode.label = trim(rowNode === null || rowNode === void 0 ? void 0 : rowNode.label);
                var id = rowNode.id.replace(ROOT_BEGINNING_REGEX, '');
                var tempLine = id.split(ID_SEPARATOR);
                // TODO 兼容下钻，需要获取下钻最大层级
                var totalLevel = maxLevel + 1;
                var emptyLength = totalLevel - tempLine.length;
                if (emptyLength > 0) {
                    tempLine.push.apply(tempLine, __spreadArray([], __read(new Array(emptyLength)), false));
                }
                // 指标挂行头且为平铺模式下，获取指标名称
                var lastLabel = sheetInstance.dataSet.getFieldName(last(tempLine));
                tempLine[tempLine.length - 1] = lastLabel;
                try {
                    for (var colLeafNodes_1 = (e_3 = void 0, __values(colLeafNodes)), colLeafNodes_1_1 = colLeafNodes_1.next(); !colLeafNodes_1_1.done; colLeafNodes_1_1 = colLeafNodes_1.next()) {
                        var colNode = colLeafNodes_1_1.value;
                        if (valueInCols) {
                            var viewMeta = getCellMeta(rowNode.rowIndex, colNode.colIndex);
                            tempLine.push(processValueInCol(viewMeta, sheetInstance, isFormat));
                        }
                        else {
                            var viewMeta = getCellMeta(rowNode.rowIndex, colNode.colIndex);
                            var lintItem = processValueInRow(viewMeta, sheetInstance, isFormat);
                            if (isArray(lintItem)) {
                                tempLine = tempLine.concat.apply(tempLine, __spreadArray([], __read(lintItem), false));
                            }
                            else {
                                tempLine.push(lintItem);
                            }
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (colLeafNodes_1_1 && !colLeafNodes_1_1.done && (_b = colLeafNodes_1.return)) _b.call(colLeafNodes_1);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                maxRowLength = max([tempLine.length, maxRowLength]);
                var lineString = tempLine
                    .map(function (value) { return getCsvString(value); })
                    .join(split);
                detailRows.push(lineString);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (caredRowLeafNodes_1_1 && !caredRowLeafNodes_1_1.done && (_a = caredRowLeafNodes_1.return)) _a.call(caredRowLeafNodes_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    // Generate the table header.
    var headers = [];
    if (isEmpty(colLeafNodes) && !sheetInstance.isPivotMode()) {
        // when there is no column in detail mode
        headers = [rowsHeader];
    }
    else {
        // 当列头label为array时用于补全其他层级的label
        var arrayLength_1 = 0;
        // Get the table header of Columns.
        var tempColHeader = clone(colLeafNodes).map(function (colItem) {
            var curColItem = colItem;
            var tempCol = [];
            // Generate the column dimensions.
            while (curColItem.level !== undefined) {
                var label = getHeaderLabel(curColItem.label);
                if (isArray(label)) {
                    arrayLength_1 = max([arrayLength_1, size(label)]);
                }
                tempCol.push(label);
                curColItem = curColItem.parent;
            }
            return tempCol;
        });
        if (arrayLength_1 > 1) {
            tempColHeader = processColHeaders(tempColHeader, arrayLength_1);
        }
        var colLevels = tempColHeader.map(function (colHeader) { return colHeader.length; });
        var colLevel_1 = max(colLevels);
        var colHeader_1 = [];
        var _loop_2 = function (i) {
            // The map of data set: key-name
            var colHeaderItem = tempColHeader
                // total col completion
                .map(function (item) {
                return item.length < colLevel_1
                    ? __spreadArray(__spreadArray([], __read(new Array(colLevel_1 - item.length)), false), __read(item), false) : item;
            })
                .map(function (item) { return item[i]; })
                .map(function (colItem) { return sheetInstance.dataSet.getFieldName(colItem); });
            colHeader_1.push(flatten$1(colHeaderItem));
        };
        // Convert the number of column dimension levels to the corresponding array.
        for (var i = colLevel_1 - 1; i >= 0; i -= 1) {
            _loop_2(i);
        }
        // Generate the table header.
        headers = colHeader_1.map(function (item, index) {
            var _a;
            var _b;
            if (sheetInstance.isPivotMode()) {
                var _c = sheetInstance.facet.cornerHeader.cfg, columns_1 = _c.columns, rows = _c.rows, data_1 = _c.data;
                var colNodes = data_1.filter(function (_a) {
                    var cornerType = _a.cornerType;
                    return cornerType === CornerNodeType.Col;
                });
                var rowNodes_1 = data_1.filter(function (_a) {
                    var cornerType = _a.cornerType;
                    return cornerType === CornerNodeType.Row;
                });
                if (index < colHeader_1.length - 1) {
                    return __spreadArray(__spreadArray(__spreadArray([], __read(Array(rowLength - 1).fill('')), false), [
                        ((_b = colNodes.find(function (_a) {
                            var field = _a.field;
                            return field === columns_1[index];
                        })) === null || _b === void 0 ? void 0 : _b.label) || ''
                    ], false), __read(item), false);
                }
                if (index < colHeader_1.length) {
                    return __spreadArray(__spreadArray([], __read(rows.map(function (row) { var _a; return ((_a = rowNodes_1.find(function (_a) {
                        var field = _a.field;
                        return field === row;
                    })) === null || _a === void 0 ? void 0 : _a.label) || ''; })), false), __read(item), false);
                }
                return rowsHeader.concat.apply(rowsHeader, __spreadArray([], __read(item), false));
            }
            return index < colHeader_1.length
                ? (_a = Array(rowLength)
                    .fill(''))
                    .concat.apply(_a, __spreadArray([], __read(item), false)) : rowsHeader.concat.apply(rowsHeader, __spreadArray([], __read(item), false));
        });
    }
    var headerRow = headers
        .map(function (header) {
        var emptyLength = maxRowLength - header.length;
        if (emptyLength > 0) {
            header.unshift.apply(header, __spreadArray([], __read(new Array(emptyLength)), false));
        }
        return header.map(function (h) { return getCsvString(h); }).join(split);
    })
        .join('\r\n');
    var data = [headerRow].concat(detailRows);
    var result = data.join('\r\n');
    return result;
};

function keyEqualTo(key, compareKey) {
    if (!key || !compareKey) {
        return false;
    }
    return String(key).toLowerCase() === String(compareKey).toLowerCase();
}
var newLine = '\r\n';
var newTab = '\t';
var getColNodeField = function (spreadsheet, id) {
    var colNode = spreadsheet.getColumnNodes().find(function (col) { return col.id === id; });
    if (spreadsheet.isPivotMode()) {
        return colNode === null || colNode === void 0 ? void 0 : colNode.value;
    }
    return colNode === null || colNode === void 0 ? void 0 : colNode.field;
};
var getFiledIdFromMeta = function (meta, spreadsheet) {
    var ids = meta.id.split('-');
    return getColNodeField(spreadsheet, ids[ids.length - 1]);
};
var getHeaderNodeFromMeta = function (meta, spreadsheet) {
    var _a = __read(meta.id.split('-'), 2), rowId = _a[0], colId = _a[1];
    return [
        spreadsheet.getRowNodes().find(function (row) { return row.id === rowId; }),
        spreadsheet.getColumnNodes().find(function (col) { return col.id === colId; }),
    ];
};
var getFormat = function (cellId, spreadsheet) {
    var ids = cellId.split('-');
    var fieldId = getColNodeField(spreadsheet, ids[ids.length - 1]);
    if (spreadsheet.options.interaction.copyWithFormat) {
        return spreadsheet.dataSet.getFieldFormatter(fieldId);
    }
    return function (v) { return v; };
};
var getValueFromMeta = function (meta, displayData, spreadsheet) {
    if (spreadsheet.isPivotMode()) {
        var _a = __read(getHeaderNodeFromMeta(meta, spreadsheet), 2), rowNode = _a[0], colNode = _a[1];
        var cell = spreadsheet.dataSet.getCellData({
            query: __assign(__assign({}, rowNode.query), colNode.query),
            rowNode: rowNode,
        });
        return cell[VALUE_FIELD];
    }
    var fieldId = getFiledIdFromMeta(meta, spreadsheet);
    return displayData[meta.rowIndex][fieldId];
};
var format = function (meta, displayData, spreadsheet) {
    var formatter = getFormat(meta.id, spreadsheet);
    return formatter(getValueFromMeta(meta, displayData, spreadsheet));
};
var convertString = function (v) {
    if (/\n/.test(v)) {
        // 单元格内换行
        return '"' + v.replace(/\r\n?/g, '\n') + '"';
    }
    return v;
};
var processCopyData = function (displayData, cells, spreadsheet) {
    var getRowString = function (pre, cur) {
        return pre +
            (cur ? convertString(format(cur, displayData, spreadsheet)) : '') +
            newTab;
    };
    var getColString = function (pre, cur) {
        return pre + cur.reduce(getRowString, '').slice(0, -1) + newLine;
    };
    return cells.reduce(getColString, '').slice(0, -2);
};
var getTwoDimData = function (cells) {
    if (!(cells === null || cells === void 0 ? void 0 : cells.length))
        return [];
    var _a = __read([
        { row: Infinity, col: Infinity },
        { row: 0, col: 0 },
    ], 2), minCell = _a[0], maxCell = _a[1];
    // get left-top cell and right-bottom cell position
    cells.forEach(function (e) {
        var rowIndex = e.rowIndex, colIndex = e.colIndex;
        minCell.col = Math.min(colIndex, minCell.col);
        minCell.row = Math.min(rowIndex, minCell.row);
        maxCell.col = Math.max(colIndex, maxCell.col);
        maxCell.row = Math.max(rowIndex, maxCell.row);
    });
    var _b = __read([
        maxCell.row - minCell.row + 1,
        maxCell.col - minCell.col + 1,
    ], 2), rowLen = _b[0], colLen = _b[1];
    var twoDimDataArray = new Array(rowLen)
        .fill('')
        .map(function () { return new Array(colLen).fill(''); });
    cells.forEach(function (e) {
        var rowIndex = e.rowIndex, colIndex = e.colIndex;
        var _a = __read([rowIndex - minCell.row, colIndex - minCell.col], 2), diffRow = _a[0], diffCol = _a[1];
        twoDimDataArray[diffRow][diffCol] = e;
    });
    return twoDimDataArray;
};
var processTableColSelected = function (displayData, spreadsheet, selectedCols) {
    var selectedFiled = selectedCols.length
        ? selectedCols.map(function (e) { return getColNodeField(spreadsheet, e.id); })
        : spreadsheet.dataCfg.fields.columns;
    return displayData
        .map(function (row) {
        return selectedFiled
            .map(function (filed) { return convertString(row[filed]); })
            .join(newTab);
    })
        .join(newLine);
};
var getPivotCopyData = function (spreadsheet, leafRows, leafCols) {
    return leafRows
        .map(function (rowNode) {
        return leafCols
            .map(function (colNode) {
            var cellData = spreadsheet.dataSet.getCellData({
                query: __assign(__assign({}, rowNode.query), colNode.query),
                rowNode: rowNode,
            });
            return getFormat(colNode.id, spreadsheet)(cellData[VALUE_FIELD]);
        })
            .join(newTab);
    })
        .join(newLine);
};
var processPivotColSelected = function (spreadsheet, selectedCols) {
    var allRowLeafNodes = spreadsheet
        .getRowNodes()
        .filter(function (node) { return node.isLeaf; });
    var allColLeafNodes = spreadsheet
        .getColumnNodes()
        .filter(function (node) { return node.isLeaf; });
    var colNodes = selectedCols.length
        ? selectedCols.reduce(function (arr, e) {
            arr.push.apply(arr, __spreadArray([], __read(allColLeafNodes.filter(function (node) { return node.id.startsWith(e.id); })), false));
            return arr;
        }, [])
        : allColLeafNodes;
    return getPivotCopyData(spreadsheet, allRowLeafNodes, colNodes);
};
var processColSelected = function (displayData, spreadsheet, selectedCols) {
    if (spreadsheet.isPivotMode()) {
        return processPivotColSelected(spreadsheet, selectedCols);
    }
    return processTableColSelected(displayData, spreadsheet, selectedCols);
};
var processTableRowSelected = function (displayData, selectedRows) {
    var selectedIndex = selectedRows.map(function (e) { return e.rowIndex; });
    return displayData
        .filter(function (e, i) { return selectedIndex.includes(i); })
        .map(function (e) {
        return Object.keys(e)
            .map(function (key) { return convertString(e[key]); })
            .join(newTab);
    })
        .join(newLine);
};
var processPivotRowSelected = function (spreadsheet, selectedRows) {
    var allRowLeafNodes = spreadsheet
        .getRowNodes()
        .filter(function (node) { return node.isLeaf; });
    var allColLeafNodes = spreadsheet
        .getColumnNodes()
        .filter(function (node) { return node.isLeaf; });
    var rowNodes = selectedRows.reduce(function (arr, e) {
        arr.push.apply(arr, __spreadArray([], __read(allRowLeafNodes.filter(function (node) { return node.id.startsWith(e.id); })), false));
        return arr;
    }, []);
    return getPivotCopyData(spreadsheet, rowNodes, allColLeafNodes);
};
var processRowSelected = function (displayData, spreadsheet, selectedRows) {
    if (spreadsheet.isPivotMode()) {
        return processPivotRowSelected(spreadsheet, selectedRows);
    }
    return processTableRowSelected(displayData, selectedRows);
};
var getSelectedData = function (spreadsheet) {
    var interaction = spreadsheet.interaction;
    var cells = interaction.getState().cells || [];
    var data;
    var selectedCols = cells.filter(function (_a) {
        var type = _a.type;
        return type === CellTypes.COL_CELL;
    });
    var selectedRows = cells.filter(function (_a) {
        var type = _a.type;
        return type === CellTypes.ROW_CELL;
    });
    var displayData = spreadsheet.dataSet.getDisplayDataSet();
    if (spreadsheet.isPivotMode() && spreadsheet.isHierarchyTreeType()) {
        // 树状模式透视表之后实现
        return;
    }
    if (interaction.getCurrentStateName() === InteractionStateName.ALL_SELECTED) {
        data = processColSelected(displayData, spreadsheet, []);
    }
    else if (selectedCols.length) {
        data = processColSelected(displayData, spreadsheet, selectedCols);
    }
    else if (selectedRows.length) {
        data = processRowSelected(displayData, spreadsheet, selectedRows);
    }
    else {
        if (!cells.length) {
            return;
        }
        // normal selected
        data = processCopyData(displayData, getTwoDimData(cells), spreadsheet);
    }
    if (data) {
        copyToClipboard(data);
    }
    return data;
};

/* formate the base Event data */
var getBaseCellData = function (ev) {
    var _a, _b, _c, _d, _e, _f;
    var currentCellData = (_c = (_b = (_a = ev.target) === null || _a === void 0 ? void 0 : _a.attrs) === null || _b === void 0 ? void 0 : _b.appendInfo) === null || _c === void 0 ? void 0 : _c.cellData;
    var target = (_e = (_d = ev.target).get) === null || _e === void 0 ? void 0 : _e.call(_d, 'parent');
    var meta = ((_f = target === null || target === void 0 ? void 0 : target.getMeta) === null || _f === void 0 ? void 0 : _f.call(target)) || currentCellData;
    return {
        target: target,
        viewMeta: meta,
        event: ev,
    };
};

/**
 * @description Return all the row cells or column cells which are needed to be highlighted.
 * @param id rowId or colId
 * @param headerCells all the rowHeader cells or all the colHeader cells
 * @param isRowInHierarchyTreeType  The tree mode will only highlight the leaf nodes at the head of the row
 */
var getActiveHoverRowColCells = function (id, headerCells, isRowInHierarchyTreeType) {
    var allHeaderIds;
    var ids = id.split(ID_SEPARATOR);
    if (isRowInHierarchyTreeType) {
        allHeaderIds = [id];
    }
    else {
        allHeaderIds = [generateId(ids[0], ids[1])];
        for (var i = 2; i < ids.length; i += 1) {
            allHeaderIds.push(generateId(allHeaderIds[i - 2], ids[i]));
        }
    }
    var allHeaderCells = filter(headerCells, function (cell) { var _a; return allHeaderIds.includes((_a = cell.getMeta()) === null || _a === void 0 ? void 0 : _a.id); });
    return allHeaderCells;
};

/**
 * -----------------------------
 * |           padding         |
 * |  |---------------------|  |
 * |  |                     |  |
 * |  |                     |  |
 * |  |---------------------|  |
 * |           padding         |
 * -----------------------------
 */
var getContentArea = function (bbox, padding) {
    var x = bbox.x, y = bbox.y, width = bbox.width, height = bbox.height;
    var contentWidth = width - (padding === null || padding === void 0 ? void 0 : padding.left) - (padding === null || padding === void 0 ? void 0 : padding.right);
    var contentHeight = height - (padding === null || padding === void 0 ? void 0 : padding.top) - (padding === null || padding === void 0 ? void 0 : padding.bottom);
    return {
        x: x + (padding === null || padding === void 0 ? void 0 : padding.left),
        y: y + (padding === null || padding === void 0 ? void 0 : padding.top),
        width: contentWidth,
        height: contentHeight,
    };
};
/**
 * text 和 icon 之间布局关系：
 *    y轴： text 和 icon 高度上居中对齐
 *    x轴：
 *       1. text 和 icon 同为 left 或者 right 时，icon bbox 只需要简单放置在 left 或者 right 即可
 *       2. 其他的情况，需要根据实际 text width 确定 icon bbox 开始位置
 */
var normalizeIconCfg = function (iconCfg) {
    return merge({
        size: 0,
        position: 'right',
        margin: {
            left: 0,
            right: 0,
        },
    }, iconCfg);
};
var getMaxTextWidth = function (contentWidth, iconCfg) {
    iconCfg = normalizeIconCfg(iconCfg);
    return (contentWidth - iconCfg.size - iconCfg.margin.right - iconCfg.margin.left);
};
var getVerticalPosition = function (_a, textBaseline, size) {
    var y = _a.y, height = _a.height;
    if (size === void 0) { size = 0; }
    var p = 0;
    switch (textBaseline) {
        case 'top':
            p = y;
            break;
        case 'middle':
            p = y + height / 2 - size / 2;
            break;
        default:
            p = y + height - size;
            break;
    }
    return p;
};
// 获取text及其跟随icon的位置坐标
var getTextAndFollowingIconPosition = function (contentBox, textCfg, textWidth, iconCfg, iconCount) {
    if (textWidth === void 0) { textWidth = 0; }
    if (iconCount === void 0) { iconCount = 1; }
    var x = contentBox.x, width = contentBox.width;
    var textAlign = textCfg.textAlign, textBaseline = textCfg.textBaseline;
    var _a = normalizeIconCfg(iconCfg), size = _a.size, margin = _a.margin, iconPosition = _a.position;
    var iconSpace = iconCount * (size + margin.left) + margin.right;
    var textX;
    var iconX;
    switch (textAlign) {
        case 'left':
            /**
             * icon left -- text left
             * ------------------------------------------------------
             * | margin-left | icon | margin-right | text | padding |
             * ------------------------------------------------------
             *
             * text left - icon right
             * ------------------------------------------------------
             * | text | margin-left | icon | margin-right | padding |
             * ------------------------------------------------------
             */
            textX = x + (iconPosition === 'left' ? iconSpace : 0);
            iconX =
                x + (iconPosition === 'left' ? margin.left : textWidth + margin.left);
            break;
        case 'center': {
            /**
             * icon left -- text center
             * ----------------------------------------------------------------
             * | padding | margin-left | icon | margin-right | text | padding |
             * ----------------------------------------------------------------
             *
             * text center - icon right
             * ----------------------------------------------------------------
             * | padding | text | margin-left | icon | margin-right | padding |
             * ----------------------------------------------------------------
             */
            var totalWidth = iconSpace -
                (iconPosition === 'left' ? margin.left : margin.right) +
                textWidth;
            var startX = x + width / 2 - totalWidth / 2;
            textX =
                startX +
                    textWidth / 2 +
                    (iconPosition === 'left' ? iconSpace - margin.left : 0);
            iconX = startX + (iconPosition === 'left' ? 0 : textWidth + margin.left);
            break;
        }
        default: {
            /**
             * icon left -- text right
             * ------------------------------------------------------
             * | padding | margin-left | icon | margin-right | text |
             * ------------------------------------------------------
             *
             * text right - icon right
             * ------------------------------------------------------
             * | padding | text | margin-left | icon | margin-right |
             * ------------------------------------------------------
             */
            textX = x + width - (iconPosition === 'right' ? iconSpace : 0);
            iconX =
                x +
                    width -
                    (iconPosition === 'right'
                        ? iconSpace - margin.left
                        : textWidth + iconSpace - margin.left);
            break;
        }
    }
    var textY = getVerticalPosition(contentBox, textBaseline, 0);
    var iconY = getVerticalPosition(contentBox, textBaseline, size);
    return {
        text: { x: textX, y: textY },
        icon: { x: iconX, y: iconY },
    };
};
var getTextPosition = function (contentBox, textCfg) { return getTextAndFollowingIconPosition(contentBox, textCfg).text; };
// 获取在列头水平滚动时，text坐标，使其始终在可视区域的格子中处于居中位置
var getTextAndIconPositionWhenHorizontalScrolling = function (viewport, content, textWidth) {
    var contentEnd = content.start + content.width;
    var viewportEnd = viewport.start + viewport.width;
    var position;
    if (content.start <= viewport.start && contentEnd >= viewportEnd) {
        position = viewport.start + viewport.width / 2;
    }
    else if (content.start <= viewport.start) {
        var restWidth = content.width - (viewport.start - content.start);
        position =
            restWidth < textWidth
                ? contentEnd - textWidth / 2
                : contentEnd - restWidth / 2;
    }
    else if (contentEnd >= viewportEnd) {
        var restWidth = content.width - (contentEnd - viewportEnd);
        position =
            restWidth < textWidth
                ? content.start + textWidth / 2
                : content.start + restWidth / 2;
    }
    else {
        position = content.start + content.width / 2;
    }
    return position;
};
var getBorderPositionAndStyle = function (position, contentBox, style) {
    var x = contentBox.x, y = contentBox.y, width = contentBox.width, height = contentBox.height;
    var horizontalBorderWidth = style.horizontalBorderWidth, horizontalBorderColorOpacity = style.horizontalBorderColorOpacity, horizontalBorderColor = style.horizontalBorderColor, verticalBorderWidth = style.verticalBorderWidth, verticalBorderColor = style.verticalBorderColor, verticalBorderColorOpacity = style.verticalBorderColorOpacity;
    var x1;
    var y1;
    var x2;
    var y2;
    var borderStyle;
    // horizontal
    if (position === CellBorderPosition.TOP ||
        position === CellBorderPosition.BOTTOM) {
        var yPosition = y;
        if (position === CellBorderPosition.TOP) {
            // 完全绘制在 Cell 内，否则会导致 Border 粗细不一： https://github.com/antvis/S2/issues/426
            yPosition = y + verticalBorderWidth / 2;
        }
        else {
            yPosition = y + height - verticalBorderWidth / 2;
        }
        y1 = yPosition;
        y2 = yPosition;
        x1 = x;
        x2 = x + width;
        borderStyle = {
            lineWidth: horizontalBorderWidth,
            stroke: horizontalBorderColor,
            strokeOpacity: horizontalBorderColorOpacity,
        };
    }
    // vertical
    if (position === CellBorderPosition.LEFT ||
        position === CellBorderPosition.RIGHT) {
        var xPosition = x;
        if (position === CellBorderPosition.LEFT) {
            xPosition = x + horizontalBorderWidth / 2;
        }
        else {
            xPosition = x + width - horizontalBorderWidth / 2;
        }
        x1 = xPosition;
        x2 = xPosition;
        y1 = y;
        y2 = y + height;
        borderStyle = {
            lineWidth: verticalBorderWidth,
            stroke: verticalBorderColor,
            strokeOpacity: verticalBorderColorOpacity,
        };
    }
    return {
        position: {
            x1: x1,
            x2: x2,
            y1: y1,
            y2: y2,
        },
        style: borderStyle,
    };
};

var BaseCell = /** @class */ (function (_super) {
    __extends(BaseCell, _super);
    function BaseCell(meta, spreadsheet) {
        var restOptions = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            restOptions[_i - 2] = arguments[_i];
        }
        var _this = _super.call(this, {}) || this;
        // actual text width after be ellipsis
        _this.actualTextWidth = 0;
        // interactive control shapes, unify read and manipulate operations
        _this.stateShapes = new Map();
        _this.meta = meta;
        _this.spreadsheet = spreadsheet;
        _this.theme = spreadsheet.theme;
        _this.handleRestOptions.apply(_this, __spreadArray([], __read(restOptions), false));
        _this.initCell();
        return _this;
    }
    BaseCell.prototype.getMeta = function () {
        return this.meta;
    };
    BaseCell.prototype.setMeta = function (viewMeta) {
        this.meta = viewMeta;
    };
    BaseCell.prototype.getIconStyle = function () {
        return this.theme[this.cellType].icon;
    };
    BaseCell.prototype.getTextAndIconPosition = function (iconCount) {
        if (iconCount === void 0) { iconCount = 1; }
        var textStyle = this.getTextStyle();
        var iconCfg = this.getIconStyle();
        return getTextAndFollowingIconPosition(this.getContentArea(), textStyle, this.actualTextWidth, iconCfg, iconCount);
    };
    BaseCell.prototype.getActualText = function () {
        return this.actualText;
    };
    BaseCell.prototype.getFieldValue = function () {
        return this.getFormattedFieldValue().formattedValue;
    };
    /**
     * in case there are more params to be handled
     * @param options any type's rest params
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    BaseCell.prototype.handleRestOptions = function () {
        var options = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            options[_i] = arguments[_i];
        }
        // default do nothing
    };
    /* -------------------------------------------------------------------------- */
    /*                common functions that will be used in subtype               */
    /* -------------------------------------------------------------------------- */
    BaseCell.prototype.getStyle = function (name) {
        return this.theme[name || this.cellType];
    };
    BaseCell.prototype.getResizeAreaStyle = function () {
        return this.getStyle('resizeArea');
    };
    BaseCell.prototype.shouldDrawResizeAreaByType = function (type) {
        var _a, _b;
        var resize = (_b = (_a = this.spreadsheet.options) === null || _a === void 0 ? void 0 : _a.interaction) === null || _b === void 0 ? void 0 : _b.resize;
        if (isBoolean(resize)) {
            return resize;
        }
        return resize[type];
    };
    BaseCell.prototype.getCellArea = function () {
        var _a = this.meta, x = _a.x, y = _a.y, height = _a.height, width = _a.width;
        return { x: x, y: y, height: height, width: width };
    };
    // get content area that exclude padding
    BaseCell.prototype.getContentArea = function () {
        var _a;
        var padding = (((_a = this.getStyle()) === null || _a === void 0 ? void 0 : _a.cell) || this.theme.dataCell.cell).padding;
        return getContentArea(this.getCellArea(), padding);
    };
    BaseCell.prototype.getIconPosition = function (iconCount) {
        if (iconCount === void 0) { iconCount = 1; }
        return this.getTextAndIconPosition(iconCount).icon;
    };
    BaseCell.prototype.drawTextShape = function () {
        var formattedValue = this.getFormattedFieldValue().formattedValue;
        var maxTextWidth = this.getMaxTextWidth();
        var textStyle = this.getTextStyle();
        var ellipsisText = getEllipsisText({
            text: formattedValue,
            maxWidth: maxTextWidth,
            fontParam: textStyle,
            placeholder: this.spreadsheet.options.placeholder,
        });
        this.actualText = ellipsisText;
        this.actualTextWidth = measureTextWidth(ellipsisText, textStyle);
        var position = this.getTextPosition();
        this.textShape = renderText(this, [this.textShape], position.x, position.y, ellipsisText, textStyle);
    };
    BaseCell.prototype.drawLinkFieldShape = function (showLinkFieldShape, linkFillColor) {
        var fill = this.getTextStyle().fill;
        // handle link nodes
        if (showLinkFieldShape) {
            var device = this.spreadsheet.options.style.device;
            var fillColor = void 0;
            // 配置了链接跳转
            if (isMobile(device)) {
                fillColor = linkFillColor;
            }
            else {
                var _a = this.textShape.getBBox(), minX = _a.minX, maxX = _a.maxX, maxY = _a.maxY;
                this.linkFieldShape = renderLine(this, {
                    x1: minX,
                    y1: maxY + 1,
                    x2: maxX,
                    y2: maxY + 1,
                }, { stroke: fill, lineWidth: 1 });
                fillColor = fill;
            }
            this.textShape.attr({
                fill: fillColor,
                cursor: 'pointer',
                appendInfo: {
                    isRowHeaderText: true,
                    cellData: this.meta,
                },
            });
        }
    };
    // 根据当前state来更新cell的样式
    BaseCell.prototype.updateByState = function (stateName, cell) {
        var _this = this;
        this.spreadsheet.interaction.setInteractedCells(cell);
        var stateStyles = get(this.theme, "".concat(this.cellType, ".cell.interactionState.").concat(stateName));
        var _a = this.getCellArea(), x = _a.x, y = _a.y, height = _a.height, width = _a.width;
        each(stateStyles, function (style, styleKey) {
            var targetShapeNames = keys(pickBy(SHAPE_ATTRS_MAP, function (attrs) { return includes(attrs, styleKey); }));
            targetShapeNames.forEach(function (shapeName) {
                var shape = _this.stateShapes.has(shapeName)
                    ? _this.stateShapes.get(shapeName)
                    : _this[shapeName];
                // 根据borderWidth更新borderShape大小 https://github.com/antvis/S2/pull/705
                if (shapeName === 'interactiveBorderShape' &&
                    styleKey === 'borderWidth') {
                    if (isNumber(style)) {
                        var marginStyle = {
                            x: x + style / 2,
                            y: y + style / 2,
                            width: width - style - 1,
                            height: height - style - 1,
                        };
                        each(marginStyle, function (currentStyle, currentStyleKey) {
                            updateShapeAttr(shape, currentStyleKey, currentStyle);
                        });
                    }
                }
                updateShapeAttr(shape, SHAPE_STYLE_MAP[styleKey], style);
            });
        });
    };
    BaseCell.prototype.hideInteractionShape = function () {
        this.stateShapes.forEach(function (shape) {
            updateShapeAttr(shape, SHAPE_STYLE_MAP.backgroundOpacity, 0);
            updateShapeAttr(shape, SHAPE_STYLE_MAP.backgroundColor, 'transparent');
            updateShapeAttr(shape, SHAPE_STYLE_MAP.borderOpacity, 0);
            updateShapeAttr(shape, SHAPE_STYLE_MAP.borderWidth, 1);
            updateShapeAttr(shape, SHAPE_STYLE_MAP.borderColor, 'transparent');
        });
    };
    BaseCell.prototype.clearUnselectedState = function () {
        updateShapeAttr(this.backgroundShape, SHAPE_STYLE_MAP.backgroundOpacity, 1);
        updateShapeAttr(this.textShape, SHAPE_STYLE_MAP.textOpacity, 1);
        updateShapeAttr(this.linkFieldShape, SHAPE_STYLE_MAP.opacity, 1);
    };
    return BaseCell;
}(Group));

var handleDataItem = function (data, callback) {
    return callback
        ? callback(data[EXTRA_FIELD], data[VALUE_FIELD])
        : data[VALUE_FIELD];
};
/**
 * @description  Determine if the current cell belongs to Cells
 * @param cells active cells
 * @param currentCell current activated cell
 */
var includeCell = function (cells, currentCell) {
    var currentId = currentCell.getMeta().id;
    return cells.some(function (cell) {
        return isEqual(cell.id, currentId);
    });
};
var getDataCellId = function (rowIndex, colIndex) {
    return "".concat(rowIndex, "-").concat(colIndex);
};

var getIconPositionCfg = function (condition) {
    var _a;
    return (_a = condition === null || condition === void 0 ? void 0 : condition.position) !== null && _a !== void 0 ? _a : 'right';
};

/**
 * DataCell for panelGroup area
 * ----------------------------
 * |                  |       |
 * |interval      text| icon  |
 * |                  |       |
 * ----------------------------
 * There are four conditions(]{@see BaseCell.conditions}) to determine how to render
 * 1、background color
 * 2、icon align in right with size {@link ICON_SIZE}
 * 3、left rect area is interval(in left) and text(in right)
 */
var DataCell = /** @class */ (function (_super) {
    __extends(DataCell, _super);
    function DataCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DataCell.prototype, "cellType", {
        get: function () {
            return CellTypes.DATA_CELL;
        },
        enumerable: false,
        configurable: true
    });
    DataCell.prototype.handlePrepareSelect = function (cells) {
        if (includeCell(cells, this)) {
            this.updateByState(InteractionStateName.PREPARE_SELECT);
        }
    };
    DataCell.prototype.handleSelect = function (cells) {
        var _a;
        var currentCellType = (_a = cells === null || cells === void 0 ? void 0 : cells[0]) === null || _a === void 0 ? void 0 : _a.type;
        switch (currentCellType) {
            // 列多选
            case CellTypes.COL_CELL:
                this.changeRowColSelectState('colIndex');
                break;
            // 行多选
            case CellTypes.ROW_CELL:
                this.changeRowColSelectState('rowIndex');
                break;
            // 单元格单选/多选
            case CellTypes.DATA_CELL:
                if (includeCell(cells, this)) {
                    this.updateByState(InteractionStateName.SELECTED);
                }
                else if (this.spreadsheet.options.interaction.selectedCellsSpotlight) {
                    this.updateByState(InteractionStateName.UNSELECTED);
                }
                break;
        }
    };
    DataCell.prototype.handleHover = function (cells) {
        var currentHoverCell = first(cells);
        if (currentHoverCell.type !== CellTypes.DATA_CELL) {
            this.hideInteractionShape();
            return;
        }
        if (this.spreadsheet.options.interaction.hoverHighlight) {
            // 如果当前是hover，要绘制出十字交叉的行列样式
            var currentColIndex = this.meta.colIndex;
            var currentRowIndex = this.meta.rowIndex;
            // 当视图内的 cell 行列 index 与 hover 的 cell 一致，绘制hover的十字样式
            if (currentColIndex === (currentHoverCell === null || currentHoverCell === void 0 ? void 0 : currentHoverCell.colIndex) ||
                currentRowIndex === (currentHoverCell === null || currentHoverCell === void 0 ? void 0 : currentHoverCell.rowIndex)) {
                this.updateByState(InteractionStateName.HOVER);
            }
            else {
                // 当视图内的 cell 行列 index 与 hover 的 cell 不一致，隐藏其他样式
                this.hideInteractionShape();
            }
        }
        if (isEqual(currentHoverCell.id, this.getMeta().id)) {
            this.updateByState(InteractionStateName.HOVER_FOCUS);
        }
    };
    DataCell.prototype.update = function () {
        var stateName = this.spreadsheet.interaction.getCurrentStateName();
        var cells = this.spreadsheet.interaction.getCells();
        if (stateName === InteractionStateName.ALL_SELECTED) {
            this.updateByState(InteractionStateName.SELECTED);
            return;
        }
        if (isEmpty(cells) || !stateName) {
            return;
        }
        switch (stateName) {
            case InteractionStateName.PREPARE_SELECT:
                this.handlePrepareSelect(cells);
                break;
            case InteractionStateName.SELECTED:
                this.handleSelect(cells);
                break;
            case InteractionStateName.HOVER_FOCUS:
            case InteractionStateName.HOVER:
                this.handleHover(cells);
                break;
        }
    };
    DataCell.prototype.setMeta = function (viewMeta) {
        _super.prototype.setMeta.call(this, viewMeta);
        this.initCell();
    };
    DataCell.prototype.initCell = function () {
        this.conditions = this.spreadsheet.options.conditions;
        this.drawBackgroundShape();
        this.drawInteractiveBgShape();
        this.drawConditionIntervalShape();
        this.drawInteractiveBorderShape();
        this.drawTextShape();
        this.drawConditionIconShapes();
        this.drawBorderShape();
        this.update();
    };
    DataCell.prototype.getTextStyle = function () {
        var _a, _b;
        var isTotals = this.meta.isTotals;
        var textStyle = isTotals
            ? this.theme.dataCell.bolderText
            : this.theme.dataCell.text;
        // get text condition's fill result
        var fill = textStyle.fill;
        var textCondition = this.findFieldCondition((_a = this.conditions) === null || _a === void 0 ? void 0 : _a.text);
        if (textCondition === null || textCondition === void 0 ? void 0 : textCondition.mapping) {
            fill = (_b = this.mappingValue(textCondition)) === null || _b === void 0 ? void 0 : _b.fill;
        }
        return __assign(__assign({}, textStyle), { fill: fill });
    };
    DataCell.prototype.getIconStyle = function () {
        var _a;
        var _b = this.theme.dataCell.icon, size = _b.size, margin = _b.margin;
        var iconCondition = this.findFieldCondition((_a = this.conditions) === null || _a === void 0 ? void 0 : _a.icon);
        var iconCfg = iconCondition &&
            iconCondition.mapping && {
            size: size,
            margin: margin,
            position: getIconPositionCfg(iconCondition),
        };
        return iconCfg;
    };
    DataCell.prototype.getFormattedFieldValue = function () {
        var _a = this.meta, rowId = _a.rowId, valueField = _a.valueField, fieldValue = _a.fieldValue, data = _a.data;
        var rowMeta = this.spreadsheet.dataSet.getFieldMeta(rowId);
        var formatter;
        if (rowMeta) {
            // format by row field
            formatter = this.spreadsheet.dataSet.getFieldFormatter(rowId);
        }
        else {
            // format by value field
            formatter = this.spreadsheet.dataSet.getFieldFormatter(valueField);
        }
        var formattedValue = formatter(fieldValue, data);
        return {
            value: fieldValue,
            formattedValue: formattedValue,
        };
    };
    DataCell.prototype.getMaxTextWidth = function () {
        var width = this.getContentArea().width;
        return getMaxTextWidth(width, this.getIconStyle());
    };
    DataCell.prototype.getTextPosition = function () {
        return this.getTextAndIconPosition().text;
    };
    DataCell.prototype.drawConditionIconShapes = function () {
        var _a;
        var iconCondition = this.findFieldCondition((_a = this.conditions) === null || _a === void 0 ? void 0 : _a.icon);
        if (iconCondition && iconCondition.mapping) {
            var attrs = this.mappingValue(iconCondition);
            var position = this.getIconPosition();
            var formattedValue = this.getFormattedFieldValue().formattedValue;
            var size = this.theme.dataCell.icon.size;
            if (!isEmpty(attrs === null || attrs === void 0 ? void 0 : attrs.icon) && formattedValue) {
                this.conditionIconShape = renderIcon(this, __assign(__assign({}, position), { name: attrs.icon, width: size, height: size, fill: attrs.fill }));
            }
        }
    };
    /**
     * 计算柱图的 scale 函数（两种情况）
     *
     * min_________x_____0___________________________max
     * |<----r---->|
     *
     * 0_________________min_________x_______________max
     * |<-------------r------------->|
     *
     * @param minValue in current field values
     * @param max in current field values
     */
    DataCell.prototype.getIntervalScale = function (minValue, maxValue) {
        if (minValue === void 0) { minValue = 0; }
        if (maxValue === void 0) { maxValue = 0; }
        minValue = parseNumberWithPrecision(minValue);
        maxValue = parseNumberWithPrecision(maxValue);
        var realMin = minValue >= 0 ? 0 : minValue;
        var distance = maxValue - realMin || 1;
        return function (current) {
            // max percentage shouldn't be greater than 100%
            // min percentage shouldn't be less than 0%
            return clamp((current - realMin) / distance, 0, 1);
        };
    };
    /**
     * Draw interval condition shape
     * @private
     */
    DataCell.prototype.drawConditionIntervalShape = function () {
        var _a, _b;
        var _c = this.getCellArea(), x = _c.x, y = _c.y, height = _c.height, width = _c.width;
        var formattedValue = this.getFormattedFieldValue().formattedValue;
        var intervalCondition = this.findFieldCondition((_a = this.conditions) === null || _a === void 0 ? void 0 : _a.interval);
        if (intervalCondition && intervalCondition.mapping && formattedValue) {
            var attrs = this.mappingValue(intervalCondition);
            if (!attrs) {
                return;
            }
            var _d = attrs.isCompare
                ? attrs
                : this.spreadsheet.dataSet.getValueRangeByField(this.meta.valueField), minValue = _d.minValue, maxValue = _d.maxValue;
            var fieldValue = parseNumberWithPrecision(this.meta.fieldValue);
            // 对于超出设定范围的值不予显示
            if (fieldValue < minValue || fieldValue > maxValue) {
                return;
            }
            var scale = this.getIntervalScale(minValue, maxValue);
            var zero = scale(0); // 零点
            var current = scale(fieldValue); // 当前数据点
            var barChartHeight = this.getStyle().cell.miniBarChartHeight;
            var barChartFillColor = this.getStyle().cell.miniBarChartFillColor;
            var fill = (_b = attrs.fill) !== null && _b !== void 0 ? _b : barChartFillColor;
            this.conditionIntervalShape = renderRect(this, {
                x: x + width * zero,
                y: y + height / 2 - barChartHeight / 2,
                width: width * (current - zero),
                height: barChartHeight,
                fill: fill,
            });
        }
    };
    DataCell.prototype.getBackgroundColor = function () {
        var _a;
        var crossBackgroundColor = this.getStyle().cell.crossBackgroundColor;
        var backgroundColor = this.getStyle().cell.backgroundColor;
        var strokeColor = 'transparent';
        if (this.spreadsheet.isPivotMode() &&
            crossBackgroundColor &&
            this.meta.rowIndex % 2 === 0) {
            // 隔行颜色的配置
            // 偶数行展示灰色背景，因为index是从0开始的
            backgroundColor = crossBackgroundColor;
        }
        // get background condition fill color
        var bgCondition = this.findFieldCondition((_a = this.conditions) === null || _a === void 0 ? void 0 : _a.background);
        if (bgCondition && bgCondition.mapping) {
            var attrs = this.mappingValue(bgCondition);
            if (attrs) {
                backgroundColor = attrs.fill;
            }
        }
        return { backgroundColor: backgroundColor, strokeColor: strokeColor };
    };
    /**
     * Draw cell background
     */
    DataCell.prototype.drawBackgroundShape = function () {
        var _a = this.getBackgroundColor(), fill = _a.backgroundColor, stroke = _a.strokeColor;
        this.backgroundShape = renderRect(this, __assign(__assign({}, this.getCellArea()), { fill: fill, stroke: stroke }));
    };
    /**
     * 绘制hover悬停，刷选的外框
     */
    DataCell.prototype.drawInteractiveBorderShape = function () {
        // 往内缩一个像素，避免和外边框重叠
        var margin = 1;
        var _a = this.getCellArea(), x = _a.x, y = _a.y, height = _a.height, width = _a.width;
        this.stateShapes.set('interactiveBorderShape', renderRect(this, {
            x: x + margin,
            y: y + margin,
            width: width - margin * 2,
            height: height - margin * 2,
            fill: 'transparent',
            stroke: 'transparent',
        }));
    };
    /**
     * Draw interactive color
     */
    DataCell.prototype.drawInteractiveBgShape = function () {
        this.stateShapes.set('interactiveBgShape', renderRect(this, __assign(__assign({}, this.getCellArea()), { fill: 'transparent', stroke: 'transparent' })));
    };
    // dataCell根据state 改变当前样式，
    DataCell.prototype.changeRowColSelectState = function (indexType) {
        var interaction = this.spreadsheet.interaction;
        var currentIndex = get(this.meta, indexType);
        var _a = interaction.getState(), _b = _a.nodes, nodes = _b === void 0 ? [] : _b, _c = _a.cells, cells = _c === void 0 ? [] : _c;
        var isEqualIndex = __spreadArray(__spreadArray([], __read(nodes), false), __read(cells), false).find(function (cell) { return get(cell, indexType) === currentIndex; });
        if (isEqualIndex) {
            this.updateByState(InteractionStateName.SELECTED);
        }
        else if (this.spreadsheet.options.interaction.selectedCellsSpotlight) {
            this.updateByState(InteractionStateName.UNSELECTED);
        }
        else {
            this.hideInteractionShape();
        }
    };
    /**
     * Render cell border controlled by verticalBorder & horizontalBorder
     * @private
     */
    DataCell.prototype.drawBorderShape = function () {
        var _this = this;
        [CellBorderPosition.BOTTOM, CellBorderPosition.RIGHT].forEach(function (type) {
            var _a = getBorderPositionAndStyle(type, _this.getCellArea(), _this.getStyle().cell), position = _a.position, style = _a.style;
            renderLine(_this, position, style);
        });
    };
    /**
     * Find current field related condition
     * @param conditions
     */
    DataCell.prototype.findFieldCondition = function (conditions) {
        var _this = this;
        return findLast(conditions, function (item) {
            return item.field instanceof RegExp
                ? item.field.test(_this.meta.valueField)
                : item.field === _this.meta.valueField;
        });
    };
    /**
     * Mapping value to get condition related attrs
     * @param condition
     */
    DataCell.prototype.mappingValue = function (condition) {
        var value = this.meta.fieldValue;
        return condition === null || condition === void 0 ? void 0 : condition.mapping(value, this.meta.data);
    };
    DataCell.prototype.updateByState = function (stateName) {
        _super.prototype.updateByState.call(this, stateName, this);
        if (stateName === InteractionStateName.UNSELECTED) {
            var stateStyles = get(this.theme, "".concat(this.cellType, ".cell.interactionState.").concat(stateName));
            if (stateStyles) {
                updateShapeAttr(this.conditionIntervalShape, SHAPE_STYLE_MAP.backgroundOpacity, stateStyles.backgroundOpacity);
                updateShapeAttr(this.conditionIconShape, SHAPE_STYLE_MAP.opacity, stateStyles.opacity);
            }
        }
    };
    DataCell.prototype.clearUnselectedState = function () {
        _super.prototype.clearUnselectedState.call(this);
        updateShapeAttr(this.conditionIntervalShape, SHAPE_STYLE_MAP.backgroundOpacity, 1);
        updateShapeAttr(this.conditionIconShape, SHAPE_STYLE_MAP.opacity, 1);
    };
    DataCell.prototype.drawLeftBorder = function () {
        var _a = getBorderPositionAndStyle(CellBorderPosition.LEFT, this.getCellArea(), this.getStyle().cell), position = _a.position, style = _a.style;
        renderLine(this, position, style);
    };
    return DataCell;
}(BaseCell));

/**
 * Cell for panelGroup area
 */
var MergedCell = /** @class */ (function (_super) {
    __extends(MergedCell, _super);
    function MergedCell(spreadsheet, cells, meta, isPartiallyVisible) {
        if (isPartiallyVisible === void 0) { isPartiallyVisible = true; }
        var _this = _super.call(this, meta, spreadsheet, cells) || this;
        _this.isPartiallyVisible = isPartiallyVisible;
        return _this;
    }
    MergedCell.prototype.handleRestOptions = function () {
        var _a = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _a[_i] = arguments[_i];
        }
        var _b = __read(_a, 1), cells = _b[0];
        this.cells = cells;
    };
    Object.defineProperty(MergedCell.prototype, "cellType", {
        get: function () {
            return CellTypes.MERGED_CELL;
        },
        enumerable: false,
        configurable: true
    });
    MergedCell.prototype.update = function () { };
    MergedCell.prototype.initCell = function () {
        // TODO：1、条件格式支持； 2、交互态扩展； 3、合并后的单元格文字布局及文字内容（目前参考Excel合并后只保留第一个单元格子的数据）
        this.drawBackgroundShape();
        this.drawTextShape();
    };
    /**
     * Draw merged cells background
     */
    MergedCell.prototype.drawBackgroundShape = function () {
        var allPoints = getPolygonPoints(this.cells);
        var cellTheme = this.theme.dataCell.cell;
        this.backgroundShape = renderPolygon(this, {
            points: allPoints,
            stroke: cellTheme.horizontalBorderColor,
            fill: cellTheme.backgroundColor,
            lineHeight: cellTheme.horizontalBorderWidth,
        });
    };
    /**
     * Render data text
     */
    MergedCell.prototype.drawTextShape = function () {
        if (isEmpty(this.meta)) {
            return;
        }
        if (isObject(this.meta.fieldValue)) {
            drawObjectText(this);
        }
        else {
            _super.prototype.drawTextShape.call(this);
        }
    };
    return MergedCell;
}(DataCell));

/**
 *  according to the coordinates of the starting point of the rectangle,
 * return the four sides of the rectangle in a clockwise direction.
 * [TopLeft] --- [TopRight]
 *    |               |
 * [BottomLeft] -[BottomRight]
 * @param x
 * @param y
 * @param width
 * @param height
 */
var getRectangleEdges = function (x, y, width, height) {
    var topLeft = [x, y];
    var topRight = [x + width, y];
    var bottomRight = [x + width, y + height];
    var bottomLeft = [x, y + height];
    return [
        [topLeft, topRight],
        [topRight, bottomRight],
        [bottomRight, bottomLeft],
        [bottomLeft, topLeft],
    ];
};
/**
 * return the edges without overlapping edges
 * @param edges the collection of edges
 */
var unique = function (edges) {
    var result = [];
    forEach(edges, function (edge) {
        var reverseEdge = [edge[1], edge[0]];
        if (!JSON.stringify(edges).includes(JSON.stringify(reverseEdge))) {
            result.push(edge);
        }
    });
    return result;
};
/**
 * return the edge according to the  coordinate of current edge
 * eg: curEdge: [[0,0], [100,0]] then the next edge: [[100, 0 ], [100, 100]]
 * @param curEdge the  coordinate of current edge
 * @param edges the collection of edges
 */
var getNextEdge = function (curEdge, edges) {
    return find(edges, function (edge) { return isEqual(edge[0], curEdge[1]); });
};
/**
 * return all the points of the polygon
 * @param cells the collection of information of cells which needed be merged
 */
var getPolygonPoints = function (cells) {
    var allEdges = [];
    cells.forEach(function (cell) {
        var meta = cell.getMeta();
        var x = meta.x, y = meta.y, width = meta.width, height = meta.height;
        allEdges = allEdges.concat(getRectangleEdges(x, y, width, height));
    });
    allEdges = unique(allEdges);
    var allPoints = [];
    var startEdge = allEdges[0];
    var curEdge = startEdge;
    var nextEdge = [];
    while (!isEqual(startEdge, nextEdge)) {
        allPoints = allPoints.concat(curEdge);
        nextEdge = getNextEdge(curEdge, allEdges);
        curEdge = nextEdge;
    }
    return allPoints;
};
/**
 * get cells on the outside of visible area through mergeCellInfo
 * @param invisibleCellInfo
 * @param sheet
 */
var getInvisibleInfo = function (invisibleCellInfo, sheet) {
    var cells = [];
    var viewMeta;
    forEach(invisibleCellInfo, function (cellInfo) {
        var _a, _b, _c;
        var meta = (_b = (_a = sheet === null || sheet === void 0 ? void 0 : sheet.facet) === null || _a === void 0 ? void 0 : _a.layoutResult) === null || _b === void 0 ? void 0 : _b.getCellMeta(cellInfo.rowIndex, cellInfo.colIndex);
        if (meta) {
            var cell = (_c = sheet === null || sheet === void 0 ? void 0 : sheet.facet) === null || _c === void 0 ? void 0 : _c.cfg.dataCell(meta);
            viewMeta = (cellInfo === null || cellInfo === void 0 ? void 0 : cellInfo.showText) ? meta : viewMeta;
            cells.push(cell);
        }
    });
    return { cells: cells, cellsMeta: viewMeta };
};
/**
 * get { cells, invisibleCellInfo, cellsMeta } in the inside of visible area through mergeCellInfo
 * @param cellsInfos
 * @param allVisibleCells
 * @returns { cells, invisibleCellInfo, cellsMeta }
 */
var getVisibleInfo = function (cellsInfos, allVisibleCells) {
    var cells = [];
    var invisibleCellInfo = [];
    var cellsMeta;
    forEach(cellsInfos, function (cellInfo) {
        var findCell = find(allVisibleCells, function (cell) {
            var _a;
            var meta = (_a = cell === null || cell === void 0 ? void 0 : cell.getMeta) === null || _a === void 0 ? void 0 : _a.call(cell);
            if ((meta === null || meta === void 0 ? void 0 : meta.colIndex) === (cellInfo === null || cellInfo === void 0 ? void 0 : cellInfo.colIndex) &&
                (meta === null || meta === void 0 ? void 0 : meta.rowIndex) === (cellInfo === null || cellInfo === void 0 ? void 0 : cellInfo.rowIndex)) {
                return cell;
            }
        });
        if (findCell) {
            cells.push(findCell);
            cellsMeta = (cellInfo === null || cellInfo === void 0 ? void 0 : cellInfo.showText)
                ? findCell === null || findCell === void 0 ? void 0 : findCell.getMeta()
                : cellsMeta;
        }
        else {
            invisibleCellInfo.push(cellInfo);
        }
    });
    return { cells: cells, invisibleCellInfo: invisibleCellInfo, cellsMeta: cellsMeta };
};
/**
 * get the data cell and meta that make up the mergedCell
 * @param cellsInfos
 * @param allVisibleCells
 * @param sheet
 */
var getTempMergedCell = function (allVisibleCells, sheet, cellsInfos) {
    var _a;
    if (cellsInfos === void 0) { cellsInfos = []; }
    var _b = getVisibleInfo(cellsInfos, allVisibleCells), cellsMeta = _b.cellsMeta, cells = _b.cells, invisibleCellInfo = _b.invisibleCellInfo;
    var viewMeta = cellsMeta;
    var mergedAllCells = cells;
    // some cells are invisible and some cells are visible
    var isPartiallyVisible = (invisibleCellInfo === null || invisibleCellInfo === void 0 ? void 0 : invisibleCellInfo.length) > 0 &&
        invisibleCellInfo.length < cellsInfos.length;
    // 当 MergedCell 只有部分在可视区域时，在此获取 MergedCell 不在可视区域内的 cells
    if (isPartiallyVisible) {
        var _c = getInvisibleInfo(invisibleCellInfo, sheet), invisibleCells = _c.cells, invisibleMeta = _c.cellsMeta;
        viewMeta = viewMeta || invisibleMeta;
        mergedAllCells = cells.concat(invisibleCells);
    }
    if (!isEmpty(cells) && !viewMeta) {
        viewMeta = (_a = mergedAllCells[0]) === null || _a === void 0 ? void 0 : _a.getMeta(); // 如果没有指定合并后的文本绘制的位置，默认画在选择的第一个单元格内
    }
    return {
        cells: mergedAllCells,
        viewMeta: viewMeta,
        isPartiallyVisible: isPartiallyVisible,
    };
};
/**
 * get the active cells' info as the default info of merged cells
 * @param sheet
 */
var getActiveCellsInfo = function (sheet) {
    var interaction = sheet.interaction;
    var cells = interaction.getActiveCells();
    var mergedCellsInfo = [];
    forEach(cells, function (cell, index) {
        var meta = cell.getMeta();
        // 在合并单元格中，第一个单元格被标标记为展示数据。
        var showText = index === 0 ? { showText: true } : {};
        mergedCellsInfo.push(__assign(__assign({}, showText), { colIndex: meta === null || meta === void 0 ? void 0 : meta.colIndex, rowIndex: meta === null || meta === void 0 ? void 0 : meta.rowIndex }));
    });
    return mergedCellsInfo;
};
/**
 * draw the background of the merged cell
 * @param sheet the base sheet instance
 * @param cellsInfo
 * @param hideData
 */
var mergeCell = function (sheet, cellsInfo, hideData) {
    var _a;
    var mergeCellInfo = cellsInfo || getActiveCellsInfo(sheet);
    if ((mergeCellInfo === null || mergeCellInfo === void 0 ? void 0 : mergeCellInfo.length) <= 1) {
        // eslint-disable-next-line no-console
        console.error('then merged cells must be more than one');
        return;
    }
    var allVisibleCells = filter(sheet.panelScrollGroup.getChildren(), function (child) { return !(child instanceof MergedCell); });
    var _b = getTempMergedCell(allVisibleCells, sheet, mergeCellInfo), cells = _b.cells, viewMeta = _b.viewMeta, isPartiallyVisible = _b.isPartiallyVisible;
    if (!isEmpty(cells)) {
        var mergedCellInfoList = ((_a = sheet.options) === null || _a === void 0 ? void 0 : _a.mergedCellsInfo) || [];
        mergedCellInfoList.push(mergeCellInfo);
        sheet.setOptions({
            mergedCellsInfo: mergedCellInfoList,
        });
        var meta = hideData ? undefined : viewMeta;
        sheet.panelScrollGroup.add(new MergedCell(sheet, cells, meta, isPartiallyVisible));
    }
};
/**
 * remove unmergedCells Info, return new mergedCell info
 * @param removeMergedCell
 * @param mergedCellsInfo
 */
var removeUnmergedCellsInfo = function (removeMergedCell, mergedCellsInfo) {
    var removeCellInfo = map(removeMergedCell.cells, function (cell) {
        return {
            colIndex: cell.getMeta().colIndex,
            rowIndex: cell.getMeta().rowIndex,
        };
    });
    return filter(mergedCellsInfo, function (mergedCellInfo) {
        var newMergedCellInfo = mergedCellInfo.map(function (info) {
            if (info.showText) {
                return {
                    colIndex: info.colIndex,
                    rowIndex: info.rowIndex,
                };
            }
            return info;
        });
        return !isEqual(newMergedCellInfo, removeCellInfo);
    });
};
/**
 * unmerge MergedCell
 * @param removedCells
 * @param sheet
 */
var unmergeCell = function (sheet, removedCells) {
    var _a, _b, _c;
    if (!removedCells || removedCells.cellType !== CellTypes.MERGED_CELL) {
        // eslint-disable-next-line no-console
        console.error("unmergeCell: the ".concat(removedCells, " is not a MergedCell"));
        return;
    }
    var newMergedCellsInfo = removeUnmergedCellsInfo(removedCells, (_a = sheet.options) === null || _a === void 0 ? void 0 : _a.mergedCellsInfo);
    if ((newMergedCellsInfo === null || newMergedCellsInfo === void 0 ? void 0 : newMergedCellsInfo.length) !== ((_c = (_b = sheet.options) === null || _b === void 0 ? void 0 : _b.mergedCellsInfo) === null || _c === void 0 ? void 0 : _c.length)) {
        sheet.setOptions({
            mergedCellsInfo: newMergedCellsInfo,
        });
        removedCells.remove(true);
    }
};
/**
 * 合并 TempMergedCell, 通过 cell.viewMeta.id 判断 TempMergedCell 是否是同一个。
 * @param TempMergedCells
 * @param otherTempMergedCells
 */
var mergeTempMergedCell = function (TempMergedCells, otherTempMergedCells) {
    var mergedTempMergedCells = {};
    __spreadArray(__spreadArray([], __read(TempMergedCells), false), __read(otherTempMergedCells), false).forEach(function (cell) {
        mergedTempMergedCells[cell.viewMeta.id] = cell;
    });
    return Object.values(mergedTempMergedCells);
};
/**
 * 将 MergedCell 转换成 TempMergedCell
 * @param oldMergedCells
 * @constructor
 */
var MergedCellConvertTempMergedCells = function (oldMergedCells) {
    return map(oldMergedCells, function (mergedCell) {
        return {
            cells: mergedCell.cells,
            viewMeta: mergedCell.getMeta(),
            isPartiallyVisible: mergedCell.isPartiallyVisible,
        };
    });
};
/**
 * 对比两个TempMergedCell，返回 mainTempMergedCells 中存在的，但是 otherTempMergedCells 中不存在的的 TempMergedCell
 * 因为 g-base 无法渲染不在可视区域内的图形，所以 isPartiallyVisible 为 true 时也需要重新渲染
 * @param mainTempMergedCells
 * @param compareTempMergedCells
 */
var differenceTempMergedCells = function (mainTempMergedCells, compareTempMergedCells) {
    return differenceWith(mainTempMergedCells, compareTempMergedCells, function (main, compare) {
        return (isEqual(main.viewMeta.id, compare.viewMeta.id) &&
            !main.isPartiallyVisible);
    });
};
/**
 * update the mergedCell
 * @param sheet the base sheet instance
 */
var updateMergedCells = function (sheet) {
    var _a;
    var mergedCellsInfo = (_a = sheet.options) === null || _a === void 0 ? void 0 : _a.mergedCellsInfo;
    if (isEmpty(mergedCellsInfo))
        return;
    // 可见区域的所有cells
    var allCells = filter(sheet.panelScrollGroup.getChildren(), function (child) { return !(child instanceof MergedCell); });
    if (isEmpty(allCells))
        return;
    // allVisibleTempMergedCells 所有可视区域的 mergedCell
    var allVisibleTempMergedCells = [];
    mergedCellsInfo.forEach(function (cellsInfo) {
        var tempMergedCell = getTempMergedCell(allCells, sheet, cellsInfo);
        if (tempMergedCell.cells.length > 0) {
            allVisibleTempMergedCells.push(tempMergedCell);
        }
    });
    // 获取 oldTempMergedCells 便用后续进行 diff 操作
    var oldMergedCells = filter(sheet.panelScrollGroup.getChildren(), function (child) { return child instanceof MergedCell; });
    var oldTempMergedCells = MergedCellConvertTempMergedCells(oldMergedCells);
    // compare oldTempMergedCells and allTempMergedCells, find remove MergedCells and add MergedCells
    var removeTempMergedCells = differenceTempMergedCells(oldTempMergedCells, allVisibleTempMergedCells);
    var addTempMergedCells = differenceTempMergedCells(allVisibleTempMergedCells, oldTempMergedCells);
    // remove old MergedCells
    forEach(removeTempMergedCells, function (tempMergedCell) {
        var oldMergedCell = find(oldMergedCells, function (mergedCell) {
            return isEqual(mergedCell.getMeta().id, tempMergedCell.viewMeta.id);
        });
        oldMergedCell === null || oldMergedCell === void 0 ? void 0 : oldMergedCell.remove(true);
    });
    // add new MergedCells
    forEach(addTempMergedCells, function (_a) {
        var cells = _a.cells, viewMeta = _a.viewMeta, isPartiallyVisible = _a.isPartiallyVisible;
        sheet.panelScrollGroup.add(new MergedCell(sheet, cells, viewMeta, isPartiallyVisible));
    });
};

var getCellMeta = function (cell) {
    var meta = cell.getMeta();
    var id = meta.id, colIndex = meta.colIndex, rowIndex = meta.rowIndex;
    return {
        id: id,
        colIndex: colIndex,
        rowIndex: rowIndex,
        type: cell.cellType,
    };
};

/**
 * @desc clear the interaction state information
 * @param spreadsheet sheet instance
 */
var clearState = function (spreadsheet) {
    var activeIcons = spreadsheet.store.get('visibleActionIcons');
    forEach(activeIcons, function (icon) {
        icon.set('visible', false);
    });
    spreadsheet.store.set('visibleActionIcons', []);
    var allInteractedCells = spreadsheet.interaction.getInteractedCells();
    if (!isEmpty(allInteractedCells)) {
        forEach(allInteractedCells, function (cell) {
            cell.hideInteractionShape();
        });
        spreadsheet.interaction.resetState();
        if (spreadsheet.options.interaction.selectedCellsSpotlight) {
            var unSelectedCells = spreadsheet.interaction.getPanelGroupAllUnSelectedDataCells() || [];
            forEach(unSelectedCells, function (cell) {
                cell.clearUnselectedState();
            });
        }
    }
};
/**
 * @desc set the interaction state information
 * @param spreadsheet sheet instance
 * @param interactionStateInfo
 */
var setState = function (spreadsheet, interactionStateInfo) {
    var stateName = interactionStateInfo === null || interactionStateInfo === void 0 ? void 0 : interactionStateInfo.stateName;
    if (!spreadsheet.interaction.isEqualStateName(stateName)) {
        // There can only be one state in the table. When the stateName is inconsistent with the state in the stateInfo, the previously stored state should be cleared.
        clearState(spreadsheet);
        spreadsheet.hideTooltip();
        spreadsheet.store.set(INTERACTION_STATE_INFO_KEY, interactionStateInfo);
    }
};

var customMerge = function () {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var customize = function (origin, updated) {
        if (isArray(origin) && isArray(updated)) {
            return updated;
        }
    };
    var args = __spreadArray(__spreadArray([], __read(objects), false), [customize], false);
    return mergeWith.apply(void 0, __spreadArray([{}], __read(args), false));
};
var getSafetyDataConfig = function (dataConfig) {
    var result = customMerge(DEFAULT_DATA_CONFIG, dataConfig);
    // 自定义树和数值为空的场景, 关闭 数值置于列头
    if (!isEmpty(result.fields.customTreeItems) ||
        isEmpty(result.fields.values)) {
        result.fields.valueInCols = false;
    }
    return result;
};
var getSafetyOptions = function (options) {
    return customMerge(DEFAULT_OPTIONS, options);
};

var isMultiDataItem = function (value) {
    return isObject(value) && 'values' in value;
};

var isNotNumber = function (value) {
    return Number.isNaN(Number(value));
};
/**
 * 浮点数加法，解决精度问题
 * 因为乘法也有精度问题，故用字符串形式
 * TODO：因为暂时只支持加法，自己先实现，如果有其他场景考虑用现有库
 * @param arg1
 * @param arg2
 */
function accAdd(arg1, arg2) {
    var _a, _b, _c;
    var _d = __read((_a = arg1 === null || arg1 === void 0 ? void 0 : arg1.toString()) === null || _a === void 0 ? void 0 : _a.split('.'), 2), pre1 = _d[0], _e = _d[1], next1 = _e === void 0 ? '' : _e;
    var _f = __read((_b = arg2 === null || arg2 === void 0 ? void 0 : arg2.toString()) === null || _b === void 0 ? void 0 : _b.split('.'), 2), pre2 = _f[0], _g = _f[1], next2 = _g === void 0 ? '' : _g;
    var r1 = (next1 === null || next1 === void 0 ? void 0 : next1.length) || 0;
    var r2 = (next2 === null || next2 === void 0 ? void 0 : next2.length) || 0;
    var m = Math.pow(10, Math.max(r1, r2));
    var suffix = (_c = Array(Math.abs(r1 - r2))
        .fill('0')) === null || _c === void 0 ? void 0 : _c.join('');
    var number1 = r2 > r1 ? "".concat(pre1).concat(next1).concat(suffix) : "".concat(pre1).concat(next1);
    var number2 = r1 > r2 ? "".concat(pre2).concat(next2).concat(suffix) : "".concat(pre2).concat(next2);
    return (Number.parseInt(number1, 10) + Number.parseInt(number2, 10)) / m;
}
/**
 * calculate sum value
 */
var getDataSumByField = function (data, field) {
    var sum = reduce(data, function (pre, next) {
        var fieldValue = get(next, field, 0);
        var v = isNotNumber(fieldValue)
            ? 0
            : Number.parseFloat(fieldValue) || Number(fieldValue);
        return accAdd(pre, v);
    }, 0);
    return sum;
};

/**
 * 获取tooltip中需要显示的数据项
 */
/** whether the data of hover is selected */
var isHoverDataInSelectedData = function (selectedData, activeData) {
    return some(selectedData, function (dataItem) {
        return isEqual(dataItem, activeData);
    });
};
/**
 * calculate tooltip show position
 */
var getAutoAdjustPosition = function (_a) {
    var spreadsheet = _a.spreadsheet, position = _a.position, tooltipContainer = _a.tooltipContainer, autoAdjustBoundary = _a.autoAdjustBoundary;
    var x = position.x + TOOLTIP_POSITION_OFFSET.x;
    var y = position.y + TOOLTIP_POSITION_OFFSET.y;
    if (!autoAdjustBoundary) {
        return {
            x: x,
            y: y,
        };
    }
    var isAdjustBodyBoundary = autoAdjustBoundary === 'body';
    var _b = spreadsheet.facet.panelBBox, maxX = _b.maxX, maxY = _b.maxY;
    var _c = spreadsheet.options, width = _c.width, height = _c.height;
    var canvas = spreadsheet.container.get('el');
    var _d = canvas.getBoundingClientRect(), canvasOffsetTop = _d.top, canvasOffsetLeft = _d.left;
    var _e = tooltipContainer.getBoundingClientRect(), tooltipWidth = _e.width, tooltipHeight = _e.height;
    var _f = document.body.getBoundingClientRect(), viewportWidth = _f.width, viewportHeight = _f.height;
    var maxWidth = isAdjustBodyBoundary
        ? viewportWidth
        : Math.min(width, maxX) + canvasOffsetLeft;
    var maxHeight = isAdjustBodyBoundary
        ? viewportHeight
        : Math.min(height, maxY) + canvasOffsetTop;
    if (x + tooltipWidth >= maxWidth) {
        x = maxWidth - tooltipWidth;
    }
    if (y + tooltipHeight >= maxHeight) {
        y = maxHeight - tooltipHeight;
    }
    return {
        x: x,
        y: y,
    };
};
var getTooltipDefaultOptions = function (options) {
    return __assign({ operator: { onClick: noop, menus: [] }, enterable: true, enableFormat: true }, options);
};
var getMergedQuery = function (meta) {
    return __assign(__assign({}, meta === null || meta === void 0 ? void 0 : meta.colQuery), meta === null || meta === void 0 ? void 0 : meta.rowQuery);
};
/**
 * add style to container
 */
var setContainerStyle = function (container, options) {
    if (options === void 0) { options = {
        className: '',
    }; }
    if (!container) {
        return;
    }
    var style = options.style, className = options.className;
    if (style) {
        Object.keys(style).forEach(function (item) {
            container.style[item] = style[item];
        });
    }
    if (className) {
        container.classList.add(className);
    }
};
/* formate */
var getFriendlyVal = function (val) {
    var isInvalidNumber = isNumber(val) && Number.isNaN(val);
    var isEmptyString = val === '';
    return isNil(val) || isInvalidNumber || isEmptyString ? '-' : val;
};
var getFieldFormatter = function (spreadsheet, field) {
    var _a;
    var formatter = (_a = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.dataSet) === null || _a === void 0 ? void 0 : _a.getFieldFormatter(field);
    return function (v, data) {
        return getFriendlyVal(formatter(v, data));
    };
};
var getListItem = function (spreadsheet, _a) {
    var _b;
    var data = _a.data, field = _a.field, valueField = _a.valueField, _c = _a.useCompleteDataForFormatter, useCompleteDataForFormatter = _c === void 0 ? true : _c;
    var name = (_b = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.dataSet) === null || _b === void 0 ? void 0 : _b.getFieldName(field);
    var formatter = getFieldFormatter(spreadsheet, field);
    // 暂时对 object 类型 data 不作处理，上层通过自定义 tooltip 的方式去自行定制
    var dataValue = isObject(data[field])
        ? JSON.stringify(data[field])
        : data[field];
    var value = formatter(valueField || dataValue, useCompleteDataForFormatter ? data : undefined);
    return {
        name: name,
        value: value,
    };
};
var getFieldList = function (spreadsheet, fields, activeData) {
    var currFields = filter(concat([], fields), function (field) { return field !== EXTRA_FIELD && activeData[field]; });
    var fieldList = map(currFields, function (field) {
        return getListItem(spreadsheet, {
            data: activeData,
            field: field,
            useCompleteDataForFormatter: false,
        });
    });
    return fieldList;
};
/**
 * 获取选中格行/列头信息
 * @param spreadsheet
 * @param activeData
 */
var getHeadInfo = function (spreadsheet, activeData, options) {
    var _a, _b, _c, _d;
    var isTotals = (options || {}).isTotals;
    var colList = [];
    var rowList = [];
    if (activeData) {
        var colFields = (_b = (_a = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.dataSet) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.columns;
        var rowFields = (_d = (_c = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.dataSet) === null || _c === void 0 ? void 0 : _c.fields) === null || _d === void 0 ? void 0 : _d.rows;
        colList = getFieldList(spreadsheet, colFields, activeData);
        rowList = getFieldList(spreadsheet, rowFields, activeData);
    }
    // 此时是总计-总计
    if (isEmpty(colList) && isEmpty(rowList) && isTotals) {
        colList = [{ value: i18n('总计') }];
    }
    return { cols: colList, rows: rowList };
};
/**
 * 获取数据明细
 * @param spreadsheet
 * @param activeData
 * @param options
 */
var getDetailList = function (spreadsheet, activeData, options) {
    if (activeData) {
        var isTotals = options.isTotals;
        var field = activeData[EXTRA_FIELD];
        var value = activeData[field];
        var valItem_1 = [];
        if (isTotals) {
            // total/subtotal
            valItem_1.push(getListItem(spreadsheet, {
                data: activeData,
                field: field,
                valueField: get(activeData, VALUE_FIELD),
            }));
        }
        // the value hangs at the head of the column, match the displayed fields according to the metric itself
        // 1、multiple derivative indicators
        // 2、only one column scene
        // 3、the clicked cell belongs to the derived index column
        // tooltip need to show all derivative indicators
        else if (isMultiDataItem(value) &&
            spreadsheet.getTooltipDataItemMappingCallback()) {
            var mappedResult_1 = handleDataItem(activeData, spreadsheet.getTooltipDataItemMappingCallback());
            forEach(mappedResult_1, function (_, key) {
                valItem_1.push(getListItem(spreadsheet, { data: mappedResult_1, field: key }));
            });
        }
        else {
            valItem_1.push(getListItem(spreadsheet, { data: activeData, field: field }));
        }
        return valItem_1;
    }
};
var getSummaryName = function (spreadsheet, currentField, isTotals) {
    var _a;
    if (isTotals) {
        return i18n('总计');
    }
    var name = (_a = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.dataSet) === null || _a === void 0 ? void 0 : _a.getFieldName(currentField);
    return name && name !== 'undefined' ? name : '';
};
var getSelectedValueFields = function (selectedData, field) {
    return uniq(selectedData.map(function (d) { return get(d, field); }));
};
var getRowOrColSelectedIndexes = function (nodes, leafNodes, isRow) {
    if (isRow === void 0) { isRow = true; }
    var selectedIndexes = [];
    forEach(leafNodes, function (leaf, index) {
        forEach(nodes, function (item) {
            if (!isRow && item.colIndex !== -1) {
                selectedIndexes.push([index, item.colIndex]);
            }
            else if (isRow && item.rowIndex !== -1) {
                selectedIndexes.push([item.rowIndex, index]);
            }
        });
    });
    return selectedIndexes;
};
var getSelectedCellIndexes = function (spreadsheet, layoutResult) {
    var _a;
    var rowLeafNodes = layoutResult.rowLeafNodes, colLeafNodes = layoutResult.colLeafNodes;
    var _b = spreadsheet.interaction.getState().nodes, nodes = _b === void 0 ? [] : _b;
    var cells = spreadsheet.interaction.getCells();
    var cellType = (_a = cells === null || cells === void 0 ? void 0 : cells[0]) === null || _a === void 0 ? void 0 : _a.type;
    if (cellType === CellTypes.COL_CELL) {
        return getRowOrColSelectedIndexes(nodes, rowLeafNodes, false);
    }
    if (cellType === CellTypes.ROW_CELL) {
        return getRowOrColSelectedIndexes(nodes, colLeafNodes);
    }
    return [];
};
var getSelectedCellsData = function (spreadsheet, showSingleTips) {
    var _a;
    var layoutResult = (_a = spreadsheet.facet) === null || _a === void 0 ? void 0 : _a.layoutResult;
    // 列头选择和行头选择没有存所有selected的cell，因此要遍历index对比，而selected则不需要
    if (showSingleTips) {
        // 行头列头单选多选
        // TODO：行头是树形时，state里没有nodes了，得重新兼容下
        var selectedCellIndexes = getSelectedCellIndexes(spreadsheet, layoutResult);
        return map(selectedCellIndexes, function (_a) {
            var _b = __read(_a, 2), i = _b[0], j = _b[1];
            var viewMeta = layoutResult.getCellMeta(i, j);
            return (viewMeta === null || viewMeta === void 0 ? void 0 : viewMeta.data) || getMergedQuery(viewMeta);
        });
    }
    // 其他（刷选，data cell多选）
    var cells = spreadsheet.interaction.getActiveCells();
    return map(cells, function (cell) { var _a; return ((_a = cell.getMeta()) === null || _a === void 0 ? void 0 : _a.data) || getMergedQuery(cell.getMeta()); });
};
var getSummaries = function (params) {
    var spreadsheet = params.spreadsheet, getShowValue = params.getShowValue, _a = params.options, options = _a === void 0 ? {} : _a;
    var summaries = [];
    var summary = {};
    var isTableMode = spreadsheet.isTableMode();
    if (isTableMode && (options === null || options === void 0 ? void 0 : options.showSingleTips)) {
        var selectedCellsData_1 = spreadsheet.dataSet.getMultiData({});
        return [{ selectedData: selectedCellsData_1, name: '', value: '' }];
    }
    var selectedCellsData = getSelectedCellsData(spreadsheet, options.showSingleTips); // 拿到选择的所有data-cell的数据
    forEach(selectedCellsData, function (item) {
        var _a;
        if (summary[item === null || item === void 0 ? void 0 : item[EXTRA_FIELD]]) {
            (_a = summary[item === null || item === void 0 ? void 0 : item[EXTRA_FIELD]]) === null || _a === void 0 ? void 0 : _a.push(item);
        }
        else {
            summary[item === null || item === void 0 ? void 0 : item[EXTRA_FIELD]] = [item];
        }
    });
    mapKeys(summary, function (selected, field) {
        var currentFormatter = getFieldFormatter(spreadsheet, field);
        var name = getSummaryName(spreadsheet, field, options === null || options === void 0 ? void 0 : options.isTotals);
        var value;
        if (getShowValue) {
            value = getShowValue(selected, VALUE_FIELD);
        }
        if (isTableMode) {
            value = '';
        }
        else if (every(selected, function (item) { return isNotNumber(get(item, VALUE_FIELD)); })) {
            // 如果选中的单元格都无数据，则显示"-"
            value = spreadsheet.options.placeholder;
        }
        else {
            var dataSum = getDataSumByField(selected, VALUE_FIELD);
            value = parseFloat(dataSum.toPrecision(PRECISION)); // solve accuracy problems
            if (currentFormatter) {
                value = currentFormatter(dataSum, selected);
            }
        }
        summaries.push({
            selectedData: selected,
            name: name,
            value: value,
        });
    });
    return summaries;
};
var getTooltipData = function (params) {
    var spreadsheet = params.spreadsheet, _a = params.cellInfos, cellInfos = _a === void 0 ? [] : _a, _b = params.options, options = _b === void 0 ? {} : _b, getShowValue = params.getShowValue;
    var summaries = null;
    var headInfo = null;
    var details = null;
    var firstCellInfo = cellInfos[0] || {};
    if (!(options === null || options === void 0 ? void 0 : options.hideSummary)) {
        // 计算多项的sum（默认为sum，可自定义）
        summaries = getSummaries({
            spreadsheet: spreadsheet,
            options: options,
            getShowValue: getShowValue,
        });
    }
    else if (options.showSingleTips) {
        // 行列头hover & 明细表所有hover
        var getFieldName = function (field) { var _a, _b; return (_b = find((_a = spreadsheet.dataCfg) === null || _a === void 0 ? void 0 : _a.meta, function (item) { return (item === null || item === void 0 ? void 0 : item.field) === field; })) === null || _b === void 0 ? void 0 : _b.name; };
        var currentFormatter = getFieldFormatter(spreadsheet, firstCellInfo.valueField);
        var formattedValue = currentFormatter(firstCellInfo.value);
        var cellName = options.enableFormat
            ? getFieldName(firstCellInfo.value) || formattedValue
            : getFieldName(firstCellInfo.valueField);
        firstCellInfo.name = cellName || '';
    }
    else {
        headInfo = getHeadInfo(spreadsheet, firstCellInfo, options);
        details = getDetailList(spreadsheet, firstCellInfo, options);
    }
    var _c = firstCellInfo || {}, interpretation = _c.interpretation, infos = _c.infos, tips = _c.tips, name = _c.name;
    return { summaries: summaries, interpretation: interpretation, infos: infos, tips: tips, name: name, headInfo: headInfo, details: details };
};
var mergeCellInfo = function (cells) {
    return map(cells, function (stateCell) {
        var stateCellMeta = stateCell.getMeta();
        return assign({}, stateCellMeta.query || {}, pick(stateCellMeta, ['colIndex', 'rowIndex']));
    });
};
var getActiveCellsTooltipData = function (spreadsheet) {
    var cellInfos = [];
    if (!spreadsheet.interaction.isSelectedState()) {
        return [];
    }
    spreadsheet.interaction.getActiveCells().forEach(function (cell) {
        var valueInCols = spreadsheet.dataCfg.fields.valueInCols;
        var meta = cell.getMeta();
        var query = getMergedQuery(meta);
        if (isEmpty(meta) || isEmpty(query)) {
            return;
        }
        var currentCellInfo = __assign(__assign({}, query), { colIndex: valueInCols ? meta.colIndex : null, rowIndex: !valueInCols ? meta.rowIndex : null });
        var isEqualCellInfo = cellInfos.find(function (cellInfo) {
            return isEqual(currentCellInfo, cellInfo);
        });
        if (!isEqualCellInfo) {
            cellInfos.push(currentCellInfo);
        }
    });
    return cellInfos;
};
var getTooltipOptionsByCellType = function (cellTooltipConfig, cellType) {
    if (cellTooltipConfig === void 0) { cellTooltipConfig = {}; }
    var getOptionsByCell = function (cellConfig) {
        return customMerge(cellTooltipConfig, cellConfig);
    };
    var col = cellTooltipConfig.col, row = cellTooltipConfig.row, data = cellTooltipConfig.data, corner = cellTooltipConfig.corner;
    if (cellType === CellTypes.COL_CELL) {
        return getOptionsByCell(col);
    }
    if (cellType === CellTypes.ROW_CELL) {
        return getOptionsByCell(row);
    }
    if (cellType === CellTypes.DATA_CELL) {
        return getOptionsByCell(data);
    }
    if (cellType === CellTypes.CORNER_CELL) {
        return getOptionsByCell(corner);
    }
    return __assign({}, cellTooltipConfig);
};
var getTooltipOptions = function (spreadsheet, event) {
    var _a;
    var cellType = (_a = spreadsheet.getCellType) === null || _a === void 0 ? void 0 : _a.call(spreadsheet, event.target);
    return getTooltipOptionsByCellType(spreadsheet.options.tooltip, cellType);
};
var getTooltipVisibleOperator = function (operation, options) {
    var _a = options.defaultMenus, defaultMenus = _a === void 0 ? [] : _a, cell = options.cell;
    var getDisplayMenus = function (menus) {
        if (menus === void 0) { menus = []; }
        return menus
            .filter(function (menu) {
            var _a;
            return isFunction(menu.visible)
                ? menu.visible(cell)
                : (_a = menu.visible) !== null && _a !== void 0 ? _a : true;
        })
            .map(function (menu) {
            if (menu.children) {
                menu.children = getDisplayMenus(menu.children);
            }
            return menu;
        });
    };
    var displayMenus = getDisplayMenus(operation.menus);
    return {
        onClick: operation.onClick,
        menus: compact(__spreadArray(__spreadArray([], __read(defaultMenus), false), __read(displayMenus), false)),
    };
};

var getClassNameWithPrefix = function () {
    var classNames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classNames[_i] = arguments[_i];
    }
    return "".concat(S2_PREFIX_CLS, "-").concat(classNames.join('-'));
};

var getHiddenColumnFieldKey = function (field) {
    var targetFieldKey = (field.includes(ID_SEPARATOR) ? 'id' : 'field');
    return targetFieldKey;
};
/**
 * @name 获取需要隐藏的 field 转成对应的 Node
 */
var getHiddenColumnNodes = function (spreadsheet, hiddenColumnFields) {
    if (hiddenColumnFields === void 0) { hiddenColumnFields = []; }
    var columnNodes = spreadsheet.getInitColumnNodes();
    return compact(hiddenColumnFields.map(function (field) {
        var targetFieldKey = getHiddenColumnFieldKey(field);
        return columnNodes.find(function (node) { return node[targetFieldKey] === field; });
    }));
};
/**
 * @name 获取隐藏列兄弟节点
 * @description 获取当前隐藏列(兼容多选) 所对应为未隐藏的兄弟节点
 * @param hideColumns 经过分组的连续隐藏列
   [ 1, 2, 3, -, -, -, (7 √), 8, 9 ]
  [ 1, 2, 3, (4 √), - ]
 */
var getHiddenColumnDisplaySiblingNode = function (spreadsheet, hiddenColumnFields) {
    if (hiddenColumnFields === void 0) { hiddenColumnFields = []; }
    if (isEmpty(hiddenColumnFields)) {
        return {
            prev: null,
            next: null,
        };
    }
    var initColumnNodes = spreadsheet.getInitColumnNodes();
    var hiddenColumnIndexes = getHiddenColumnNodes(spreadsheet, hiddenColumnFields).map(function (node) { return node === null || node === void 0 ? void 0 : node.colIndex; });
    var lastHiddenColumnIndex = Math.max.apply(Math, __spreadArray([], __read(hiddenColumnIndexes), false));
    var firstHiddenColumnIndex = Math.min.apply(Math, __spreadArray([], __read(hiddenColumnIndexes), false));
    var nextSiblingNode = initColumnNodes.find(function (node) { return node.colIndex === lastHiddenColumnIndex + 1; });
    var prevSiblingNode = initColumnNodes.find(function (node) { return node.colIndex === firstHiddenColumnIndex - 1; });
    return {
        prev: prevSiblingNode || null,
        next: nextSiblingNode || null,
    };
};
/**
 * @name 获取隐藏列组
 * @description 如果给定的隐藏列不是连续的, 比如原始列是 [1,2,3,4,5,6,7], 隐藏列是 [2,3,6], 那么其实在表格上需要显示两个展开按钮
   [[2,3],[6]]
 */
var getHiddenColumnsThunkGroup = function (columns, hiddenColumnFields) {
    if (isEmpty(hiddenColumnFields)) {
        return [];
    }
    // 上一个需要隐藏项的序号
    var prevHiddenIndex = Number.NEGATIVE_INFINITY;
    return columns.reduce(function (result, field, index) {
        if (!hiddenColumnFields.includes(field)) {
            return result;
        }
        if (index === prevHiddenIndex + 1) {
            var lastGroup = last(result);
            lastGroup.push(field);
        }
        else {
            var group = [field];
            result.push(group);
        }
        prevHiddenIndex = index;
        return result;
    }, []);
};
/**
 * @name 隐藏指定列
 * @description 1. 通过分析组件隐藏, 2. 点击列头隐藏
   存储: 1.隐藏列所对应的兄弟节点 (显示展开按钮), 2.当前隐藏列 (点击展开按钮恢复隐藏)
   重置交互: 比如选中当前列, 显示高亮背景色, 隐藏后需要取消高亮
   钩子: 提供当前被隐藏的列, 和全量的隐藏组
 */
var hideColumns = function (spreadsheet, selectedColumnFields, forceRender) {
    if (selectedColumnFields === void 0) { selectedColumnFields = []; }
    if (forceRender === void 0) { forceRender = false; }
    var lastHiddenColumnDetail = spreadsheet.store.get('hiddenColumnsDetail', []);
    var lastHiddenColumnFields = spreadsheet.options.interaction.hiddenColumnFields;
    if (isEqual(selectedColumnFields, lastHiddenColumnFields) && !forceRender) {
        return;
    }
    var hiddenColumnFields = uniq(__spreadArray(__spreadArray([], __read(selectedColumnFields), false), __read(lastHiddenColumnFields), false));
    spreadsheet.setOptions({
        interaction: {
            hiddenColumnFields: hiddenColumnFields,
        },
    });
    var displaySiblingNode = getHiddenColumnDisplaySiblingNode(spreadsheet, selectedColumnFields);
    var currentHiddenColumnsInfo = {
        hideColumnNodes: getHiddenColumnNodes(spreadsheet, selectedColumnFields),
        displaySiblingNode: displaySiblingNode,
    };
    var hiddenColumnsDetail = __spreadArray(__spreadArray([], __read(lastHiddenColumnDetail), false), [
        currentHiddenColumnsInfo,
    ], false);
    spreadsheet.emit(S2Event.LAYOUT_TABLE_COL_HIDDEN, currentHiddenColumnsInfo, hiddenColumnsDetail);
    spreadsheet.store.set('hiddenColumnsDetail', hiddenColumnsDetail);
    spreadsheet.interaction.reset();
    spreadsheet.render(false);
};
/**
 * @name 根据分组隐藏指定列
 * @description 根据配置的隐藏列自动分组, 批量隐藏
 */
var hideColumnsByThunkGroup = function (spreadsheet, hiddenColumnFields, forceRender) {
    if (hiddenColumnFields === void 0) { hiddenColumnFields = []; }
    if (forceRender === void 0) { forceRender = false; }
    var hiddenColumnsGroup = getHiddenColumnsThunkGroup(spreadsheet.dataCfg.fields.columns, hiddenColumnFields);
    hiddenColumnsGroup.forEach(function (fields) {
        hideColumns(spreadsheet, fields, forceRender);
    });
};
var isLastColumnAfterHidden = function (spreadsheet, columnField) {
    var columnNodes = spreadsheet.getColumnNodes();
    var initColumnNodes = spreadsheet.getInitColumnNodes();
    var fieldKey = getHiddenColumnFieldKey(columnField);
    return (get(last(columnNodes), fieldKey) === columnField &&
        get(last(initColumnNodes), fieldKey) !== columnField);
};
var getValidDisplaySiblingNode = function (displaySiblingNode) {
    return (displaySiblingNode === null || displaySiblingNode === void 0 ? void 0 : displaySiblingNode.next) || (displaySiblingNode === null || displaySiblingNode === void 0 ? void 0 : displaySiblingNode.prev);
};
var getValidDisplaySiblingNodeId = function (displaySiblingNode) {
    var node = getValidDisplaySiblingNode(displaySiblingNode);
    return node === null || node === void 0 ? void 0 : node.id;
};
var isEqualDisplaySiblingNodeId = function (displaySiblingNode, nodeId) {
    return getValidDisplaySiblingNodeId(displaySiblingNode) === nodeId;
};

var shouldShowActionIcons = function (actionIconCfg, meta, cellType) {
    if (!actionIconCfg) {
        return false;
    }
    var iconNames = actionIconCfg.iconNames, displayCondition = actionIconCfg.displayCondition, belongsCell = actionIconCfg.belongsCell;
    if (isEmpty(iconNames)) {
        return false;
    }
    if (belongsCell !== cellType) {
        return false;
    }
    if (!displayCondition) {
        // 没有展示条件参数默认全展示
        return true;
    }
    return displayCondition(meta);
};

/**
 * Transform from origin single data to correct dimension values
 * data: {
 *  price: 16,
 *  province: '辽宁省',
 *  city: '芜湖市',
 *  category: '家具',
 *  subCategory: '椅子',
 * }
 * dimensions: [province, city]
 * return [辽宁省, 芜湖市]
 *
 * @param record
 * @param dimensions
 */
function transformDimensionsValues(record, dimensions, sortedDimensionValues) {
    var dimensionValuePath = [];
    return map(dimensions, function (dimension) {
        var _a;
        var dimensionValue = record[dimension];
        dimensionValuePath.push("".concat(dimensionValue));
        var cacheKey = dimensionValuePath.join("".concat(ID_SEPARATOR));
        if (!sortedDimensionValues[dimension]) {
            sortedDimensionValues[dimension] = [cacheKey];
        }
        else if (!((_a = sortedDimensionValues[dimension]) === null || _a === void 0 ? void 0 : _a.includes(cacheKey))) {
            sortedDimensionValues[dimension].push(cacheKey);
        }
        // 保证 undefined 之外的数据都为 string 类型
        if (dimensionValue === undefined) {
            return dimensionValue;
        }
        return "".concat(dimensionValue);
    });
}
/**
 * Get dimensions without path pre
 * dimensions: ['辽宁省[&]芜湖市[&]家具[&]椅子']
 * return ['椅子']
 *
 * @param dimensions
 */
function getDimensionsWithoutPathPre(dimensions) {
    return dimensions.map(function (item) {
        var splitArr = item === null || item === void 0 ? void 0 : item.split(ID_SEPARATOR);
        return splitArr[(splitArr === null || splitArr === void 0 ? void 0 : splitArr.length) - 1] || item;
    });
}
/**
 * Get dimensions with parent path
 * field: 'category'
 * defaultDimensions: ['province', 'city', 'category', 'subCategory']
 * dimensions: [
 *  {
 *   province: '辽宁省',
 *   city: '芜湖市',
 *   category: '家具',
 *   subCategory: '椅子',
 *   price: ''
 *  },
 * ]
 * return ['辽宁省[&]芜湖市[&]家具']
 *
 * @param field
 * @param defaultDimensions
 * @param dimensions
 */
function getDimensionsWithParentPath(field, defaultDimensions, dimensions) {
    var _a;
    var measure = defaultDimensions.slice(0, defaultDimensions.indexOf(field) + 1);
    return (_a = dimensions
        .map(function (item) { return measure.map(function (i) { return item[i]; }).join("".concat(ID_SEPARATOR)); })) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item; });
}
/**
 * Transform a single data to path
 * {
 * $$VALUE$$: 15
 * $$EXTRA$$: 'price'
 * "price": 15,
 * "province": "辽宁省",
 * "city": "达州市",
 * "category": "家具",
 * "subCategory": "椅子"
 * }
 * rows: [province, city]
 * columns: [category, subCategory, $$EXTRA$$]
 *
 * rowDimensionValues = [辽宁省, 达州市]
 * colDimensionValues = [家具, 椅子, price]
 *
 * @param params
 */
function getDataPath(params) {
    var rowDimensionValues = params.rowDimensionValues, colDimensionValues = params.colDimensionValues, careUndefined = params.careUndefined, isFirstCreate = params.isFirstCreate, rowFields = params.rowFields, colFields = params.colFields, rowPivotMeta = params.rowPivotMeta, colPivotMeta = params.colPivotMeta;
    // 根据行、列维度值生成对应的 path路径，有两个情况
    // 如果是汇总格子：path = [0,undefined, 0] path中会存在undefined的值（这里在indexesData里面会映射）
    // 如果是明细格子: path = [0,0,0] 全数字，无undefined存在
    var getPath = function (dimensionValues, isRow, rowMeta, colMeta) {
        if (isRow === void 0) { isRow = true; }
        var currentMeta = isRow ? rowMeta : colMeta;
        var fields = isRow ? rowFields : colFields;
        var path = [];
        for (var i = 0; i < dimensionValues.length; i++) {
            var value = dimensionValues[i];
            if (!currentMeta.has(value)) {
                if (isFirstCreate) {
                    currentMeta.set(value, {
                        level: currentMeta.size,
                        children: new Map(),
                    });
                }
                else {
                    var meta_1 = currentMeta.get(value);
                    if (meta_1) {
                        path.push(meta_1.level);
                    }
                    if (!careUndefined) {
                        break;
                    }
                }
            }
            var meta = currentMeta.get(value);
            if (isUndefined(value) && careUndefined) {
                path.push(value);
            }
            else {
                path.push(meta === null || meta === void 0 ? void 0 : meta.level);
            }
            if (meta) {
                if (isFirstCreate) {
                    // mark the child field
                    meta.childField = fields === null || fields === void 0 ? void 0 : fields[i + 1];
                }
                currentMeta = meta === null || meta === void 0 ? void 0 : meta.children;
            }
        }
        return path;
    };
    var rowPath = getPath(rowDimensionValues, true, rowPivotMeta, colPivotMeta);
    var colPath = getPath(colDimensionValues, false, rowPivotMeta, colPivotMeta);
    var result = rowPath.concat.apply(rowPath, __spreadArray([], __read(colPath), false));
    return result;
}
/**
 * 获取查询结果中的纬度值
 * @param dimensions [province, city]
 * @param query { province: '四川省', city: '成都市', type: '办公用品' }
 * @returns ['四川省', '成都市']
 */
function getQueryDimValues(dimensions, query) {
    return reduce(dimensions, function (res, dimension) {
        // push undefined when not exist
        res.push(query[dimension]);
        return res;
    }, []);
}
/**
 * 转换原始数据为二维数组数据
 * @param rows
 * @param columns
 * @param originData
 * @param indexesData
 * @param totalData
 * @param sortedDimensionValues
 * @param rowPivotMeta
 * @param colPivotMeta
 */
function transformIndexesData(params) {
    var e_1, _a;
    var rows = params.rows, columns = params.columns, _b = params.originData, originData = _b === void 0 ? [] : _b, _c = params.indexesData, indexesData = _c === void 0 ? [] : _c, _d = params.totalData, totalData = _d === void 0 ? [] : _d, sortedDimensionValues = params.sortedDimensionValues, rowPivotMeta = params.rowPivotMeta, colPivotMeta = params.colPivotMeta;
    var paths = [];
    try {
        for (var _e = __values(__spreadArray(__spreadArray([], __read(originData), false), __read(totalData), false)), _f = _e.next(); !_f.done; _f = _e.next()) {
            var data = _f.value;
            var rowDimensionValues = transformDimensionsValues(data, rows, sortedDimensionValues);
            var colDimensionValues = transformDimensionsValues(data, columns, sortedDimensionValues);
            var path = getDataPath({
                rowDimensionValues: rowDimensionValues,
                colDimensionValues: colDimensionValues,
                rowPivotMeta: rowPivotMeta,
                colPivotMeta: colPivotMeta,
                isFirstCreate: true,
                careUndefined: (totalData === null || totalData === void 0 ? void 0 : totalData.length) > 0,
                rowFields: rows,
                colFields: columns,
            });
            paths.push(path);
            set(indexesData, path, data);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return {
        paths: paths,
        indexesData: indexesData,
        rowPivotMeta: rowPivotMeta,
        colPivotMeta: colPivotMeta,
        sortedDimensionValues: sortedDimensionValues,
    };
}
function deleteMetaById(meta, nodeId) {
    if (!meta || !nodeId)
        return;
    var paths = nodeId.split(ID_SEPARATOR);
    var deletePath = last(paths);
    var currentMeta = meta;
    forEach(paths, function (path, idx) {
        var pathMeta = currentMeta.get(path);
        if (pathMeta) {
            if (path === deletePath) {
                pathMeta.children = new Map();
                pathMeta.childField = undefined;
            }
            else {
                currentMeta = pathMeta.children;
            }
            return true;
        }
        // exit iteration early when pathMeta not exists
        return idx === 0 && path === ROOT_ID;
    });
}

var isAscSort = function (sortMethod) { return toUpper(sortMethod) === 'ASC'; };
var isDescSort = function (sortMethod) { return toUpper(sortMethod) === 'DESC'; };
/**
 * 执行排序
 * @param list - 待排序数组
 * @param sortMethod - 升、降序
 * @param key - 根据key数值排序，如果有key代表根据维度值排序，故按数字排，如果没有按照字典排
 */
var sortAction = function (list, sortMethod, key) {
    var sort = isAscSort(sortMethod) ? 1 : -1;
    var specialValues = ['-', undefined];
    return list === null || list === void 0 ? void 0 : list.sort(function (pre, next) {
        var a = pre;
        var b = next;
        if (key) {
            a = pre[key];
            b = next[key];
            if (Number(a) && Number(b)) {
                return (Number(a) - Number(b)) * sort;
            }
            if (a && (specialValues === null || specialValues === void 0 ? void 0 : specialValues.includes(a === null || a === void 0 ? void 0 : a.toString()))) {
                return -sort;
            }
            if (Number(a) && (specialValues === null || specialValues === void 0 ? void 0 : specialValues.includes(b === null || b === void 0 ? void 0 : b.toString()))) {
                return sort;
            }
        }
        if (a && b) {
            // 数据健全兼容，用户数据不全时，能够展示.
            return a.toString().localeCompare(b.toString(), 'zh') * sort;
        }
        if (a) {
            return sort;
        }
        return -sort;
    });
};
var mergeDataWhenASC = function (sortedValues, originValues, asc) {
    if (asc) {
        // 如果是升序，需要将无数据的项放到前面
        return sortByItems(originValues, uniq(sortedValues));
    }
    return __spreadArray([], __read(new Set(__spreadArray(__spreadArray([], __read(sortedValues), false), __read(originValues), false))), false);
};
var sortByFunc = function (params) {
    var originValues = params.originValues, measureValues = params.measureValues, sortParam = params.sortParam;
    var sortFunc = sortParam.sortFunc;
    return sortFunc(__assign({ data: measureValues }, sortParam)) || originValues;
};
var sortByCustom = function (params) {
    var sortByValues = params.sortByValues, originValues = params.originValues;
    // 从 originValues 中过滤出所有包含 sortByValue 的 id
    var idWithPre = originValues.filter(function (originItem) {
        return sortByValues.find(function (value) { return endsWith(originItem, value); });
    });
    // 将 id 拆分为父节点和目标节点
    var idListWithPre = idWithPre.map(function (idStr) {
        var ids = idStr.split(ID_SEPARATOR);
        if (ids.length > 1) {
            var parentId = ids.slice(0, ids.length - 1).join(ID_SEPARATOR);
            return [parentId, ids[ids.length - 1]];
        }
        return ids;
    });
    // 获取父节点顺序
    var parentOrder = Array.from(new Set(idListWithPre.map(function (id) { return id[0]; })));
    // 排序
    idListWithPre.sort(function (a, b) {
        var aParent = a.slice(0, a.length - 1);
        var bParent = b.slice(0, b.length - 1);
        // 父节点不同时，按 parentOrder 排序
        if (aParent.join() !== bParent.join()) {
            var aParentIndex = parentOrder.indexOf(aParent[0]);
            var bParentIndex = parentOrder.indexOf(bParent[0]);
            return aParentIndex - bParentIndex;
        }
        // 父节点相同时，按 sortByValues 排序
        var aIndex = sortByValues.indexOf(a[a.length - 1]);
        var bIndex = sortByValues.indexOf(b[b.length - 1]);
        return aIndex - bIndex;
    });
    // 拼接 id
    var sortedIdWithPre = idListWithPre.map(function (idArr) {
        return idArr.join(ID_SEPARATOR);
    });
    return getListBySorted(originValues, sortedIdWithPre);
};
var sortByMethod = function (params) {
    var sortParam = params.sortParam, measureValues = params.measureValues, originValues = params.originValues, dataSet = params.dataSet;
    var sortByMeasure = sortParam.sortByMeasure, query = sortParam.query, sortFieldId = sortParam.sortFieldId, sortMethod = sortParam.sortMethod;
    var _a = dataSet.fields, rows = _a.rows, columns = _a.columns;
    var isInRows = rows.includes(sortFieldId);
    var result = originValues;
    if (sortByMeasure) {
        var dimensions = sortAction(measureValues, sortMethod, sortByMeasure === TOTAL_VALUE ? query[EXTRA_FIELD] : sortByMeasure);
        result = getDimensionsWithParentPath(sortFieldId, isInRows ? rows : columns, dimensions);
    }
    else {
        result = map(sortAction(measureValues, sortMethod));
    }
    return mergeDataWhenASC(result, originValues, isAscSort(sortMethod));
};
var processSort = function (params) {
    var sortParam = params.sortParam, originValues = params.originValues, measureValues = params.measureValues, dataSet = params.dataSet;
    var sortFunc = sortParam.sortFunc, sortMethod = sortParam.sortMethod, sortBy = sortParam.sortBy;
    var result = originValues;
    var sortActionParams = {
        originValues: originValues,
        measureValues: measureValues,
        sortParam: sortParam,
        dataSet: dataSet,
    };
    if (sortFunc) {
        result = sortByFunc(sortActionParams);
    }
    else if (sortBy) {
        // 自定义列表
        result = sortByCustom({ sortByValues: sortBy, originValues: originValues });
    }
    else if (isAscSort(sortMethod) || isDescSort(sortMethod)) {
        // 如果是升序，需要将无数据的项放到前面
        result = sortByMethod(sortActionParams);
    }
    return result;
};
var handleSortAction = function (params) {
    var _a, _b;
    var dataSet = params.dataSet, sortParam = params.sortParam, originValues = params.originValues, isSortByMeasure = params.isSortByMeasure;
    var fields = dataSet.fields;
    var sortByMeasure = sortParam.sortByMeasure, query = sortParam.query, sortFieldId = sortParam.sortFieldId;
    var measureValues;
    if (isSortByMeasure) {
        // 根据指标排序，需要首先找到指标的对应的值
        if (sortByMeasure === TOTAL_VALUE) {
            // 按小计，总计排序
            var isRow = ((_a = fields === null || fields === void 0 ? void 0 : fields.columns) === null || _a === void 0 ? void 0 : _a.includes(sortFieldId)) &&
                ((_b = keys(query)) === null || _b === void 0 ? void 0 : _b.length) === 1 &&
                has(query, EXTRA_FIELD);
            measureValues = dataSet.getMultiData(query, true, isRow);
        }
        else {
            measureValues = dataSet.getMultiData(query);
        }
    }
    else {
        // 其他都是维度本身的排序方式
        measureValues = originValues;
    }
    return processSort({
        sortParam: sortParam,
        originValues: originValues,
        measureValues: measureValues,
        dataSet: dataSet,
    });
};
var getSortTypeIcon = function (sortParam, isSortCell) {
    if (sortParam === null || sortParam === void 0 ? void 0 : sortParam.sortMethod) {
        if (isAscSort(sortParam === null || sortParam === void 0 ? void 0 : sortParam.sortMethod)) {
            return 'groupAsc';
        }
        if (isDescSort(sortParam === null || sortParam === void 0 ? void 0 : sortParam.sortMethod)) {
            return 'groupDesc';
        }
    }
    if (isSortCell) {
        return 'SortDown';
    }
};

var HeaderCell = /** @class */ (function (_super) {
    __extends(HeaderCell, _super);
    function HeaderCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderCell.prototype.handleRestOptions = function () {
        var _a = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _a[_i] = arguments[_i];
        }
        var _b = __read(_a, 1), headerConfig = _b[0];
        this.headerConfig = __assign({}, headerConfig);
        var _c = this.meta, value = _c.value, query = _c.query;
        var sortParams = this.spreadsheet.dataCfg.sortParams;
        var isSortCell = this.isSortCell(); // 改单元格是否为需要展示排序 icon 单元格
        var sortParam = find(sortParams.reverse(), function (item) {
            return isSortCell &&
                (item === null || item === void 0 ? void 0 : item.sortByMeasure) === value &&
                isEqual(get(item, 'query'), query);
        });
        var type = getSortTypeIcon(sortParam, isSortCell);
        this.headerConfig.sortParam = __assign(__assign(__assign({}, this.headerConfig.sortParam), (sortParam || { query: query })), { type: type });
    };
    HeaderCell.prototype.initCell = function () {
        this.actionIcons = [];
    };
    HeaderCell.prototype.showActionIcons = function (actionIconCfg) {
        return shouldShowActionIcons(actionIconCfg, this.meta, this.cellType);
    };
    HeaderCell.prototype.getActionIconCfg = function () {
        var _this = this;
        return find(this.spreadsheet.options.headerActionIcons, function (headerActionIcon) {
            return _this.showActionIcons(headerActionIcon);
        });
    };
    HeaderCell.prototype.showSortIcon = function () {
        if (this.spreadsheet.options.showDefaultHeaderActionIcon) {
            var sortParam = this.headerConfig.sortParam;
            var query = this.meta.query;
            // sortParam的query，和type本身可能会 undefined
            return (query &&
                isEqual(get(sortParam, 'query'), query) &&
                get(sortParam, 'type') &&
                get(sortParam, 'type') !== 'none');
        }
        return false;
    };
    HeaderCell.prototype.getActionIconsCount = function () {
        if (this.showSortIcon()) {
            return 1;
        }
        var actionIconCfg = this.getActionIconCfg();
        if (actionIconCfg) {
            var iconNames = actionIconCfg.iconNames;
            return iconNames.length;
        }
        return 0;
    };
    HeaderCell.prototype.getActionIconsWidth = function () {
        var _a = this.getStyle().icon, size = _a.size, margin = _a.margin;
        return (size + margin.left) * this.getActionIconsCount();
    };
    // 绘制排序icon
    HeaderCell.prototype.drawSortIcons = function () {
        var _this = this;
        if (!this.showSortIcon()) {
            return;
        }
        var _a = this.getStyle(), icon = _a.icon, text = _a.text;
        var sortParam = this.headerConfig.sortParam;
        var position = this.getIconPosition();
        var sortIcon = new GuiIcon(__assign(__assign({ name: get(sortParam, 'type', 'none') }, position), { width: icon.size, height: icon.size, fill: text.fill }));
        sortIcon.on('click', function (event) {
            _this.spreadsheet.emit(S2Event.GLOBAL_ACTION_ICON_CLICK, event);
            _this.spreadsheet.handleGroupSort(event, _this.meta);
        });
        this.add(sortIcon);
        this.actionIcons.push(sortIcon);
    };
    // 是否设置为默认隐藏 action icon，默认隐藏的交互为 hover 后可见
    HeaderCell.prototype.hasDefaultHideActionIcon = function () {
        var actionIconCfg = this.getActionIconCfg();
        return actionIconCfg === null || actionIconCfg === void 0 ? void 0 : actionIconCfg.defaultHide;
    };
    HeaderCell.prototype.addActionIcon = function (iconName, x, y, size, action, defaultHide) {
        var _this = this;
        var text = this.getStyle().text;
        var icon = new GuiIcon({
            name: iconName,
            x: x,
            y: y,
            width: size,
            height: size,
            fill: text.fill,
        });
        // 默认隐藏，hover 可见
        icon.set('visible', !defaultHide);
        icon.on('mouseover', function (event) {
            _this.spreadsheet.emit(S2Event.GLOBAL_ACTION_ICON_HOVER, event);
        });
        icon.on('click', function (event) {
            _this.spreadsheet.emit(S2Event.GLOBAL_ACTION_ICON_CLICK, event);
            action({
                iconName: iconName,
                meta: _this.meta,
                event: event,
            });
        });
        this.actionIcons.push(icon);
        this.add(icon);
    };
    HeaderCell.prototype.drawActionIcons = function () {
        var _this = this;
        if (this.showSortIcon()) {
            this.drawSortIcons();
            return;
        }
        var actionIconCfg = this.getActionIconCfg();
        if (!actionIconCfg)
            return;
        var iconNames = actionIconCfg.iconNames, action = actionIconCfg.action, defaultHide = actionIconCfg.defaultHide;
        var position = this.getIconPosition(iconNames.length);
        var _a = this.getStyle().icon, size = _a.size, margin = _a.margin;
        forEach(iconNames, function (iconName, key) {
            var x = position.x + key * size + key * margin.left;
            _this.addActionIcon(iconName, x, position.y, size, action, defaultHide);
        });
    };
    HeaderCell.prototype.isSortCell = function () {
        var _a, _b, _c;
        // 数值置于列头, 排序 icon 绘制在列头叶子节点; 置于行头, 排序 icon 绘制在行头叶子节点
        var isValueInCols = (_b = (_a = this.meta.spreadsheet) === null || _a === void 0 ? void 0 : _a.isValueInCols) === null || _b === void 0 ? void 0 : _b.call(_a);
        var isMaxLevel = this.meta.level === ((_c = this.meta.hierarchy) === null || _c === void 0 ? void 0 : _c.maxLevel);
        if (isValueInCols) {
            return isMaxLevel && this.cellType === CellTypes.COL_CELL;
        }
        return isMaxLevel && this.cellType === CellTypes.ROW_CELL;
    };
    HeaderCell.prototype.handleHover = function (cells) {
        var _a;
        if (includeCell(cells, this)) {
            this.updateByState(InteractionStateName.HOVER);
            if (this.hasDefaultHideActionIcon()) {
                // hover 只会有一个 cell
                this.toggleActionIcon((_a = cells === null || cells === void 0 ? void 0 : cells[0]) === null || _a === void 0 ? void 0 : _a.id);
            }
        }
    };
    HeaderCell.prototype.handleSelect = function (cells, nodes) {
        if (includeCell(cells, this)) {
            this.updateByState(InteractionStateName.SELECTED);
        }
        var selectedNodeIds = map(nodes, 'id');
        if (includes(selectedNodeIds, this.meta.id)) {
            this.updateByState(InteractionStateName.SELECTED);
        }
    };
    HeaderCell.prototype.toggleActionIcon = function (id) {
        if (this.getMeta().id === id) {
            var visibleActionIcons_1 = [];
            // 理论上每次只会显示一个 header cell 的所有 actionIcon（大部分情况下只会有一个）
            forEach(this.actionIcons, function (icon) {
                icon.set('visible', true);
                visibleActionIcons_1.push(icon);
            });
            this.spreadsheet.store.set('visibleActionIcons', visibleActionIcons_1);
        }
    };
    HeaderCell.prototype.update = function () {
        var interaction = this.spreadsheet.interaction;
        var stateInfo = interaction === null || interaction === void 0 ? void 0 : interaction.getState();
        var cells = interaction === null || interaction === void 0 ? void 0 : interaction.getCells();
        if (!first(cells))
            return;
        switch (stateInfo === null || stateInfo === void 0 ? void 0 : stateInfo.stateName) {
            case InteractionStateName.SELECTED:
                this.handleSelect(cells, stateInfo === null || stateInfo === void 0 ? void 0 : stateInfo.nodes);
                break;
            case InteractionStateName.HOVER_FOCUS:
            case InteractionStateName.HOVER:
                this.handleHover(cells);
                break;
        }
    };
    HeaderCell.prototype.updateByState = function (stateName) {
        _super.prototype.updateByState.call(this, stateName, this);
    };
    HeaderCell.prototype.hideInteractionShape = function () {
        _super.prototype.hideInteractionShape.call(this);
    };
    return HeaderCell;
}(BaseCell));

var getResizeAreaAttrs = function (options) {
    var type = options.type, id = options.id, theme = options.theme, resizeAreaWidth = options.width, resizeAreaHeight = options.height, otherOptions = __rest(options, ["type", "id", "theme", "width", "height"]);
    var width = type === ResizeDirectionType.Horizontal ? theme.size : null;
    var height = type === ResizeDirectionType.Vertical ? theme.size : null;
    return {
        fill: theme.background,
        fillOpacity: theme.backgroundOpacity,
        cursor: "".concat(type, "-resize"),
        width: width,
        height: height,
        appendInfo: __assign(__assign({}, otherOptions), { isResizeArea: true, type: type, id: id, width: resizeAreaWidth, height: resizeAreaHeight, size: theme.size }),
    };
};
var getOrCreateResizeAreaGroupById = function (spreadsheet, id) {
    if (!spreadsheet.foregroundGroup) {
        return;
    }
    var existedResizeArea = spreadsheet.foregroundGroup.findById(id);
    return (existedResizeArea ||
        spreadsheet.foregroundGroup.addGroup({
            id: id,
            zIndex: FRONT_GROUND_GROUP_RESIZE_AREA_Z_INDEX,
        }));
};
var shouldAddResizeArea = function (resizeArea, resizeClipArea, scrollOffset) {
    var _a = scrollOffset !== null && scrollOffset !== void 0 ? scrollOffset : {}, _b = _a.scrollX, scrollX = _b === void 0 ? 0 : _b, _c = _a.scrollY, scrollY = _c === void 0 ? 0 : _c;
    // x轴上有重叠
    var overlapInXAxis = !(resizeArea.x - scrollX > resizeClipArea.x + resizeClipArea.width ||
        resizeArea.x + resizeArea.width - scrollX < resizeClipArea.x);
    // y轴上有重叠
    var overlapInYAxis = !(resizeArea.y - scrollY > resizeClipArea.y + resizeClipArea.height ||
        resizeArea.y + resizeArea.height - scrollY < resizeClipArea.y);
    return overlapInXAxis && overlapInYAxis;
};

var ColCell = /** @class */ (function (_super) {
    __extends(ColCell, _super);
    function ColCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ColCell.prototype, "cellType", {
        get: function () {
            return CellTypes.COL_CELL;
        },
        enumerable: false,
        configurable: true
    });
    ColCell.prototype.initCell = function () {
        _super.prototype.initCell.call(this);
        // 1、draw rect background
        this.drawBackgroundShape();
        // interactive background shape
        this.drawInteractiveBgShape();
        // draw text
        this.drawTextShape();
        // draw action icons
        this.drawActionIcons();
        // draw borders
        this.drawBorders();
        // draw resize ares
        this.drawResizeArea();
        this.addExpandColumnIconShapes();
        this.update();
    };
    ColCell.prototype.drawBackgroundShape = function () {
        var backgroundColor = this.getStyle().cell.backgroundColor;
        this.backgroundShape = renderRect(this, __assign(__assign({}, this.getCellArea()), { fill: backgroundColor }));
    };
    // 交互使用的背景色
    ColCell.prototype.drawInteractiveBgShape = function () {
        this.stateShapes.set('interactiveBgShape', renderRect(this, __assign(__assign({}, this.getCellArea()), { fill: 'transparent', stroke: 'transparent' })));
    };
    ColCell.prototype.getTextStyle = function () {
        var _a = this.meta, isLeaf = _a.isLeaf, isTotals = _a.isTotals;
        var _b = this.getStyle(), text = _b.text, bolderText = _b.bolderText;
        var textStyle = isLeaf && !isTotals ? text : bolderText;
        var hideMeasureColumn = this.spreadsheet.options.style.colCfg.hideMeasureColumn;
        var textAlign;
        var textBaseline;
        if (isLeaf && !hideMeasureColumn) {
            // 最后一个层级的非维值指标单元格，与 dataCell 对齐方式保持一致
            textAlign = this.theme.dataCell.text.textAlign;
            textBaseline = this.theme.dataCell.text.textBaseline;
        }
        else {
            textAlign = 'center';
            textBaseline = 'middle';
        }
        return __assign(__assign({}, textStyle), { textAlign: textAlign, textBaseline: textBaseline });
    };
    ColCell.prototype.getFormattedFieldValue = function () {
        var _a = this.meta, label = _a.label, key = _a.key;
        var formatter = this.headerConfig.formatter(key);
        var content = formatter(label);
        return {
            formattedValue: content,
            value: label,
        };
    };
    ColCell.prototype.getMaxTextWidth = function () {
        var width = this.getContentArea().width;
        return width - this.getActionIconsWidth();
    };
    ColCell.prototype.getIconPosition = function () {
        var isLeaf = this.meta.isLeaf;
        var iconStyle = this.getIconStyle();
        if (isLeaf) {
            return _super.prototype.getIconPosition.call(this, this.getActionIconsCount());
        }
        var position = this.textAndIconPositionWhenHorizontalScrolling;
        var totalSpace = this.actualTextWidth +
            this.getActionIconsWidth() -
            iconStyle.margin.right;
        var startX = position.x - totalSpace / 2;
        return {
            x: startX + this.actualTextWidth + iconStyle.margin.left,
            y: position.y - iconStyle.size / 2,
        };
    };
    ColCell.prototype.getTextPosition = function () {
        var isLeaf = this.meta.isLeaf;
        var _a = this.headerConfig, width = _a.width, scrollContainsRowHeader = _a.scrollContainsRowHeader, cornerWidth = _a.cornerWidth, scrollX = _a.scrollX;
        var textStyle = this.getTextStyle();
        var contentBox = this.getContentArea();
        var iconStyle = this.getIconStyle();
        if (isLeaf) {
            return getTextAndFollowingIconPosition(contentBox, textStyle, this.actualTextWidth, iconStyle, this.getActionIconsCount()).text;
        }
        // 将viewport坐标映射到 col header的坐标体系中，简化计算逻辑
        var viewport = {
            start: scrollX - (scrollContainsRowHeader ? cornerWidth : 0),
            width: width + (scrollContainsRowHeader ? cornerWidth : 0),
        };
        var textAndIconSpace = this.actualTextWidth +
            this.getActionIconsWidth() -
            iconStyle.margin.right;
        var startX = getTextAndIconPositionWhenHorizontalScrolling(viewport, { start: contentBox.x, width: contentBox.width }, textAndIconSpace);
        var textY = contentBox.y + contentBox.height / 2;
        this.textAndIconPositionWhenHorizontalScrolling = { x: startX, y: textY };
        return {
            x: startX - textAndIconSpace / 2 + this.actualTextWidth / 2,
            y: textY,
        };
    };
    ColCell.prototype.getActionIconsWidth = function () {
        var _a = this.getStyle().icon, size = _a.size, margin = _a.margin;
        var iconCount = this.getActionIconsCount();
        return (size + margin.left) * iconCount + iconCount > 0 ? margin.right : 0;
    };
    ColCell.prototype.getColResizeAreaKey = function () {
        return this.meta.key;
    };
    ColCell.prototype.getColResizeArea = function () {
        return getOrCreateResizeAreaGroupById(this.spreadsheet, KEY_GROUP_COL_RESIZE_AREA);
    };
    ColCell.prototype.getHorizontalResizeAreaName = function () {
        return "".concat(HORIZONTAL_RESIZE_AREA_KEY_PRE).concat(this.meta.key);
    };
    ColCell.prototype.drawHorizontalResizeArea = function () {
        if (!this.shouldDrawResizeAreaByType('colCellVertical')) {
            return;
        }
        var _a = this.headerConfig, cornerWidth = _a.cornerWidth, headerWidth = _a.viewportWidth;
        var _b = this.meta, y = _b.y, height = _b.height;
        var resizeStyle = this.getResizeAreaStyle();
        var resizeArea = this.getColResizeArea();
        var resizeAreaName = this.getHorizontalResizeAreaName();
        var existedHorizontalResizeArea = resizeArea.find(function (element) { return element.attrs.name === resizeAreaName; });
        // 如果已经绘制当前列高调整热区热区，则不再绘制
        if (existedHorizontalResizeArea) {
            return;
        }
        var resizeAreaWidth = cornerWidth + headerWidth;
        // 列高调整热区
        resizeArea.addShape('rect', {
            attrs: __assign(__assign({}, getResizeAreaAttrs({
                theme: resizeStyle,
                type: ResizeDirectionType.Vertical,
                id: this.getColResizeAreaKey(),
                effect: ResizeAreaEffect.Field,
                offsetX: 0,
                offsetY: y,
                width: resizeAreaWidth,
                height: height,
            })), { name: resizeAreaName, x: 0, y: y + height - resizeStyle.size / 2, width: resizeAreaWidth }),
        });
    };
    ColCell.prototype.shouldAddVerticalResizeArea = function () {
        var _a = this.meta, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var _b = this.headerConfig, scrollX = _b.scrollX, scrollY = _b.scrollY, scrollContainsRowHeader = _b.scrollContainsRowHeader, cornerWidth = _b.cornerWidth, headerHeight = _b.height, headerWidth = _b.width;
        var resizeStyle = this.getResizeAreaStyle();
        var resizeAreaBBox = {
            x: x + width - resizeStyle.size / 2,
            y: y,
            width: resizeStyle.size,
            height: height,
        };
        var resizeClipAreaBBox = {
            x: scrollContainsRowHeader ? -cornerWidth : 0,
            y: 0,
            width: scrollContainsRowHeader ? cornerWidth + headerWidth : headerWidth,
            height: headerHeight,
        };
        return shouldAddResizeArea(resizeAreaBBox, resizeClipAreaBBox, {
            scrollX: scrollX,
            scrollY: scrollY,
        });
    };
    ColCell.prototype.getVerticalResizeAreaOffset = function () {
        var _a = this.meta, x = _a.x, y = _a.y;
        var _b = this.headerConfig, scrollX = _b.scrollX, position = _b.position;
        return {
            x: position.x + x - scrollX,
            y: position.y + y,
        };
    };
    ColCell.prototype.drawVerticalResizeArea = function () {
        if (!this.meta.isLeaf ||
            !this.shouldDrawResizeAreaByType('colCellHorizontal')) {
            return;
        }
        var _a = this.meta, label = _a.label, width = _a.width, height = _a.height, parent = _a.parent;
        var resizeStyle = this.getResizeAreaStyle();
        var resizeArea = this.getColResizeArea();
        if (!this.shouldAddVerticalResizeArea()) {
            return;
        }
        var _b = this.getVerticalResizeAreaOffset(), offsetX = _b.x, offsetY = _b.y;
        // 列宽调整热区
        // 基准线是根据container坐标来的，因此把热区画在container
        resizeArea.addShape('rect', {
            attrs: __assign(__assign({}, getResizeAreaAttrs({
                theme: resizeStyle,
                type: ResizeDirectionType.Horizontal,
                effect: ResizeAreaEffect.Cell,
                id: parent.isTotals ? '' : label,
                offsetX: offsetX,
                offsetY: offsetY,
                width: width,
                height: height,
            })), { x: offsetX + width - resizeStyle.size / 2, y: offsetY, height: height }),
        });
    };
    // 绘制热区
    ColCell.prototype.drawResizeArea = function () {
        this.drawHorizontalResizeArea();
        this.drawVerticalResizeArea();
    };
    ColCell.prototype.drawHorizontalBorder = function () {
        var _a = getBorderPositionAndStyle(CellBorderPosition.TOP, this.meta, this.theme.colCell.cell), position = _a.position, style = _a.style;
        renderLine(this, position, style);
    };
    ColCell.prototype.drawVerticalBorder = function () {
        var _a = getBorderPositionAndStyle(CellBorderPosition.RIGHT, this.meta, this.theme.colCell.cell), position = _a.position, style = _a.style;
        renderLine(this, position, style);
    };
    ColCell.prototype.drawBorders = function () {
        this.drawHorizontalBorder();
        this.drawVerticalBorder();
    };
    ColCell.prototype.hasHiddenColumnCell = function () {
        var _this = this;
        var _a = this.spreadsheet.options, _b = _a.interaction.hiddenColumnFields, hiddenColumnFields = _b === void 0 ? [] : _b, operation = _a.tooltip.operation;
        var hiddenColumnsDetail = this.spreadsheet.store.get('hiddenColumnsDetail', []);
        if (isEmpty(hiddenColumnsDetail) ||
            isEmpty(hiddenColumnFields) ||
            !operation.hiddenColumns) {
            return false;
        }
        return !!hiddenColumnsDetail.find(function (column) {
            return isEqualDisplaySiblingNodeId(column === null || column === void 0 ? void 0 : column.displaySiblingNode, _this.meta.id);
        });
    };
    ColCell.prototype.getExpandIconTheme = function () {
        var themeCfg = this.getStyle();
        return themeCfg.icon;
    };
    ColCell.prototype.addExpandColumnSplitLine = function () {
        var _a = this.meta, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var _b = this.theme.splitLine, horizontalBorderColor = _b.horizontalBorderColor, horizontalBorderWidth = _b.horizontalBorderWidth, horizontalBorderColorOpacity = _b.horizontalBorderColorOpacity;
        var lineX = this.isLastColumn() ? x + width - horizontalBorderWidth : x;
        renderLine(this, {
            x1: lineX,
            y1: y,
            x2: lineX,
            y2: y + height,
        }, {
            stroke: horizontalBorderColor,
            lineWidth: horizontalBorderWidth,
            strokeOpacity: horizontalBorderColorOpacity,
        });
    };
    ColCell.prototype.addExpandColumnIconShapes = function () {
        if (!this.hasHiddenColumnCell()) {
            return;
        }
        this.addExpandColumnSplitLine();
        this.addExpandColumnIcon();
    };
    ColCell.prototype.addExpandColumnIcon = function () {
        var _this = this;
        var iconConfig = this.getExpandColumnIconConfig();
        var icon = renderIcon(this, __assign(__assign({}, iconConfig), { name: 'ExpandColIcon', cursor: 'pointer' }));
        icon.on('click', function () {
            _this.spreadsheet.emit(S2Event.LAYOUT_TABLE_COL_EXPANDED, _this.meta);
        });
    };
    // 在隐藏的下一个兄弟节点的起始坐标显示隐藏提示线和展开按钮, 如果是尾元素, 则显示在前一个兄弟节点的结束坐标
    ColCell.prototype.getExpandColumnIconConfig = function () {
        var size = this.getExpandIconTheme().size;
        var _a = this.getCellArea(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var baseIconX = x - size;
        var iconX = this.isLastColumn() ? baseIconX + width : baseIconX;
        var iconY = y + height / 2 - size / 2;
        return {
            x: iconX,
            y: iconY,
            width: size * 2,
            height: size,
        };
    };
    ColCell.prototype.isLastColumn = function () {
        return isLastColumnAfterHidden(this.spreadsheet, this.meta.id);
    };
    return ColCell;
}(HeaderCell));

var CornerCell = /** @class */ (function (_super) {
    __extends(CornerCell, _super);
    function CornerCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textShapes = [];
        return _this;
    }
    Object.defineProperty(CornerCell.prototype, "cellType", {
        get: function () {
            return CellTypes.CORNER_CELL;
        },
        enumerable: false,
        configurable: true
    });
    CornerCell.prototype.update = function () { };
    CornerCell.prototype.initCell = function () {
        _super.prototype.initCell.call(this);
        this.textShapes = [];
        this.drawBackgroundShape();
        this.drawTreeIcon();
        this.drawCellText();
        this.drawActionIcons();
        this.drawBorderShape();
        this.drawResizeArea();
    };
    CornerCell.prototype.drawCellText = function () {
        var _a;
        var label = this.meta.label;
        if (isEqual(label, EXTRA_FIELD)) {
            // don't render extra node
            return;
        }
        var x = this.getContentArea().x;
        var _b = this.getCellArea(), y = _b.y, height = _b.height;
        var textStyle = this.getTextStyle();
        var formattedValue = this.getFormattedFieldValue().formattedValue;
        var cornerText = ((_a = this.spreadsheet.options) === null || _a === void 0 ? void 0 : _a.cornerText) || formattedValue;
        // 当为树状结构下需要计算文本前收起展开的icon占的位置
        var maxWidth = this.getMaxTextWidth();
        var text = getEllipsisText({
            text: cornerText,
            maxWidth: maxWidth,
            fontParam: textStyle,
            placeholder: this.spreadsheet.options.placeholder,
        });
        this.actualText = text;
        var ellipseIndex = text.indexOf('...');
        var firstLine = text;
        var secondLine = '';
        // 存在文字的省略号 & 展示为tree结构
        if (ellipseIndex !== -1 && this.spreadsheet.isHierarchyTreeType()) {
            // 剪裁到 ... 最有点的后1个像素位置
            var lastIndex = ellipseIndex + (isIPhoneX() ? 1 : 0);
            firstLine = cornerText.substr(0, lastIndex);
            secondLine = cornerText.slice(lastIndex);
            // 第二行重新计算...逻辑
            secondLine = getEllipsisText({
                text: secondLine,
                maxWidth: maxWidth,
                fontParam: textStyle,
            });
        }
        var textX = getTextPosition({
            x: x + this.getTreeIconWidth(),
            y: y,
            width: maxWidth,
            height: height,
        }, textStyle).x;
        var textY = y + (isEmpty(secondLine) ? height / 2 : height / 4);
        // first line
        this.textShapes.push(renderText(this, [this.textShapes[0]], textX, textY, firstLine, textStyle));
        // second line
        if (!isEmpty(secondLine)) {
            this.textShapes.push(renderText(this, [this.textShapes[1]], textX, y + height * 0.75, secondLine, textStyle));
        }
        this.actualTextWidth = max([
            measureTextWidth(firstLine, textStyle),
            measureTextWidth(secondLine, textStyle),
        ]);
    };
    /**
     * 绘制折叠展开的icon
     */
    CornerCell.prototype.drawTreeIcon = function () {
        var _this = this;
        if (!this.showTreeIcon() || this.meta.cornerType === CornerNodeType.Col) {
            return;
        }
        var hierarchyCollapse = this.headerConfig.hierarchyCollapse;
        var size = this.getStyle().icon.size;
        var _a = this.getTextStyle(), textBaseline = _a.textBaseline, fill = _a.fill;
        var area = this.getContentArea();
        this.treeIcon = renderTreeIcon(this, {
            x: area.x,
            y: getVerticalPosition(area, textBaseline, size),
            width: size,
            height: size,
        }, fill, hierarchyCollapse, function () {
            _this.headerConfig.spreadsheet.store.set('scrollY', 0);
            _this.headerConfig.spreadsheet.emit(S2Event.LAYOUT_TREE_ROWS_COLLAPSE_ALL, hierarchyCollapse);
        });
    };
    CornerCell.prototype.drawBackgroundShape = function () {
        var backgroundColorOpacity = this.getStyle().cell.backgroundColorOpacity;
        var attrs = __assign(__assign({}, this.getCellArea()), { opacity: backgroundColorOpacity });
        this.backgroundShape = renderRect(this, attrs);
    };
    /**
     * Render cell horizontalBorder border
     * @private
     */
    CornerCell.prototype.drawBorderShape = function () {
        var _this = this;
        [CellBorderPosition.TOP, CellBorderPosition.LEFT].forEach(function (type) {
            var _a = getBorderPositionAndStyle(type, _this.getCellArea(), _this.getStyle().cell), position = _a.position, style = _a.style;
            renderLine(_this, position, style);
        });
    };
    CornerCell.prototype.isLastRowCornerCell = function () {
        var _a = this.meta, cornerType = _a.cornerType, field = _a.field;
        var rows = this.headerConfig.rows;
        return (cornerType === CornerNodeType.Row &&
            (this.spreadsheet.isHierarchyTreeType() || last(rows) === field));
    };
    CornerCell.prototype.getResizeAreaEffect = function () {
        var cornerType = this.meta.cornerType;
        if (cornerType === CornerNodeType.Series) {
            return ResizeAreaEffect.Series;
        }
        return this.isLastRowCornerCell() && this.spreadsheet.isHierarchyTreeType()
            ? ResizeAreaEffect.Tree
            : ResizeAreaEffect.Field;
    };
    CornerCell.prototype.drawResizeArea = function () {
        if (!this.shouldDrawResizeAreaByType('cornerCellHorizontal')) {
            return;
        }
        var resizeStyle = this.getResizeAreaStyle();
        var resizeArea = getOrCreateResizeAreaGroupById(this.spreadsheet, KEY_GROUP_CORNER_RESIZE_AREA);
        var _a = this.headerConfig, position = _a.position, scrollX = _a.scrollX, scrollY = _a.scrollY, headerWidth = _a.width, headerHeight = _a.height;
        var _b = this.meta, x = _b.x, y = _b.y, width = _b.width, height = _b.height, field = _b.field, cornerType = _b.cornerType;
        var resizeAreaBBox = {
            x: x + width - resizeStyle.size / 2,
            y: y,
            width: resizeStyle.size,
            height: height,
        };
        var resizeClipAreaBBox = {
            x: 0,
            y: 0,
            width: headerWidth,
            height: headerHeight,
        };
        if (cornerType === CornerNodeType.Col ||
            !shouldAddResizeArea(resizeAreaBBox, resizeClipAreaBBox, {
                scrollX: scrollX,
                scrollY: scrollY,
            })) {
            return;
        }
        // 将相对坐标映射到全局坐标系中
        // 最后一个维度需要撑满角头高度
        var offsetX = position.x + x - scrollX;
        var offsetY = position.y + (this.isLastRowCornerCell() ? 0 : y);
        resizeArea.addShape('rect', {
            attrs: __assign(__assign({}, getResizeAreaAttrs({
                theme: resizeStyle,
                id: field,
                type: ResizeDirectionType.Horizontal,
                effect: this.getResizeAreaEffect(),
                offsetX: offsetX,
                offsetY: offsetY,
                width: width,
                height: height,
            })), { x: offsetX + width - resizeStyle.size / 2, y: offsetY, height: this.isLastRowCornerCell() ? headerHeight : height }),
        });
    };
    CornerCell.prototype.showTreeIcon = function () {
        var _a;
        // 批量折叠或者展开的icon，只存在树状结构的第一个cell前
        return (this.headerConfig.spreadsheet.isHierarchyTreeType() && ((_a = this.meta) === null || _a === void 0 ? void 0 : _a.x) === 0);
    };
    CornerCell.prototype.getIconPosition = function () {
        var _a, _b;
        var textCfg = (_b = (_a = this.textShapes) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.cfg.attrs;
        var _c = this.getTextStyle(), textBaseline = _c.textBaseline, textAlign = _c.textAlign;
        var _d = this.getStyle().icon, size = _d.size, margin = _d.margin;
        var iconX = (textCfg === null || textCfg === void 0 ? void 0 : textCfg.x) +
            cond([
                [matches('center'), constant(this.actualTextWidth / 2)],
                [matches('right'), constant(0)],
                [stubTrue, constant(this.actualTextWidth)],
            ])(textAlign) +
            margin.left;
        var iconY = getVerticalPosition(this.getContentArea(), textBaseline, size);
        return { x: iconX, y: iconY };
    };
    CornerCell.prototype.getTreeIconWidth = function () {
        var _a = this.getStyle().icon, size = _a.size, margin = _a.margin;
        return this.showTreeIcon() ? size + margin.right : 0;
    };
    CornerCell.prototype.getTextStyle = function () {
        var cornerTextStyle = this.getStyle().bolderText;
        var cornerType = this.meta.cornerType;
        var textAlign = cornerType === CornerNodeType.Col ? 'right' : cornerTextStyle.textAlign;
        return __assign(__assign({}, cornerTextStyle), { textAlign: textAlign, textBaseline: 'middle' });
    };
    CornerCell.prototype.getFormattedFieldValue = function () {
        return { formattedValue: this.meta.label, value: this.meta.label };
    };
    CornerCell.prototype.getMaxTextWidth = function () {
        var width = this.getContentArea().width;
        return width - this.getTreeIconWidth() - this.getActionIconsWidth();
    };
    CornerCell.prototype.getTextPosition = function () {
        return {
            x: 0,
            y: 0,
        };
    };
    return CornerCell;
}(HeaderCell));

/**
 * 获取当前node所有children的总高度
 * @param node
 */
var getAllChildrenNodeHeight = function (node) {
    var nodeAllCellHeight = 0;
    var nodes = node.children;
    nodes === null || nodes === void 0 ? void 0 : nodes.forEach(function (item) {
        nodeAllCellHeight += item.height || 0;
    });
    return nodeAllCellHeight;
};

/**
 * 文本吸附定位计算
 * @param rectLeft       矩形左边
 * @param rectWidth      矩形宽度
 * @param viewportLeft   视窗左边
 * @param viewportWidth  视窗宽度
 * @param textWidth
 * @returns 文本定位坐标 x 或者 y
 *
 * 画布元素：视窗矩形、矩形、文本，其中文本放置在矩形中
 * 矩形从右进入视窗时，交互流程为：
 *  1. 文本开始显示，文本贴左边
 *  2. 文本还未达到矩形中心位置，继续贴左边
 *  3. 文本显示全时，文本贴右边
 *  4. 文本居于矩形中心时，文本贴中间
 *  5. 文本贴近视窗左边还能显示全，文本贴左边
 *  6. 文本开始显示不全时，文本贴右边
 * **************************************************************
 *                    viewportLeft               rectLeft
 *                    ▲                          ▲   centerTextLeft
 *                    |                          |   ▲
 *                    +------------------+       |   |
 *                    |                  |       +------------+
 *                    |                  |       |   +----+   |
 *                    |                  |       |   |Text|   |
 *                    |                  |       |   +----+   |
 *                    |                  |       +------------+
 *                    +------------------+       ◀- rectWidth -▶
 *                    ◀- viewportWidth  -▶
 * ****************************************************************
 */
var getAdjustPosition = function (rectLeft, rectWidth, viewportLeft, viewportWidth, textWidth) {
    var textX = 0;
    // 文本居于矩形中间时的坐标
    var centerTextLeft = rectLeft + (rectWidth - textWidth) / 2;
    var centerTextRight = rectLeft + (rectWidth + textWidth) / 2;
    var viewportRight = viewportLeft + viewportWidth;
    if (rectLeft + textWidth >= viewportRight) {
        // 1. 文本开始显示，文本贴左边
        textX = rectLeft;
    }
    else if (viewportRight < centerTextRight) {
        // 2. 文本还未达到矩形中心位置，继续贴左边
        textX = viewportLeft + viewportWidth - textWidth;
    }
    else if (viewportLeft > centerTextLeft) {
        // 3. 文本显示全时，文本贴右边
        if (rectLeft + rectWidth - viewportLeft > textWidth) {
            // 5. 文本贴近视窗左边还能显示全，文本贴左边
            textX = viewportLeft;
        }
        else {
            // 6. 文本开始显示不全时，文本贴右边
            textX = rectLeft + rectWidth - textWidth;
        }
    }
    else {
        // 4. 文本居于矩形中心时，文本贴中间
        textX = rectLeft + (rectWidth - textWidth) / 2;
    }
    return textX;
};

var RowCell = /** @class */ (function (_super) {
    __extends(RowCell, _super);
    function RowCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RowCell.prototype, "cellType", {
        get: function () {
            return CellTypes.ROW_CELL;
        },
        enumerable: false,
        configurable: true
    });
    RowCell.prototype.destroy = function () {
        var _a;
        _super.prototype.destroy.call(this);
        (_a = this.gm) === null || _a === void 0 ? void 0 : _a.destroy();
    };
    RowCell.prototype.initCell = function () {
        _super.prototype.initCell.call(this);
        // 1、draw rect background
        this.drawBackgroundShape();
        this.drawInteractiveBgShape();
        // draw icon
        this.drawTreeIcon();
        // draw text
        this.drawTextShape();
        // draw bottom border
        this.drawRectBorder();
        // draw hot-spot rect
        this.drawResizeAreaInLeaf();
        // draw action icon shapes: trend icon, drill-down icon ...
        this.drawActionIcons();
        this.update();
    };
    RowCell.prototype.drawBackgroundShape = function () {
        var _a = this.getStyle().cell, backgroundColor = _a.backgroundColor, backgroundColorOpacity = _a.backgroundColorOpacity;
        this.backgroundShape = renderRect(this, __assign(__assign({}, this.getCellArea()), { fill: backgroundColor, stroke: 'transparent', opacity: backgroundColorOpacity }));
    };
    // 交互使用的背景色
    RowCell.prototype.drawInteractiveBgShape = function () {
        this.stateShapes.set('interactiveBgShape', renderRect(this, __assign(__assign({}, this.getCellArea()), { fill: 'transparent', stroke: 'transparent' })));
    };
    RowCell.prototype.showTreeIcon = function () {
        return this.spreadsheet.isHierarchyTreeType() && !this.meta.isLeaf;
    };
    // draw tree icon
    RowCell.prototype.drawTreeIcon = function () {
        var _this = this;
        if (!this.showTreeIcon()) {
            return;
        }
        var _a = this.meta, isCollapsed = _a.isCollapsed, id = _a.id, hierarchy = _a.hierarchy;
        var x = this.getContentArea().x;
        var fill = this.getTextStyle().fill;
        var size = this.getStyle().icon.size;
        var contentIndent = this.getContentIndent();
        var iconX = x + contentIndent;
        var iconY = this.getIconYPosition();
        this.treeIcon = renderTreeIcon(this, {
            x: iconX,
            y: iconY,
            width: size,
            height: size,
        }, fill, isCollapsed, function () {
            if (isMobile()) {
                return;
            }
            // 折叠行头时因scrollY没变，导致底层出现空白
            if (!isCollapsed) {
                var oldScrollY = _this.spreadsheet.store.get('scrollY');
                // 可视窗口高度
                var viewportHeight = _this.spreadsheet.facet.panelBBox.viewportHeight || 0;
                // 被折叠项的高度
                var deleteHeight = getAllChildrenNodeHeight(_this.meta);
                // 折叠后真实高度
                var realHeight = hierarchy.height - deleteHeight;
                if (oldScrollY > 0 && oldScrollY + viewportHeight > realHeight) {
                    var currentScrollY = realHeight - viewportHeight;
                    _this.spreadsheet.store.set('scrollY', currentScrollY > 0 ? currentScrollY : 0);
                }
            }
            _this.spreadsheet.emit(S2Event.ROW_CELL_COLLAPSE_TREE_ROWS, {
                id: id,
                isCollapsed: !isCollapsed,
                node: _this.meta,
            });
        });
        // in mobile, we use this cell
        if (isMobile()) {
            this.gm = new GM(this, {
                gestures: ['Tap'],
            });
            this.gm.on('tap', function () {
                _this.spreadsheet.emit(S2Event.ROW_CELL_COLLAPSE_TREE_ROWS, {
                    id: id,
                    isCollapsed: !isCollapsed,
                    node: _this.meta,
                });
            });
        }
    };
    // draw text
    RowCell.prototype.drawTextShape = function () {
        _super.prototype.drawTextShape.call(this);
        this.drawLinkFieldShape();
    };
    RowCell.prototype.drawLinkFieldShape = function () {
        var _a = this.headerConfig.linkFields, linkFields = _a === void 0 ? [] : _a;
        var linkTextFill = this.getTextStyle().linkTextFill;
        _super.prototype.drawLinkFieldShape.call(this, linkFields.includes(this.meta.key), linkTextFill);
    };
    RowCell.prototype.drawRectBorder = function () {
        var _this = this;
        var x = this.getCellArea().x;
        var contentIndent = this.getContentIndent();
        var finalX = this.spreadsheet.isHierarchyTreeType()
            ? x
            : x + contentIndent;
        [CellBorderPosition.BOTTOM, CellBorderPosition.LEFT].forEach(function (type) {
            var _a = getBorderPositionAndStyle(type, __assign(__assign({}, _this.getCellArea()), { x: finalX }), _this.getStyle().cell), position = _a.position, style = _a.style;
            renderLine(_this, position, style);
        });
    };
    RowCell.prototype.drawResizeAreaInLeaf = function () {
        if (!this.meta.isLeaf ||
            !this.shouldDrawResizeAreaByType('rowCellVertical')) {
            return;
        }
        var _a = this.getCellArea(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var resizeStyle = this.getResizeAreaStyle();
        var resizeArea = getOrCreateResizeAreaGroupById(this.spreadsheet, KEY_GROUP_ROW_RESIZE_AREA);
        var _b = this.headerConfig, position = _b.position, seriesNumberWidth = _b.seriesNumberWidth, headerWidth = _b.width, headerHeight = _b.viewportHeight, scrollX = _b.scrollX, scrollY = _b.scrollY;
        var resizeAreaBBox = {
            x: x,
            y: y + height - resizeStyle.size / 2,
            width: width,
            height: resizeStyle.size,
        };
        var resizeClipAreaBBox = {
            x: 0,
            y: 0,
            width: headerWidth,
            height: headerHeight,
        };
        if (!shouldAddResizeArea(resizeAreaBBox, resizeClipAreaBBox, {
            scrollX: scrollX,
            scrollY: scrollY,
        })) {
            return;
        }
        var offsetX = position.x + x - scrollX + seriesNumberWidth;
        var offsetY = position.y + y - scrollY;
        var resizeAreaWidth = this.spreadsheet.isFrozenRowHeader()
            ? headerWidth - seriesNumberWidth - (x - scrollX)
            : width;
        resizeArea.addShape('rect', {
            attrs: __assign(__assign({}, getResizeAreaAttrs({
                id: this.meta.id,
                theme: resizeStyle,
                type: ResizeDirectionType.Vertical,
                effect: ResizeAreaEffect.Cell,
                offsetX: offsetX,
                offsetY: offsetY,
                width: width,
                height: height,
            })), { x: offsetX, y: offsetY + height - resizeStyle.size / 2, width: resizeAreaWidth }),
        });
    };
    RowCell.prototype.getContentIndent = function () {
        if (!this.spreadsheet.isHierarchyTreeType()) {
            return 0;
        }
        var icon = this.getStyle().icon;
        var iconWidth = icon.size + icon.margin.right;
        var parent = this.meta.parent;
        var multiplier = 0;
        while (parent) {
            if (parent.height !== 0) {
                multiplier += iconWidth;
            }
            parent = parent.parent;
        }
        return multiplier;
    };
    RowCell.prototype.getTextIndent = function () {
        var _a = this.getStyle().icon, size = _a.size, margin = _a.margin;
        var contentIndent = this.getContentIndent();
        var treeIconWidth = this.showTreeIcon() ? size + margin.right : 0;
        return contentIndent + treeIconWidth;
    };
    RowCell.prototype.getTextStyle = function () {
        var _a = this.meta, isLeaf = _a.isLeaf, isTotals = _a.isTotals;
        var _b = this.getStyle(), text = _b.text, bolderText = _b.bolderText;
        var style = isLeaf && !isTotals ? text : bolderText;
        var textAlign = text.textAlign;
        return __assign(__assign({}, style), { textAlign: textAlign, textBaseline: 'top' });
    };
    RowCell.prototype.getFormattedFieldValue = function () {
        var label = this.meta.label;
        var content = label;
        var formatter = this.spreadsheet.dataSet.getFieldFormatter(this.meta.field);
        if (formatter) {
            content = formatter(label);
        }
        return {
            formattedValue: content,
            value: label,
        };
    };
    RowCell.prototype.getIconPosition = function () {
        var _a = this.textShape.cfg.attrs, x = _a.x, y = _a.y, textAlign = _a.textAlign;
        return {
            x: x +
                (textAlign === 'center'
                    ? this.actualTextWidth / 2
                    : this.actualTextWidth) +
                this.getStyle().icon.margin.left,
            y: y,
        };
    };
    RowCell.prototype.getMaxTextWidth = function () {
        var width = this.getContentArea().width;
        return width - this.getTextIndent() - this.getActionIconsWidth();
    };
    RowCell.prototype.getTextPosition = function () {
        var _a = this.getContentArea(), y = _a.y, contentHeight = _a.height;
        var _b = this.headerConfig, scrollY = _b.scrollY, height = _b.viewportHeight;
        var fontSize = this.getTextStyle().fontSize;
        var textIndent = this.getTextIndent();
        var textY = getAdjustPosition(y, contentHeight, scrollY, height, fontSize);
        var textX = getTextPosition(this.getContentArea(), this.getTextStyle()).x +
            textIndent;
        return { x: textX, y: textY };
    };
    RowCell.prototype.getIconYPosition = function () {
        var textY = this.getTextPosition().y;
        var size = this.getStyle().icon.size;
        var fontSize = this.getTextStyle().fontSize;
        return textY + (fontSize - size) / 2;
    };
    return RowCell;
}(HeaderCell));

var isFrozenCol = function (colIndex, frozenCount) {
    return frozenCount > 0 && colIndex < frozenCount;
};
var isFrozenTrailingCol = function (colIndex, frozenCount, colLength) {
    return frozenCount > 0 && colIndex >= colLength - frozenCount;
};
var isFrozenRow = function (rowIndex, minRowIndex, frozenCount) {
    return frozenCount > 0 && rowIndex < minRowIndex + frozenCount;
};
var isFrozenTrailingRow = function (rowIndex, maxRowIndex, frozenCount) {
    return frozenCount > 0 && rowIndex >= maxRowIndex + 1 - frozenCount;
};
/**
 * 计算偏移 scrollX、scrollY 的时候，在视窗中的节点索引
 * @param scrollX
 * @param scrollY
 * @param widths
 * @param heights
 * @param viewport
 * @param rowRemainWidth
 */
var calculateInViewIndexes = function (scrollX, scrollY, widths, heights, viewport, rowRemainWidth) {
    // 1. 计算 x min、max
    var xMin = findIndex(widths, function (width, idx) {
        var x = scrollX - (isNil(rowRemainWidth) ? 0 : rowRemainWidth) + viewport.x;
        return x >= width && x < widths[idx + 1];
    }, 0);
    xMin = Math.max(xMin, 0);
    var xMax = findIndex(widths, function (width, idx) {
        var x = viewport.width + scrollX + viewport.x;
        return x >= width && x < widths[idx + 1];
    }, xMin);
    xMax = Math.min(xMax === -1 ? Infinity : xMax, widths.length - 2);
    var _a = heights.getIndexRange(scrollY + viewport.y, viewport.height + scrollY + viewport.y), yMin = _a.start, yMax = _a.end;
    // use direction
    // const halfWidthSize = Math.ceil(xMax - xMin / 4);
    // const halfHeightSize = Math.ceil(yMax - yMin / 4);
    // xMin = Math.max(0, xMin - halfWidthSize)
    // xMax = xMax + halfWidthSize;
    // yMin = Math.max(0, yMin - halfHeightSize);
    // yMax = yMax + halfHeightSize;
    return [xMin, xMax, yMin, yMax];
};
/**
 * 优化滚动方向，对于小角度的滚动，固定为一个方向
 * @param x
 * @param y
 * @param ratio
 */
var optimizeScrollXY = function (x, y, ratio) {
    var ANGLE = 2; // 调参工程师
    var angle = Math.abs(x / y);
    // 经过滚动优化之后的 x, y
    var deltaX = angle <= 1 / ANGLE ? 0 : x;
    var deltaY = angle > ANGLE ? 0 : y;
    return [deltaX * ratio.horizontal, deltaY * ratio.vertical];
};
var translateGroup = function (group, scrollX, scrollY) {
    var _a, _b;
    var matrix = group === null || group === void 0 ? void 0 : group.getMatrix();
    var preX = (_a = matrix === null || matrix === void 0 ? void 0 : matrix[6]) !== null && _a !== void 0 ? _a : 0;
    var preY = (_b = matrix === null || matrix === void 0 ? void 0 : matrix[7]) !== null && _b !== void 0 ? _b : 0;
    group === null || group === void 0 ? void 0 : group.translate(scrollX - preX, scrollY - preY);
};
var translateGroupX = function (group, scrollX) {
    var _a;
    var matrix = group === null || group === void 0 ? void 0 : group.getMatrix();
    var preX = (_a = matrix === null || matrix === void 0 ? void 0 : matrix[6]) !== null && _a !== void 0 ? _a : 0;
    group === null || group === void 0 ? void 0 : group.translate(scrollX - preX, 0);
};
var translateGroupY = function (group, scrollY) {
    var _a;
    var matrix = group === null || group === void 0 ? void 0 : group.getMatrix();
    var preY = (_a = matrix === null || matrix === void 0 ? void 0 : matrix[7]) !== null && _a !== void 0 ? _a : 0;
    group === null || group === void 0 ? void 0 : group.translate(0, scrollY - preY);
};
/**
 * frozen                     frozenTrailing
 * ColCount                   ColCount
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * |     |     frozenRow     |          |  frozenRowCount
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * | fro |                   | fro      |
 * | zen |      panel        | zen      |
 * | col |      scroll       | trailing |
 * |     |                   | col      |
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * |     | frozenTrailingRow |          |  frozenTrailingRowCount
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * @description returns which group data cell belongs in frozen mode
 */
var getFrozenDataCellType = function (meta, frozenOpts, colLength, cellRange) {
    var frozenColCount = frozenOpts.frozenColCount, frozenRowCount = frozenOpts.frozenRowCount, frozenTrailingColCount = frozenOpts.frozenTrailingColCount, frozenTrailingRowCount = frozenOpts.frozenTrailingRowCount;
    var colIndex = meta.colIndex, rowIndex = meta.rowIndex;
    if (isFrozenRow(rowIndex, cellRange.start, frozenRowCount)) {
        return FrozenCellType.ROW;
    }
    if (isFrozenTrailingRow(rowIndex, cellRange.end, frozenTrailingRowCount)) {
        return FrozenCellType.TRAILING_ROW;
    }
    if (isFrozenCol(colIndex, frozenColCount)) {
        return FrozenCellType.COL;
    }
    if (isFrozenTrailingCol(colIndex, frozenTrailingColCount, colLength)) {
        return FrozenCellType.TRAILING_COL;
    }
    return FrozenCellType.SCROLL;
};
/**
 * @description calculate all cells in frozen group's intersection region
 */
var calculateFrozenCornerCells = function (opts, colLength, cellRange) {
    var _a;
    var frozenColCount = opts.frozenColCount, frozenRowCount = opts.frozenRowCount, frozenTrailingColCount = opts.frozenTrailingColCount, frozenTrailingRowCount = opts.frozenTrailingRowCount;
    var result = (_a = {},
        _a[FrozenCellType.TOP] = [],
        _a[FrozenCellType.BOTTOM] = [],
        _a);
    // frozenColGroup with frozenRowGroup or frozenTrailingRowGroup. Top left and bottom left corner.
    for (var i = 0; i < frozenColCount; i++) {
        for (var j = cellRange.start; j < cellRange.start + frozenRowCount; j++) {
            result[FrozenCellType.TOP].push({
                x: i,
                y: j,
            });
        }
        if (frozenTrailingRowCount > 0) {
            for (var j = 0; j < frozenTrailingRowCount; j++) {
                var index = cellRange.end - j;
                result[FrozenCellType.BOTTOM].push({
                    x: i,
                    y: index,
                });
            }
        }
    }
    // frozenTrailingColGroup with frozenRowGroup or frozenTrailingRowGroup. Top right and bottom right corner.
    for (var i = 0; i < frozenTrailingColCount; i++) {
        var colIndex = colLength - 1 - i;
        for (var j = cellRange.start; j < cellRange.start + frozenRowCount; j++) {
            result[FrozenCellType.TOP].push({
                x: colIndex,
                y: j,
            });
        }
        if (frozenTrailingRowCount > 0) {
            for (var j = 0; j < frozenTrailingRowCount; j++) {
                var index = cellRange.end - j;
                result[FrozenCellType.BOTTOM].push({
                    x: colIndex,
                    y: index,
                });
            }
        }
    }
    return result;
};
/**
 * @description split all cells in current panel with five child group
 */
var splitInViewIndexesWithFrozen = function (indexes, frozenOpts, colLength, cellRange) {
    var frozenColCount = frozenOpts.frozenColCount, frozenRowCount = frozenOpts.frozenRowCount, frozenTrailingColCount = frozenOpts.frozenTrailingColCount, frozenTrailingRowCount = frozenOpts.frozenTrailingRowCount;
    var centerIndexes = __spreadArray([], __read(indexes), false);
    // Cut off frozen cells from centerIndexes
    if (isFrozenCol(centerIndexes[0], frozenColCount)) {
        centerIndexes[0] = frozenColCount;
    }
    if (isFrozenTrailingCol(centerIndexes[1], frozenTrailingColCount, colLength)) {
        centerIndexes[1] = colLength - frozenTrailingColCount - 1;
    }
    if (isFrozenRow(centerIndexes[2], cellRange.start, frozenRowCount)) {
        centerIndexes[2] = cellRange.start + frozenRowCount;
    }
    if (isFrozenTrailingRow(centerIndexes[3], cellRange.end, frozenTrailingRowCount)) {
        centerIndexes[3] = cellRange.end - frozenTrailingRowCount;
    }
    // Calculate indexes for four frozen groups
    var frozenRowIndexes = __spreadArray([], __read(centerIndexes), false);
    frozenRowIndexes[2] = cellRange.start;
    frozenRowIndexes[3] = cellRange.start + frozenRowCount - 1;
    var frozenColIndexes = __spreadArray([], __read(centerIndexes), false);
    frozenColIndexes[0] = 0;
    frozenColIndexes[1] = frozenColCount - 1;
    var frozenTrailingRowIndexes = __spreadArray([], __read(centerIndexes), false);
    frozenTrailingRowIndexes[2] = cellRange.end + 1 - frozenTrailingRowCount;
    frozenTrailingRowIndexes[3] = cellRange.end;
    var frozenTrailingColIndexes = __spreadArray([], __read(centerIndexes), false);
    frozenTrailingColIndexes[0] = colLength - frozenTrailingColCount;
    frozenTrailingColIndexes[1] = colLength - 1;
    return {
        center: centerIndexes,
        frozenRow: frozenRowIndexes,
        frozenCol: frozenColIndexes,
        frozenTrailingCol: frozenTrailingColIndexes,
        frozenTrailingRow: frozenTrailingRowIndexes,
    };
};
var getCellRange = function (viewCellHeights, pagination) {
    var heights = viewCellHeights;
    var start = 0;
    var end = heights.getTotalLength() - 1;
    if (pagination) {
        var current = pagination.current, pageSize = pagination.pageSize;
        start = Math.max((current - 1) * pageSize, 0);
        end = Math.min(current * pageSize - 1, heights.getTotalLength() - 1);
    }
    return {
        start: start,
        end: end,
    };
};

var getTableColIconsWidth = function (ss, meta, cellType, iconStyle) {
    var _a, _b;
    var iconSize = get(iconStyle, 'size');
    var iconMargin = get(iconStyle, 'margin');
    var iconNums = 0;
    if (ss.options.showDefaultHeaderActionIcon) {
        iconNums = 1;
    }
    else {
        iconNums = ((_b = (_a = find(ss.options.headerActionIcons, function (headerActionIcon) {
            return shouldShowActionIcons(headerActionIcon, meta, cellType);
        })) === null || _a === void 0 ? void 0 : _a.iconNames) !== null && _b !== void 0 ? _b : []).length;
    }
    return (iconNums * (iconSize + iconMargin.left) +
        (iconNums > 0 ? iconMargin.right : 0));
};
var getExtraPaddingForExpandIcon = function (ss, field, style) {
    var _a, _b;
    var iconMarginLeft = ((_a = style.icon.margin) === null || _a === void 0 ? void 0 : _a.left) || 0;
    var iconMarginRight = ((_b = style.icon.margin) === null || _b === void 0 ? void 0 : _b.right) || 0;
    var hiddenColumnsDetail = ss.store.get('hiddenColumnsDetail', []);
    var hasPrevSiblingCell = false;
    var hasNextSiblingCell = false;
    hiddenColumnsDetail.forEach(function (column) {
        var _a, _b, _c, _d;
        if (((_b = (_a = column === null || column === void 0 ? void 0 : column.displaySiblingNode) === null || _a === void 0 ? void 0 : _a.prev) === null || _b === void 0 ? void 0 : _b.field) === field) {
            hasPrevSiblingCell = true;
        }
        if (((_d = (_c = column === null || column === void 0 ? void 0 : column.displaySiblingNode) === null || _c === void 0 ? void 0 : _c.next) === null || _d === void 0 ? void 0 : _d.field) === field) {
            hasNextSiblingCell = true;
        }
    });
    var iconSize = get(style, 'icon.size');
    // 图标本身宽度 + 主题配置的 icon margin
    return {
        left: hasNextSiblingCell ? iconSize + iconMarginRight : 0,
        right: hasPrevSiblingCell ? iconSize + iconMarginLeft : 0,
    };
};
var getOccupiedWidthForTableCol = function (ss, meta, style) {
    var padding = get(style, 'cell.padding');
    var expandIconPadding = getExtraPaddingForExpandIcon(ss, meta.field, style);
    return (padding.left +
        padding.right +
        getTableColIconsWidth(ss, meta, CellTypes.COL_CELL, get(style, 'icon')) +
        expandIconPadding.left +
        expandIconPadding.right);
};

var TableColCell = /** @class */ (function (_super) {
    __extends(TableColCell, _super);
    function TableColCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableColCell.prototype.handleRestOptions = function () {
        var _a = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _a[_i] = arguments[_i];
        }
        var _b = __read(_a, 1), headerConfig = _b[0];
        this.headerConfig = __assign({}, headerConfig);
        var field = this.meta.field;
        var sortParams = this.spreadsheet.dataCfg.sortParams;
        var sortParam = find(sortParams, function (item) { return (item === null || item === void 0 ? void 0 : item.sortFieldId) === field; });
        var type = getSortTypeIcon(sortParam, true);
        this.headerConfig.sortParam = __assign(__assign(__assign({}, this.headerConfig.sortParam), (sortParam || {})), { type: type });
    };
    TableColCell.prototype.isFrozenCell = function () {
        var _a = this.spreadsheet.options, frozenColCount = _a.frozenColCount, frozenTrailingColCount = _a.frozenTrailingColCount;
        var colIndex = this.meta.colIndex;
        var colLeafNodes = this.spreadsheet.facet.layoutResult.colLeafNodes;
        return (isFrozenCol(colIndex, frozenColCount) ||
            isFrozenTrailingCol(colIndex, frozenTrailingColCount, colLeafNodes.length));
    };
    TableColCell.prototype.getColResizeArea = function () {
        var isFrozenCell = this.isFrozenCell();
        if (!isFrozenCell) {
            return _super.prototype.getColResizeArea.call(this);
        }
        return getOrCreateResizeAreaGroupById(this.spreadsheet, KEY_GROUP_FROZEN_COL_RESIZE_AREA);
    };
    TableColCell.prototype.isSortCell = function () {
        return true;
    };
    TableColCell.prototype.showSortIcon = function () {
        return this.spreadsheet.options.showDefaultHeaderActionIcon;
    };
    TableColCell.prototype.getTextStyle = function () {
        var style = this.getStyle();
        return get(style, 'bolderText');
    };
    TableColCell.prototype.getContentArea = function () {
        var _a;
        var padding = (((_a = this.getStyle()) === null || _a === void 0 ? void 0 : _a.cell) || this.theme.dataCell.cell).padding;
        var newPadding = __assign({}, padding);
        var extraPadding = getExtraPaddingForExpandIcon(this.spreadsheet, this.meta.field, this.getStyle());
        if (extraPadding.left) {
            newPadding.left = (newPadding.left || 0) + extraPadding.left;
        }
        if (extraPadding.right) {
            newPadding.right = (newPadding.right || 0) + extraPadding.right;
        }
        return getContentArea(this.getCellArea(), newPadding);
    };
    TableColCell.prototype.getHorizontalResizeAreaName = function () {
        return "".concat(HORIZONTAL_RESIZE_AREA_KEY_PRE).concat('table-col-cell');
    };
    // 明细表列头不应该格式化 https://github.com/antvis/S2/issues/840
    TableColCell.prototype.getFormattedFieldValue = function () {
        var label = this.meta.label;
        return {
            formattedValue: label,
            value: label,
        };
    };
    TableColCell.prototype.drawBackgroundShape = function () {
        var backgroundColor = this.getStyle().cell.backgroundColor;
        this.backgroundShape = renderRect(this, __assign(__assign({}, this.getCellArea()), { fill: backgroundColor }));
    };
    return TableColCell;
}(ColCell));

var TableCornerCell = /** @class */ (function (_super) {
    __extends(TableCornerCell, _super);
    function TableCornerCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableCornerCell.prototype.getStyle = function (name) {
        return name ? this.theme[name] : get(this, 'theme.cornerCell');
    };
    TableCornerCell.prototype.showSortIcon = function () {
        return false;
    };
    TableCornerCell.prototype.drawLeftBorder = function () {
        var _a = getBorderPositionAndStyle(CellBorderPosition.LEFT, this.getCellArea(), this.getStyle().cell), position = _a.position, style = _a.style;
        renderLine(this, position, style);
    };
    TableCornerCell.prototype.drawBorders = function () {
        _super.prototype.drawBorders.call(this);
        if (this.meta.colIndex === 0) {
            this.drawLeftBorder();
        }
    };
    return TableCornerCell;
}(TableColCell));

var TableDataCell = /** @class */ (function (_super) {
    __extends(TableDataCell, _super);
    function TableDataCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableDataCell.prototype.drawTextShape = function () {
        _super.prototype.drawTextShape.call(this);
        this.drawLinkFieldShape();
    };
    TableDataCell.prototype.drawLinkFieldShape = function () {
        var _a = this.spreadsheet.options.interaction.linkFields, linkFields = _a === void 0 ? [] : _a;
        var linkTextFill = this.theme.rowCell.text.linkTextFill;
        _super.prototype.drawLinkFieldShape.call(this, linkFields.includes(this.meta.valueField), linkTextFill);
    };
    TableDataCell.prototype.drawBorderShape = function () {
        _super.prototype.drawBorderShape.call(this);
        if (this.meta.colIndex === 0) {
            this.drawLeftBorder();
        }
    };
    return TableDataCell;
}(DataCell));

var TableRowCell = /** @class */ (function (_super) {
    __extends(TableRowCell, _super);
    function TableRowCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TableRowCell.prototype, "cellType", {
        get: function () {
            return CellTypes.ROW_CELL;
        },
        enumerable: false,
        configurable: true
    });
    TableRowCell.prototype.getTextStyle = function () {
        return this.theme.rowCell.text;
    };
    TableRowCell.prototype.drawBorderShape = function () {
        _super.prototype.drawBorderShape.call(this);
        if (this.meta.colIndex === 0) {
            this.drawLeftBorder();
        }
    };
    TableRowCell.prototype.drawResizeArea = function () {
        var _a = this.getCellArea(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var rowIndex = this.meta.rowIndex;
        var resizeStyle = this.getResizeAreaStyle();
        var _b = this.spreadsheet.options, frozenRowCount = _b.frozenRowCount, frozenTrailingRowCount = _b.frozenTrailingRowCount;
        var cellRange = this.spreadsheet.facet.getCellRange();
        var isFrozenRow$1 = isFrozenRow(rowIndex, cellRange.start, frozenRowCount);
        var isFrozenTrailingRow$1 = isFrozenTrailingRow(rowIndex, cellRange.end, frozenTrailingRowCount);
        var isFrozen = isFrozenRow$1 || isFrozenTrailingRow$1;
        var resizeAreaId = isFrozen
            ? KEY_GROUP_FROZEN_ROW_RESIZE_AREA
            : KEY_GROUP_ROW_RESIZE_AREA;
        var resizeArea = getOrCreateResizeAreaGroupById(this.spreadsheet, resizeAreaId);
        var colHeight = this.spreadsheet.facet.layoutResult.colsHierarchy.height;
        var sy = this.spreadsheet.facet.getScrollOffset().scrollY;
        var paginationSy = this.spreadsheet.facet.getPaginationScrollY();
        var scrollY = sy + paginationSy;
        var yOffset = y + (isFrozenTrailingRow$1 ? 0 : colHeight);
        if (!isFrozenTrailingRow$1) {
            yOffset -= isFrozenRow$1 ? paginationSy : scrollY;
        }
        resizeArea.addShape('rect', {
            attrs: __assign(__assign({}, getResizeAreaAttrs({
                id: String(this.meta.rowIndex),
                theme: resizeStyle,
                type: ResizeDirectionType.Vertical,
                effect: ResizeAreaEffect.Cell,
                offsetX: x,
                offsetY: yOffset,
                width: width,
                height: height,
            })), { x: x, y: yOffset + height - resizeStyle.size / 2, width: width }),
        });
    };
    return TableRowCell;
}(DataCell));

var BaseEvent = /** @class */ (function () {
    function BaseEvent(spreadsheet) {
        this.spreadsheet = spreadsheet;
        this.bindEvents();
    }
    return BaseEvent;
}());

var DataCellClick = /** @class */ (function (_super) {
    __extends(DataCellClick, _super);
    function DataCellClick() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataCellClick.prototype.bindEvents = function () {
        this.bindDataCellClick();
    };
    DataCellClick.prototype.bindDataCellClick = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.DATA_CELL_CLICK, function (event) {
            event.stopPropagation();
            var interaction = _this.spreadsheet.interaction;
            if (interaction.hasIntercepts([InterceptType.CLICK])) {
                return;
            }
            interaction.clearHoverTimer();
            _this.emitLinkFieldClickEvent(event);
            var cell = _this.spreadsheet.getCell(event.target);
            var meta = cell.getMeta();
            if (!meta) {
                return;
            }
            interaction.addIntercepts([InterceptType.HOVER]);
            if (interaction.isSelectedCell(cell)) {
                interaction.reset();
                return;
            }
            interaction.clearState();
            interaction.changeState({
                cells: [getCellMeta(cell)],
                stateName: InteractionStateName.SELECTED,
            });
            _this.spreadsheet.emit(S2Event.GLOBAL_SELECTED, [cell]);
            _this.showTooltip(event, meta);
        });
    };
    DataCellClick.prototype.getTooltipOperator = function (event, meta) {
        var _this = this;
        var cell = this.spreadsheet.getCell(event.target);
        var operation = getTooltipOptions(this.spreadsheet, event).operation;
        var trendMenu = operation.trend && __assign(__assign({}, TOOLTIP_OPERATOR_TREND_MENU), { onClick: function () {
                _this.spreadsheet.emit(S2Event.DATA_CELL_TREND_ICON_CLICK, meta);
                _this.spreadsheet.hideTooltip();
            } });
        return getTooltipVisibleOperator(operation, {
            defaultMenus: [trendMenu],
            cell: cell,
        });
    };
    DataCellClick.prototype.showTooltip = function (event, meta) {
        var data = meta.data, _a = meta.isTotals, isTotals = _a === void 0 ? false : _a, value = meta.value, fieldValue = meta.fieldValue, field = meta.field, valueField = meta.valueField;
        var currentCellMeta = data;
        var showSingleTips = this.spreadsheet.isTableMode();
        var cellData = showSingleTips
            ? __assign(__assign({}, currentCellMeta), { value: value || fieldValue, valueField: field || valueField }) : currentCellMeta;
        var cellInfos = [
            cellData || __assign(__assign({}, meta.rowQuery), meta.colQuery),
        ];
        var operator = this.getTooltipOperator(event, meta);
        this.spreadsheet.showTooltipWithInfo(event, cellInfos, {
            isTotals: isTotals,
            operator: operator,
            enterable: true,
            hideSummary: true,
            showSingleTips: showSingleTips,
        });
    };
    DataCellClick.prototype.emitLinkFieldClickEvent = function (event) {
        var appendInfo = get(event.target, 'attrs.appendInfo', {});
        if (appendInfo.isRowHeaderText) {
            var cellData = appendInfo.cellData;
            var key = cellData.valueField, record = cellData.data;
            this.spreadsheet.emit(S2Event.GLOBAL_LINK_FIELD_JUMP, {
                key: key,
                record: record,
            });
        }
    };
    return DataCellClick;
}(BaseEvent));

var MergedCellClick = /** @class */ (function (_super) {
    __extends(MergedCellClick, _super);
    function MergedCellClick() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MergedCellClick.prototype.bindEvents = function () {
        this.bindDataCellClick();
    };
    MergedCellClick.prototype.bindDataCellClick = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.MERGED_CELLS_CLICK, function (event) {
            event.stopPropagation();
            var interaction = _this.spreadsheet.interaction;
            if (interaction.hasIntercepts([InterceptType.CLICK])) {
                return;
            }
            interaction.addIntercepts([InterceptType.HOVER]);
        });
    };
    return MergedCellClick;
}(BaseEvent));

var RowColumnClick = /** @class */ (function (_super) {
    __extends(RowColumnClick, _super);
    function RowColumnClick() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMultiSelection = false;
        _this.handleRowColClick = function (event, isTreeRowClick) {
            if (isTreeRowClick === void 0) { isTreeRowClick = false; }
            event.stopPropagation();
            var interaction = _this.spreadsheet.interaction;
            var cell = _this.spreadsheet.getCell(event.target);
            if (interaction.isSelectedCell(cell)) {
                interaction.reset();
                return;
            }
            if (interaction.selectHeaderCell({
                cell: cell,
                isTreeRowClick: isTreeRowClick,
                isMultiSelection: _this.isMultiSelection,
            })) {
                _this.showTooltip(event);
            }
        };
        return _this;
    }
    RowColumnClick.prototype.bindEvents = function () {
        this.bindKeyboardDown();
        this.bindKeyboardUp();
        this.bindColCellClick();
        this.bindRowCellClick();
        this.bindTableColExpand();
    };
    RowColumnClick.prototype.bindKeyboardDown = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.GLOBAL_KEYBOARD_DOWN, function (event) {
            if (event.key === InteractionKeyboardKey.META) {
                _this.isMultiSelection = true;
            }
        });
    };
    RowColumnClick.prototype.bindKeyboardUp = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.GLOBAL_KEYBOARD_UP, function (event) {
            if (event.key === InteractionKeyboardKey.META) {
                _this.isMultiSelection = false;
                _this.spreadsheet.interaction.removeIntercepts([InterceptType.CLICK]);
            }
        });
    };
    RowColumnClick.prototype.bindRowCellClick = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.ROW_CELL_CLICK, function (event) {
            _this.handleRowColClick(event, _this.spreadsheet.isHierarchyTreeType());
        });
    };
    RowColumnClick.prototype.bindColCellClick = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.COL_CELL_CLICK, function (event) {
            _this.handleRowColClick(event);
        });
    };
    RowColumnClick.prototype.showTooltip = function (event) {
        var _a = getTooltipOptions(this.spreadsheet, event), operation = _a.operation, showTooltip = _a.showTooltip;
        if (!showTooltip) {
            return;
        }
        var interaction = this.spreadsheet.interaction;
        var cellInfos = interaction.isSelectedState()
            ? mergeCellInfo(interaction.getActiveCells())
            : [];
        var operator = this.getTooltipOperator(event, operation);
        this.spreadsheet.showTooltipWithInfo(event, cellInfos, {
            showSingleTips: true,
            operator: operator,
        });
    };
    RowColumnClick.prototype.getTooltipOperator = function (event, operation) {
        var _this = this;
        var _a;
        var cell = this.spreadsheet.getCell(event.target);
        var cellMeta = (_a = cell.getMeta) === null || _a === void 0 ? void 0 : _a.call(cell);
        var isColCell = cell.cellType === CellTypes.COL_CELL;
        // 是叶子节点, 并且是列头单元格, 且大于一个时, 显示隐藏按钮
        var isMultiColumns = this.spreadsheet.getColumnNodes().length > 1;
        var enableHiddenColumnOperator = isColCell && isMultiColumns && cellMeta.isLeaf && operation.hiddenColumns;
        var hiddenColumnsMenu = enableHiddenColumnOperator && __assign(__assign({}, TOOLTIP_OPERATOR_HIDDEN_COLUMNS_MENU), { onClick: function () {
                _this.hideSelectedColumns();
            } });
        return getTooltipVisibleOperator(operation, {
            defaultMenus: [hiddenColumnsMenu],
            cell: cell,
        });
    };
    RowColumnClick.prototype.bindTableColExpand = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.LAYOUT_TABLE_COL_EXPANDED, function (node) {
            _this.handleExpandIconClick(node);
        });
    };
    /**
     * 隐藏选中的列
     * 每次点击存储两个信息
     * 1. [hiddenColumnFields]: 当前选中 (单/多选) 的 field, 对应 dataCfg 里面的 column
     *    用于点击展开按钮后还原, 区别于 options.hiddenColumnFields, 这里需要分段存储, 比如现在有两个隐藏的列
     *    [1,2, (3隐藏), 4, 5, (6隐藏), 7]
     *    展开按钮在 4, 7, 点击任意按钮, 应该只展开所对应的那组 : 4 => [3], 7 => [6]
     * 2. [displaySiblingNode]: 当前这一组的列隐藏后, 需要将展开按钮显示到对应的兄弟节点
     * 这样不用每次 render 的时候实时计算, 渲染列头单元格 直接取数据即可
     */
    RowColumnClick.prototype.hideSelectedColumns = function () {
        var interaction = this.spreadsheet.interaction;
        var selectedColumnNodes = interaction
            .getActiveCells()
            .map(function (cell) { return cell.getMeta(); });
        if (this.spreadsheet.isTableMode()) {
            var selectedColumnFields = selectedColumnNodes.map(function (_a) {
                var field = _a.field;
                return field;
            });
            // 兼容多选
            hideColumnsByThunkGroup(this.spreadsheet, selectedColumnFields, true);
        }
        else {
            var selectedColumnFields = selectedColumnNodes.map(function (_a) {
                var id = _a.id;
                return id;
            });
            hideColumns(this.spreadsheet, selectedColumnFields, true);
        }
    };
    RowColumnClick.prototype.handleExpandIconClick = function (node) {
        var _this = this;
        var lastHiddenColumnsDetail = this.spreadsheet.store.get('hiddenColumnsDetail', []);
        var _a = (lastHiddenColumnsDetail.find(function (_a) {
            var displaySiblingNode = _a.displaySiblingNode;
            return isEqualDisplaySiblingNodeId(displaySiblingNode, node.id);
        }) || {}).hideColumnNodes, hideColumnNodes = _a === void 0 ? [] : _a;
        var lastHideColumnFields = this.spreadsheet.options.interaction.hiddenColumnFields;
        var willDisplayColumnFields = hideColumnNodes.map(function (hideColumnNode) {
            return _this.spreadsheet.isTableMode() ? hideColumnNode.field : hideColumnNode.id;
        });
        var hiddenColumnFields = difference(lastHideColumnFields, willDisplayColumnFields);
        var hiddenColumnsDetail = lastHiddenColumnsDetail.filter(function (_a) {
            var displaySiblingNode = _a.displaySiblingNode;
            return !isEqualDisplaySiblingNodeId(displaySiblingNode, node.id);
        });
        this.spreadsheet.setOptions({
            interaction: {
                hiddenColumnFields: hiddenColumnFields,
            },
        });
        this.spreadsheet.store.set('hiddenColumnsDetail', hiddenColumnsDetail);
        this.spreadsheet.interaction.reset();
        this.spreadsheet.render(false);
    };
    return RowColumnClick;
}(BaseEvent));

/**
 * Row header click navigation interaction
 */
var RowTextClick = /** @class */ (function (_super) {
    __extends(RowTextClick, _super);
    function RowTextClick() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRowData = function (cellData) {
            var node = cellData;
            var nodeData = {};
            while (node.parent) {
                nodeData[node.key] = node.value;
                node = node.parent;
            }
            var rowIndex = _this.getRowIndex(cellData);
            var originalRowData = _this.getOriginalRowData(cellData, rowIndex);
            var rowData = __assign(__assign(__assign({}, originalRowData), nodeData), { rowIndex: rowIndex });
            return rowData;
        };
        _this.getOriginalRowData = function (cellData, rowIndex) {
            var _a;
            var options = _this.spreadsheet.options;
            var _b = ((_a = options === null || options === void 0 ? void 0 : options.totals) === null || _a === void 0 ? void 0 : _a.row) || {}, showGrandTotals = _b.showGrandTotals, showSubTotals = _b.showSubTotals, reverseLayout = _b.reverseLayout, reverseSubLayout = _b.reverseSubLayout;
            // If grand totals, sub totals enabled and in the table head
            var grandTotalsRowIndexDiff = showGrandTotals && reverseLayout ? 1 : 0;
            var subTotalsRowIndexDiff = showSubTotals && reverseSubLayout ? 1 : 0;
            var dataIndex = Math.max(0, rowIndex - grandTotalsRowIndexDiff - subTotalsRowIndexDiff);
            var currentRowData = find(_this.spreadsheet.dataCfg.data, function (row, index) {
                return row[cellData.key] === cellData.value && index === dataIndex;
            });
            return currentRowData;
        };
        _this.getRowIndex = function (cellData) {
            var _a, _b;
            var isTree = _this.spreadsheet.options.hierarchyType === 'tree';
            if (isTree) {
                var child = cellData;
                while (!isEmpty(child.children)) {
                    child = head(child.children);
                }
                return (_a = cellData.rowIndex) !== null && _a !== void 0 ? _a : child.rowIndex;
            }
            // if current cell has no row index, return dynamic computed value
            var rowIndex = Math.floor(cellData.y / cellData.height);
            return (_b = cellData.rowIndex) !== null && _b !== void 0 ? _b : rowIndex;
        };
        return _this;
    }
    RowTextClick.prototype.bindEvents = function () {
        this.bindRowCellClick();
    };
    RowTextClick.prototype.bindRowCellClick = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.ROW_CELL_CLICK, function (event) {
            if (_this.spreadsheet.interaction.hasIntercepts([InterceptType.CLICK])) {
                return;
            }
            var appendInfo = get(event.target, 'attrs.appendInfo', {});
            if (appendInfo.isRowHeaderText) {
                var cellData = appendInfo.cellData;
                var key = cellData.key;
                var rowData = _this.getRowData(cellData);
                _this.spreadsheet.emit(S2Event.GLOBAL_LINK_FIELD_JUMP, {
                    key: key,
                    record: rowData,
                });
            }
        });
    };
    return RowTextClick;
}(BaseEvent));

/**
 * @description Hover event for data cells, row cells and col cells
 */
var HoverEvent = /** @class */ (function (_super) {
    __extends(HoverEvent, _super);
    function HoverEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HoverEvent.prototype.bindEvents = function () {
        this.bindDataCellHover();
        this.bindRowCellHover();
        this.bindColCellHover();
    };
    HoverEvent.prototype.updateRowColCells = function (meta) {
        var rowId = meta.rowId, colId = meta.colId;
        var interaction = this.spreadsheet.interaction;
        if (colId) {
            // update colHeader cells
            var allColHeaderCells = getActiveHoverRowColCells(colId, interaction.getAllColHeaderCells());
            forEach(allColHeaderCells, function (cell) {
                cell.updateByState(InteractionStateName.HOVER);
            });
        }
        if (rowId) {
            // update rowHeader cells
            var allRowHeaderCells = getActiveHoverRowColCells(rowId, interaction.getAllRowHeaderCells(), this.spreadsheet.isHierarchyTreeType());
            forEach(allRowHeaderCells, function (cell) {
                cell.updateByState(InteractionStateName.HOVER);
            });
        }
    };
    /**
     * @description change the data cell state from hover to hover focus
     * @param cell
     * @param event
     * @param meta
     */
    HoverEvent.prototype.changeStateToHoverFocus = function (cell, event, meta) {
        var _this = this;
        var interaction = this.spreadsheet.interaction;
        interaction.clearHoverTimer();
        var hoverTimer = setTimeout(function () {
            interaction.changeState({
                cells: [getCellMeta(cell)],
                stateName: InteractionStateName.HOVER_FOCUS,
            });
            var showSingleTips = _this.spreadsheet.isTableMode();
            var options = {
                isTotals: meta.isTotals,
                enterable: true,
                hideSummary: true,
                showSingleTips: showSingleTips,
            };
            var data = _this.getCellInfo(meta, showSingleTips);
            _this.spreadsheet.showTooltipWithInfo(event, data, options);
        }, HOVER_FOCUS_TIME);
        interaction.setHoverTimer(hoverTimer);
    };
    /**
     * @description handle the row or column header hover state
     * @param event
     */
    HoverEvent.prototype.handleHeaderHover = function (event) {
        var cell = this.spreadsheet.getCell(event.target);
        if (isEmpty(cell)) {
            return;
        }
        var interaction = this.spreadsheet.interaction;
        var activeCells = interaction.getActiveCells();
        interaction.clearHoverTimer();
        // 避免在统一单元格内鼠标移动造成的多次渲染
        if (isEqual(activeCells === null || activeCells === void 0 ? void 0 : activeCells[0], cell)) {
            return;
        }
        var meta = cell.getMeta();
        interaction.changeState({
            cells: [getCellMeta(cell)],
            stateName: InteractionStateName.HOVER,
        });
        cell.update();
        if (cell.getActualText() !== cell.getFieldValue()) {
            var showSingleTips = true;
            var options = {
                isTotals: meta.isTotals,
                enterable: true,
                hideSummary: true,
                showSingleTips: showSingleTips,
                enableFormat: this.spreadsheet.isPivotMode(),
            };
            var data = this.getCellInfo(meta, showSingleTips);
            this.spreadsheet.showTooltipWithInfo(event, data, options);
        }
    };
    HoverEvent.prototype.getCellInfo = function (meta, showSingleTips) {
        if (meta === void 0) { meta = {}; }
        var data = meta.data, query = meta.query, value = meta.value, field = meta.field, fieldValue = meta.fieldValue, valueField = meta.valueField, rowQuery = meta.rowQuery, colQuery = meta.colQuery;
        var currentCellMeta = data;
        var cellInfos = showSingleTips
            ? [
                __assign(__assign({}, query), { value: value || fieldValue, valueField: field || valueField }),
            ]
            : [currentCellMeta || __assign(__assign({}, rowQuery), colQuery)];
        return cellInfos;
    };
    HoverEvent.prototype.bindDataCellHover = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.DATA_CELL_HOVER, function (event) {
            var cell = _this.spreadsheet.getCell(event.target);
            if (isEmpty(cell)) {
                return;
            }
            var _a = _this.spreadsheet, interaction = _a.interaction, options = _a.options;
            var interactionOptions = options.interaction;
            var meta = cell === null || cell === void 0 ? void 0 : cell.getMeta();
            interaction.changeState({
                cells: [getCellMeta(cell)],
                stateName: InteractionStateName.HOVER,
            });
            if (interactionOptions.hoverHighlight) {
                // highlight all the row and column cells which the cell belongs to
                _this.updateRowColCells(meta);
            }
            if (interactionOptions.hoverFocus) {
                _this.changeStateToHoverFocus(cell, event, meta);
            }
        });
    };
    HoverEvent.prototype.bindRowCellHover = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.ROW_CELL_HOVER, function (event) {
            _this.handleHeaderHover(event);
        });
    };
    HoverEvent.prototype.bindColCellHover = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.COL_CELL_HOVER, function (event) {
            _this.handleHeaderHover(event);
        });
    };
    return HoverEvent;
}(BaseEvent));

var EventController = /** @class */ (function () {
    function EventController(spreadsheet) {
        var _this = this;
        this.canvasEventHandlers = [];
        this.s2EventHandlers = [];
        this.domEventListeners = [];
        this.onCanvasMousedown = function (event) {
            _this.target = event.target;
            // 点击时清除 hover focus 状态
            _this.spreadsheet.interaction.clearHoverTimer();
            if (_this.isResizeArea(event)) {
                _this.spreadsheet.emit(S2Event.LAYOUT_RESIZE_MOUSE_DOWN, event);
                return;
            }
            var cellType = _this.spreadsheet.getCellType(event.target);
            switch (cellType) {
                case CellTypes.DATA_CELL:
                    _this.spreadsheet.emit(S2Event.DATA_CELL_MOUSE_DOWN, event);
                    break;
                case CellTypes.ROW_CELL:
                    _this.spreadsheet.emit(S2Event.ROW_CELL_MOUSE_DOWN, event);
                    break;
                case CellTypes.COL_CELL:
                    _this.spreadsheet.emit(S2Event.COL_CELL_MOUSE_DOWN, event);
                    break;
                case CellTypes.CORNER_CELL:
                    _this.spreadsheet.emit(S2Event.CORNER_CELL_MOUSE_DOWN, event);
                    break;
                case CellTypes.MERGED_CELL:
                    _this.spreadsheet.emit(S2Event.MERGED_CELLS_MOUSE_DOWN, event);
                    break;
            }
        };
        this.onCanvasMousemove = function (event) {
            if (_this.isResizeArea(event)) {
                _this.activeResizeArea(event);
                _this.spreadsheet.emit(S2Event.LAYOUT_RESIZE_MOUSE_MOVE, event);
                return;
            }
            _this.resetResizeArea();
            var cell = _this.spreadsheet.getCell(event.target);
            if (cell) {
                var cellType = cell.cellType;
                switch (cellType) {
                    case CellTypes.DATA_CELL:
                        _this.spreadsheet.emit(S2Event.DATA_CELL_MOUSE_MOVE, event);
                        break;
                    case CellTypes.ROW_CELL:
                        _this.spreadsheet.emit(S2Event.ROW_CELL_MOUSE_MOVE, event);
                        break;
                    case CellTypes.COL_CELL:
                        _this.spreadsheet.emit(S2Event.COL_CELL_MOUSE_MOVE, event);
                        break;
                    case CellTypes.CORNER_CELL:
                        _this.spreadsheet.emit(S2Event.CORNER_CELL_MOUSE_MOVE, event);
                        break;
                    case CellTypes.MERGED_CELL:
                        _this.spreadsheet.emit(S2Event.MERGED_CELLS_MOUSE_MOVE, event);
                        break;
                }
                if (!_this.spreadsheet.interaction.hasIntercepts([
                    InterceptType.HOVER,
                    InterceptType.BRUSH_SELECTION,
                ])) {
                    _this.spreadsheet.emit(S2Event.GLOBAL_HOVER, event);
                    switch (cellType) {
                        case CellTypes.DATA_CELL:
                            _this.spreadsheet.emit(S2Event.DATA_CELL_HOVER, event);
                            break;
                        case CellTypes.ROW_CELL:
                            _this.spreadsheet.emit(S2Event.ROW_CELL_HOVER, event);
                            break;
                        case CellTypes.COL_CELL:
                            _this.spreadsheet.emit(S2Event.COL_CELL_HOVER, event);
                            break;
                        case CellTypes.CORNER_CELL:
                            _this.spreadsheet.emit(S2Event.CORNER_CELL_HOVER, event);
                            break;
                        case CellTypes.MERGED_CELL:
                            _this.spreadsheet.emit(S2Event.MERGED_CELLS_HOVER, event);
                            break;
                    }
                }
            }
        };
        this.onCanvasMouseup = function (event) {
            if (_this.isResizeArea(event)) {
                _this.spreadsheet.emit(S2Event.LAYOUT_RESIZE_MOUSE_UP, event);
                return;
            }
            var cell = _this.spreadsheet.getCell(event.target);
            if (cell) {
                var cellType = cell.cellType;
                // target相同，说明是一个cell内的click事件
                if (_this.target === event.target) {
                    switch (cellType) {
                        case CellTypes.DATA_CELL:
                            _this.spreadsheet.emit(S2Event.DATA_CELL_CLICK, event);
                            break;
                        case CellTypes.ROW_CELL:
                            // 屏蔽 actionIcons的点击，只有HeaderCells 需要， DataCell 有状态类 icon， 不需要屏蔽
                            if (_this.getTargetType() === IMAGE) {
                                break;
                            }
                            _this.spreadsheet.emit(S2Event.ROW_CELL_CLICK, event);
                            break;
                        case CellTypes.COL_CELL:
                            if (_this.getTargetType() === IMAGE) {
                                break;
                            }
                            _this.spreadsheet.emit(S2Event.COL_CELL_CLICK, event);
                            break;
                        case CellTypes.CORNER_CELL:
                            if (_this.getTargetType() === IMAGE) {
                                break;
                            }
                            _this.spreadsheet.emit(S2Event.CORNER_CELL_CLICK, event);
                            break;
                        case CellTypes.MERGED_CELL:
                            _this.spreadsheet.emit(S2Event.MERGED_CELLS_CLICK, event);
                            break;
                    }
                }
                // 通用的mouseup事件
                switch (cellType) {
                    case CellTypes.DATA_CELL:
                        _this.spreadsheet.emit(S2Event.DATA_CELL_MOUSE_UP, event);
                        break;
                    case CellTypes.ROW_CELL:
                        _this.spreadsheet.emit(S2Event.ROW_CELL_MOUSE_UP, event);
                        break;
                    case CellTypes.COL_CELL:
                        _this.spreadsheet.emit(S2Event.COL_CELL_MOUSE_UP, event);
                        break;
                    case CellTypes.CORNER_CELL:
                        _this.spreadsheet.emit(S2Event.CORNER_CELL_MOUSE_UP, event);
                        break;
                    case CellTypes.MERGED_CELL:
                        _this.spreadsheet.emit(S2Event.MERGED_CELLS_MOUSE_UP, event);
                        break;
                }
            }
        };
        this.onCanvasDoubleClick = function (event) {
            var spreadsheet = _this.spreadsheet;
            if (_this.isResizeArea(event)) {
                spreadsheet.emit(S2Event.LAYOUT_RESIZE_MOUSE_UP, event);
                return;
            }
            var cell = spreadsheet.getCell(event.target);
            if (cell) {
                var cellType = cell.cellType;
                if (_this.target === event.target) {
                    switch (cellType) {
                        case CellTypes.DATA_CELL:
                            spreadsheet.emit(S2Event.DATA_CELL_DOUBLE_CLICK, event);
                            break;
                        case CellTypes.ROW_CELL:
                            spreadsheet.emit(S2Event.ROW_CELL_DOUBLE_CLICK, event);
                            break;
                        case CellTypes.COL_CELL:
                            spreadsheet.emit(S2Event.COL_CELL_DOUBLE_CLICK, event);
                            break;
                        case CellTypes.CORNER_CELL:
                            spreadsheet.emit(S2Event.CORNER_CELL_DOUBLE_CLICK, event);
                            break;
                        case CellTypes.MERGED_CELL:
                            spreadsheet.emit(S2Event.MERGED_CELLS_DOUBLE_CLICK, event);
                            break;
                    }
                }
            }
        };
        this.onCanvasMouseout = function () {
            if (!_this.isAutoResetSheetStyle) {
                return;
            }
            var interaction = _this.spreadsheet.interaction;
            // 两种情况不能重置 1. 选中单元格 2. 有交互功能的tooltip打开时
            if (!interaction.isSelectedState() &&
                !interaction.hasIntercepts([InterceptType.HOVER])) {
                interaction.reset();
            }
        };
        this.onCanvasContextMenu = function (event) {
            var spreadsheet = _this.spreadsheet;
            if (_this.isResizeArea(event)) {
                spreadsheet.emit(S2Event.LAYOUT_RESIZE_MOUSE_UP, event);
                return;
            }
            spreadsheet.emit(S2Event.GLOBAL_CONTEXT_MENU, event);
        };
        this.spreadsheet = spreadsheet;
        this.bindEvents();
    }
    Object.defineProperty(EventController.prototype, "canvasContainer", {
        get: function () {
            return this.spreadsheet.container;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventController.prototype, "isAutoResetSheetStyle", {
        get: function () {
            return this.spreadsheet.options.interaction.autoResetSheetStyle;
        },
        enumerable: false,
        configurable: true
    });
    EventController.prototype.bindEvents = function () {
        var _this = this;
        this.clearAllEvents();
        // canvas events
        this.addCanvasEvent(OriginEventType.MOUSE_DOWN, this.onCanvasMousedown);
        this.addCanvasEvent(OriginEventType.MOUSE_MOVE, this.onCanvasMousemove);
        this.addCanvasEvent(OriginEventType.MOUSE_OUT, this.onCanvasMouseout);
        this.addCanvasEvent(OriginEventType.MOUSE_UP, this.onCanvasMouseup);
        this.addCanvasEvent(OriginEventType.DOUBLE_CLICK, this.onCanvasDoubleClick);
        this.addCanvasEvent(OriginEventType.CONTEXT_MENU, this.onCanvasContextMenu);
        // spreadsheet events
        this.addS2Event(S2Event.GLOBAL_ACTION_ICON_CLICK, function () {
            _this.spreadsheet.interaction.addIntercepts([InterceptType.HOVER]);
            _this.spreadsheet.interaction.clearState();
        });
        // dom events
        this.addDomEventListener(document, OriginEventType.CLICK, function (event) {
            _this.resetSheetStyle(event);
        });
        this.addDomEventListener(window, OriginEventType.KEY_DOWN, function (event) {
            _this.onKeyboardCopy(event);
            _this.onKeyboardEsc(event);
            _this.spreadsheet.emit(S2Event.GLOBAL_KEYBOARD_DOWN, event);
        });
        this.addDomEventListener(window, OriginEventType.KEY_UP, function (event) {
            _this.spreadsheet.emit(S2Event.GLOBAL_KEYBOARD_UP, event);
        });
        this.addDomEventListener(window, OriginEventType.MOUSE_UP, function (event) {
            _this.spreadsheet.emit(S2Event.GLOBAL_MOUSE_UP, event);
        });
    };
    EventController.prototype.getTargetType = function () {
        return get(this, 'target.cfg.type');
    };
    EventController.prototype.onKeyboardCopy = function (event) {
        // windows and macos copy
        if (this.spreadsheet.options.interaction.enableCopy &&
            keyEqualTo(event.key, InteractionKeyboardKey.COPY) &&
            (event.metaKey || event.ctrlKey)) {
            var copyData = getSelectedData(this.spreadsheet);
            if (!isNil(copyData)) {
                this.spreadsheet.emit(S2Event.GLOBAL_COPIED, copyData);
            }
        }
    };
    EventController.prototype.onKeyboardEsc = function (event) {
        if (keyEqualTo(event.key, InteractionKeyboardKey.ESC)) {
            this.resetSheetStyle(event);
        }
    };
    EventController.prototype.resetSheetStyle = function (event) {
        if (!this.isAutoResetSheetStyle || !this.spreadsheet) {
            return;
        }
        // 全局有 mouseUp 和 click 事件, 当刷选完成后会同时触发, 当选中单元格后, 会同时触发 click 对应的 reset 事件
        // 所以如果是 刷选过程中 引起的 click(mousedown + mouseup) 事件, 则不需要重置
        var interaction = this.spreadsheet.interaction;
        if (interaction.hasIntercepts([InterceptType.BRUSH_SELECTION])) {
            interaction.removeIntercepts([InterceptType.BRUSH_SELECTION]);
            return;
        }
        if (this.isMouseOnTheTooltip(event) ||
            this.isMouseOnTheCanvasContainer(event)) {
            return;
        }
        this.spreadsheet.emit(S2Event.GLOBAL_RESET, event);
        interaction.reset();
    };
    EventController.prototype.isMouseOnTheCanvasContainer = function (event) {
        if (event instanceof MouseEvent) {
            var canvas = this.spreadsheet.container.get('el');
            var _a = canvas.getBoundingClientRect() || {}, x = _a.x, y = _a.y;
            // 这里不能使用 bounding rect 的 width 和 height, 高清适配后 canvas 实际宽高会变
            // 比如实际 400 * 300 => hd (800 * 600)
            // 从视觉来看, 虽然点击了空白处, 但其实还是处于 放大后的 canvas 区域, 所以还需要额外判断一下坐标
            var _b = this.getContainerRect(), width = _b.width, height = _b.height;
            return (canvas.contains(event.target) &&
                event.clientX <= x + width &&
                event.clientY <= y + height);
        }
        return false;
    };
    EventController.prototype.getContainerRect = function () {
        var _a;
        var _b = ((_a = this.spreadsheet.facet) === null || _a === void 0 ? void 0 : _a.panelBBox) || {}, maxX = _b.maxX, maxY = _b.maxY;
        var _c = this.spreadsheet.options, width = _c.width, height = _c.height;
        return {
            width: Math.min(width, maxX),
            height: Math.min(height, maxY),
        };
    };
    EventController.prototype.isMouseOnTheTooltip = function (event) {
        var _a, _b, _c;
        if (!getTooltipOptions(this.spreadsheet, event).showTooltip) {
            return false;
        }
        var _d = ((_c = (_b = (_a = this.spreadsheet.tooltip) === null || _a === void 0 ? void 0 : _a.container) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect) === null || _c === void 0 ? void 0 : _c.call(_b)) || {}, x = _d.x, y = _d.y, width = _d.width, height = _d.height;
        if (event instanceof MouseEvent) {
            return (event.clientX >= x &&
                event.clientX <= x + width &&
                event.clientY >= y &&
                event.clientY <= y + height);
        }
        return false;
    };
    EventController.prototype.isResizeArea = function (event) {
        var appendInfo = get(event.target, 'attrs.appendInfo');
        return appendInfo === null || appendInfo === void 0 ? void 0 : appendInfo.isResizeArea;
    };
    EventController.prototype.activeResizeArea = function (event) {
        this.resetResizeArea();
        var resizeArea = event.target;
        this.spreadsheet.store.set('activeResizeArea', resizeArea);
        resizeArea.attr(SHAPE_STYLE_MAP.backgroundOpacity, this.spreadsheet.theme.resizeArea.interactionState.hover
            .backgroundOpacity);
    };
    EventController.prototype.resetResizeArea = function () {
        var resizeArea = this.spreadsheet.store.get('activeResizeArea');
        if (!isEmpty(resizeArea)) {
            resizeArea.attr(SHAPE_STYLE_MAP.backgroundOpacity, this.spreadsheet.theme.resizeArea.backgroundOpacity);
        }
        this.spreadsheet.store.set('activeResizeArea', resizeArea);
    };
    EventController.prototype.clear = function () {
        this.unbindEvents();
    };
    EventController.prototype.unbindEvents = function () {
        this.clearAllEvents();
    };
    EventController.prototype.addCanvasEvent = function (eventType, handler) {
        var _a;
        (_a = this.canvasContainer) === null || _a === void 0 ? void 0 : _a.on(eventType, handler);
        this.canvasEventHandlers.push({ type: eventType, handler: handler });
    };
    EventController.prototype.addS2Event = function (eventType, handler) {
        this.spreadsheet.on(eventType, handler);
        this.s2EventHandlers.push({
            type: eventType,
            handler: handler,
        });
    };
    EventController.prototype.addDomEventListener = function (target, type, handler) {
        if (target.addEventListener) {
            target.addEventListener(type, handler);
            this.domEventListeners.push({ target: target, type: type, handler: handler });
        }
        else {
            // eslint-disable-next-line no-console
            console.error("Please make sure ".concat(target, " has addEventListener function"));
        }
    };
    EventController.prototype.clearAllEvents = function () {
        var _this = this;
        each(this.canvasEventHandlers, function (_a) {
            var _b;
            var type = _a.type, handler = _a.handler;
            (_b = _this.canvasContainer) === null || _b === void 0 ? void 0 : _b.off(type, handler);
        });
        each(this.s2EventHandlers, function (_a) {
            var type = _a.type, handler = _a.handler;
            _this.spreadsheet.off(type, handler);
        });
        each(this.domEventListeners, function (event) {
            event.target.removeEventListener(event.type, event.handler);
        });
        this.canvasEventHandlers = [];
        this.s2EventHandlers = [];
        this.domEventListeners = [];
    };
    return EventController;
}());

var RangeSelection = /** @class */ (function (_super) {
    __extends(RangeSelection, _super);
    function RangeSelection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isRangeSelection = false;
        _this.handleColClick = function (event) {
            event.stopPropagation();
            var interaction = _this.spreadsheet.interaction;
            var cell = _this.spreadsheet.getCell(event.target);
            var meta = cell === null || cell === void 0 ? void 0 : cell.getMeta();
            if (!isNil(meta === null || meta === void 0 ? void 0 : meta.x)) {
                interaction.addIntercepts([InterceptType.HOVER]);
                var selectedCells = [getCellMeta(cell)];
                var lastCell = _this.spreadsheet.store.get('lastClickedCell');
                // 处理shift区间多选
                if (_this.isRangeSelection &&
                    lastCell &&
                    lastCell.cellType === cell.cellType &&
                    lastCell.getMeta().level === cell.getMeta().level) {
                    var _a = __read([
                        _this.spreadsheet.facet.layoutResult.rowsHierarchy.maxLevel,
                        _this.spreadsheet.facet.layoutResult.colsHierarchy.maxLevel,
                    ], 2), rowMaxLevel = _a[0], colMaxLevel = _a[1];
                    var _b = _this.getShiftSelectRange(lastCell.getMeta(), cell.getMeta()), start = _b.start, end = _b.end;
                    if (cell instanceof DataCell) {
                        selectedCells = _this.handleSeriesNumberRowSelected(start.rowIndex, end.rowIndex, cell);
                    }
                    else if (cell.cellType === CellTypes.ROW_CELL &&
                        cell.getMeta().level === rowMaxLevel) {
                        selectedCells = _this.handleRowSelected(start.rowIndex, end.rowIndex, cell);
                    }
                    else if (cell.cellType === CellTypes.COL_CELL &&
                        cell.getMeta().level === colMaxLevel) {
                        selectedCells = _this.handleColSelected(start.colIndex, end.colIndex, cell);
                    }
                    // 兼容行列多选
                    // Set the header cells (colCell or RowCell)  selected information and update the dataCell state.
                    interaction.changeState({
                        cells: selectedCells,
                        stateName: InteractionStateName.SELECTED,
                    });
                }
                else {
                    _this.spreadsheet.store.set('lastClickedCell', cell);
                }
                var selectedCellIds = selectedCells.map(function (_a) {
                    var id = _a.id;
                    return id;
                });
                // Update the interaction state of all the selected cells:  header cells(colCell or RowCell) and dataCells belong to them.
                interaction.updateCells(interaction.getRowColActiveCells(selectedCellIds));
                _this.spreadsheet.emit(S2Event.GLOBAL_SELECTED, interaction.getActiveCells());
            }
        };
        return _this;
    }
    RangeSelection.prototype.bindEvents = function () {
        this.bindKeyboardDown();
        this.bindDataCellClick();
        this.bindColCellClick();
        this.bindKeyboardUp();
    };
    RangeSelection.prototype.bindKeyboardDown = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.GLOBAL_KEYBOARD_DOWN, function (event) {
            if (event.key === InteractionKeyboardKey.SHIFT) {
                _this.isRangeSelection = true;
                _this.spreadsheet.interaction.addIntercepts([InterceptType.CLICK]);
            }
        });
    };
    RangeSelection.prototype.bindKeyboardUp = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.GLOBAL_KEYBOARD_UP, function (event) {
            if (event.key === InteractionKeyboardKey.SHIFT) {
                _this.isRangeSelection = false;
                _this.spreadsheet.interaction.removeIntercepts([InterceptType.CLICK]);
            }
        });
    };
    RangeSelection.prototype.bindColCellClick = function () {
        var _this = this;
        if (this.spreadsheet.isTableMode()) {
            // series-number click
            this.spreadsheet.on(S2Event.ROW_CELL_CLICK, function (event) {
                _this.handleColClick(event);
            });
        }
        this.spreadsheet.on(S2Event.COL_CELL_CLICK, function (event) {
            _this.handleColClick(event);
        });
    };
    RangeSelection.prototype.getShiftSelectRange = function (start, end) {
        var minRowIndex = Math.min(start.rowIndex, end.rowIndex);
        var maxRowIndex = Math.max(start.rowIndex, end.rowIndex);
        var minColIndex = Math.min(start.colIndex, end.colIndex);
        var maxColIndex = Math.max(start.colIndex, end.colIndex);
        return {
            start: {
                rowIndex: minRowIndex,
                colIndex: minColIndex,
            },
            end: {
                rowIndex: maxRowIndex,
                colIndex: maxColIndex,
            },
        };
    };
    RangeSelection.prototype.bindDataCellClick = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.DATA_CELL_CLICK, function (event) {
            event.stopPropagation();
            var cell = _this.spreadsheet.getCell(event.target);
            var meta = cell.getMeta();
            var interaction = _this.spreadsheet.interaction;
            if (!meta) {
                return;
            }
            var lastClickedCell = _this.spreadsheet.store.get('lastClickedCell');
            var isShiftSelect = _this.isRangeSelection && (lastClickedCell === null || lastClickedCell === void 0 ? void 0 : lastClickedCell.cellType) === cell.cellType;
            if (!isShiftSelect) {
                _this.spreadsheet.store.set('lastClickedCell', cell);
                return;
            }
            var _a = _this.getShiftSelectRange(lastClickedCell.getMeta(), cell.getMeta()), start = _a.start, end = _a.end;
            var cells = range(start.colIndex, end.colIndex + 1).flatMap(function (col) {
                var cellIdSuffix = _this.spreadsheet.facet.layoutResult.colLeafNodes[col].id;
                return range(start.rowIndex, end.rowIndex + 1).map(function (row) {
                    var cellIdPrefix = _this.spreadsheet.facet.getSeriesNumberWidth()
                        ? String(row)
                        : _this.spreadsheet.facet.layoutResult.rowLeafNodes[row].id;
                    return {
                        id: cellIdPrefix + '-' + cellIdSuffix,
                        colIndex: col,
                        rowIndex: row,
                        type: cell.cellType,
                    };
                });
            });
            interaction.addIntercepts([InterceptType.CLICK, InterceptType.HOVER]);
            _this.spreadsheet.hideTooltip();
            interaction.changeState({
                cells: cells,
                stateName: InteractionStateName.SELECTED,
            });
            _this.spreadsheet.emit(S2Event.GLOBAL_SELECTED, interaction.getActiveCells());
        });
    };
    RangeSelection.prototype.handleSeriesNumberRowSelected = function (startIndex, endIndex, cell) {
        // table模式下序列号行头
        var cellIdSufFix = this.spreadsheet.facet.layoutResult.colLeafNodes[0].id;
        return range(startIndex, endIndex + 1).map(function (row) {
            var cellIdPrefix = String(row);
            return {
                id: cellIdPrefix + '-' + cellIdSufFix,
                colIndex: 0,
                rowIndex: row,
                type: cell.cellType,
            };
        });
    };
    RangeSelection.prototype.handleRowSelected = function (startIndex, endIndex, cell) {
        // ROW_CELL类型 最后一个Level支持区间选择
        return this.spreadsheet.facet.layoutResult.rowNodes
            .filter(function (_a) {
            var rowIndex = _a.rowIndex;
            return inRange(rowIndex, startIndex, endIndex + 1);
        })
            .map(function (e) { return ({
            id: e.id,
            colIndex: e.colIndex,
            rowIndex: e.rowIndex,
            type: cell.cellType,
        }); });
    };
    RangeSelection.prototype.handleColSelected = function (startIndex, endIndex, cell) {
        // COL_CELL类型 最后一个Level支持区间选择
        return this.spreadsheet.facet.layoutResult.colLeafNodes
            .filter(function (_a) {
            var colIndex = _a.colIndex;
            return inRange(colIndex, startIndex, endIndex + 1);
        })
            .map(function (e) { return ({
            id: e.id,
            colIndex: e.colIndex,
            rowIndex: e.rowIndex,
            type: cell.cellType,
        }); });
    };
    return RangeSelection;
}(BaseEvent));

var SelectedCellMove = /** @class */ (function (_super) {
    __extends(SelectedCellMove, _super);
    function SelectedCellMove() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectedCellMove.prototype.bindEvents = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.GLOBAL_KEYBOARD_DOWN, function (event) {
            var SelectedCellMoveMap = [
                InteractionKeyboardKey.ARROW_LEFT,
                InteractionKeyboardKey.ARROW_RIGHT,
                InteractionKeyboardKey.ARROW_UP,
                InteractionKeyboardKey.ARROW_DOWN,
            ];
            if (SelectedCellMoveMap.includes(event.key)) {
                var cells = _this.spreadsheet.interaction.getCells();
                var cell = cells.length ? cells[cells.length - 1] : null;
                var rowCol = _this.getMoveInfo(event.key, cell);
                if (rowCol) {
                    _this.scrollToActiveCell(_this.spreadsheet, rowCol.row, rowCol.col);
                }
            }
        });
    };
    SelectedCellMove.prototype.getMoveInfo = function (code, cell) {
        if (!cell)
            return;
        switch (code) {
            case InteractionKeyboardKey.ARROW_RIGHT:
                return { row: cell.rowIndex, col: cell.colIndex + 1 };
            case InteractionKeyboardKey.ARROW_LEFT:
                return { row: cell.rowIndex, col: cell.colIndex - 1 };
            case InteractionKeyboardKey.ARROW_UP:
                return { row: cell.rowIndex - 1, col: cell.colIndex };
            case InteractionKeyboardKey.ARROW_DOWN:
                return { row: cell.rowIndex + 1, col: cell.colIndex };
        }
    };
    // 判断是否在可移动范围内
    SelectedCellMove.prototype.isInRange = function (spreadsheet, rowIndex, colIndex) {
        var rowLeafNodes = spreadsheet.facet.layoutResult.rowLeafNodes;
        var seriesCount = spreadsheet.isTableMode() && spreadsheet.options.showSeriesNumber ? 1 : 0;
        var colInRange = inRange(colIndex, 0, spreadsheet.dataSet.fields.columns.length + seriesCount);
        var rowInRange = inRange(rowIndex, 0, spreadsheet.isTableMode()
            ? spreadsheet.dataSet.getDisplayDataSet().length
            : rowLeafNodes.length);
        if (!(colInRange && rowInRange)) {
            return false;
        }
        return true;
    };
    // 计算需要滚动的offset
    SelectedCellMove.prototype.calculateOffset = function (spreadsheet, rowIndex, colIndex) {
        var _a = spreadsheet.options, _b = _a.frozenRowCount, frozenRowCount = _b === void 0 ? 0 : _b, _c = _a.frozenTrailingRowCount, frozenTrailingRowCount = _c === void 0 ? 0 : _c;
        var facet = spreadsheet.facet, frozenColGroup = spreadsheet.frozenColGroup, frozenTrailingColGroup = spreadsheet.frozenTrailingColGroup, frozenRowGroup = spreadsheet.frozenRowGroup, frozenTrailingRowGroup = spreadsheet.frozenTrailingRowGroup;
        var colLeafNodes = facet.layoutResult.colLeafNodes;
        var _d = facet.getScrollOffset(), scrollX = _d.scrollX, scrollY = _d.scrollY;
        var _e = facet.panelBBox, height = _e.viewportHeight, width = _e.viewportWidth;
        var frozenColWidth = frozenColGroup
            ? Math.floor(frozenColGroup.getBBox().width)
            : 0;
        var frozenTrailingColWidth = frozenTrailingColGroup
            ? Math.floor(frozenTrailingColGroup.getBBox().width)
            : 0;
        var frozenRowHeight = frozenRowGroup
            ? Math.floor(frozenRowGroup.getBBox().height)
            : 0;
        var frozenTrailingRowHeight = frozenTrailingRowGroup
            ? Math.floor(frozenTrailingRowGroup.getBBox().height)
            : 0;
        var indexes = calculateInViewIndexes(scrollX, scrollY, facet.viewCellWidths, facet.viewCellHeights, {
            width: width - frozenColWidth - frozenTrailingColWidth,
            height: height - frozenRowHeight - frozenTrailingRowHeight,
            x: frozenColWidth,
            y: frozenRowHeight,
        }, facet.getRealScrollX(facet.cornerBBox.width));
        // 小于0的初始值
        var offsetX = -1;
        var offsetY = -1;
        var targetNode = colLeafNodes.find(function (node) { return node.colIndex === colIndex; });
        // offsetX
        if (colIndex <= indexes[0]) {
            // scroll left
            offsetX = targetNode.x - frozenColWidth;
        }
        else if (colIndex >= indexes[1] &&
            colIndex < colLeafNodes.length - frozenTrailingRowCount) {
            // scroll right
            offsetX =
                targetNode.x + targetNode.width - width + frozenTrailingColWidth;
        }
        // offsetY
        if (rowIndex <= indexes[2]) {
            // scroll top
            offsetY = facet.viewCellHeights.getCellOffsetY(rowIndex - frozenRowCount);
        }
        else if (rowIndex >= indexes[3]) {
            // scroll bottom
            var y = facet.viewCellHeights.getCellOffsetY(rowIndex + 1);
            offsetY = y + frozenTrailingRowHeight - height;
        }
        return { offsetX: offsetX, offsetY: offsetY };
    };
    SelectedCellMove.prototype.scrollToActiveCell = function (spreadsheet, rowIndex, colIndex) {
        if (!this.isInRange(spreadsheet, rowIndex, colIndex)) {
            return;
        }
        var _a = this.calculateOffset(spreadsheet, rowIndex, colIndex), offsetX = _a.offsetX, offsetY = _a.offsetY;
        var _b = spreadsheet.facet.layoutResult, colLeafNodes = _b.colLeafNodes, rowLeafNodes = _b.rowLeafNodes;
        var facet = spreadsheet.facet, interaction = spreadsheet.interaction, isTableMode = spreadsheet.isTableMode;
        var _c = facet.getScrollOffset(), scrollX = _c.scrollX, scrollY = _c.scrollY;
        facet.scrollWithAnimation({
            offsetX: { value: offsetX > 0 ? offsetX : scrollX },
            offsetY: { value: offsetY > 0 ? offsetY : scrollY },
        });
        var rowId = isTableMode() ? String(rowIndex) : rowLeafNodes[rowIndex].id;
        interaction.changeState({
            stateName: InteractionStateName.SELECTED,
            cells: [
                {
                    colIndex: colIndex,
                    rowIndex: rowIndex,
                    id: getDataCellId(rowId, colLeafNodes[colIndex].id),
                    type: CellTypes.DATA_CELL,
                },
            ],
        });
        spreadsheet.emit(S2Event.GLOBAL_SELECTED, interaction.getActiveCells());
    };
    return SelectedCellMove;
}(BaseEvent));

/**
 * Panel area's brush selection interaction
 */
var BrushSelection = /** @class */ (function (_super) {
    __extends(BrushSelection, _super);
    function BrushSelection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayedDataCells = [];
        _this.brushRangeDataCells = [];
        _this.brushSelectionStage = InteractionBrushSelectionStage.UN_DRAGGED;
        _this.brushSelectionMinimumMoveDistance = 5;
        // 刷选过程中高亮的cell
        _this.showPrepareSelectedCells = function () {
            var brushRangeDataCells = _this.getBrushRangeDataCells();
            _this.spreadsheet.interaction.changeState({
                cells: brushRangeDataCells.map(function (item) { return getCellMeta(item); }),
                stateName: InteractionStateName.PREPARE_SELECT,
                // 刷选首先会经过 hover => mousedown => mousemove, hover时会将当前行全部高亮 (row cell + data cell)
                // 如果是有效刷选, 更新时会重新渲染, hover 高亮的格子 会正常重置
                // 如果是无效刷选(全部都是没数据的格子), brushRangeDataCells = [], 更新时会跳过, 需要强制重置 hover 高亮
                force: true,
            });
            _this.brushRangeDataCells = brushRangeDataCells;
        };
        return _this;
    }
    BrushSelection.prototype.bindEvents = function () {
        this.bindMouseDown();
        this.bindMouseMove();
        this.bindMouseUp();
    };
    BrushSelection.prototype.getPrepareSelectMaskTheme = function () {
        var _a;
        return (_a = this.spreadsheet.theme) === null || _a === void 0 ? void 0 : _a.prepareSelectMask;
    };
    BrushSelection.prototype.initPrepareSelectMaskShape = function () {
        var foregroundGroup = this.spreadsheet.foregroundGroup;
        if (!foregroundGroup) {
            return;
        }
        foregroundGroup.removeChild(this.prepareSelectMaskShape);
        var prepareSelectMaskTheme = this.getPrepareSelectMaskTheme();
        this.prepareSelectMaskShape = foregroundGroup.addShape('rect', {
            visible: false,
            attrs: {
                width: 0,
                height: 0,
                x: 0,
                y: 0,
                fill: prepareSelectMaskTheme === null || prepareSelectMaskTheme === void 0 ? void 0 : prepareSelectMaskTheme.backgroundColor,
                fillOpacity: prepareSelectMaskTheme === null || prepareSelectMaskTheme === void 0 ? void 0 : prepareSelectMaskTheme.backgroundOpacity,
                zIndex: FRONT_GROUND_GROUP_BRUSH_SELECTION_Z_INDEX,
            },
            capture: false,
        });
    };
    BrushSelection.prototype.setBrushSelectionStage = function (stage) {
        this.brushSelectionStage = stage;
    };
    BrushSelection.prototype.bindMouseDown = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.DATA_CELL_MOUSE_DOWN, function (event) {
            var _a;
            (_a = event === null || event === void 0 ? void 0 : event.preventDefault) === null || _a === void 0 ? void 0 : _a.call(event);
            if (_this.spreadsheet.interaction.hasIntercepts([InterceptType.CLICK])) {
                return;
            }
            _this.setBrushSelectionStage(InteractionBrushSelectionStage.CLICK);
            _this.initPrepareSelectMaskShape();
            _this.setDisplayedDataCells();
            _this.startBrushPoint = _this.getBrushPoint(event);
        });
    };
    BrushSelection.prototype.bindMouseMove = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.DATA_CELL_MOUSE_MOVE, function (event) {
            var _a;
            (_a = event === null || event === void 0 ? void 0 : event.preventDefault) === null || _a === void 0 ? void 0 : _a.call(event);
            if (_this.brushSelectionStage === InteractionBrushSelectionStage.UN_DRAGGED) {
                return;
            }
            var interaction = _this.spreadsheet.interaction;
            _this.setBrushSelectionStage(InteractionBrushSelectionStage.DRAGGED);
            _this.endBrushPoint = _this.getBrushPoint(event);
            interaction.addIntercepts([InterceptType.HOVER]);
            interaction.clearStyleIndependent();
            _this.updatePrepareSelectMask();
            _this.showPrepareSelectedCells();
        });
    };
    BrushSelection.prototype.bindMouseUp = function () {
        var _this = this;
        // 使用全局的 mouseup, 而不是 canvas 的 mouse up 防止刷选过程中移出表格区域时无法响应事件
        this.spreadsheet.on(S2Event.GLOBAL_MOUSE_UP, function (event) {
            var _a;
            (_a = event === null || event === void 0 ? void 0 : event.preventDefault) === null || _a === void 0 ? void 0 : _a.call(event);
            if (_this.isValidBrushSelection()) {
                _this.spreadsheet.interaction.addIntercepts([
                    InterceptType.BRUSH_SELECTION,
                ]);
                _this.updateSelectedCells();
                _this.spreadsheet.showTooltipWithInfo(event, getActiveCellsTooltipData(_this.spreadsheet));
            }
            _this.resetDrag();
        });
        // 刷选过程中右键弹出系统菜单时, 应该重置刷选, 防止系统菜单关闭后 mouse up 未相应依然是刷选状态
        this.spreadsheet.on(S2Event.GLOBAL_CONTEXT_MENU, function () {
            _this.spreadsheet.interaction.removeIntercepts([InterceptType.HOVER]);
            _this.resetDrag();
        });
    };
    BrushSelection.prototype.resetDrag = function () {
        this.hidePrepareSelectMaskShape();
        this.setBrushSelectionStage(InteractionBrushSelectionStage.UN_DRAGGED);
    };
    BrushSelection.prototype.isValidBrushSelection = function () {
        if (this.brushSelectionStage !== InteractionBrushSelectionStage.DRAGGED) {
            return false;
        }
        var _a = this.getBrushRange(), start = _a.start, end = _a.end;
        var isMovedEnoughDistance = end.x - start.x > this.brushSelectionMinimumMoveDistance ||
            end.y - start.y > this.brushSelectionMinimumMoveDistance;
        return isMovedEnoughDistance;
    };
    BrushSelection.prototype.setDisplayedDataCells = function () {
        this.displayedDataCells =
            this.spreadsheet.interaction.getPanelGroupAllDataCells();
    };
    BrushSelection.prototype.updatePrepareSelectMask = function () {
        var brushRange = this.getBrushRange();
        this.prepareSelectMaskShape.attr({
            x: brushRange.start.x,
            y: brushRange.start.y,
            width: brushRange.width,
            height: brushRange.height,
        });
        this.prepareSelectMaskShape.show();
    };
    BrushSelection.prototype.hidePrepareSelectMaskShape = function () {
        var _a;
        (_a = this.prepareSelectMaskShape) === null || _a === void 0 ? void 0 : _a.hide();
    };
    BrushSelection.prototype.getBrushPoint = function (event) {
        var originalEvent = event.originalEvent;
        var point = {
            x: originalEvent === null || originalEvent === void 0 ? void 0 : originalEvent.layerX,
            y: originalEvent === null || originalEvent === void 0 ? void 0 : originalEvent.layerY,
        };
        var cell = this.spreadsheet.getCell(event.target);
        var _a = cell.getMeta(), colIndex = _a.colIndex, rowIndex = _a.rowIndex;
        return __assign(__assign({}, point), { rowIndex: rowIndex, colIndex: colIndex });
    };
    // 四个刷选方向: 左 => 右, 右 => 左, 上 => 下, 下 => 上, 将最终结果进行重新排序, 获取真实的 row, col index
    BrushSelection.prototype.getBrushRange = function () {
        var minRowIndex = Math.min(this.startBrushPoint.rowIndex, this.endBrushPoint.rowIndex);
        var maxRowIndex = Math.max(this.startBrushPoint.rowIndex, this.endBrushPoint.rowIndex);
        var minColIndex = Math.min(this.startBrushPoint.colIndex, this.endBrushPoint.colIndex);
        var maxColIndex = Math.max(this.startBrushPoint.colIndex, this.endBrushPoint.colIndex);
        var minX = Math.min(this.startBrushPoint.x, this.endBrushPoint.x);
        var maxX = Math.max(this.startBrushPoint.x, this.endBrushPoint.x);
        var minY = Math.min(this.startBrushPoint.y, this.endBrushPoint.y);
        var maxY = Math.max(this.startBrushPoint.y, this.endBrushPoint.y);
        return {
            start: {
                rowIndex: minRowIndex,
                colIndex: minColIndex,
                x: minX,
                y: minY,
            },
            end: {
                rowIndex: maxRowIndex,
                colIndex: maxColIndex,
                x: maxX,
                y: maxY,
            },
            width: maxX - minX,
            height: maxY - minY,
        };
    };
    BrushSelection.prototype.isInBrushRange = function (meta) {
        var _a = this.getBrushRange(), start = _a.start, end = _a.end;
        var rowIndex = meta.rowIndex, colIndex = meta.colIndex;
        return (rowIndex >= start.rowIndex &&
            rowIndex <= end.rowIndex &&
            colIndex >= start.colIndex &&
            colIndex <= end.colIndex);
    };
    // 获取对角线的两个坐标, 得到对应矩阵并且有数据的单元格
    BrushSelection.prototype.getBrushRangeDataCells = function () {
        var _this = this;
        return this.displayedDataCells.filter(function (cell) {
            var meta = cell.getMeta();
            return _this.isInBrushRange(meta);
        });
    };
    // 最终刷选的cell
    BrushSelection.prototype.updateSelectedCells = function () {
        var interaction = this.spreadsheet.interaction;
        interaction.changeState({
            cells: this.brushRangeDataCells.map(function (item) { return getCellMeta(item); }),
            stateName: InteractionStateName.SELECTED,
        });
        this.spreadsheet.emit(S2Event.DATE_CELL_BRUSH_SELECTION, this.brushRangeDataCells);
        this.spreadsheet.emit(S2Event.GLOBAL_SELECTED, this.brushRangeDataCells);
        // 未刷选到有效格子, 允许 hover
        if (isEmpty(this.brushRangeDataCells)) {
            interaction.removeIntercepts([InterceptType.HOVER]);
        }
    };
    return BrushSelection;
}(BaseEvent));

var DataCellMultiSelection = /** @class */ (function (_super) {
    __extends(DataCellMultiSelection, _super);
    function DataCellMultiSelection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMultiSelection = false;
        return _this;
    }
    DataCellMultiSelection.prototype.bindEvents = function () {
        this.bindKeyboardDown();
        this.bindDataCellClick();
        this.bindKeyboardUp();
    };
    DataCellMultiSelection.prototype.bindKeyboardDown = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.GLOBAL_KEYBOARD_DOWN, function (event) {
            if (event.key === InteractionKeyboardKey.META) {
                _this.isMultiSelection = true;
                _this.spreadsheet.interaction.addIntercepts([InterceptType.CLICK]);
            }
        });
    };
    DataCellMultiSelection.prototype.bindKeyboardUp = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.GLOBAL_KEYBOARD_UP, function (event) {
            if (event.key === InteractionKeyboardKey.META) {
                _this.isMultiSelection = false;
                _this.spreadsheet.interaction.removeIntercepts([InterceptType.CLICK]);
            }
        });
    };
    DataCellMultiSelection.prototype.getSelectedCells = function (cell) {
        var id = cell.getMeta().id;
        var interaction = this.spreadsheet.interaction;
        var selectedCells = interaction.getCells();
        var cells = [];
        if (interaction.getCurrentStateName() !== InteractionStateName.SELECTED) {
            selectedCells = [];
        }
        if (selectedCells.find(function (meta) { return meta.id === id; })) {
            cells = selectedCells.filter(function (item) { return item.id !== id; });
        }
        else {
            cells = __spreadArray(__spreadArray([], __read(selectedCells), false), [getCellMeta(cell)], false);
        }
        return cells;
    };
    DataCellMultiSelection.prototype.bindDataCellClick = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.DATA_CELL_CLICK, function (event) {
            event.stopPropagation();
            var cell = _this.spreadsheet.getCell(event.target);
            var meta = cell.getMeta();
            var interaction = _this.spreadsheet.interaction;
            if (_this.isMultiSelection && meta) {
                var selectedCells = _this.getSelectedCells(cell);
                if (isEmpty(selectedCells)) {
                    interaction.clearState();
                    _this.spreadsheet.hideTooltip();
                    return;
                }
                interaction.addIntercepts([InterceptType.CLICK, InterceptType.HOVER]);
                _this.spreadsheet.hideTooltip();
                interaction.changeState({
                    cells: selectedCells,
                    stateName: InteractionStateName.SELECTED,
                });
                _this.spreadsheet.emit(S2Event.GLOBAL_SELECTED, interaction.getActiveCells());
                _this.spreadsheet.showTooltipWithInfo(event, getActiveCellsTooltipData(_this.spreadsheet));
            }
        });
    };
    return DataCellMultiSelection;
}(BaseEvent));

var RowColumnResize = /** @class */ (function (_super) {
    __extends(RowColumnResize, _super);
    function RowColumnResize() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.resizeStartPosition = {};
        _this.resizeMouseMove = function (event) {
            var _a, _b;
            if (!((_a = _this.resizeReferenceGroup) === null || _a === void 0 ? void 0 : _a.get('visible'))) {
                return;
            }
            (_b = event === null || event === void 0 ? void 0 : event.preventDefault) === null || _b === void 0 ? void 0 : _b.call(event);
            var originalEvent = event.originalEvent;
            var resizeInfo = _this.getResizeInfo();
            var resizeShapes = _this.resizeReferenceGroup.get('children');
            if (isEmpty(resizeShapes)) {
                return;
            }
            var _c = __read(resizeShapes, 2), endGuideLineShape = _c[1];
            var _d = __read(clone(endGuideLineShape.attr('path')), 2), guideLineStart = _d[0], guideLineEnd = _d[1];
            if (resizeInfo.type === ResizeDirectionType.Horizontal) {
                _this.updateHorizontalResizingEndGuideLinePosition(originalEvent, resizeInfo, guideLineStart, guideLineEnd);
            }
            else {
                _this.updateVerticalResizingEndGuideLinePosition(originalEvent, resizeInfo, guideLineStart, guideLineEnd);
            }
            endGuideLineShape.attr('path', [guideLineStart, guideLineEnd]);
        };
        return _this;
    }
    RowColumnResize.prototype.bindEvents = function () {
        this.bindMouseDown();
        this.bindMouseMove();
        this.bindMouseUp();
    };
    RowColumnResize.prototype.initResizeGroup = function () {
        if (this.resizeReferenceGroup) {
            return;
        }
        this.resizeReferenceGroup = this.spreadsheet.foregroundGroup.addGroup();
        var _a = this.spreadsheet.options, width = _a.width, height = _a.height;
        var _b = this.getResizeAreaTheme(), guideLineColor = _b.guideLineColor, guideLineDash = _b.guideLineDash, size = _b.size;
        var attrs = {
            path: '',
            lineDash: guideLineDash,
            stroke: guideLineColor,
            strokeWidth: size,
        };
        // 起始参考线
        this.resizeReferenceGroup.addShape('path', {
            id: RESIZE_START_GUIDE_LINE_ID,
            attrs: attrs,
        });
        // 结束参考线
        this.resizeReferenceGroup.addShape('path', {
            id: RESIZE_END_GUIDE_LINE_ID,
            attrs: attrs,
        });
        // Resize 蒙层
        this.resizeReferenceGroup.addShape('rect', {
            id: RESIZE_MASK_ID,
            attrs: {
                appendInfo: {
                    isResizeArea: true,
                },
                x: 0,
                y: 0,
                width: width,
                height: height,
                fill: 'transparent',
            },
        });
    };
    RowColumnResize.prototype.getResizeAreaTheme = function () {
        return this.spreadsheet.theme.resizeArea;
    };
    RowColumnResize.prototype.setResizeTarget = function (target) {
        this.resizeTarget = target;
    };
    RowColumnResize.prototype.getGuideLineWidthAndHeight = function () {
        var _a = this.spreadsheet.options, canvasWidth = _a.width, canvasHeight = _a.height;
        var _b = this.spreadsheet.facet.panelBBox, maxY = _b.maxY, maxX = _b.maxX;
        var width = Math.min(maxX, canvasWidth);
        var height = Math.min(maxY, canvasHeight);
        return {
            width: width,
            height: height,
        };
    };
    RowColumnResize.prototype.updateResizeGuideLinePosition = function (event, resizeInfo) {
        var resizeShapes = this.resizeReferenceGroup.get('children');
        if (isEmpty(resizeShapes)) {
            return;
        }
        var _a = __read(resizeShapes, 3), startResizeGuideLineShape = _a[0], endResizeGuideLineShape = _a[1], resizeMask = _a[2];
        var type = resizeInfo.type, offsetX = resizeInfo.offsetX, offsetY = resizeInfo.offsetY, width = resizeInfo.width, height = resizeInfo.height;
        var _b = this.getGuideLineWidthAndHeight(), guideLineMaxWidth = _b.width, guideLineMaxHeight = _b.height;
        resizeMask.attr('cursor', "".concat(type, "-resize"));
        if (type === ResizeDirectionType.Horizontal) {
            startResizeGuideLineShape.attr('path', [
                ['M', offsetX, offsetY],
                ['L', offsetX, guideLineMaxHeight],
            ]);
            endResizeGuideLineShape.attr('path', [
                ['M', offsetX + width, offsetY],
                ['L', offsetX + width, guideLineMaxHeight],
            ]);
            this.resizeStartPosition.offsetX = event.offsetX;
            return;
        }
        startResizeGuideLineShape.attr('path', [
            ['M', offsetX, offsetY],
            ['L', guideLineMaxWidth, offsetY],
        ]);
        endResizeGuideLineShape.attr('path', [
            ['M', offsetX, offsetY + height],
            ['L', guideLineMaxWidth, offsetY + height],
        ]);
        this.resizeStartPosition.offsetY = event.offsetY;
    };
    RowColumnResize.prototype.bindMouseDown = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.LAYOUT_RESIZE_MOUSE_DOWN, function (event) {
            var shape = event.target;
            var resizeInfo = shape === null || shape === void 0 ? void 0 : shape.attr('appendInfo');
            var originalEvent = event.originalEvent;
            _this.spreadsheet.store.set('resized', false);
            if (!(resizeInfo === null || resizeInfo === void 0 ? void 0 : resizeInfo.isResizeArea)) {
                return;
            }
            // 鼠标在 resize 热区 按下时, 将 tooltip 关闭, 避免造成干扰
            _this.spreadsheet.hideTooltip();
            _this.spreadsheet.interaction.addIntercepts([InterceptType.RESIZE]);
            _this.setResizeTarget(shape);
            _this.showResizeGroup();
            _this.updateResizeGuideLinePosition(originalEvent, resizeInfo);
        });
    };
    RowColumnResize.prototype.bindMouseMove = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.LAYOUT_RESIZE_MOUSE_MOVE, function (event) {
            throttle(_this.resizeMouseMove, 33)(event);
        });
    };
    // 将 SVG 的 path 转成更可读的坐标对象
    RowColumnResize.prototype.getResizeGuideLinePosition = function () {
        var _a = __read(this.resizeReferenceGroup.getChildren() || [], 2), startGuideLineShape = _a[0], endGuideLineShape = _a[1];
        var startGuideLinePath = (startGuideLineShape === null || startGuideLineShape === void 0 ? void 0 : startGuideLineShape.attr('path')) || [];
        var endGuideLinePath = (endGuideLineShape === null || endGuideLineShape === void 0 ? void 0 : endGuideLineShape.attr('path')) || [];
        var _b = __read(startGuideLinePath[0] || [], 3), _c = _b[1], startX = _c === void 0 ? 0 : _c, _d = _b[2], startY = _d === void 0 ? 0 : _d;
        var _e = __read(endGuideLinePath[0] || [], 3), _f = _e[1], endX = _f === void 0 ? 0 : _f, _g = _e[2], endY = _g === void 0 ? 0 : _g;
        return {
            start: {
                x: startX,
                y: startY,
            },
            end: {
                x: endX,
                y: endY,
            },
        };
    };
    RowColumnResize.prototype.getResizeWidthDetail = function () {
        var _a, _b;
        var _c = this.getResizeGuideLinePosition(), start = _c.start, end = _c.end;
        var width = Math.floor(end.x - start.x);
        var resizeInfo = this.getResizeInfo();
        switch (resizeInfo.effect) {
            case ResizeAreaEffect.Field:
                return {
                    eventType: S2Event.LAYOUT_RESIZE_ROW_WIDTH,
                    style: {
                        rowCfg: {
                            widthByField: (_a = {},
                                _a[resizeInfo.id] = width,
                                _a),
                        },
                    },
                };
            case ResizeAreaEffect.Tree:
                return {
                    eventType: S2Event.LAYOUT_RESIZE_TREE_WIDTH,
                    style: {
                        rowCfg: {
                            treeRowsWidth: width,
                        },
                    },
                };
            case ResizeAreaEffect.Cell:
                return {
                    eventType: S2Event.LAYOUT_RESIZE_COL_WIDTH,
                    style: {
                        colCfg: {
                            widthByFieldValue: (_b = {},
                                _b[resizeInfo.id] = width,
                                _b),
                        },
                    },
                };
            case ResizeAreaEffect.Series:
                return {
                    eventType: S2Event.LAYOUT_RESIZE_SERIES_WIDTH,
                    seriesNumberWidth: width,
                };
            default:
                return null;
        }
    };
    RowColumnResize.prototype.getResizeHeightDetail = function () {
        var _a, _b;
        var _c = this.spreadsheet.options, resize = _c.interaction.resize, heightByField = _c.style.rowCfg.heightByField;
        var rowCellPadding = this.spreadsheet.theme.rowCell.cell.padding;
        var _d = this.getResizeGuideLinePosition(), start = _d.start, end = _d.end;
        var baseHeight = Math.floor(end.y - start.y);
        var height = baseHeight - rowCellPadding.top - rowCellPadding.bottom;
        var resizeInfo = this.getResizeInfo();
        var rowCellStyle;
        switch (resizeInfo.effect) {
            case ResizeAreaEffect.Field:
                return {
                    eventType: S2Event.LAYOUT_RESIZE_COL_HEIGHT,
                    style: {
                        colCfg: {
                            heightByField: (_a = {},
                                _a[resizeInfo.id] = baseHeight,
                                _a),
                        },
                    },
                };
            case ResizeAreaEffect.Cell:
                if (heightByField[String(resizeInfo.id)] ||
                    get(resize, 'rowResizeType') === ResizeType.CURRENT) {
                    rowCellStyle = {
                        rowCfg: {
                            heightByField: (_b = {},
                                _b[resizeInfo.id] = height,
                                _b),
                        },
                    };
                }
                else {
                    rowCellStyle = {
                        cellCfg: {
                            height: height,
                        },
                    };
                }
                return {
                    eventType: S2Event.LAYOUT_RESIZE_ROW_HEIGHT,
                    style: rowCellStyle,
                };
            default:
                return null;
        }
    };
    RowColumnResize.prototype.getResizeDetail = function () {
        var resizeInfo = this.getResizeInfo();
        return resizeInfo.type === ResizeDirectionType.Horizontal
            ? this.getResizeWidthDetail()
            : this.getResizeHeightDetail();
    };
    RowColumnResize.prototype.showResizeGroup = function () {
        this.initResizeGroup();
        this.resizeReferenceGroup.set('visible', true);
    };
    RowColumnResize.prototype.hideResizeGroup = function () {
        this.resizeReferenceGroup.set('visible', false);
    };
    RowColumnResize.prototype.bindMouseUp = function () {
        var _this = this;
        this.spreadsheet.on(S2Event.GLOBAL_MOUSE_UP, function () {
            var _a;
            if (!_this.resizeReferenceGroup ||
                isEmpty((_a = _this.resizeReferenceGroup) === null || _a === void 0 ? void 0 : _a.getChildren())) {
                return;
            }
            _this.hideResizeGroup();
            _this.renderResizedResult();
        });
    };
    RowColumnResize.prototype.updateHorizontalResizingEndGuideLinePosition = function (originalEvent, resizeInfo, guideLineStart, guideLineEnd) {
        var offsetX = originalEvent.offsetX - this.resizeStartPosition.offsetX;
        if (resizeInfo.width + offsetX < MIN_CELL_WIDTH) {
            // 禁止拖到最小宽度
            offsetX = -(resizeInfo.width - MIN_CELL_WIDTH);
        }
        var resizedOffsetX = resizeInfo.offsetX + resizeInfo.width + offsetX;
        guideLineStart[1] = resizedOffsetX;
        guideLineEnd[1] = resizedOffsetX;
        this.resizeTarget.attr({
            x: resizedOffsetX - resizeInfo.size / 2,
        });
    };
    RowColumnResize.prototype.updateVerticalResizingEndGuideLinePosition = function (originalEvent, resizeInfo, guideLineStart, guideLineEnd) {
        var offsetY = originalEvent.offsetY - this.resizeStartPosition.offsetY;
        if (resizeInfo.height + offsetY < MIN_CELL_HEIGHT) {
            offsetY = -(resizeInfo.height - MIN_CELL_HEIGHT);
        }
        var resizedOffsetY = resizeInfo.offsetY + resizeInfo.height + offsetY;
        guideLineStart[2] = resizedOffsetY;
        guideLineEnd[2] = resizedOffsetY;
        this.resizeTarget.attr({
            y: resizedOffsetY - resizeInfo.size / 2,
        });
    };
    RowColumnResize.prototype.renderResizedResult = function () {
        var resizeInfo = this.getResizeInfo();
        var _a = this.getResizeDetail() || {}, style = _a.style, seriesNumberWidth = _a.seriesNumberWidth, resizeEventType = _a.eventType;
        var resizeDetail = {
            info: resizeInfo,
            style: style,
        };
        this.spreadsheet.emit(S2Event.LAYOUT_RESIZE, resizeDetail);
        this.spreadsheet.emit(resizeEventType, resizeDetail);
        if (style) {
            this.spreadsheet.setOptions({ style: style });
        }
        else {
            this.spreadsheet.theme.rowCell.seriesNumberWidth = seriesNumberWidth;
        }
        this.spreadsheet.store.set('resized', true);
        this.render();
    };
    RowColumnResize.prototype.getResizeInfo = function () {
        var _a;
        return (_a = this.resizeTarget) === null || _a === void 0 ? void 0 : _a.attr('appendInfo');
    };
    RowColumnResize.prototype.render = function () {
        this.resizeStartPosition = {};
        this.resizeTarget = null;
        this.resizeReferenceGroup = null;
        this.spreadsheet.render(false);
    };
    return RowColumnResize;
}(BaseEvent));

/**
 * New Base Header for all headers(cornerHeader, rowHeader, colHeader)
 * NOTE: Do not use this.cfg(which lays in group) to get header config,
 * use {@see headerConfig} instead
 */
var BaseHeader = /** @class */ (function (_super) {
    __extends(BaseHeader, _super);
    function BaseHeader(cfg) {
        var _this = _super.call(this, cfg) || this;
        /**
         * Check whether header cell in viewPort
         * @param gridPos
         * @param gridSize
         * @param viewportPos
         * @param viewportSize
         */
        _this.isHeaderCellInViewport = function (gridPos, gridSize, viewportPos, viewportSize) {
            return (gridPos + gridSize >= viewportPos && viewportPos + viewportSize >= gridPos);
        };
        _this.headerConfig = cfg;
        return _this;
    }
    /**
     * 清空热区，为重绘做准备，防止热区重复渲染
     * @param type 当前重绘的header类型
     */
    BaseHeader.prototype.clearResizeAreaGroup = function (type) {
        var foregroundGroup = this.get('parent');
        var resizerGroup = foregroundGroup === null || foregroundGroup === void 0 ? void 0 : foregroundGroup.findById(type);
        resizerGroup === null || resizerGroup === void 0 ? void 0 : resizerGroup.clear();
    };
    // start render header
    BaseHeader.prototype.render = function (type) {
        // clear resize group
        this.clearResizeAreaGroup(type);
        // clear self first
        this.clear();
        // draw by new data
        this.layout();
        // offset group
        this.offset();
        // clip group
        this.clip();
    };
    /**
     * Scroll header group's x,y
     * @param scrollX hScrollBar horizontal offset
     * @param scrollY hScrollBar vertical offset
     * @param type
     */
    BaseHeader.prototype.onScrollXY = function (scrollX, scrollY, type) {
        this.headerConfig.scrollX = scrollX;
        this.headerConfig.scrollY = scrollY;
        this.render(type);
    };
    /**
     * Only call when hRowScrollBar scrolls
     * @param rowScrollX  hRowScrollbar horizontal offset
     * @param type
     */
    BaseHeader.prototype.onRowScrollX = function (rowScrollX, type) {
        this.headerConfig.scrollX = rowScrollX;
        this.render(type);
    };
    BaseHeader.prototype.clear = function () {
        _super.prototype.clear.call(this);
    };
    return BaseHeader;
}(Group));

/**
 * Column Header for SpreadSheet
 */
var ColHeader = /** @class */ (function (_super) {
    __extends(ColHeader, _super);
    function ColHeader(cfg) {
        var _this = _super.call(this, cfg) || this;
        _this.scrollGroup = _this.addGroup({
            name: KEY_GROUP_COL_SCROLL,
            zIndex: FRONT_GROUND_GROUP_COL_SCROLL_Z_INDEX,
        });
        return _this;
    }
    /**
     * Make colHeader scroll with hScrollBar
     * @param scrollX horizontal offset
     * @param cornerWidth only has real meaning when scroll contains rowCell
     * @param type
     */
    ColHeader.prototype.onColScroll = function (scrollX, type) {
        if (this.headerConfig.scrollX !== scrollX) {
            this.headerConfig.scrollX = scrollX;
            this.render(type);
        }
    };
    ColHeader.prototype.clip = function () {
        var _a = this.headerConfig, width = _a.width, height = _a.height, scrollX = _a.scrollX, spreadsheet = _a.spreadsheet;
        var isFrozenRowHeader = spreadsheet.isFrozenRowHeader();
        this.scrollGroup.setClip({
            type: 'rect',
            attrs: {
                x: isFrozenRowHeader ? scrollX : 0,
                y: 0,
                width: isFrozenRowHeader ? width : width + scrollX,
                height: height,
            },
        });
    };
    ColHeader.prototype.clear = function () {
        var _a, _b;
        (_a = this.scrollGroup) === null || _a === void 0 ? void 0 : _a.clear();
        (_b = this.background) === null || _b === void 0 ? void 0 : _b.remove(true);
    };
    ColHeader.prototype.getCellInstance = function (item, spreadsheet, headerConfig) {
        return new ColCell(item, spreadsheet, headerConfig);
    };
    ColHeader.prototype.getCellGroup = function (node) {
        return this.scrollGroup;
    };
    ColHeader.prototype.isColCellInRect = function (item) {
        var _a = this.headerConfig, spreadsheet = _a.spreadsheet, cornerWidth = _a.cornerWidth, width = _a.width, scrollX = _a.scrollX;
        return (
        // don't care about scrollY, because there is only freeze col-header exist
        width + scrollX > item.x &&
            scrollX - (spreadsheet.isFrozenRowHeader() ? 0 : cornerWidth) <
                item.x + item.width);
    };
    ColHeader.prototype.layout = function () {
        var _this = this;
        var _a = this.headerConfig, data = _a.data, spreadsheet = _a.spreadsheet;
        var colCell = spreadsheet.options.colCell;
        each(data, function (node) {
            var item = node;
            if (_this.isColCellInRect(item)) {
                var cell = (colCell === null || colCell === void 0 ? void 0 : colCell(item, spreadsheet, _this.headerConfig)) ||
                    _this.getCellInstance(item, spreadsheet, _this.headerConfig);
                item.belongsCell = cell;
                var group = _this.getCellGroup(item);
                group.add(cell);
            }
        });
    };
    ColHeader.prototype.offset = function () {
        var _a = this.headerConfig, position = _a.position, scrollX = _a.scrollX;
        // 暂时不考虑移动y
        translateGroupX(this.scrollGroup, position.x - scrollX);
    };
    return ColHeader;
}(BaseHeader));

/**
 * Row Header for SpreadSheet
 */
var RowHeader = /** @class */ (function (_super) {
    __extends(RowHeader, _super);
    function RowHeader(cfg) {
        return _super.call(this, cfg) || this;
    }
    RowHeader.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        if (this.gm) {
            this.gm.destroy();
        }
    };
    RowHeader.prototype.layout = function () {
        var _this = this;
        var _a, _b;
        var _c = this.headerConfig, data = _c.data, spreadsheet = _c.spreadsheet, width = _c.width, viewportHeight = _c.viewportHeight, seriesNumberWidth = _c.seriesNumberWidth, scrollY = _c.scrollY, scrollX = _c.scrollX;
        var rowCell = (_b = (_a = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.facet) === null || _a === void 0 ? void 0 : _a.cfg) === null || _b === void 0 ? void 0 : _b.rowCell;
        // row'cell only show when visible
        var rowCellInRect = function (item) {
            return (viewportHeight + scrollY > item.y && // bottom
                scrollY < item.y + item.height && // top
                width - seriesNumberWidth + scrollX > item.x && // left
                scrollX - seriesNumberWidth < item.x + item.width); // right
        };
        each(data, function (item) {
            if (rowCellInRect(item) && item.height !== 0) {
                var cell = void 0;
                // 首先由外部控制UI展示
                if (rowCell) {
                    cell = rowCell(item, spreadsheet, _this.headerConfig);
                }
                // 如果外部没处理，就用默认的
                if (isEmpty(cell)) {
                    if (spreadsheet.isPivotMode()) {
                        cell = new RowCell(item, spreadsheet, _this.headerConfig);
                    }
                }
                item.belongsCell = cell;
                _this.add(cell);
            }
        });
    };
    RowHeader.prototype.offset = function () {
        var _a = this.headerConfig, scrollX = _a.scrollX, scrollY = _a.scrollY, position = _a.position, seriesNumberWidth = _a.seriesNumberWidth;
        // 向右多移动的seriesNumberWidth是序号的宽度
        translateGroup(this, position.x - scrollX + seriesNumberWidth, position.y - scrollY);
    };
    RowHeader.prototype.clip = function () {
        var _a = this.headerConfig, width = _a.width, viewportHeight = _a.viewportHeight, scrollX = _a.scrollX, scrollY = _a.scrollY, seriesNumberWidth = _a.seriesNumberWidth;
        this.setClip({
            type: 'rect',
            attrs: {
                // 由于多移动了seriesNumberWidth跨度，所有需要向左切。 - 是反向剪裁（右 -> 左）
                x: scrollX - seriesNumberWidth,
                y: scrollY,
                width: width,
                height: viewportHeight,
            },
        });
    };
    return RowHeader;
}(BaseHeader));

/**
 * Corner Header for SpreadSheet
 */
var CornerHeader = /** @class */ (function (_super) {
    __extends(CornerHeader, _super);
    function CornerHeader(cfg) {
        return _super.call(this, cfg) || this;
    }
    /**
     * Get corner Header by config
     * @param panelBBox
     * @param cornerBBox
     * @param seriesNumberWidth
     * @param cfg
     * @param layoutResult
     * @param s2 spreadsheet
     */
    CornerHeader.getCornerHeader = function (panelBBox, cornerBBox, seriesNumberWidth, cfg, layoutResult, s2) {
        var width = panelBBox.width, height = panelBBox.height;
        var cornerOriginalWidth = cornerBBox.originalWidth, cornerOriginalHeight = cornerBBox.originalHeight, cornerWidth = cornerBBox.width, cornerHeight = cornerBBox.height;
        var cornerNodes = this.getCornerNodes({ x: cornerBBox.x, y: cornerBBox.y }, cornerOriginalWidth, cornerOriginalHeight, cfg.rows, cfg.columns, layoutResult.rowsHierarchy, layoutResult.colsHierarchy, cfg.dataSet, seriesNumberWidth, s2);
        return new CornerHeader({
            data: cornerNodes,
            position: { x: cornerBBox.x, y: cornerBBox.y },
            width: cornerWidth,
            height: cornerHeight,
            originalHeight: cornerOriginalHeight,
            originalWidth: cornerOriginalWidth,
            viewportWidth: width,
            viewportHeight: height,
            hierarchyType: cfg.hierarchyType,
            hierarchyCollapse: cfg.hierarchyCollapse,
            rows: cfg.rows,
            columns: cfg.columns,
            seriesNumberWidth: seriesNumberWidth,
            spreadsheet: s2,
        });
    };
    CornerHeader.getCornerNodes = function (position, width, height, rows, columns, rowsHierarchy, colsHierarchy, dataSet, seriesNumberWidth, s2) {
        var _a, _b, _c, _d;
        var cornerNodes = [];
        // check if show series number node
        // spreadsheet must have at least one node in last level
        if (seriesNumberWidth && (colsHierarchy === null || colsHierarchy === void 0 ? void 0 : colsHierarchy.sampleNodeForLastLevel)) {
            var sNode = new Node({
                id: '',
                key: KEY_SERIES_NUMBER_NODE,
                value: i18n('序号'),
            });
            sNode.x = position === null || position === void 0 ? void 0 : position.x;
            // different type different y
            sNode.y = (_a = colsHierarchy === null || colsHierarchy === void 0 ? void 0 : colsHierarchy.sampleNodeForLastLevel) === null || _a === void 0 ? void 0 : _a.y;
            sNode.width = seriesNumberWidth;
            // different type different height
            sNode.height = (_b = colsHierarchy === null || colsHierarchy === void 0 ? void 0 : colsHierarchy.sampleNodeForLastLevel) === null || _b === void 0 ? void 0 : _b.height;
            sNode.isPivotMode = true;
            sNode.cornerType = CornerNodeType.Series;
            cornerNodes.push(sNode);
        }
        // spreadsheet type tree mode
        if (colsHierarchy === null || colsHierarchy === void 0 ? void 0 : colsHierarchy.sampleNodeForLastLevel) {
            if (s2.isHierarchyTreeType()) {
                var drillDownFieldInLevel = s2.store.get('drillDownFieldInLevel', []);
                var drillFields_1 = drillDownFieldInLevel.map(function (d) { return d.drillField; });
                var cNode = new Node({
                    key: '',
                    id: '',
                    // 角头过滤下钻的维度
                    value: rows
                        .filter(function (value) { return !includes(drillFields_1, value); })
                        .map(function (key) { return dataSet.getFieldName(key); })
                        .join('/'),
                });
                cNode.x = position.x + seriesNumberWidth;
                cNode.y = (_c = colsHierarchy === null || colsHierarchy === void 0 ? void 0 : colsHierarchy.sampleNodeForLastLevel) === null || _c === void 0 ? void 0 : _c.y;
                // cNode should subtract series width
                cNode.width = width - seriesNumberWidth;
                cNode.height = (_d = colsHierarchy === null || colsHierarchy === void 0 ? void 0 : colsHierarchy.sampleNodeForLastLevel) === null || _d === void 0 ? void 0 : _d.height;
                cNode.seriesNumberWidth = seriesNumberWidth;
                cNode.isPivotMode = true;
                cNode.spreadsheet = s2;
                cNode.cornerType = CornerNodeType.Row;
                cornerNodes.push(cNode);
            }
            else {
                // spreadsheet type grid mode
                rowsHierarchy.sampleNodesForAllLevels.forEach(function (rowNode) {
                    var field = rows[rowNode.level];
                    var cNode = new Node({
                        key: field,
                        id: '',
                        value: dataSet.getFieldName(field),
                    });
                    cNode.x = rowNode.x + seriesNumberWidth;
                    cNode.y = colsHierarchy.sampleNodeForLastLevel.y;
                    cNode.width = rowNode.width;
                    cNode.height = colsHierarchy.sampleNodeForLastLevel.height;
                    cNode.field = field;
                    cNode.isPivotMode = true;
                    cNode.cornerType = CornerNodeType.Row;
                    cNode.spreadsheet = s2;
                    cornerNodes.push(cNode);
                });
            }
        }
        colsHierarchy.sampleNodesForAllLevels.forEach(function (colNode) {
            // 列头最后一个层级的位置为行头 label 标识，需要过滤
            if (colNode.level < colsHierarchy.maxLevel) {
                var field = columns[colNode.level];
                var cNode = new Node({
                    key: field,
                    id: '',
                    value: dataSet.getFieldName(field),
                });
                cNode.x = position.x;
                cNode.y = colNode.y;
                cNode.width = width;
                cNode.height = colNode.height;
                cNode.field = field;
                cNode.isPivotMode = true;
                cNode.cornerType = CornerNodeType.Col;
                cNode.spreadsheet = s2;
                cornerNodes.push(cNode);
            }
        });
        return cornerNodes;
    };
    /**
     *  Make cornerHeader scroll with hScrollBar
     * @param scrollX
     */
    CornerHeader.prototype.onCorScroll = function (scrollX, type) {
        this.headerConfig.scrollX = scrollX;
        this.render(type);
    };
    CornerHeader.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    CornerHeader.prototype.layout = function () {
        this.renderCells();
    };
    CornerHeader.prototype.renderCells = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var _e = this.headerConfig, data = _e.data, spreadsheet = _e.spreadsheet;
        var cornerHeader = (_b = (_a = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.facet) === null || _a === void 0 ? void 0 : _a.cfg) === null || _b === void 0 ? void 0 : _b.cornerHeader;
        var cornerCell = (_d = (_c = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.facet) === null || _c === void 0 ? void 0 : _c.cfg) === null || _d === void 0 ? void 0 : _d.cornerCell;
        if (cornerHeader) {
            cornerHeader(this, spreadsheet, this.headerConfig);
            return;
        }
        this.addBgRect();
        data.forEach(function (item) {
            var cell;
            if (cornerCell) {
                cell = cornerCell(item, _this.headerConfig.spreadsheet, _this.headerConfig);
            }
            if (isEmpty(cell)) {
                cell = new CornerCell(item, _this.headerConfig.spreadsheet, _this.headerConfig);
            }
            _this.add(cell);
        });
    };
    CornerHeader.prototype.offset = function () {
        var scrollX = this.headerConfig.scrollX;
        translateGroupX(this, -scrollX);
    };
    CornerHeader.prototype.clip = function () {
        var _a = this.headerConfig, width = _a.width, height = _a.height, scrollX = _a.scrollX;
        this.setClip({
            type: 'rect',
            attrs: {
                x: scrollX,
                y: 0,
                width: width,
                height: height,
            },
        });
    };
    CornerHeader.prototype.addBgRect = function () {
        var cfg = this.headerConfig;
        var originalWidth = cfg.originalWidth, originalHeight = cfg.originalHeight, position = cfg.position;
        this.addShape('rect', {
            attrs: {
                x: position.x,
                y: position.y,
                width: originalWidth,
                height: originalHeight,
                fill: get(this.headerConfig, 'spreadsheet.theme.cornerCell.cell.backgroundColor'),
            },
        });
    };
    return CornerHeader;
}(BaseHeader));

var SeriesNumberHeader = /** @class */ (function (_super) {
    __extends(SeriesNumberHeader, _super);
    function SeriesNumberHeader(cfg) {
        return _super.call(this, cfg) || this;
    }
    /**
     * Get seriesNumber header by config
     * @param viewportBBox
     * @param seriesNumberWidth
     * @param leafNodes
     * @param spreadsheet
     * @param cornerWidth
     */
    SeriesNumberHeader.getSeriesNumberHeader = function (viewportBBox, seriesNumberWidth, leafNodes, spreadsheet, cornerWidth) {
        var height = viewportBBox.height, viewportHeight = viewportBBox.viewportHeight;
        var seriesNodes = [];
        var isHierarchyTreeType = spreadsheet.isHierarchyTreeType();
        leafNodes.forEach(function (node) {
            // 1、is spreadsheet and node is not total(grand or sub)
            // 2、is listSheet
            if (!node.isTotals || isHierarchyTreeType) {
                var sNode = new Node({
                    id: '',
                    key: '',
                    value: "".concat(seriesNodes.length + 1),
                });
                sNode.x = node.x;
                sNode.y = node.y;
                sNode.height = node.height;
                sNode.width = seriesNumberWidth;
                seriesNodes.push(sNode);
            }
        });
        return new SeriesNumberHeader({
            width: cornerWidth,
            height: height,
            viewportWidth: cornerWidth,
            viewportHeight: viewportHeight,
            position: { x: 0, y: viewportBBox.y },
            data: seriesNodes,
            spreadsheet: spreadsheet,
        });
    };
    SeriesNumberHeader.prototype.clip = function () {
        var _a = this.headerConfig, width = _a.width, viewportHeight = _a.viewportHeight, scrollY = _a.scrollY;
        this.setClip({
            type: 'rect',
            attrs: {
                x: 0,
                y: scrollY,
                width: width,
                height: viewportHeight,
            },
        });
    };
    SeriesNumberHeader.prototype.layout = function () {
        var _this = this;
        var _a = this.headerConfig, data = _a.data, scrollY = _a.scrollY, viewportHeight = _a.viewportHeight, spreadsheet = _a.spreadsheet;
        if (spreadsheet.isPivotMode) {
            //  添加矩形背景
            this.addBackGround();
        }
        var borderGroup = this.addGroup();
        each(data, function (item) {
            var y = item.y, cellHeight = item.height, isLeaf = item.isLeaf;
            var isHeaderCellInViewport = _this.isHeaderCellInViewport(y, cellHeight, scrollY, viewportHeight);
            if (isHeaderCellInViewport) {
                // 按需渲染：视窗内的才渲染
                var group = _this.addGroup();
                // 添加文本
                _this.addText(group, item);
                _this.add(group);
                // 添加边框
                if (!isLeaf) {
                    _this.addBorder(borderGroup, item);
                }
            }
        });
    };
    SeriesNumberHeader.prototype.offset = function () {
        var _a = this.headerConfig, scrollY = _a.scrollY, scrollX = _a.scrollX, position = _a.position;
        translateGroup(this, position.x - scrollX, position.y - scrollY);
        if (this.backgroundShape) {
            this.backgroundShape.translate(position.x, position.y + scrollY);
        }
        if (this.leftBorderShape) {
            this.leftBorderShape.translate(position.x, position.y + scrollY);
        }
    };
    SeriesNumberHeader.prototype.addBackGround = function () {
        var rowCellTheme = this.headerConfig.spreadsheet.theme.rowCell.cell;
        var _a = this.headerConfig, position = _a.position, width = _a.width, viewportHeight = _a.viewportHeight;
        this.backgroundShape = renderRect(this, {
            x: position.x,
            y: -position.y,
            width: width,
            height: viewportHeight,
            fill: rowCellTheme.backgroundColor,
            stroke: 'transparent',
            opacity: rowCellTheme.backgroundColorOpacity,
        });
        var _b = getBorderPositionAndStyle(CellBorderPosition.LEFT, {
            x: position.x,
            y: -position.y,
            width: width,
            height: viewportHeight,
        }, rowCellTheme), borderPosition = _b.position, borderStyle = _b.style;
        this.leftBorderShape = renderLine(this, borderPosition, borderStyle);
    };
    SeriesNumberHeader.prototype.addBorder = function (group, cellData) {
        var cellTheme = this.headerConfig.spreadsheet.theme.rowCell.cell;
        var _a = getBorderPositionAndStyle(CellBorderPosition.BOTTOM, cellData, cellTheme), horizontalPosition = _a.position, horizontalStyle = _a.style;
        renderLine(group, horizontalPosition, horizontalStyle);
    };
    SeriesNumberHeader.prototype.addText = function (group, cellData) {
        var _a = this.headerConfig, scrollY = _a.scrollY, height = _a.viewportHeight;
        var rowCellTheme = this.headerConfig.spreadsheet.theme.rowCell;
        var label = cellData.label, x = cellData.x, y = cellData.y, cellWidth = cellData.width, cellHeight = cellData.height, isLeaf = cellData.isLeaf, isTotals = cellData.isTotals;
        var padding = this.getTextPadding(label, cellWidth);
        var textStyle = isLeaf && !isTotals ? rowCellTheme.text : rowCellTheme.bolderText;
        var textY = getAdjustPosition(y + padding.top, cellHeight - padding.top - padding.bottom, scrollY, height, textStyle.fontSize);
        group.addShape('text', {
            attrs: __assign(__assign({ x: x + padding.left, y: textY + textStyle.fontSize / 2, text: label }, textStyle), { cursor: 'pointer' }),
        });
    };
    SeriesNumberHeader.prototype.getTextPadding = function (text, cellWidth) {
        var rowCellTheme = this.headerConfig.spreadsheet.theme.rowCell;
        var textWidth = measureTextWidth(text, rowCellTheme.text);
        var padding = Math.max(Math.abs((cellWidth - textWidth) / 2), 4);
        return __assign(__assign({}, rowCellTheme.cell.padding), { left: padding, right: padding });
    };
    return SeriesNumberHeader;
}(BaseHeader));

var Frame = /** @class */ (function (_super) {
    __extends(Frame, _super);
    function Frame(cfg) {
        var _this = _super.call(this, cfg) || this;
        _this.render();
        return _this;
    }
    Frame.prototype.layout = function () {
        // corner底部的横线条
        this.addCornerBottomBorder();
        // corner右边的竖线条
        this.addCornerRightBorder();
        // 一级纵向分割线两侧的shadow
        this.addSplitLineShadow();
    };
    /**
     * 渲染
     */
    Frame.prototype.render = function () {
        this.clear();
        this.layout();
    };
    Frame.prototype.onBorderScroll = function (scrollX) {
        this.cfg.scrollX = scrollX;
        var position = this.cfg.position;
        translateGroup(this, position.x - scrollX, 0);
        this.render();
    };
    Frame.prototype.onChangeShadowVisibility = function (scrollX, maxScrollX) {
        this.cfg.showViewportLeftShadow = scrollX > 0;
        // baseFacet#renderHScrollBar render condition
        this.cfg.showViewportRightShadow =
            Math.floor(scrollX) < Math.floor(maxScrollX);
        this.render();
    };
    Frame.prototype.addCornerRightBorder = function () {
        var _a;
        var cfg = this.cfg;
        // 是否是透视表
        var isPivotMode = cfg.isPivotMode;
        // 明细表啥也不要
        if (!isPivotMode) {
            return;
        }
        var width = cfg.width, height = cfg.height, viewportHeight = cfg.viewportHeight, position = cfg.position, spreadsheet = cfg.spreadsheet;
        var splitLine = (_a = spreadsheet.theme) === null || _a === void 0 ? void 0 : _a.splitLine;
        var x = position.x + width;
        var y1 = position.y;
        var y2 = position.y + height + viewportHeight;
        this.addShape('line', {
            attrs: {
                x1: x,
                y1: y1,
                x2: x,
                y2: y2,
                stroke: splitLine.verticalBorderColor,
                lineWidth: splitLine.verticalBorderWidth,
                opacity: splitLine.verticalBorderColorOpacity,
            },
        });
    };
    Frame.prototype.addCornerBottomBorder = function () {
        var _a;
        var cfg = this.cfg;
        var width = cfg.width, height = cfg.height, viewportWidth = cfg.viewportWidth, position = cfg.position, scrollX = cfg.scrollX, scrollContainsRowHeader = cfg.scrollContainsRowHeader, spreadsheet = cfg.spreadsheet;
        var splitLine = (_a = spreadsheet.theme) === null || _a === void 0 ? void 0 : _a.splitLine;
        var x1 = position.x;
        var x2 = x1 + width + viewportWidth + (scrollContainsRowHeader ? scrollX : 0);
        var y = position.y + height - 1;
        this.addShape('line', {
            attrs: {
                x1: x1,
                y1: y,
                x2: x2,
                y2: y,
                stroke: splitLine.horizontalBorderColor,
                lineWidth: splitLine.horizontalBorderWidth,
                opacity: splitLine.horizontalBorderColorOpacity,
            },
        });
    };
    Frame.prototype.addSplitLineShadow = function () {
        var _a;
        var cfg = this.cfg;
        var isPivotMode = cfg.isPivotMode, spreadsheet = cfg.spreadsheet;
        var splitLine = (_a = spreadsheet.theme) === null || _a === void 0 ? void 0 : _a.splitLine;
        if (!isPivotMode ||
            !splitLine.showShadow ||
            !spreadsheet.isFrozenRowHeader()) {
            return;
        }
        // do render...
        this.addSplitLineLeftShadow();
        this.addSplitLineRightShadow();
    };
    Frame.prototype.addSplitLineLeftShadow = function () {
        var _a, _b, _c;
        if (!this.cfg.showViewportLeftShadow) {
            return;
        }
        var _d = this.cfg, width = _d.width, height = _d.height, viewportHeight = _d.viewportHeight, position = _d.position, spreadsheet = _d.spreadsheet;
        var splitLine = (_a = spreadsheet.theme) === null || _a === void 0 ? void 0 : _a.splitLine;
        var x = position.x + width;
        var y = position.y;
        this.addShape('rect', {
            attrs: {
                x: x,
                y: y,
                width: splitLine.shadowWidth,
                height: viewportHeight + height,
                fill: "l (0) 0:".concat((_b = splitLine.shadowColors) === null || _b === void 0 ? void 0 : _b.left, " 1:").concat((_c = splitLine.shadowColors) === null || _c === void 0 ? void 0 : _c.right),
            },
        });
    };
    Frame.prototype.addSplitLineRightShadow = function () {
        var _a, _b, _c;
        if (!this.cfg.showViewportRightShadow) {
            return;
        }
        var _d = this.cfg, width = _d.width, height = _d.height, viewportHeight = _d.viewportHeight, viewportWidth = _d.viewportWidth, position = _d.position, spreadsheet = _d.spreadsheet;
        var splitLine = (_a = spreadsheet.theme) === null || _a === void 0 ? void 0 : _a.splitLine;
        var x = position.x + width + viewportWidth - splitLine.shadowWidth;
        var y = position.y;
        this.addShape('rect', {
            attrs: {
                x: x,
                y: y,
                width: splitLine.shadowWidth,
                height: viewportHeight + height,
                fill: "l (0) 0:".concat((_b = splitLine.shadowColors) === null || _b === void 0 ? void 0 : _b.right, " 1:").concat((_c = splitLine.shadowColors) === null || _c === void 0 ? void 0 : _c.left),
            },
        });
    };
    return Frame;
}(Group));

var getAllChildCells = function (children, cellType) {
    if (children === void 0) { children = []; }
    var cells = [];
    children.forEach(function (child) {
        if (child instanceof cellType) {
            cells.push(child);
        }
        // panel group has child group
        if (child instanceof Group) {
            var groupChildren = child.getChildren();
            groupChildren.forEach(function (item) {
                if (item instanceof cellType) {
                    cells.push(item);
                }
            });
        }
    });
    return cells;
};

var RootInteraction = /** @class */ (function () {
    function RootInteraction(spreadsheet) {
        var _this = this;
        this.interactions = new Map();
        // 用来标记需要拦截的交互，interaction和本身的hover等事件可能会有冲突，有冲突时在此屏蔽
        this.intercepts = new Set();
        // hover有keep-hover态，是个计时器，hover后800毫秒还在当前cell的情况下，该cell进入keep-hover状态
        // 在任何触发点击，或者点击空白区域时，说明已经不是hover了，因此需要取消这个计时器。
        this.hoverTimer = null;
        this.defaultState = {
            cells: [],
            force: false,
        };
        this.selectAll = function () {
            _this.changeState({
                stateName: InteractionStateName.ALL_SELECTED,
            });
        };
        this.selectHeaderCell = function (selectHeaderCellInfo) {
            var cell = (selectHeaderCellInfo || {}).cell;
            if (isEmpty(cell)) {
                return;
            }
            var lastState = _this.getState();
            var meta = cell === null || cell === void 0 ? void 0 : cell.getMeta();
            if (isNil(meta.x)) {
                return;
            }
            _this.addIntercepts([InterceptType.HOVER]);
            // 树状结构的行头点击不需要遍历当前行头的所有子节点，因为只会有一级
            var leafNodes = (selectHeaderCellInfo === null || selectHeaderCellInfo === void 0 ? void 0 : selectHeaderCellInfo.isTreeRowClick)
                ? Node.getAllLeavesOfNode(meta).filter(function (node) { return node.rowIndex === meta.rowIndex; })
                : Node.getAllChildrenNode(meta);
            var selectedCells = [getCellMeta(cell)];
            if ((selectHeaderCellInfo === null || selectHeaderCellInfo === void 0 ? void 0 : selectHeaderCellInfo.isMultiSelection) && _this.isSelectedState()) {
                selectedCells = isEmpty(lastState === null || lastState === void 0 ? void 0 : lastState.cells)
                    ? selectedCells
                    : concat(lastState === null || lastState === void 0 ? void 0 : lastState.cells, selectedCells);
                leafNodes = isEmpty(lastState === null || lastState === void 0 ? void 0 : lastState.nodes)
                    ? leafNodes
                    : concat(lastState === null || lastState === void 0 ? void 0 : lastState.nodes, leafNodes);
            }
            // 兼容行列多选
            // Set the header cells (colCell or RowCell)  selected information and update the dataCell state.
            _this.changeState({
                cells: selectedCells,
                nodes: leafNodes,
                stateName: InteractionStateName.SELECTED,
            });
            var selectedCellIds = selectedCells.map(function (_a) {
                var id = _a.id;
                return id;
            });
            // Update the interaction state of all the selected cells:  header cells(colCell or RowCell) and dataCells belong to them.
            _this.updateCells(_this.getRowColActiveCells(selectedCellIds));
            if (!(selectHeaderCellInfo === null || selectHeaderCellInfo === void 0 ? void 0 : selectHeaderCellInfo.isTreeRowClick)) {
                leafNodes.forEach(function (node) {
                    var _a;
                    (_a = node === null || node === void 0 ? void 0 : node.belongsCell) === null || _a === void 0 ? void 0 : _a.updateByState(InteractionStateName.SELECTED, node.belongsCell);
                });
            }
            _this.spreadsheet.emit(S2Event.GLOBAL_SELECTED, _this.getActiveCells());
            return true;
        };
        this.mergeCells = function (cellsInfo, hideData) {
            mergeCell(_this.spreadsheet, cellsInfo, hideData);
        };
        this.unmergeCell = function (removedCells) {
            unmergeCell(_this.spreadsheet, removedCells);
        };
        this.spreadsheet = spreadsheet;
        this.registerEventController();
        this.registerInteractions();
    }
    RootInteraction.prototype.destroy = function () {
        this.interactions.clear();
        this.intercepts.clear();
        this.eventController.clear();
        this.clearHoverTimer();
        this.resetState();
    };
    RootInteraction.prototype.reset = function () {
        this.clearState();
        this.clearHoverTimer();
        this.intercepts.clear();
        this.spreadsheet.hideTooltip();
    };
    RootInteraction.prototype.setState = function (interactionStateInfo) {
        setState(this.spreadsheet, interactionStateInfo);
    };
    RootInteraction.prototype.getState = function () {
        return (this.spreadsheet.store.get(INTERACTION_STATE_INFO_KEY) ||
            this.defaultState);
    };
    RootInteraction.prototype.setInteractedCells = function (cell) {
        var interactedCells = this.getInteractedCells().concat([cell]);
        var state = this.getState();
        state.interactedCells = interactedCells;
        this.setState(state);
    };
    RootInteraction.prototype.getInteractedCells = function () {
        var currentState = this.getState();
        return (currentState === null || currentState === void 0 ? void 0 : currentState.interactedCells) || [];
    };
    RootInteraction.prototype.resetState = function () {
        this.spreadsheet.store.set(INTERACTION_STATE_INFO_KEY, this.defaultState);
    };
    RootInteraction.prototype.getCurrentStateName = function () {
        return this.getState().stateName;
    };
    RootInteraction.prototype.isEqualStateName = function (stateName) {
        return this.getCurrentStateName() === stateName;
    };
    RootInteraction.prototype.isStateOf = function (stateName) {
        var currentState = this.getState();
        return (currentState === null || currentState === void 0 ? void 0 : currentState.stateName) === stateName;
    };
    RootInteraction.prototype.isSelectedState = function () {
        return this.isStateOf(InteractionStateName.SELECTED);
    };
    RootInteraction.prototype.isHoverFocusState = function () {
        return this.isStateOf(InteractionStateName.HOVER_FOCUS);
    };
    RootInteraction.prototype.isHoverState = function () {
        return this.isStateOf(InteractionStateName.HOVER);
    };
    RootInteraction.prototype.isActiveCell = function (cell) {
        return this.getCells().find(function (meta) { return cell.getMeta().id === meta.id; });
    };
    RootInteraction.prototype.isSelectedCell = function (cell) {
        return this.isSelectedState() && this.isActiveCell(cell);
    };
    // 获取当前 interaction 记录的 Cells 元信息列表，包括不在可视区域内的格子
    RootInteraction.prototype.getCells = function () {
        var currentState = this.getState();
        return (currentState === null || currentState === void 0 ? void 0 : currentState.cells) || [];
    };
    // 获取 cells 中在可视区域内的实例列表
    RootInteraction.prototype.getActiveCells = function () {
        var ids = this.getCells().map(function (item) { return item.id; });
        var allCells = this.getAllCells();
        // 这里的顺序要以 ids 中的顺序为准，代表点击 cell 的顺序
        return map(ids, function (id) {
            return find(allCells, function (cell) { var _a; return ((_a = cell === null || cell === void 0 ? void 0 : cell.getMeta()) === null || _a === void 0 ? void 0 : _a.id) === id; });
        }).filter(function (cell) { return cell; }); // 去除 undefined
    };
    RootInteraction.prototype.clearStyleIndependent = function () {
        var currentState = this.getState();
        if ((currentState === null || currentState === void 0 ? void 0 : currentState.stateName) === InteractionStateName.SELECTED ||
            (currentState === null || currentState === void 0 ? void 0 : currentState.stateName) === InteractionStateName.HOVER) {
            this.getPanelGroupAllDataCells().forEach(function (cell) {
                cell.hideInteractionShape();
            });
        }
    };
    RootInteraction.prototype.getPanelGroupAllUnSelectedDataCells = function () {
        var _this = this;
        return this.getPanelGroupAllDataCells().filter(function (cell) { return !_this.isActiveCell(cell); });
    };
    RootInteraction.prototype.getPanelGroupAllDataCells = function () {
        var _a;
        return getAllChildCells((_a = this.spreadsheet.panelGroup) === null || _a === void 0 ? void 0 : _a.getChildren(), DataCell);
    };
    RootInteraction.prototype.getAllRowHeaderCells = function () {
        var _a, _b, _c, _d, _e, _f;
        var children = (_a = this.spreadsheet.foregroundGroup) === null || _a === void 0 ? void 0 : _a.getChildren();
        var rowHeader = (_b = filter(children, function (group) { return group instanceof RowHeader; })) === null || _b === void 0 ? void 0 : _b[0];
        var currentNode = (_c = rowHeader === null || rowHeader === void 0 ? void 0 : rowHeader.cfg) === null || _c === void 0 ? void 0 : _c.children;
        if (isEmpty(currentNode)) {
            return [];
        }
        while (!((_d = currentNode === null || currentNode === void 0 ? void 0 : currentNode[0]) === null || _d === void 0 ? void 0 : _d.cellType)) {
            currentNode = (_f = (_e = currentNode === null || currentNode === void 0 ? void 0 : currentNode[0]) === null || _e === void 0 ? void 0 : _e.cfg) === null || _f === void 0 ? void 0 : _f.children;
        }
        var rowCells = currentNode || [];
        return rowCells.filter(function (cell) { return cell.cellType === CellTypes.ROW_CELL; });
    };
    RootInteraction.prototype.getAllColHeaderCells = function () {
        var _a, _b, _c;
        var children = (_b = (_a = this.spreadsheet) === null || _a === void 0 ? void 0 : _a.foregroundGroup) === null || _b === void 0 ? void 0 : _b.getChildren();
        var colHeader = filter(children, function (group) { return group instanceof ColHeader; })[0];
        var headerChildren = (_c = colHeader === null || colHeader === void 0 ? void 0 : colHeader.cfg) === null || _c === void 0 ? void 0 : _c.children;
        if (isEmpty(headerChildren)) {
            return [];
        }
        var colCells = getAllChildCells(headerChildren, ColCell);
        return colCells.filter(function (cell) { return cell.cellType === CellTypes.COL_CELL; });
    };
    RootInteraction.prototype.getRowColActiveCells = function (ids) {
        return concat(this.getAllRowHeaderCells(), this.getAllColHeaderCells()).filter(function (item) { return ids.includes(item.getMeta().id); });
    };
    RootInteraction.prototype.getAllCells = function () {
        return concat(this.getPanelGroupAllDataCells(), this.getAllRowHeaderCells(), this.getAllColHeaderCells());
    };
    RootInteraction.prototype.hideColumns = function (hiddenColumnFields) {
        if (hiddenColumnFields === void 0) { hiddenColumnFields = []; }
        if (this.spreadsheet.isTableMode()) {
            hideColumnsByThunkGroup(this.spreadsheet, hiddenColumnFields, true);
            return;
        }
        hideColumns(this.spreadsheet, hiddenColumnFields, true);
    };
    RootInteraction.prototype.getDefaultInteractions = function () {
        var _a = this.spreadsheet.options.interaction, resize = _a.resize, brushSelection = _a.brushSelection, multiSelection = _a.multiSelection, rangeSelection = _a.rangeSelection, selectedCellMove = _a.selectedCellMove;
        return [
            {
                key: InteractionName.DATA_CELL_CLICK,
                interaction: DataCellClick,
            },
            {
                key: InteractionName.ROW_COLUMN_CLICK,
                interaction: RowColumnClick,
            },
            {
                key: InteractionName.ROW_TEXT_CLICK,
                interaction: RowTextClick,
            },
            {
                key: InteractionName.MERGED_CELLS_CLICK,
                interaction: MergedCellClick,
            },
            {
                key: InteractionName.HOVER,
                interaction: HoverEvent,
                enable: !isMobile(),
            },
            {
                key: InteractionName.BRUSH_SELECTION,
                interaction: BrushSelection,
                enable: !isMobile() && brushSelection,
            },
            {
                key: InteractionName.COL_ROW_RESIZE,
                interaction: RowColumnResize,
                enable: !isMobile() && resize,
            },
            {
                key: InteractionName.DATA_CELL_MULTI_SELECTION,
                interaction: DataCellMultiSelection,
                enable: !isMobile() && multiSelection,
            },
            {
                key: InteractionName.RANGE_SELECTION,
                interaction: RangeSelection,
                enable: !isMobile() && rangeSelection,
            },
            {
                key: InteractionName.SELECTED_CELL_MOVE,
                interaction: SelectedCellMove,
                enable: !isMobile() && selectedCellMove,
            },
        ];
    };
    RootInteraction.prototype.registerInteractions = function () {
        var _this = this;
        var customInteractions = this.spreadsheet.options.interaction.customInteractions;
        this.interactions.clear();
        var defaultInteractions = this.getDefaultInteractions();
        defaultInteractions.forEach(function (_a) {
            var key = _a.key, Interaction = _a.interaction, enable = _a.enable;
            if (enable !== false) {
                _this.interactions.set(key, new Interaction(_this.spreadsheet));
            }
        });
        if (!isEmpty(customInteractions)) {
            forEach(customInteractions, function (customInteraction) {
                var CustomInteractionClass = customInteraction.interaction;
                _this.interactions.set(customInteraction.key, new CustomInteractionClass(_this.spreadsheet));
            });
        }
    };
    RootInteraction.prototype.registerEventController = function () {
        this.eventController = new EventController(this.spreadsheet);
    };
    RootInteraction.prototype.draw = function () {
        this.spreadsheet.container.draw();
    };
    RootInteraction.prototype.clearState = function () {
        clearState(this.spreadsheet);
        this.draw();
    };
    RootInteraction.prototype.changeState = function (interactionStateInfo) {
        var interaction = this.spreadsheet.interaction;
        var cells = interactionStateInfo.cells, force = interactionStateInfo.force, stateName = interactionStateInfo.stateName;
        if (isEmpty(cells) && stateName === InteractionStateName.SELECTED) {
            if (force) {
                interaction.changeState({
                    cells: [],
                    stateName: InteractionStateName.UNSELECTED,
                });
            }
            return;
        }
        this.clearState();
        this.setState(interactionStateInfo);
        this.updatePanelGroupAllDataCells();
        this.draw();
    };
    RootInteraction.prototype.updatePanelGroupAllDataCells = function () {
        this.updateCells(this.getPanelGroupAllDataCells());
    };
    RootInteraction.prototype.updateCells = function (cells) {
        if (cells === void 0) { cells = []; }
        cells.forEach(function (cell) {
            cell.update();
        });
    };
    RootInteraction.prototype.addIntercepts = function (interceptTypes) {
        var _this = this;
        if (interceptTypes === void 0) { interceptTypes = []; }
        interceptTypes.forEach(function (interceptType) {
            _this.intercepts.add(interceptType);
        });
    };
    RootInteraction.prototype.hasIntercepts = function (interceptTypes) {
        var _this = this;
        if (interceptTypes === void 0) { interceptTypes = []; }
        return interceptTypes.some(function (interceptType) {
            return _this.intercepts.has(interceptType);
        });
    };
    RootInteraction.prototype.removeIntercepts = function (interceptTypes) {
        var _this = this;
        if (interceptTypes === void 0) { interceptTypes = []; }
        interceptTypes.forEach(function (interceptType) {
            _this.intercepts.delete(interceptType);
        });
    };
    RootInteraction.prototype.clearHoverTimer = function () {
        clearTimeout(this.hoverTimer);
    };
    RootInteraction.prototype.setHoverTimer = function (timer) {
        this.hoverTimer = timer;
    };
    RootInteraction.prototype.getHoverTimer = function () {
        return this.hoverTimer;
    };
    return RootInteraction;
}());

var HdAdapter = /** @class */ (function () {
    function HdAdapter(spreadsheet) {
        var _this = this;
        this.viewport = window;
        this.init = function () {
            _this.initDevicePixelRatioListener();
            _this.initDeviceZoomListener();
        };
        this.destroy = function () {
            _this.removeDevicePixelRatioListener();
            _this.removeDeviceZoomListener();
        };
        this.removeDevicePixelRatioListener = function () {
            var _a;
            if ((_a = _this.devicePixelRatioMedia) === null || _a === void 0 ? void 0 : _a.removeEventListener) {
                _this.devicePixelRatioMedia.removeEventListener('change', _this.renderByDevicePixelRatioChanged);
            }
            else {
                _this.devicePixelRatioMedia.removeListener(_this.renderByDevicePixelRatioChanged);
            }
        };
        this.initDeviceZoomListener = function () {
            var _a, _b;
            if (isMobile()) {
                return;
            }
            // VisualViewport support browser zoom & mac touch tablet
            (_b = (_a = _this.viewport) === null || _a === void 0 ? void 0 : _a.visualViewport) === null || _b === void 0 ? void 0 : _b.addEventListener('resize', _this.renderByZoomScale);
        };
        this.removeDeviceZoomListener = function () {
            var _a, _b;
            if (isMobile()) {
                return;
            }
            (_b = (_a = _this.viewport) === null || _a === void 0 ? void 0 : _a.visualViewport) === null || _b === void 0 ? void 0 : _b.removeEventListener('resize', _this.renderByZoomScale);
        };
        this.renderByDevicePixelRatioChanged = function () {
            _this.renderByDevicePixelRatio();
        };
        this.renderByDevicePixelRatio = function (ratio) {
            if (ratio === void 0) { ratio = window.devicePixelRatio; }
            var _a = _this.spreadsheet, container = _a.container, _b = _a.options, width = _b.width, height = _b.height, devicePixelRatio = _b.devicePixelRatio;
            // 缩放时, 以向上取整后的缩放比为准
            // 设备像素比改变时, 取当前和用户配置中最大的, 保证显示效果
            var pixelRatio = Math.max(ratio, devicePixelRatio, MIN_DEVICE_PIXEL_RATIO);
            container.set('pixelRatio', pixelRatio);
            container.changeSize(width, height);
            _this.spreadsheet.render(false);
        };
        this.renderByZoomScale = debounce(function (event) {
            var ratio = Math.ceil(event.target.scale);
            if (ratio >= 1) {
                _this.renderByDevicePixelRatio(ratio);
            }
        }, 350);
        this.spreadsheet = spreadsheet;
    }
    HdAdapter.prototype.initDevicePixelRatioListener = function () {
        var _a;
        this.devicePixelRatioMedia = window.matchMedia("(resolution: ".concat(window.devicePixelRatio, "dppx)"));
        if ((_a = this.devicePixelRatioMedia) === null || _a === void 0 ? void 0 : _a.addEventListener) {
            this.devicePixelRatioMedia.addEventListener('change', this.renderByDevicePixelRatioChanged);
        }
        else {
            this.devicePixelRatioMedia.addListener(this.renderByDevicePixelRatioChanged);
        }
    };
    return HdAdapter;
}());

/**
 * Base tooltips component
 */
var BaseTooltip = /** @class */ (function () {
    function BaseTooltip(spreadsheet) {
        this.position = { x: 0, y: 0 }; // tooltips position info
        this.spreadsheet = spreadsheet;
    }
    /**
     * Show toolTips
     * @param position
     * @param data
     * @param options {@link TooltipOptions}
     * @param content
     */
    BaseTooltip.prototype.show = function (showOptions) {
        var position = showOptions.position, options = showOptions.options, content = showOptions.content;
        var enterable = getTooltipDefaultOptions(options).enterable;
        var container = this.getContainer();
        var autoAdjustBoundary = (this.spreadsheet.options.tooltip || {}).autoAdjustBoundary;
        this.options = showOptions;
        this.renderContent(content);
        var _a = getAutoAdjustPosition({
            spreadsheet: this.spreadsheet,
            position: position,
            tooltipContainer: container,
            autoAdjustBoundary: autoAdjustBoundary,
        }), x = _a.x, y = _a.y;
        this.position = {
            x: x,
            y: y,
        };
        setContainerStyle(container, {
            style: {
                left: "".concat(x, "px"),
                top: "".concat(y, "px"),
                pointerEvents: enterable ? 'all' : 'none',
            },
            className: "".concat(TOOLTIP_CONTAINER_CLS, "-show"),
        });
    };
    BaseTooltip.prototype.hide = function () {
        var container = this.getContainer();
        setContainerStyle(container, {
            style: {
                pointerEvents: 'none',
            },
            className: "".concat(TOOLTIP_CONTAINER_CLS, "-hide"),
        });
        this.resetPosition();
    };
    BaseTooltip.prototype.destroy = function () {
        var container = this.getContainer();
        if (container) {
            this.resetPosition();
            container === null || container === void 0 ? void 0 : container.remove();
        }
    };
    BaseTooltip.prototype.renderContent = function (content) {
        this.clearContent();
        var contentFromOptions = (this.spreadsheet.options.tooltip || {}).content;
        var container = this.getContainer();
        var displayContent = content !== null && content !== void 0 ? content : contentFromOptions;
        // 兼容 displayContent = '' 空字符串的场景
        if (isNil(displayContent)) {
            return;
        }
        if (typeof displayContent === 'string') {
            container.innerHTML = displayContent;
            return;
        }
        if (displayContent instanceof Element) {
            container.appendChild(displayContent);
        }
    };
    BaseTooltip.prototype.clearContent = function () {
        var container = this.getContainer();
        container.innerHTML = '';
    };
    BaseTooltip.prototype.disablePointerEvent = function () {
        if (!this.container) {
            return;
        }
        if (this.container.style.pointerEvents === 'none') {
            return;
        }
        setContainerStyle(this.container, {
            style: {
                pointerEvents: 'none',
            },
        });
    };
    BaseTooltip.prototype.resetPosition = function () {
        this.position = { x: 0, y: 0 };
    };
    /**
     * ToolTips container element
     */
    BaseTooltip.prototype.getContainer = function () {
        if (!this.container) {
            var container = document.createElement('div');
            document.body.appendChild(container);
            this.container = container;
            return this.container;
        }
        this.container.className = "".concat(TOOLTIP_PREFIX_CLS, "-container");
        return this.container;
    };
    return BaseTooltip;
}());

/**
 * @desc clear all value ranges
 */
var clearValueRangeState = function (spreadsheet) {
    spreadsheet.store.set(VALUE_RANGES_KEY, DEFAULT_VALUE_RANGES);
};
/**
 * @desc merge new value ranges with old values
 * @param spreadsheet sheet instance
 * @param updatedRanges updated value ranges
 */
var setValueRangeState = function (spreadsheet, updatedRanges) {
    var valueRanges = spreadsheet.store.get(VALUE_RANGES_KEY, DEFAULT_VALUE_RANGES);
    spreadsheet.store.set(VALUE_RANGES_KEY, __assign(__assign({}, valueRanges), updatedRanges));
};
/**
 * @desc get target value ranges
 * @param spreadsheet sheet instance
 * @param valueField target field
 */
var getValueRangeState = function (spreadsheet, valueField) {
    var valueRanges = spreadsheet.store.get(VALUE_RANGES_KEY, DEFAULT_VALUE_RANGES);
    return valueRanges[valueField];
};

var SpreadSheet = /** @class */ (function (_super) {
    __extends(SpreadSheet, _super);
    function SpreadSheet(dom, dataCfg, options) {
        var _this = _super.call(this) || this;
        // store some temporary data
        _this.store = new Store();
        _this.untypedOn = _this.on;
        _this.untypedEmit = _this.emit;
        _this.on = function (event, listener) { return _this.untypedOn(event, listener); };
        _this.emit = function (event) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return _this.untypedEmit.apply(_this, __spreadArray([event], __read(args), false));
        };
        // 初次渲染时, 如果配置了隐藏列, 则生成一次相关配置信息
        _this.initHiddenColumnsDetail = once(function () {
            var hiddenColumnFields = _this.options.interaction.hiddenColumnFields;
            if (isEmpty(hiddenColumnFields)) {
                return;
            }
            hideColumnsByThunkGroup(_this, hiddenColumnFields, true);
        });
        _this.dataCfg = getSafetyDataConfig(dataCfg);
        _this.options = getSafetyOptions(options);
        _this.dataSet = _this.getDataSet(_this.options);
        _this.initTooltip();
        _this.initGroups(dom);
        _this.bindEvents();
        _this.initInteraction();
        _this.initTheme();
        _this.initHdAdapter();
        _this.registerIcons();
        _this.setDebug();
        return _this;
    }
    SpreadSheet.prototype.setDebug = function () {
        DebuggerUtil.getInstance().setDebug(this.options.debug);
    };
    SpreadSheet.prototype.initTheme = function () {
        // When calling spreadsheet directly, there is no theme and initialization is required
        this.setThemeCfg({
            name: 'default',
        });
    };
    SpreadSheet.prototype.getMountContainer = function (dom) {
        var mountContainer = isString(dom) ? document.querySelector(dom) : dom;
        if (!mountContainer) {
            throw new Error('Target mount container is not a DOM element');
        }
        return mountContainer;
    };
    SpreadSheet.prototype.initHdAdapter = function () {
        if (this.options.hdAdapter) {
            this.hdAdapter = new HdAdapter(this);
            this.hdAdapter.init();
        }
    };
    SpreadSheet.prototype.initInteraction = function () {
        this.interaction = new RootInteraction(this);
    };
    SpreadSheet.prototype.initTooltip = function () {
        var _a, _b;
        this.tooltip = this.renderTooltip();
        if (!(this.tooltip instanceof BaseTooltip)) {
            // eslint-disable-next-line no-console
            console.warn("[Custom Tooltip]: ".concat((_b = (_a = this.tooltip) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.toString(), " should be extends from BaseTooltip"));
        }
    };
    SpreadSheet.prototype.renderTooltip = function () {
        var _a, _b;
        return ((_b = (_a = this.options.tooltip) === null || _a === void 0 ? void 0 : _a.renderTooltip) === null || _b === void 0 ? void 0 : _b.call(_a, this)) || new BaseTooltip(this);
    };
    SpreadSheet.prototype.showTooltip = function (showOptions) {
        var _a, _b;
        var content = showOptions.content, event = showOptions.event;
        var cell = this.getCell(event === null || event === void 0 ? void 0 : event.target);
        var displayContent = isFunction(content)
            ? content(cell, showOptions)
            : content;
        (_b = (_a = this.tooltip).show) === null || _b === void 0 ? void 0 : _b.call(_a, __assign(__assign({}, showOptions), { content: displayContent }));
    };
    SpreadSheet.prototype.showTooltipWithInfo = function (event, data, options) {
        var _a = getTooltipOptions(this, event), showTooltip = _a.showTooltip, content = _a.content;
        if (!showTooltip) {
            return;
        }
        var tooltipData = getTooltipData({
            spreadsheet: this,
            cellInfos: data,
            options: __assign({ enableFormat: true }, options),
        });
        this.showTooltip({
            data: tooltipData,
            position: {
                x: event.clientX,
                y: event.clientY,
            },
            options: __assign({ enterable: true }, options),
            event: event,
            content: content,
        });
    };
    SpreadSheet.prototype.hideTooltip = function () {
        var _a, _b;
        (_b = (_a = this.tooltip).hide) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    SpreadSheet.prototype.destroyTooltip = function () {
        var _a, _b;
        (_b = (_a = this.tooltip).destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    SpreadSheet.prototype.registerIcons = function () {
        var customSVGIcons = this.options.customSVGIcons;
        if (isEmpty(customSVGIcons)) {
            return;
        }
        forEach(customSVGIcons, function (customSVGIcon) {
            if (isEmpty(getIcon(customSVGIcon.name))) {
                registerIcon(customSVGIcon.name, customSVGIcon.svg);
            }
        });
    };
    /**
     * Update data config and keep pre-sort operations
     * Group sort params kept in {@see store} and
     * Priority: group sort > advanced sort
     * @param dataCfg
     */
    SpreadSheet.prototype.setDataCfg = function (dataCfg) {
        this.store.set('originalDataCfg', dataCfg);
        var newDataCfg = clone(dataCfg);
        this.dataCfg = getSafetyDataConfig(newDataCfg);
        // clear value ranger after each updated data cfg
        clearValueRangeState(this);
    };
    SpreadSheet.prototype.setOptions = function (options) {
        this.hideTooltip();
        this.options = customMerge(this.options, options);
        this.registerIcons();
    };
    SpreadSheet.prototype.render = function (reloadData, reBuildDataSet) {
        if (reloadData === void 0) { reloadData = true; }
        if (reBuildDataSet === void 0) { reBuildDataSet = false; }
        this.emit(S2Event.LAYOUT_BEFORE_RENDER);
        if (reBuildDataSet) {
            this.dataSet = this.getDataSet(this.options);
        }
        if (reloadData) {
            this.clearDrillDownData('', true);
            this.dataSet.setDataCfg(this.dataCfg);
        }
        this.buildFacet();
        this.initHiddenColumnsDetail();
        this.emit(S2Event.LAYOUT_AFTER_RENDER);
    };
    SpreadSheet.prototype.destroy = function () {
        var _a;
        this.emit(S2Event.LAYOUT_DESTROY);
        this.facet.destroy();
        (_a = this.hdAdapter) === null || _a === void 0 ? void 0 : _a.destroy();
        this.interaction.destroy();
        this.store.clear();
        this.destroyTooltip();
        this.clearCanvasEvent();
        this.container.destroy();
    };
    /**
     * Update theme config, if the {@param type} is exists, re-use it,
     * otherwise create new one {@see theme}
     * @param type string
     * @param theme
     */
    SpreadSheet.prototype.setThemeCfg = function (themeCfg) {
        var theme = (themeCfg === null || themeCfg === void 0 ? void 0 : themeCfg.theme) || {};
        this.theme = customMerge(getTheme(__assign(__assign({}, themeCfg), { spreadsheet: this })), theme);
    };
    /**
     * Update pagination config which store in {@see options}
     * @param pagination
     */
    SpreadSheet.prototype.updatePagination = function (pagination) {
        this.options = customMerge(this.options, {
            pagination: pagination,
        });
        // 清空滚动进度
        this.store.set('scrollX', 0);
        this.store.set('scrollY', 0);
    };
    /**
     * 获取当前表格实际内容高度
     */
    SpreadSheet.prototype.getContentHeight = function () {
        return this.facet.getContentHeight();
    };
    /**
     * 修改表格画布大小，不用重新加载数据
     * @param width
     * @param height
     */
    SpreadSheet.prototype.changeSize = function (width, height) {
        if (width === void 0) { width = this.options.width; }
        if (height === void 0) { height = this.options.height; }
        var isEqualSize = width === this.options.width && height === this.options.height;
        if (isEqualSize) {
            return;
        }
        this.options = customMerge(this.options, { width: width, height: height });
        // resize the canvas
        this.container.changeSize(width, height);
    };
    SpreadSheet.prototype.getLayoutWidthType = function () {
        return this.options.style.layoutWidthType;
    };
    SpreadSheet.prototype.getRowNodes = function (level) {
        if (level === void 0) { level = -1; }
        if (level === -1) {
            return this.facet.layoutResult.rowNodes;
        }
        return this.facet.layoutResult.rowNodes.filter(function (value) { return value.level === level; });
    };
    /**
     * get columnNode in levels,
     * @param level -1 = get all
     */
    SpreadSheet.prototype.getColumnNodes = function (level) {
        var _a, _b;
        if (level === void 0) { level = -1; }
        if (level === -1) {
            return (_a = this.facet) === null || _a === void 0 ? void 0 : _a.layoutResult.colNodes;
        }
        return (_b = this.facet) === null || _b === void 0 ? void 0 : _b.layoutResult.colNodes.filter(function (value) { return value.level === level; });
    };
    /**
     * Update scroll's offset, the value can be undefined,
     * indicate not update current value
     * @param offsetConfig
     * default offsetX(horizontal scroll need animation)
     * but offsetY(vertical scroll don't need animation)
     */
    SpreadSheet.prototype.updateScrollOffset = function (offsetConfig) {
        this.facet.updateScrollOffset(customMerge({
            offsetX: {
                value: undefined,
                animate: false,
            },
            offsetY: {
                value: undefined,
                animate: false,
            },
        }, offsetConfig));
    };
    SpreadSheet.prototype.getTooltipDataItemMappingCallback = function () {
        var _a;
        return (_a = this.options) === null || _a === void 0 ? void 0 : _a.mappingDisplayDataItem;
    };
    // 获取当前cell实例
    SpreadSheet.prototype.getCell = function (target) {
        var _a;
        var parent = target;
        // 一直索引到g顶层的canvas来检查是否在指定的cell中
        while (parent && !(parent instanceof Canvas)) {
            if (parent instanceof BaseCell) {
                // 在单元格中，返回true
                return parent;
            }
            parent = (_a = parent.get) === null || _a === void 0 ? void 0 : _a.call(parent, 'parent');
        }
        return null;
    };
    // 获取当前cell类型
    SpreadSheet.prototype.getCellType = function (target) {
        var cell = this.getCell(target);
        return cell === null || cell === void 0 ? void 0 : cell.cellType;
    };
    /**
     * get total's config by dimension id
     * @param dimension unique dimension id
     */
    SpreadSheet.prototype.getTotalsConfig = function (dimension) {
        var totals = this.options.totals;
        var rows = this.dataCfg.fields.rows;
        var totalConfig = get(totals, includes(rows, dimension) ? 'row' : 'col', {});
        var showSubTotals = totalConfig.showSubTotals
            ? includes(totalConfig.subTotalsDimensions, dimension)
            : false;
        return {
            showSubTotals: showSubTotals,
            showGrandTotals: totalConfig.showGrandTotals,
            reverseLayout: totalConfig.reverseLayout,
            reverseSubLayout: totalConfig.reverseSubLayout,
            label: totalConfig.label || i18n('总计'),
            subLabel: totalConfig.subLabel || i18n('小计'),
        };
    };
    /**
     * Create all related groups, contains:
     * 1. container -- base canvas group
     * 2. backgroundGroup
     * 3. panelGroup -- main facet group belongs to
     * 4. foregroundGroup
     * @param dom
     * @private
     */
    SpreadSheet.prototype.initGroups = function (dom) {
        var _a = this.options, width = _a.width, height = _a.height, supportCSSTransform = _a.supportCSSTransform, devicePixelRatio = _a.devicePixelRatio;
        // base canvas group
        this.container = new Canvas({
            container: this.getMountContainer(dom),
            width: width,
            height: height,
            localRefresh: false,
            supportCSSTransform: supportCSSTransform,
            pixelRatio: Math.max(devicePixelRatio, MIN_DEVICE_PIXEL_RATIO),
        });
        // the main three layer groups
        this.backgroundGroup = this.container.addGroup({
            name: KEY_GROUP_BACK_GROUND,
            zIndex: BACK_GROUND_GROUP_CONTAINER_Z_INDEX,
        });
        this.panelGroup = this.container.addGroup({
            name: KEY_GROUP_PANEL_GROUND,
            zIndex: PANEL_GROUP_GROUP_CONTAINER_Z_INDEX,
        });
        this.foregroundGroup = this.container.addGroup({
            name: KEY_GROUP_FORE_GROUND,
            zIndex: FRONT_GROUND_GROUP_CONTAINER_Z_INDEX,
        });
        this.initPanelGroupChildren();
        this.updateContainerStyle();
    };
    // canvas 需要设置为 块级元素, 不然和父元素有 5px 的高度差
    SpreadSheet.prototype.updateContainerStyle = function () {
        var canvas = this.container.get('el');
        canvas.style.display = 'block';
    };
    SpreadSheet.prototype.initPanelGroupChildren = function () {
        this.panelScrollGroup = this.panelGroup.addGroup({
            name: KEY_GROUP_PANEL_SCROLL,
            zIndex: PANEL_GROUP_SCROLL_GROUP_Z_INDEX,
        });
    };
    SpreadSheet.prototype.getInitColumnNodes = function () {
        return this.store.get('initColumnNodes', []);
    };
    SpreadSheet.prototype.clearCanvasEvent = function () {
        var _this = this;
        var canvasEvents = this.getEvents();
        forIn(canvasEvents, function (_, event) {
            _this.off(event);
        });
    };
    return SpreadSheet;
}(EE));

var BaseDataSet = /** @class */ (function () {
    function BaseDataSet(spreadsheet) {
        var _this = this;
        /**
         * 查找字段信息
         */
        this.getFieldMeta = memoize(function (field, meta) {
            return find(_this.meta || meta, function (m) { return m.field === field; });
        });
        this.spreadsheet = spreadsheet;
    }
    /**
     * 获得字段名称
     * @param field
     */
    BaseDataSet.prototype.getFieldName = function (field) {
        return get(this.getFieldMeta(field, this.meta), 'name', field);
    };
    /**
     * 获得字段格式方法
     * @param field
     */
    BaseDataSet.prototype.getFieldFormatter = function (field) {
        return get(this.getFieldMeta(field, this.meta), 'formatter', identity);
    };
    /**
     * 获得字段描述
     * @param field
     */
    BaseDataSet.prototype.getFieldDescription = function (field) {
        return get(this.getFieldMeta(field, this.meta), 'description');
    };
    BaseDataSet.prototype.setDataCfg = function (dataCfg) {
        this.getFieldMeta.cache.clear();
        var _a = this.processDataCfg(dataCfg), fields = _a.fields, meta = _a.meta, data = _a.data, totalData = _a.totalData, sortParams = _a.sortParams, filterParams = _a.filterParams;
        this.fields = fields;
        this.meta = meta;
        this.originData = data;
        this.totalData = totalData;
        this.sortParams = sortParams;
        this.filterParams = filterParams;
        this.displayData = this.originData;
        this.indexesData = [];
    };
    BaseDataSet.prototype.getDisplayDataSet = function () {
        return this.displayData;
    };
    BaseDataSet.prototype.getValueRangeByField = function (field) {
        var _a;
        var cacheRange = getValueRangeState(this.spreadsheet, field);
        if (cacheRange) {
            return cacheRange;
        }
        var fieldValues = compact(map(this.originData, function (item) {
            var value = item[field];
            return isNil(value) ? null : Number.parseFloat(value);
        }));
        var range = {
            maxValue: max(fieldValues),
            minValue: min(fieldValues),
        };
        setValueRangeState(this.spreadsheet, (_a = {},
            _a[field] = range,
            _a));
        return range;
    };
    BaseDataSet.prototype.moreThanOneValue = function () {
        var _a, _b;
        return ((_b = (_a = this.fields) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.length) > 1;
    };
    return BaseDataSet;
}());

var PivotDataSet = /** @class */ (function (_super) {
    __extends(PivotDataSet, _super);
    function PivotDataSet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // each path items max index
        _this.pathIndexMax = [];
        /**
         * 排序优先级：
         * 1、sortParams里的条件优先级高于原始数据
         * 2、sortParams多个item：按照顺序优先级，排在后面的优先级高
         * 3、item中多个条件：sortByField > sortFunc > sortBy > sortMethod
         */
        _this.handleDimensionValuesSort = function () {
            each(_this.sortParams, function (item) {
                var sortFieldId = item.sortFieldId, sortByMeasure = item.sortByMeasure;
                // 万物排序的前提
                if (!sortFieldId)
                    return;
                var originValues = __spreadArray([], __read((_this.sortedDimensionValues[sortFieldId] || [])), false);
                var result = handleSortAction({
                    dataSet: _this,
                    sortParam: item,
                    originValues: originValues,
                    isSortByMeasure: !isEmpty(sortByMeasure),
                });
                _this.sortedDimensionValues[sortFieldId] = result;
            });
        };
        _this.getCustomData = function (path) {
            var _a;
            var hadUndefined = false;
            var currentData = _this.indexesData;
            var _loop_1 = function (i) {
                var current = path[i];
                if (hadUndefined) {
                    if (isUndefined(current)) {
                        currentData = flatten(currentData);
                    }
                    else {
                        currentData = (_a = values(currentData)) === null || _a === void 0 ? void 0 : _a.map(function (d) { return d && get(d, current); });
                    }
                }
                else if (isUndefined(current)) {
                    hadUndefined = true;
                }
                else {
                    currentData = currentData === null || currentData === void 0 ? void 0 : currentData[current];
                }
            };
            for (var i = 0; i < path.length; i++) {
                _loop_1(i);
            }
            return currentData;
        };
        _this.getTotalStatus = function (query) {
            var _a = _this.fields, columns = _a.columns, rows = _a.rows;
            var isTotals = function (dimensions, isSubTotal) {
                if (isSubTotal) {
                    var firstDimension = find(dimensions, function (item) { return !has(query, item); });
                    return firstDimension && firstDimension !== first(dimensions);
                }
                return every(dimensions, function (item) { return !has(query, item); });
            };
            var getDimensions = function (dimensions, hasExtra) {
                return hasExtra
                    ? dimensions.filter(function (item) { return item !== EXTRA_FIELD; })
                    : dimensions;
            };
            return {
                isRowTotal: isTotals(getDimensions(rows, !_this.spreadsheet.isValueInCols())),
                isRowSubTotal: isTotals(rows, true),
                isColTotal: isTotals(getDimensions(columns, _this.spreadsheet.isValueInCols())),
                isColSubTotal: isTotals(columns, true),
            };
        };
        return _this;
    }
    /**
     * When data related config changed, we need
     * 1、re-process config
     * 2、re-transform origin data
     * 3、sort and other things
     * @param dataCfg
     */
    PivotDataSet.prototype.setDataCfg = function (dataCfg) {
        var _this = this;
        _super.prototype.setDataCfg.call(this, dataCfg);
        this.sortedDimensionValues = {};
        this.rowPivotMeta = new Map();
        this.colPivotMeta = new Map();
        // total data in raw data scene.
        this.totalData = []
            .concat(splitTotal(dataCfg.data, dataCfg.fields))
            .concat(this.totalData);
        DebuggerUtil.getInstance().debugCallback(DEBUG_TRANSFORM_DATA, function () {
            var _a = _this.fields, rows = _a.rows, columns = _a.columns;
            var indexesData = transformIndexesData({
                rows: rows,
                columns: columns,
                originData: _this.originData,
                totalData: _this.totalData,
                indexesData: _this.indexesData,
                sortedDimensionValues: _this.sortedDimensionValues,
                rowPivotMeta: _this.rowPivotMeta,
                colPivotMeta: _this.colPivotMeta,
            }).indexesData;
            _this.indexesData = indexesData;
        });
        this.handleDimensionValuesSort();
    };
    /**
     * Provide a way to append some drill-down data in indexesData
     * @param extraRowField
     * @param drillDownData
     * @param rowNode
     */
    PivotDataSet.prototype.transformDrillDownData = function (extraRowField, drillDownData, rowNode) {
        var _this = this;
        var _a;
        var _b = this.fields, columns = _b.columns, dataValues = _b.values;
        var currentRowFields = Node.getFieldPath(rowNode, true);
        var nextRowFields = __spreadArray(__spreadArray([], __read(currentRowFields), false), [extraRowField], false);
        var store = this.spreadsheet.store;
        // 1、通过values在data中注入额外的维度信息，并分离`明细数据`&`汇总数据`
        var transformedData = this.standardTransform(drillDownData, dataValues);
        var totalData = splitTotal(transformedData, {
            columns: this.fields.columns,
            rows: nextRowFields,
        });
        var originData = difference(transformedData, totalData);
        // 2. 检查该节点是否已经存在下钻维度
        var rowNodeId = rowNode === null || rowNode === void 0 ? void 0 : rowNode.id;
        var idPathMap = (_a = store.get('drillDownIdPathMap')) !== null && _a !== void 0 ? _a : new Map();
        if (idPathMap.has(rowNodeId)) {
            // the current node has a drill-down field, clean it
            forEach(idPathMap.get(rowNodeId), function (path) {
                unset(_this.indexesData, path);
            });
            deleteMetaById(this.rowPivotMeta, rowNodeId);
        }
        // 3、转换数据
        var _c = transformIndexesData({
            rows: nextRowFields,
            columns: columns,
            originData: originData,
            totalData: totalData,
            indexesData: this.indexesData,
            sortedDimensionValues: this.sortedDimensionValues,
            rowPivotMeta: this.rowPivotMeta,
            colPivotMeta: this.colPivotMeta,
        }), drillDownDataPaths = _c.paths, indexesData = _c.indexesData, rowPivotMeta = _c.rowPivotMeta, colPivotMeta = _c.colPivotMeta, sortedDimensionValues = _c.sortedDimensionValues;
        this.indexesData = indexesData;
        this.rowPivotMeta = rowPivotMeta;
        this.colPivotMeta = colPivotMeta;
        this.sortedDimensionValues = sortedDimensionValues;
        // 4、record data paths by nodeId
        // set new drill-down data path
        idPathMap.set(rowNodeId, drillDownDataPaths);
        store.set('drillDownIdPathMap', idPathMap);
    };
    /**
     * Clear drill down data by rowNodeId
     * rowNodeId is undefined => clear all
     * @param rowNodeId
     */
    PivotDataSet.prototype.clearDrillDownData = function (rowNodeId) {
        var _this = this;
        var store = this.spreadsheet.store;
        var idPathMap = store.get('drillDownIdPathMap');
        if (!idPathMap) {
            return;
        }
        var drillDownDataCache = store.get('drillDownDataCache', []);
        if (rowNodeId) {
            // 1. 删除 indexesData 当前下钻层级对应数据
            var currentIdPathMap = idPathMap.get(rowNodeId);
            if (currentIdPathMap) {
                forEach(currentIdPathMap, function (path) {
                    unset(_this.indexesData, path);
                });
            }
            // 2. 删除 rowPivotMeta 当前下钻层级对应 meta 信息
            deleteMetaById(this.rowPivotMeta, rowNodeId);
            // 3. 删除下钻缓存路径
            idPathMap.delete(rowNodeId);
            // 4. 过滤清除的下钻缓存
            var restDataCache = filter(drillDownDataCache, function (cache) {
                return idPathMap.has(cache === null || cache === void 0 ? void 0 : cache.rowId);
            });
            store.set('drillDownDataCache', restDataCache);
            // 5. 过滤清除的下钻层级
            var restDrillLevels_1 = restDataCache.map(function (cache) { return cache === null || cache === void 0 ? void 0 : cache.drillLevel; });
            var drillDownFieldInLevel = store.get('drillDownFieldInLevel', []);
            var restFieldInLevel = drillDownFieldInLevel.filter(function (filed) {
                return includes(restDrillLevels_1, filed === null || filed === void 0 ? void 0 : filed.drillLevel);
            });
            store.set('drillDownFieldInLevel', restFieldInLevel);
        }
        else {
            idPathMap.clear();
            // 需要对应清空所有下钻后的dataCfg信息
            // 因此如果缓存有下钻前原始dataCfg，需要清空所有的下钻数据
            var originalDataCfg = this.spreadsheet.store.get('originalDataCfg');
            if (!isEmpty(originalDataCfg)) {
                this.spreadsheet.setDataCfg(originalDataCfg);
            }
            // 清空所有的下钻信息
            this.spreadsheet.store.set('drillItemsNum', -1);
            this.spreadsheet.store.set('drillDownDataCache', []);
            this.spreadsheet.store.set('drillDownFieldInLevel', []);
        }
        store.set('drillDownIdPathMap', idPathMap);
    };
    PivotDataSet.prototype.standardTransform = function (originData, fieldsValues) {
        if (isEmpty(fieldsValues)) {
            return originData;
        }
        var transformedData = [];
        forEach(fieldsValues, function (value) {
            forEach(originData, function (dataItem) {
                var _a;
                if (has(dataItem, value)) {
                    transformedData.push(__assign(__assign({}, dataItem), (_a = {}, _a[EXTRA_FIELD] = value, _a[VALUE_FIELD] = dataItem[value], _a)));
                }
            });
        });
        return transformedData;
    };
    PivotDataSet.prototype.processDataCfg = function (dataCfg) {
        var data = dataCfg.data, _a = dataCfg.meta, meta = _a === void 0 ? [] : _a, fields = dataCfg.fields, _b = dataCfg.sortParams, sortParams = _b === void 0 ? [] : _b, totalData = dataCfg.totalData;
        var columns = fields.columns, rows = fields.rows, values = fields.values, valueInCols = fields.valueInCols, customValueOrder = fields.customValueOrder;
        var newColumns = columns;
        var newRows = rows;
        if (valueInCols) {
            newColumns = this.isCustomMeasuresPosition(customValueOrder)
                ? this.handleCustomMeasuresOrder(customValueOrder, newColumns)
                : uniq(__spreadArray(__spreadArray([], __read(columns), false), [EXTRA_FIELD], false));
        }
        else {
            newRows = this.isCustomMeasuresPosition(customValueOrder)
                ? this.handleCustomMeasuresOrder(customValueOrder, newRows)
                : uniq(__spreadArray(__spreadArray([], __read(rows), false), [EXTRA_FIELD], false));
        }
        var valueFormatter = function (value) {
            var findOne = find(meta, function (mt) { return mt.field === value; });
            return get(findOne, 'name', value);
        };
        var newMeta = __spreadArray(__spreadArray([], __read(meta), false), [
            // 虚拟列字段，为文本分类字段
            {
                field: EXTRA_FIELD,
                name: i18n('数值'),
                formatter: function (value) { return valueFormatter(value); },
            },
        ], false);
        var newData = this.standardTransform(data, values);
        var newTotalData = this.standardTransform(totalData, values);
        // 返回新的结构
        return {
            data: newData,
            meta: newMeta,
            fields: __assign(__assign({}, fields), { rows: newRows, columns: newColumns, values: values }),
            totalData: newTotalData,
            sortParams: sortParams,
        };
    };
    PivotDataSet.prototype.getDimensionValues = function (field, query) {
        var e_1, _a;
        var _b, _c;
        var _d = this.fields || {}, _e = _d.rows, rows = _e === void 0 ? [] : _e, _f = _d.columns, columns = _f === void 0 ? [] : _f;
        var meta = new Map();
        var dimensions = [];
        if (includes(rows, field)) {
            meta = this.rowPivotMeta;
            dimensions = rows;
        }
        else if (includes(columns, field)) {
            meta = this.colPivotMeta;
            dimensions = columns;
        }
        if (!isEmpty(query)) {
            var sortedMeta = [];
            var dimensionValuePath = [];
            var _loop_2 = function (dimension) {
                var value = get(query, dimension);
                dimensionValuePath.push("".concat(value));
                var cacheKey = dimensionValuePath.join("".concat(ID_SEPARATOR));
                if (meta.has(value) && !isUndefined(value)) {
                    var childField_1 = (_b = meta.get(value)) === null || _b === void 0 ? void 0 : _b.childField;
                    meta = meta.get(value).children;
                    if (find(this_1.sortParams, function (item) { return item.sortFieldId === childField_1; }) &&
                        this_1.sortedDimensionValues[childField_1]) {
                        var dimensionValues = (_c = this_1.sortedDimensionValues[childField_1]) === null || _c === void 0 ? void 0 : _c.filter(function (item) { return item === null || item === void 0 ? void 0 : item.includes(cacheKey); });
                        sortedMeta = getDimensionsWithoutPathPre(__spreadArray([], __read(dimensionValues), false));
                    }
                    else {
                        sortedMeta = __spreadArray([], __read(meta.keys()), false);
                    }
                }
            };
            var this_1 = this;
            try {
                for (var dimensions_1 = __values(dimensions), dimensions_1_1 = dimensions_1.next(); !dimensions_1_1.done; dimensions_1_1 = dimensions_1.next()) {
                    var dimension = dimensions_1_1.value;
                    _loop_2(dimension);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (dimensions_1_1 && !dimensions_1_1.done && (_a = dimensions_1.return)) _a.call(dimensions_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (isEmpty(sortedMeta)) {
                return [];
            }
            return filterUndefined(getListBySorted(__spreadArray([], __read(meta.keys()), false), sortedMeta));
        }
        if (this.sortedDimensionValues[field]) {
            return filterUndefined(getDimensionsWithoutPathPre(__spreadArray([], __read(this.sortedDimensionValues[field]), false)));
        }
        return filterUndefined(__spreadArray([], __read(meta.keys()), false));
    };
    PivotDataSet.prototype.getTotalValue = function (query) {
        var _a;
        var _b;
        var _c = getAggregationAndCalcFuncByQuery(this.getTotalStatus(query), (_b = this.spreadsheet.options) === null || _b === void 0 ? void 0 : _b.totals) || {}, aggregation = _c.aggregation, calcFunc = _c.calcFunc;
        // 前端计算汇总值
        if (aggregation || calcFunc) {
            var data = this.getMultiData(query);
            var totalValue = void 0;
            if (calcFunc) {
                totalValue = calcFunc(query, data);
            }
            else if (aggregation === EAggregation.SUM) {
                totalValue = getDataSumByField(data, VALUE_FIELD);
            }
            return __assign(__assign({}, query), (_a = {}, _a[VALUE_FIELD] = totalValue, _a[query[EXTRA_FIELD]] = totalValue, _a));
        }
    };
    PivotDataSet.prototype.getCellData = function (params) {
        var _a, _b, _c;
        var _d = params || {}, query = _d.query, rowNode = _d.rowNode, _e = _d.isTotals, isTotals = _e === void 0 ? false : _e;
        var _f = this.fields, columns = _f.columns, originRows = _f.rows;
        var rows = originRows;
        var drillDownIdPathMap = (_a = this.spreadsheet) === null || _a === void 0 ? void 0 : _a.store.get('drillDownIdPathMap');
        // 判断当前是否为下钻节点
        // 需检查 rowNode.id 是否属于下钻根节点(drillDownIdPathMap.keys)的下属节点
        var isDrillDown = Array.from((_b = drillDownIdPathMap === null || drillDownIdPathMap === void 0 ? void 0 : drillDownIdPathMap.keys()) !== null && _b !== void 0 ? _b : []).some(function (parentPath) { return rowNode.id.startsWith(parentPath); });
        // 如果是下钻结点，小计行维度在 originRows 中并不存在
        if (!isTotals || isDrillDown) {
            rows = (_c = Node.getFieldPath(rowNode, isDrillDown)) !== null && _c !== void 0 ? _c : originRows;
        }
        var rowDimensionValues = getQueryDimValues(rows, query);
        var colDimensionValues = getQueryDimValues(columns, query);
        var path = getDataPath({
            rowDimensionValues: rowDimensionValues,
            colDimensionValues: colDimensionValues,
            careUndefined: isTotals || isTotalData([].concat(originRows).concat(columns), query),
            rowPivotMeta: this.rowPivotMeta,
            colPivotMeta: this.colPivotMeta,
        });
        var data = get(this.indexesData, path);
        if (data) {
            // 如果已经有数据则取已有数据
            return data;
        }
        return isTotals ? this.getTotalValue(query) : data;
    };
    PivotDataSet.prototype.getMultiData = function (query, isTotals, isRow, drillDownFields) {
        var _a;
        if (isEmpty(query)) {
            return compact(flattenDeep(this.indexesData));
        }
        var _b = this.fields, rows = _b.rows, columns = _b.columns, valueList = _b.values;
        var totalRows = !isEmpty(drillDownFields)
            ? rows.concat(drillDownFields)
            : rows;
        var rowDimensionValues = getQueryDimValues(totalRows, query);
        var colDimensionValues = getQueryDimValues(columns, query);
        var path = getDataPath({
            rowDimensionValues: rowDimensionValues,
            colDimensionValues: colDimensionValues,
            careUndefined: true,
            isFirstCreate: true,
            rowPivotMeta: this.rowPivotMeta,
            colPivotMeta: this.colPivotMeta,
        });
        var currentData = this.getCustomData(path);
        var result = compact(flatten(currentData));
        if (isTotals) {
            // 总计/小计（行/列）
            // need filter extra data
            // grand total =>  {$$extra$$: 'price'}
            // sub total => {$$extra$$: 'price', category: 'xxxx'}
            // [undefined, undefined, "price"] => [category]
            var fieldKeys_1 = [];
            var rowKeys = getFieldKeysByDimensionValues(rowDimensionValues, rows);
            var colKeys = getFieldKeysByDimensionValues(colDimensionValues, columns);
            if (isRow) {
                // 行总计
                fieldKeys_1 = rowKeys;
            }
            else {
                // 只有一个值，此时为列总计
                var isCol = ((_a = keys(query)) === null || _a === void 0 ? void 0 : _a.length) === 1 && has(query, EXTRA_FIELD);
                if (isCol) {
                    fieldKeys_1 = colKeys;
                }
                else {
                    var getTotalStatus = function (dimensions) {
                        return isEveryUndefined(dimensions === null || dimensions === void 0 ? void 0 : dimensions.filter(function (item) { return !(valueList === null || valueList === void 0 ? void 0 : valueList.includes(item)); }));
                    };
                    var isRowTotal = getTotalStatus(colDimensionValues);
                    var isColTotal = getTotalStatus(rowDimensionValues);
                    if (isRowTotal) {
                        // 行小计
                        fieldKeys_1 = rowKeys;
                    }
                    else if (isColTotal) {
                        // 列小计
                        fieldKeys_1 = colKeys;
                    }
                    else {
                        // 行小计+列 or 列小计+行
                        fieldKeys_1 = __spreadArray(__spreadArray([], __read(rowKeys), false), __read(colKeys), false);
                    }
                }
            }
            result = result.filter(function (r) {
                return !(fieldKeys_1 === null || fieldKeys_1 === void 0 ? void 0 : fieldKeys_1.find(function (item) { var _a; return item !== EXTRA_FIELD && ((_a = keys(r)) === null || _a === void 0 ? void 0 : _a.includes(item)); }));
            });
        }
        return result || [];
    };
    PivotDataSet.prototype.getFieldFormatter = function (field, cellMeta) {
        // 兼容总计小计场景
        if (field === TOTAL_VALUE) {
            return this.getFieldFormatterForTotalValue(cellMeta);
        }
        return _super.prototype.getFieldFormatter.call(this, field);
    };
    PivotDataSet.prototype.getFieldFormatterForTotalValue = function (cellMeta) {
        var valueField;
        // 当数据置于行头时，小计总计列尝试去找对应的指标
        if (!this.spreadsheet.isValueInCols() && cellMeta) {
            valueField = get(cellMeta.rowQuery, EXTRA_FIELD);
        }
        // 如果没有找到对应指标，则默认取第一个维度
        valueField = valueField !== null && valueField !== void 0 ? valueField : get(this.fields.values, 0);
        return _super.prototype.getFieldFormatter.call(this, valueField);
    };
    /**
     * 自定义度量组位置值
     * @param customValueOrder 用户配置度量组位置，从 0 开始
     * @param fields Rows || Columns
     */
    PivotDataSet.prototype.handleCustomMeasuresOrder = function (customValueOrder, fields) {
        var newFields = uniq(__spreadArray([], __read(fields), false));
        if (fields.length >= customValueOrder) {
            newFields.splice(customValueOrder, 0, EXTRA_FIELD);
            return newFields;
        }
        // 当用户配置的度量组位置大于等于度量组数量时，默认放在最后
        return __spreadArray(__spreadArray([], __read(newFields), false), [EXTRA_FIELD], false);
    };
    // 是否开启自定义度量组位置值
    PivotDataSet.prototype.isCustomMeasuresPosition = function (customValueOrder) {
        return isNumber(customValueOrder);
    };
    return PivotDataSet;
}(BaseDataSet));

var TableDataSet = /** @class */ (function (_super) {
    __extends(TableDataSet, _super);
    function TableDataSet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleDimensionValueFilter = function () {
            each(_this.filterParams, function (_a) {
                var filterKey = _a.filterKey, filteredValues = _a.filteredValues, customFilter = _a.customFilter;
                var defaultFilterFunc = function (row) {
                    return row[filterKey] && !includes(filteredValues, row[filterKey]);
                };
                _this.displayData = __spreadArray(__spreadArray(__spreadArray([], __read(_this.getStartRows()), false), __read(filter(_this.getMovableRows(), function (row) {
                    if (customFilter) {
                        return customFilter(row) && defaultFilterFunc(row);
                    }
                    return defaultFilterFunc(row);
                })), false), __read(_this.getEndRows()), false);
            });
        };
        _this.handleDimensionValuesSort = function () {
            each(_this.sortParams, function (item) {
                var sortFieldId = item.sortFieldId, sortBy = item.sortBy, sortMethod = item.sortMethod;
                // 万物排序的前提
                if (!sortFieldId || !sortMethod)
                    return;
                // For frozen options
                _this.displayData = __spreadArray(__spreadArray(__spreadArray([], __read(_this.getStartRows()), false), __read(orderBy(_this.getMovableRows(), [sortBy || sortFieldId], [sortMethod.toLocaleLowerCase()])), false), __read(_this.getEndRows()), false);
            });
        };
        return _this;
    }
    TableDataSet.prototype.processDataCfg = function (dataCfg) {
        return dataCfg;
    };
    TableDataSet.prototype.setDataCfg = function (dataCfg) {
        _super.prototype.setDataCfg.call(this, dataCfg);
        this.handleDimensionValueFilter();
        this.handleDimensionValuesSort();
    };
    /**
     * 返回顶部冻结行
     * @returns
     */
    TableDataSet.prototype.getStartRows = function () {
        var frozenRowCount = (this.spreadsheet.options || {}).frozenRowCount;
        if (!frozenRowCount)
            return [];
        var displayData = this.displayData;
        return displayData.slice(0, frozenRowCount);
    };
    /**
     * 返回底部冻结行
     * @returns
     */
    TableDataSet.prototype.getEndRows = function () {
        var frozenTrailingRowCount = (this.spreadsheet.options || {}).frozenTrailingRowCount;
        // 没有冻结行时返回空数组
        if (!frozenTrailingRowCount)
            return [];
        var displayData = this.displayData;
        return displayData.slice(-frozenTrailingRowCount);
    };
    /**
     * 返回可移动的非冻结行
     * @returns
     */
    TableDataSet.prototype.getMovableRows = function () {
        var displayData = this.displayData;
        var _a = this.spreadsheet.options || {}, frozenTrailingRowCount = _a.frozenTrailingRowCount, frozenRowCount = _a.frozenRowCount;
        return displayData.slice(frozenRowCount || 0, -frozenTrailingRowCount || undefined);
    };
    TableDataSet.prototype.getDimensionValues = function (field, query) {
        return [];
    };
    TableDataSet.prototype.getCellData = function (_a) {
        var query = _a.query;
        if (this.displayData.length === 0 && query.rowIndex === 0) {
            return;
        }
        return this.displayData[query.rowIndex][query.col];
    };
    TableDataSet.prototype.getMultiData = function (query, isTotals) {
        return this.displayData;
    };
    return TableDataSet;
}(BaseDataSet));

var CustomTreePivotDataSet = /** @class */ (function (_super) {
    __extends(CustomTreePivotDataSet, _super);
    function CustomTreePivotDataSet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomTreePivotDataSet.prototype.getCellData = function (params) {
        var query = params.query;
        var _a = this.fields, columns = _a.columns, rows = _a.rows;
        var rowDimensionValues = getQueryDimValues(rows, query);
        var colDimensionValues = getQueryDimValues(columns, query);
        var path = getDataPath({
            rowDimensionValues: rowDimensionValues,
            colDimensionValues: colDimensionValues,
            rowPivotMeta: this.rowPivotMeta,
            colPivotMeta: this.colPivotMeta,
            isFirstCreate: true,
            careUndefined: true,
            rowFields: rows,
            colFields: columns,
        });
        var data = get(this.indexesData, path);
        return data;
    };
    CustomTreePivotDataSet.prototype.setDataCfg = function (dataCfg) {
        _super.prototype.setDataCfg.call(this, dataCfg);
        this.sortedDimensionValues = {};
        this.rowPivotMeta = new Map();
        this.colPivotMeta = new Map();
        var _a = this.fields, rows = _a.rows, columns = _a.columns;
        var indexesData = transformIndexesData({
            rows: rows,
            columns: columns,
            originData: this.originData,
            totalData: [],
            indexesData: this.indexesData,
            sortedDimensionValues: this.sortedDimensionValues,
            rowPivotMeta: this.rowPivotMeta,
            colPivotMeta: this.colPivotMeta,
        }).indexesData;
        this.indexesData = indexesData;
        this.handleDimensionValuesSort();
    };
    CustomTreePivotDataSet.prototype.processDataCfg = function (dataCfg) {
        // 自定义行头有如下几个特点
        // 1、rows配置必须是空，需要额外添加 $$extra$$ 定位数据（标记指标的id）
        // 2、要有配置 fields.rowCustomTree(行头结构)
        // 3、values 不需要参与计算，默认就在行头结构中
        dataCfg.fields.rows = [EXTRA_FIELD];
        dataCfg.fields.valueInCols = false;
        var data = dataCfg.data, restCfg = __rest(dataCfg, ["data"]);
        var values = dataCfg.fields.values;
        // 将源数据中的value值，映射为 $$extra$$,$$value$$
        // {
        // province: '四川',    province: '四川',
        // city: '成都',   =>   city: '成都',
        // price='11'           price='11'
        //                      $$extra$$=price
        //                      $$value$$=11
        // 此时 province, city 均配置在columns里面
        // }
        var transformedData = [];
        forEach(data, function (dataItem) {
            if (isEmpty(intersection(keys(dataItem), values))) {
                transformedData.push(dataItem);
            }
            else {
                forEach(values, function (value) {
                    var _a;
                    if (has(dataItem, value)) {
                        transformedData.push(__assign(__assign({}, dataItem), (_a = {}, _a[EXTRA_FIELD] = value, _a[VALUE_FIELD] = dataItem[value], _a)));
                    }
                });
            }
        });
        return __assign({ data: uniq(transformedData) }, restCfg);
    };
    return CustomTreePivotDataSet;
}(PivotDataSet));

// BBox相同数据结构，便于已有逻辑的直接复用
var BaseBBox = /** @class */ (function () {
    function BaseBBox(facet, autoCalculateBBoxWhenCreated) {
        if (autoCalculateBBoxWhenCreated === void 0) { autoCalculateBBoxWhenCreated = false; }
        this.x = 0;
        this.y = 0;
        this.minX = 0;
        this.minY = 0;
        this.maxX = 0;
        this.maxY = 0;
        this.width = 0;
        this.height = 0;
        // 记录未裁剪时的原始宽高
        this.originalWidth = 0;
        this.originalHeight = 0;
        // 视口宽高，数据少时可能小于 bbox 的宽高
        this.viewportHeight = 0;
        this.viewportWidth = 0;
        this.facet = facet;
        this.spreadsheet = facet.spreadsheet;
        this.layoutResult = facet.layoutResult;
        if (autoCalculateBBoxWhenCreated) {
            this.calculateBBox();
        }
    }
    return BaseBBox;
}());

var CornerBBox = /** @class */ (function (_super) {
    __extends(CornerBBox, _super);
    function CornerBBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CornerBBox.prototype.calculateBBox = function () {
        var width = this.getCornerBBoxWidth();
        var height = this.getCornerBBoxHeight();
        this.width = width;
        this.height = height;
        this.maxX = width;
        this.maxY = height;
    };
    CornerBBox.prototype.getCornerBBoxHeight = function () {
        var colsHierarchy = this.layoutResult.colsHierarchy;
        this.originalHeight = Math.floor(colsHierarchy.height);
        return this.originalHeight;
    };
    CornerBBox.prototype.getCornerBBoxWidth = function () {
        var rowsHierarchy = this.layoutResult.rowsHierarchy;
        this.originalWidth = Math.floor(rowsHierarchy.width + this.facet.getSeriesNumberWidth());
        // 在行头不固定时，无需对角头 BBox 进行裁剪
        if (this.spreadsheet.isScrollContainsRowHeader()) {
            return this.originalWidth;
        }
        return this.adjustCornerBBoxWidth();
    };
    CornerBBox.prototype.adjustCornerBBoxWidth = function () {
        var colsHierarchy = this.layoutResult.colsHierarchy;
        var canvasWidth = this.spreadsheet.options.width;
        var maxCornerBBoxWidth = canvasWidth * CORNER_MAX_WIDTH_RATIO;
        var colsHierarchyWidth = colsHierarchy === null || colsHierarchy === void 0 ? void 0 : colsHierarchy.width;
        var panelWidthWidthUnClippedCorner = canvasWidth - this.originalWidth;
        // 不需要裁剪条件：
        // 1. 角头的宽度没有超过最大的角头范围
        // 2. 列头的宽度没有超过在不裁剪角头前提下的剩余范围
        if (this.originalWidth <= maxCornerBBoxWidth ||
            colsHierarchyWidth <= panelWidthWidthUnClippedCorner) {
            return this.originalWidth;
        }
        var clippedWidth = 0;
        var maxPanelWidth = canvasWidth - maxCornerBBoxWidth;
        // 列头宽度超过了剩余宽度，但是小于 Panel 的最大宽度
        if (colsHierarchyWidth <= maxPanelWidth) {
            clippedWidth =
                this.originalWidth -
                    (colsHierarchyWidth - panelWidthWidthUnClippedCorner);
        }
        else {
            clippedWidth = maxCornerBBoxWidth;
        }
        return Math.floor(clippedWidth);
    };
    return CornerBBox;
}(BaseBBox));

var PanelBBox = /** @class */ (function (_super) {
    __extends(PanelBBox, _super);
    function PanelBBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PanelBBox.prototype.calculateBBox = function () {
        this.originalWidth = this.facet.getRealWidth();
        this.originalHeight = this.facet.getRealHeight();
        var cornerBBox = this.facet.cornerBBox;
        var cornerPosition = {
            x: Math.floor(cornerBBox.maxX),
            y: Math.floor(cornerBBox.maxY),
        };
        var scrollBarSize = this.spreadsheet.theme.scrollBar.size;
        var _a = this.spreadsheet.options, canvasWidth = _a.width, canvasHeight = _a.height;
        var panelWidth = Math.max(0, canvasWidth - cornerPosition.x);
        var panelHeight = Math.max(0, canvasHeight - cornerPosition.y - scrollBarSize);
        this.x = cornerPosition.x;
        this.y = cornerPosition.y;
        this.width = panelWidth;
        this.height = panelHeight;
        this.viewportHeight = Math.abs(Math.floor(Math.min(panelHeight, this.originalHeight)));
        this.viewportWidth = Math.abs(Math.floor(Math.min(panelWidth, this.originalWidth)));
        this.maxX = cornerPosition.x + this.viewportWidth;
        this.maxY = cornerPosition.y + this.viewportHeight;
        this.minX = cornerPosition.x;
        this.minY = cornerPosition.y;
        var _b = this.spreadsheet.options, frozenTrailingColCount = _b.frozenTrailingColCount, frozenTrailingRowCount = _b.frozenTrailingRowCount;
        if (frozenTrailingColCount > 0) {
            this.viewportWidth = this.width;
            this.maxX = cornerPosition.x + this.width;
        }
        if (frozenTrailingRowCount > 0) {
            this.viewportHeight = this.height;
            this.maxY = cornerPosition.y + this.height;
        }
    };
    return PanelBBox;
}(BaseBBox));

var ScrollType;
(function (ScrollType) {
    ScrollType["ScrollChange"] = "scroll-change";
    ScrollType["ScrollEnd"] = "scroll-end";
})(ScrollType || (ScrollType = {}));
var ScrollBar = /** @class */ (function (_super) {
    __extends(ScrollBar, _super);
    function ScrollBar(scrollBarCfg) {
        var _this = _super.call(this, scrollBarCfg) || this;
        // 通过拖拽开始的事件是 mousedown 还是 touchstart 来决定是移动端还是 pc 端
        _this.isMobile = false;
        _this.eventHandlers = [];
        _this.scrollFrameId = null;
        _this.getCoordinates = function () {
            var from = _this.isHorizontal ? 'x1' : 'y1';
            var to = _this.isHorizontal ? 'x2' : 'y2';
            return { from: from, to: to };
        };
        /**
         * 当前滑块滑动的位置 0 ~ 1
         */
        _this.current = function () {
            var thumbRate = _this.thumbLen / _this.trackLen;
            var offsetRate = _this.thumbOffset / _this.trackLen;
            return offsetRate / (1 - thumbRate);
        };
        /**
         * 更新滑道长度
         * @param newTrackLen 新的滑块长度
         */
        _this.updateTrackLen = function (newTrackLen) {
            // 如果更新后的 trackLen 没改变，无需执行后续逻辑
            if (_this.trackLen === newTrackLen) {
                return;
            }
            // 更新滑道长度的时候，同时按比例更新滑块长度和 offset(增大视窗或者减小视窗的场景))
            var thumbRate = _this.thumbLen / _this.trackLen;
            var offsetRate = _this.thumbOffset / _this.trackLen;
            var newThumbLen = newTrackLen * thumbRate;
            var newOffset = newTrackLen * offsetRate;
            _this.scrollTargetMaxOffset =
                _this.scrollTargetMaxOffset + _this.trackLen - newTrackLen;
            _this.trackLen = newTrackLen;
            var coordinate = _this.getCoordinates();
            _this.trackShape.attr(coordinate.to, newTrackLen);
            _this.updateThumbLen(newThumbLen);
            _this.updateThumbOffset(newOffset);
            _this.emitScrollChange((newOffset / (newTrackLen - newThumbLen)) * _this.scrollTargetMaxOffset, false);
        };
        /**
         * 更新滑块长度
         * @param newThumbLen 新的滑道长度
         */
        _this.updateThumbLen = function (newThumbLen) {
            // 如果更新后的 thumbLen 没改变，无需执行后续逻辑
            if (_this.thumbLen === newThumbLen) {
                return;
            }
            _this.thumbLen = newThumbLen;
            var coordinate = _this.getCoordinates();
            _this.thumbShape.attr(coordinate.to, _this.thumbOffset + newThumbLen);
            _this.emitScrollChange((_this.thumbOffset / (_this.trackLen - _this.thumbLen)) *
                _this.scrollTargetMaxOffset, false);
        };
        /**
         * 更新滑块的 offset 值
         * @param offset
         */
        _this.updateThumbOffset = function (offset, emitScrollChange) {
            var _a;
            if (emitScrollChange === void 0) { emitScrollChange = true; }
            var newOffset = _this.validateRange(offset);
            var isNotChanged = _this.thumbOffset === newOffset && newOffset !== 0;
            if (isNotChanged) {
                return;
            }
            _this.thumbOffset = newOffset;
            var _b = _this.getCoordinates(), from = _b.from, to = _b.to;
            _this.thumbShape.attr((_a = {},
                _a[from] = newOffset,
                _a[to] = newOffset + _this.thumbLen,
                _a));
            if (emitScrollChange) {
                _this.emitScrollChange((newOffset / (_this.trackLen - _this.thumbLen)) *
                    _this.scrollTargetMaxOffset, false);
            }
        };
        /**
         * 只更新位置属性，而不emit滚动事件
         * @param offset
         */
        _this.onlyUpdateThumbOffset = function (offset) {
            var _a;
            _this.updateThumbOffset(offset, false);
            (_a = _this.get('canvas')) === null || _a === void 0 ? void 0 : _a.draw();
        };
        _this.emitScrollChange = function (offset, updateThumbOffset) {
            if (updateThumbOffset === void 0) { updateThumbOffset = true; }
            cancelAnimationFrame(_this.scrollFrameId);
            _this.scrollFrameId = requestAnimationFrame(function () {
                _this.emit(ScrollType.ScrollChange, {
                    offset: offset,
                    updateThumbOffset: updateThumbOffset,
                });
            });
        };
        _this.addEventListener = function (target, eventType, callback) {
            target === null || target === void 0 ? void 0 : target.addEventListener(eventType, callback, false);
            return {
                remove: function () {
                    target === null || target === void 0 ? void 0 : target.removeEventListener(eventType, callback, false);
                },
            };
        };
        _this.addEvent = function (target, type, handler) {
            target.on(type, handler);
            _this.eventHandlers.push({ target: target, type: type, handler: handler });
        };
        _this.initScrollBar = function () {
            _this.scrollBarGroup = _this.createScrollBarGroup();
            _this.scrollBarGroup.move(_this.position.x, _this.position.y);
            _this.bindEvents();
        };
        // 创建 scrollBar 的 group
        _this.createScrollBarGroup = function () {
            var group = _this.addGroup({
                className: _this.isHorizontal ? 'horizontalBar' : 'verticalBar',
            });
            _this.trackShape = _this.createTrackShape(group);
            _this.thumbShape = _this.createThumbShape(group);
            return group;
        };
        // 创建滑道的 shape
        _this.createTrackShape = function (group) {
            var _a = _this.theme, _b = _a.lineCap, lineCap = _b === void 0 ? 'round' : _b, trackColor = _a.trackColor, size = _a.size;
            var baseAttrs = {
                lineWidth: size,
                stroke: trackColor,
                lineCap: lineCap,
            };
            if (_this.isHorizontal) {
                return group.addShape('line', {
                    attrs: __assign(__assign({}, baseAttrs), { x1: 0, y1: size / 2, x2: _this.trackLen, y2: size / 2 }),
                });
            }
            return group.addShape('line', {
                attrs: __assign(__assign({}, baseAttrs), { x1: size / 2, y1: 0, x2: size / 2, y2: _this.trackLen }),
            });
        };
        // 创建滑块的 shape
        _this.createThumbShape = function (group) {
            var _a = _this.theme, size = _a.size, _b = _a.lineCap, lineCap = _b === void 0 ? 'round' : _b, thumbColor = _a.thumbColor;
            var baseAttrs = {
                lineWidth: size,
                stroke: thumbColor,
                lineCap: lineCap,
                cursor: 'default',
            };
            if (_this.isHorizontal) {
                return group.addShape('line', {
                    attrs: __assign(__assign({}, baseAttrs), { x1: _this.thumbOffset, y1: size / 2, x2: _this.thumbOffset + _this.thumbLen, y2: size / 2 }),
                });
            }
            return group.addShape('line', {
                attrs: __assign(__assign({}, baseAttrs), { x1: size / 2, y1: _this.thumbOffset, x2: size / 2, y2: _this.thumbOffset + _this.thumbLen }),
            });
        };
        _this.bindEvents = function () {
            _this.on('mousedown', _this.onStartEvent(false));
            // 因为上层透视表交互 prevent 事件，导致 container 上的 mouseup 事件没有执行，
            // 整个拖拽过程没有 cancel 掉。
            _this.on('mouseup', _this.onMouseUp);
            _this.on('touchstart', _this.onStartEvent(true));
            _this.on('touchend', _this.onMouseUp);
            _this.trackShape.on('click', _this.onTrackClick);
            _this.thumbShape.on('mouseover', _this.onTrackMouseOver);
            _this.thumbShape.on('mouseout', _this.onTrackMouseOut);
        };
        _this.onStartEvent = function (isMobile) { return function (e) {
            e.preventDefault();
            _this.isMobile = isMobile;
            var event = _this.isMobile ? get(e, 'touches.0', e) : e;
            var clientX = event.clientX, clientY = event.clientY;
            // 将开始的点记录下来
            _this.startPos = _this.isHorizontal ? clientX : clientY;
            _this.bindLaterEvent();
        }; };
        _this.bindLaterEvent = function () {
            var canvas = _this.get('canvas');
            var containerDOM = document.body;
            var events = [];
            if (_this.isMobile) {
                events = [
                    _this.addEventListener(containerDOM, 'touchmove', _this.onMouseMove),
                    _this.addEventListener(containerDOM, 'touchend', _this.onMouseUp),
                    _this.addEventListener(containerDOM, 'touchcancel', _this.onMouseUp),
                ];
                _this.addEvent(canvas, 'touchend', _this.onMouseUp);
                _this.addEvent(canvas, 'touchcancel', _this.onMouseUp);
            }
            else {
                events = [
                    _this.addEventListener(containerDOM, 'mousemove', _this.onMouseMove),
                    _this.addEventListener(containerDOM, 'mouseup', _this.onMouseUp),
                    // 为了保证划出 canvas containerDom 时还没触发 mouseup
                    _this.addEventListener(containerDOM, 'mouseleave', _this.onMouseUp),
                ];
                _this.addEvent(canvas, 'mouseup', _this.onMouseUp);
            }
            _this.clearEvents = function () {
                events.forEach(function (e) {
                    e === null || e === void 0 ? void 0 : e.remove();
                });
                each(_this.eventHandlers, function (eh) {
                    var _a;
                    (_a = eh.target) === null || _a === void 0 ? void 0 : _a.off(eh.type, eh.handler);
                });
                _this.eventHandlers.length = 0;
            };
        };
        // 点击滑道的事件回调,移动滑块位置
        _this.onTrackClick = function (e) {
            var containerDOM = _this.get('canvas').get('container');
            var rect = containerDOM.getBoundingClientRect();
            var clientX = e.clientX, clientY = e.clientY;
            var offset = _this.isHorizontal
                ? clientX - rect.left - _this.position.x - _this.thumbLen / 2
                : clientY - rect.top - _this.position.y - _this.thumbLen / 2;
            var newOffset = _this.validateRange(offset);
            _this.updateThumbOffset(newOffset);
        };
        // 拖拽滑块的事件回调
        // 这里是 dom 原生事件，绑定在 dom 元素上的
        _this.onMouseMove = function (e) {
            e.preventDefault();
            var event = _this.isMobile ? get(e, 'touches.0', e) : e;
            var clientX = event.clientX;
            var clientY = event.clientY;
            // 鼠标松开的位置
            var endPos = _this.isHorizontal ? clientX : clientY;
            // 滑块需要移动的距离, 由于这里是对滑块监听，所以移动的距离就是 diffDis, 如果监听对象是 container dom，则需要算比例
            var diff = endPos - _this.startPos;
            // 更新 startPos
            _this.startPos = endPos;
            _this.updateThumbOffset(_this.thumbOffset + diff);
        };
        _this.onMouseUp = function (e) {
            var _a;
            _this.emit(ScrollType.ScrollEnd, {});
            e.preventDefault();
            (_a = _this.clearEvents) === null || _a === void 0 ? void 0 : _a.call(_this);
        };
        _this.onTrackMouseOver = function () {
            var _a = _this.theme, thumbHoverColor = _a.thumbHoverColor, hoverSize = _a.hoverSize;
            _this.thumbShape.attr('stroke', thumbHoverColor);
            _this.thumbShape.attr('lineWidth', hoverSize);
        };
        _this.onTrackMouseOut = function () {
            var _a = _this.theme, thumbColor = _a.thumbColor, size = _a.size;
            _this.thumbShape.attr('stroke', thumbColor);
            _this.thumbShape.attr('lineWidth', size);
        };
        // 判断滑块位置是否超出滑道区域
        _this.validateRange = function (offset) {
            var newOffset = offset;
            if (offset + _this.thumbLen > _this.trackLen) {
                newOffset = _this.trackLen - _this.thumbLen;
            }
            else if (offset + _this.thumbLen < _this.thumbLen) {
                newOffset = 0;
            }
            return newOffset;
        };
        var _a = scrollBarCfg.isHorizontal, isHorizontal = _a === void 0 ? false : _a, trackLen = scrollBarCfg.trackLen, thumbLen = scrollBarCfg.thumbLen, position = scrollBarCfg.position, _b = scrollBarCfg.minThumbLen, minThumbLen = _b === void 0 ? MIN_SCROLL_BAR_HEIGHT : _b, _c = scrollBarCfg.thumbOffset, thumbOffset = _c === void 0 ? 0 : _c, theme = scrollBarCfg.theme, scrollTargetMaxOffset = scrollBarCfg.scrollTargetMaxOffset;
        _this.isHorizontal = isHorizontal;
        _this.thumbOffset = thumbOffset;
        _this.trackLen = trackLen;
        _this.thumbLen = thumbLen;
        _this.position = position;
        _this.minThumbLen = minThumbLen;
        _this.theme = theme;
        _this.scrollTargetMaxOffset = scrollTargetMaxOffset;
        _this.initScrollBar();
        return _this;
    }
    return ScrollBar;
}(Group));

/**
 * 是否在 视窗索引范围中
 * @param x
 * @param y
 * @param indexes
 */
var isXYInRange = function (x, y, indexes) {
    var _a = __read(indexes, 4), xMin = _a[0], xMax = _a[1], yMin = _a[2], yMax = _a[3];
    return x >= xMin && x <= xMax && y >= yMin && y <= yMax;
};
var allIndexes = function (indexes) {
    var _a = __read(indexes, 4), minI = _a[0], maxI = _a[1], minJ = _a[2], maxJ = _a[3];
    var r = [];
    for (var i = minI; i <= maxI; i += 1) {
        for (var j = minJ; j <= maxJ; j += 1) {
            r.push([i, j]);
        }
    }
    return r;
};
/**
 * 计算两个 indexes 的 diff，获取 sourceIndexes -> targetIndexes 过程中新增的和移除的index
 * @param sourceIndexes
 * @param targetIndexes
 */
var diffIndexes = function (sourceIndexes, targetIndexes) {
    var add = [];
    var remove = [];
    // source 为空
    if (isEmpty(sourceIndexes)) {
        if (isEmpty(targetIndexes)) {
            // 都为空
            return { add: add, remove: remove };
        }
        // target 不为空
        return { add: allIndexes(targetIndexes), remove: remove };
    }
    // source 不为空，target 为空
    if (isEmpty(targetIndexes)) {
        return { add: add, remove: allIndexes(sourceIndexes) };
    }
    var _a = __read(sourceIndexes, 4), sourceMinI = _a[0], sourceMaxI = _a[1], sourceMinJ = _a[2], sourceMaxJ = _a[3];
    var _b = __read(targetIndexes, 4), targetMinI = _b[0], targetMaxI = _b[1], targetMinJ = _b[2], targetMaxJ = _b[3];
    // sourceIndexes -> targetIndexes 过程中，remove 掉的单元格
    for (var i = sourceMinI; i <= sourceMaxI; i++) {
        for (var j = sourceMinJ; j <= sourceMaxJ; j++) {
            if (!isXYInRange(i, j, targetIndexes)) {
                remove.push([i, j]);
            }
        }
    }
    // sourceIndexes -> targetIndexes 过程中，add 新增的单元格
    for (var i = targetMinI; i <= targetMaxI; i += 1) {
        for (var j = targetMinJ; j <= targetMaxJ; j += 1) {
            if (!isXYInRange(i, j, sourceIndexes)) {
                add.push([i, j]);
            }
        }
    }
    return {
        add: add,
        remove: remove,
    };
};
/**
 * 计算 Panel 下所有子 Group的 Indexes Diff
 */
var diffPanelIndexes = function (sourceIndexes, targetIndexes) {
    var allAdd = [];
    var allRemove = [];
    Object.keys(targetIndexes).forEach(function (key) {
        var _a = diffIndexes((sourceIndexes === null || sourceIndexes === void 0 ? void 0 : sourceIndexes[key]) || [], targetIndexes[key]), add = _a.add, remove = _a.remove;
        allAdd.push.apply(allAdd, __spreadArray([], __read(add), false));
        allRemove.push.apply(allRemove, __spreadArray([], __read(remove), false));
    });
    return {
        add: allAdd,
        remove: allRemove,
    };
};

var BaseFacet = /** @class */ (function () {
    function BaseFacet(cfg) {
        var _this = this;
        this.scrollFrameId = null;
        this.hideScrollBar = function () {
            var _a, _b, _c;
            (_a = _this.hRowScrollBar) === null || _a === void 0 ? void 0 : _a.hide();
            (_b = _this.hScrollBar) === null || _b === void 0 ? void 0 : _b.hide();
            (_c = _this.vScrollBar) === null || _c === void 0 ? void 0 : _c.hide();
        };
        this.delayHideScrollBar = debounce(this.hideScrollBar, 1000);
        this.delayHideScrollbarOnMobile = function () {
            if (isMobile()) {
                _this.delayHideScrollBar();
            }
        };
        this.showVerticalScrollBar = function () {
            var _a;
            (_a = _this.vScrollBar) === null || _a === void 0 ? void 0 : _a.show();
        };
        this.showHorizontalScrollBar = function () {
            var _a, _b;
            (_a = _this.hRowScrollBar) === null || _a === void 0 ? void 0 : _a.show();
            (_b = _this.hScrollBar) === null || _b === void 0 ? void 0 : _b.show();
        };
        this.onContainerWheel = function () {
            _this.onContainerWheelForPc();
            _this.onContainerWheelForMobile();
        };
        this.onContainerWheelForPc = function () {
            var canvas = _this.spreadsheet.container.get('el');
            canvas === null || canvas === void 0 ? void 0 : canvas.addEventListener('wheel', _this.onWheel);
        };
        this.onContainerWheelForMobile = function () {
            // mock wheel event fo mobile
            _this.mobileWheel = new Wheel(_this.spreadsheet.container);
            _this.mobileWheel.on('wheel', function (ev) {
                _this.spreadsheet.hideTooltip();
                var originEvent = ev.event;
                var deltaX = ev.deltaX, deltaY = ev.deltaY, x = ev.x, y = ev.y;
                // The coordinates of mobile and pc are three times different
                _this.onWheel(__assign(__assign({}, originEvent), { deltaX: deltaX, deltaY: deltaY, layerX: x, layerY: y }));
            });
        };
        this.bindEvents = function () {
            _this.onContainerWheel();
            _this.emitPaginationEvent();
        };
        this.setScrollOffset = function (scrollOffset) {
            Object.keys(scrollOffset).forEach(function (key) {
                var offset = scrollOffset[key];
                if (!isUndefined(offset)) {
                    _this.spreadsheet.store.set(key, Math.floor(offset));
                }
            });
        };
        this.getScrollOffset = function () {
            var store = _this.spreadsheet.store;
            return {
                scrollX: store.get('scrollX', 0),
                scrollY: store.get('scrollY', 0),
                hRowScrollX: store.get('hRowScrollX', 0),
            };
        };
        this.emitPaginationEvent = function () {
            var pagination = _this.cfg.pagination;
            if (pagination) {
                var current = pagination.current, pageSize = pagination.pageSize;
                var total = _this.viewCellHeights.getTotalLength();
                var pageCount = Math.floor((total - 1) / pageSize) + 1;
                _this.cfg.spreadsheet.emit(S2Event.LAYOUT_PAGINATION, {
                    pageSize: pageSize,
                    pageCount: pageCount,
                    total: total,
                    current: current,
                });
            }
        };
        this.unbindEvents = function () {
            var canvas = _this.spreadsheet.container.get('el');
            canvas === null || canvas === void 0 ? void 0 : canvas.removeEventListener('wheel', _this.onWheel);
            _this.mobileWheel.destroy();
        };
        this.clipPanelGroup = function () {
            var _a;
            _this.foregroundGroup = _this.spreadsheet.foregroundGroup;
            _this.backgroundGroup = _this.spreadsheet.backgroundGroup;
            _this.panelGroup = _this.spreadsheet.panelGroup;
            var _b = _this.panelBBox, width = _b.width, height = _b.height;
            (_a = _this.spreadsheet.panelScrollGroup) === null || _a === void 0 ? void 0 : _a.setClip({
                type: 'rect',
                attrs: {
                    x: 0,
                    y: _this.cornerBBox.height,
                    width: width,
                    height: height,
                },
            });
        };
        this.calculateCellWidthHeight = function () {
            var colLeafNodes = _this.layoutResult.colLeafNodes;
            var widths = reduce(colLeafNodes, function (result, node) {
                result.push(last(result) + node.width);
                return result;
            }, [0]);
            _this.viewCellWidths = widths;
            _this.viewCellHeights = _this.getViewCellHeights(_this.layoutResult);
        };
        this.getRealScrollX = function (scrollX, hRowScroll) {
            if (hRowScroll === void 0) { hRowScroll = 0; }
            return _this.cfg.spreadsheet.isScrollContainsRowHeader()
                ? scrollX
                : hRowScroll;
        };
        this.calculatePanelBBox = function () {
            _this.panelBBox = new PanelBBox(_this, true);
        };
        this.getRealWidth = function () {
            return last(_this.viewCellWidths);
        };
        this.getRealHeight = function () {
            var pagination = _this.cfg.pagination;
            var heights = _this.viewCellHeights;
            if (pagination) {
                var _a = _this.getCellRange(), start = _a.start, end = _a.end;
                return heights.getCellOffsetY(end + 1) - heights.getCellOffsetY(start);
            }
            return heights.getTotalHeight();
        };
        this.clearAllGroup = function () {
            var children = _this.panelGroup.getChildren() || [];
            for (var i = children.length - 1; i >= 0; i--) {
                var child = children[i];
                if (child instanceof Group) {
                    child.set('children', []);
                }
                else {
                    children[i].remove();
                }
            }
            _this.foregroundGroup.set('children', []);
            _this.backgroundGroup.set('children', []);
        };
        this.scrollWithAnimation = function (offsetConfig) {
            var _a = _this.getAdjustedScrollOffset({
                scrollX: offsetConfig.offsetX.value || 0,
                scrollY: offsetConfig.offsetY.value || 0,
            }), adjustedScrollX = _a.scrollX, adjustedScrollY = _a.scrollY;
            if (_this.timer) {
                _this.timer.stop();
            }
            var duration = 200;
            var oldOffset = Object.values(_this.getScrollOffset());
            var newOffset = [
                adjustedScrollX === undefined ? oldOffset[0] : adjustedScrollX,
                adjustedScrollY === undefined ? oldOffset[1] : adjustedScrollY,
            ];
            var interpolate = interpolateArray(oldOffset, newOffset);
            _this.timer = d3Timer.timer(function (elapsed) {
                var ratio = Math.min(elapsed / duration, 1);
                var _a = __read(interpolate(ratio), 2), scrollX = _a[0], scrollY = _a[1];
                _this.setScrollOffset({ scrollX: scrollX, scrollY: scrollY });
                _this.startScroll(adjustedScrollX, adjustedScrollY);
                if (elapsed > duration) {
                    _this.timer.stop();
                }
            });
        };
        this.scrollImmediately = function (offsetConfig) {
            var _a = _this.getAdjustedScrollOffset({
                scrollX: offsetConfig.offsetX.value || 0,
                scrollY: offsetConfig.offsetY.value || 0,
            }), scrollX = _a.scrollX, scrollY = _a.scrollY;
            _this.setScrollOffset({ scrollX: scrollX, scrollY: scrollY });
            _this.startScroll(scrollX, scrollY);
        };
        this.startScroll = function (newX, newY) {
            var _a, _b;
            var _c = _this.getScrollOffset(), scrollX = _c.scrollX, scrollY = _c.scrollY;
            if (newX !== undefined) {
                (_a = _this.hScrollBar) === null || _a === void 0 ? void 0 : _a.onlyUpdateThumbOffset(_this.getScrollBarOffset(scrollX, _this.hScrollBar));
            }
            if (newY !== undefined) {
                (_b = _this.vScrollBar) === null || _b === void 0 ? void 0 : _b.onlyUpdateThumbOffset(_this.getScrollBarOffset(scrollY, _this.vScrollBar));
            }
            _this.dynamicRenderCell();
        };
        this.getRendererHeight = function () {
            var _a = _this.getCellRange(), start = _a.start, end = _a.end;
            return (_this.viewCellHeights.getCellOffsetY(end + 1) -
                _this.viewCellHeights.getCellOffsetY(start));
        };
        this.getAdjustedRowScrollX = function (hRowScrollX) {
            if (hRowScrollX + _this.cornerBBox.width >= _this.cornerBBox.originalWidth) {
                return _this.cornerBBox.originalWidth - _this.cornerBBox.width;
            }
            return hRowScrollX;
        };
        this.getAdjustedScrollX = function (scrollX) {
            var colsHierarchyWidth = _this.layoutResult.colsHierarchy.width;
            var panelWidth = _this.panelBBox.width;
            if (scrollX + panelWidth >= colsHierarchyWidth &&
                colsHierarchyWidth > panelWidth) {
                return colsHierarchyWidth - panelWidth;
            }
            return Math.max(0, scrollX);
        };
        this.getAdjustedScrollY = function (scrollY) {
            var rendererHeight = _this.getRendererHeight();
            var panelHeight = _this.panelBBox.height;
            if (scrollY + panelHeight >= rendererHeight &&
                rendererHeight > panelHeight) {
                return rendererHeight - panelHeight;
            }
            // 当数据为空时，rendererHeight 可能为 0，此时 scrollY 为负值，需要调整为 0。
            if (scrollY < 0) {
                return 0;
            }
            return Math.max(0, scrollY);
        };
        this.getAdjustedScrollOffset = function (_a) {
            var scrollX = _a.scrollX, scrollY = _a.scrollY, hRowScrollX = _a.hRowScrollX;
            return {
                scrollX: _this.getAdjustedScrollX(scrollX),
                scrollY: _this.getAdjustedScrollY(scrollY),
                hRowScrollX: _this.getAdjustedRowScrollX(hRowScrollX),
            };
        };
        this.renderRowScrollBar = function (rowScrollX) {
            if (!_this.cfg.spreadsheet.isScrollContainsRowHeader() &&
                _this.cornerBBox.width < _this.cornerBBox.originalWidth) {
                var maxOffset_1 = _this.cornerBBox.originalWidth - _this.cornerBBox.width;
                var maxY = _this.getScrollbarPosition().maxY;
                var thumbLen = (_this.cornerBBox.width * _this.cornerBBox.width) /
                    _this.cornerBBox.originalWidth;
                _this.hRowScrollBar = new ScrollBar({
                    isHorizontal: true,
                    trackLen: _this.cornerBBox.width,
                    thumbLen: thumbLen,
                    position: {
                        x: _this.cornerBBox.minX + _this.scrollBarSize / 2,
                        y: maxY,
                    },
                    thumbOffset: (rowScrollX * (_this.cornerBBox.width - thumbLen)) / maxOffset_1,
                    theme: _this.scrollBarTheme,
                    scrollTargetMaxOffset: maxOffset_1,
                });
                _this.hRowScrollBar.on(ScrollType.ScrollChange, function (_a) {
                    var _b, _c;
                    var offset = _a.offset;
                    var newOffset = _this.getValidScrollBarOffset(offset, maxOffset_1);
                    var hRowScrollX = newOffset;
                    _this.setScrollOffset({ hRowScrollX: hRowScrollX });
                    (_b = _this.rowHeader) === null || _b === void 0 ? void 0 : _b.onRowScrollX(hRowScrollX, KEY_GROUP_ROW_RESIZE_AREA);
                    (_c = _this.rowIndexHeader) === null || _c === void 0 ? void 0 : _c.onRowScrollX(hRowScrollX, KEY_GROUP_ROW_INDEX_RESIZE_AREA);
                    _this.cornerHeader.onRowScrollX(hRowScrollX, KEY_GROUP_CORNER_RESIZE_AREA);
                    _this.hRowScrollBar.updateThumbOffset(_this.getScrollBarOffset(newOffset, _this.hRowScrollBar), false);
                });
                _this.foregroundGroup.add(_this.hRowScrollBar);
            }
        };
        this.getValidScrollBarOffset = function (offset, maxOffset) {
            if (offset > maxOffset) {
                return maxOffset;
            }
            if (offset < 0) {
                return 0;
            }
            return offset;
        };
        this.renderHScrollBar = function (width, realWidth, scrollX) {
            if (Math.floor(width) < Math.floor(realWidth)) {
                var halfScrollSize = _this.scrollBarSize / 2;
                var maxY = _this.getScrollbarPosition().maxY;
                var finalWidth = width +
                    (_this.cfg.spreadsheet.isScrollContainsRowHeader()
                        ? _this.cornerBBox.width
                        : 0);
                var finalPosition = {
                    x: _this.panelBBox.minX +
                        (_this.cfg.spreadsheet.isScrollContainsRowHeader()
                            ? -_this.cornerBBox.width + halfScrollSize
                            : halfScrollSize),
                    y: maxY,
                };
                var finaleRealWidth = realWidth +
                    (_this.cfg.spreadsheet.isScrollContainsRowHeader()
                        ? _this.cornerBBox.width
                        : 0);
                var maxOffset_2 = finaleRealWidth - finalWidth;
                var thumbLen = (finalWidth / finaleRealWidth) * finalWidth;
                // TODO abstract
                _this.hScrollBar = new ScrollBar({
                    isHorizontal: true,
                    trackLen: finalWidth,
                    thumbLen: thumbLen,
                    // position: this.viewport.bl,
                    position: finalPosition,
                    thumbOffset: (scrollX * (finalWidth - thumbLen)) / maxOffset_2,
                    theme: _this.scrollBarTheme,
                    scrollTargetMaxOffset: maxOffset_2,
                });
                _this.hScrollBar.on(ScrollType.ScrollChange, function (_a) {
                    var offset = _a.offset, updateThumbOffset = _a.updateThumbOffset;
                    var newScrollX = _this.getValidScrollBarOffset(offset, maxOffset_2);
                    if (updateThumbOffset) {
                        _this.hScrollBar.updateThumbOffset(_this.getScrollBarOffset(newScrollX, _this.hScrollBar), false);
                    }
                    _this.setScrollOffset({
                        scrollX: newScrollX,
                    });
                    _this.dynamicRenderCell();
                });
                _this.foregroundGroup.add(_this.hScrollBar);
            }
        };
        this.getScrollbarPosition = function () {
            var _a = _this.panelBBox, maxX = _a.maxX, maxY = _a.maxY;
            var _b = _this.getCanvasHW(), width = _b.width, height = _b.height;
            var isContentMode = _this.spreadsheet.options.interaction.scrollbarPosition ===
                ScrollbarPositionType.CONTENT;
            return {
                maxX: (isContentMode ? maxX : width) - _this.scrollBarSize,
                maxY: isContentMode ? maxY : height - _this.scrollBarSize,
            };
        };
        this.renderVScrollBar = function (height, realHeight, scrollY) {
            if (height < realHeight) {
                var thumbHeight = Math.max((height / realHeight) * height, MIN_SCROLL_BAR_HEIGHT);
                var maxOffset_3 = realHeight - height;
                var maxX = _this.getScrollbarPosition().maxX;
                _this.vScrollBar = new ScrollBar({
                    isHorizontal: false,
                    trackLen: height,
                    thumbLen: thumbHeight,
                    thumbOffset: (scrollY * (height - thumbHeight)) / maxOffset_3,
                    position: {
                        x: maxX,
                        y: _this.panelBBox.minY,
                    },
                    theme: _this.scrollBarTheme,
                    scrollTargetMaxOffset: maxOffset_3,
                });
                _this.vScrollBar.on(ScrollType.ScrollChange, function (_a) {
                    var offset = _a.offset, updateThumbOffset = _a.updateThumbOffset;
                    var newScrollY = _this.getValidScrollBarOffset(offset, maxOffset_3);
                    if (updateThumbOffset) {
                        _this.vScrollBar.updateThumbOffset(_this.getScrollBarOffset(newScrollY, _this.vScrollBar), false);
                    }
                    _this.setScrollOffset({ scrollY: newScrollY });
                    _this.dynamicRenderCell();
                });
                _this.foregroundGroup.add(_this.vScrollBar);
            }
        };
        // (滑动 offset / 最大 offset（滚动对象真正长度 - 轨道长）) = (滑块 offset / 最大滑动距离（轨道长 - 滑块长）)
        this.getScrollBarOffset = function (offset, scrollbar) {
            var trackLen = scrollbar.trackLen, thumbLen = scrollbar.thumbLen, scrollTargetMaxOffset = scrollbar.scrollTargetMaxOffset;
            return (offset * (trackLen - thumbLen)) / scrollTargetMaxOffset;
        };
        this.isScrollOverThePanelArea = function (_a) {
            var layerX = _a.layerX, layerY = _a.layerY;
            return (layerX > _this.panelBBox.minX &&
                layerX < _this.panelBBox.maxX &&
                layerY > _this.panelBBox.minY &&
                layerY < _this.panelBBox.maxY);
        };
        this.isScrollOverTheCornerArea = function (_a) {
            var layerX = _a.layerX, layerY = _a.layerY;
            return (layerX > _this.cornerBBox.minX &&
                layerX < _this.cornerBBox.maxX &&
                layerY > _this.cornerBBox.minY &&
                layerY < _this.cornerBBox.maxY + _this.panelBBox.height);
        };
        this.updateHorizontalRowScrollOffset = function (_a) {
            var _b;
            var offset = _a.offset, layerX = _a.layerX, layerY = _a.layerY;
            // 在行头区域滚动时 才更新行头水平滚动条
            if (_this.isScrollOverTheCornerArea({ layerX: layerX, layerY: layerY })) {
                (_b = _this.hRowScrollBar) === null || _b === void 0 ? void 0 : _b.emitScrollChange(offset);
            }
        };
        this.updateHorizontalScrollOffset = function (_a) {
            var _b;
            var offset = _a.offset, layerX = _a.layerX, layerY = _a.layerY;
            // 1.行头没有滚动条 2.在数值区域滚动时 才更新数值区域水平滚动条
            if (!_this.hRowScrollBar ||
                _this.isScrollOverThePanelArea({ layerX: layerX, layerY: layerY })) {
                (_b = _this.hScrollBar) === null || _b === void 0 ? void 0 : _b.emitScrollChange(offset);
            }
        };
        this.isScrollToLeft = function (deltaX) {
            if (!_this.hScrollBar) {
                return true;
            }
            var isScrollRowHeaderToLeft = !_this.hRowScrollBar || _this.hRowScrollBar.thumbOffset <= 0;
            var isScrollPanelToLeft = deltaX <= 0 && _this.hScrollBar.thumbOffset <= 0;
            return isScrollPanelToLeft && isScrollRowHeaderToLeft;
        };
        this.isScrollToRight = function (deltaX) {
            var _a, _b;
            if (!_this.hScrollBar) {
                return true;
            }
            var viewportWidth = _this.spreadsheet.isFrozenRowHeader()
                ? (_a = _this.panelBBox) === null || _a === void 0 ? void 0 : _a.width
                : (_b = _this.panelBBox) === null || _b === void 0 ? void 0 : _b.maxX;
            var isScrollRowHeaderToRight = !_this.hRowScrollBar ||
                _this.hRowScrollBar.thumbOffset + _this.hRowScrollBar.thumbLen >=
                    _this.cornerBBox.width;
            var isScrollPanelToRight = _this.hScrollBar.thumbOffset + _this.hScrollBar.thumbLen >= viewportWidth;
            return deltaX >= 0 && isScrollPanelToRight && isScrollRowHeaderToRight;
        };
        this.isScrollToTop = function (deltaY) {
            var _a;
            if (!_this.vScrollBar) {
                return true;
            }
            return deltaY <= 0 && ((_a = _this.vScrollBar) === null || _a === void 0 ? void 0 : _a.thumbOffset) <= 0;
        };
        this.isScrollToBottom = function (deltaY) {
            var _a, _b, _c;
            if (!_this.vScrollBar) {
                return true;
            }
            return (deltaY >= 0 &&
                ((_a = _this.vScrollBar) === null || _a === void 0 ? void 0 : _a.thumbOffset) + ((_b = _this.vScrollBar) === null || _b === void 0 ? void 0 : _b.thumbLen) >=
                    ((_c = _this.panelBBox) === null || _c === void 0 ? void 0 : _c.height));
        };
        this.isVerticalScrollOverTheViewport = function (deltaY) {
            return !_this.isScrollToTop(deltaY) && !_this.isScrollToBottom(deltaY);
        };
        this.isHorizontalScrollOverTheViewport = function (deltaX) {
            return !_this.isScrollToLeft(deltaX) && !_this.isScrollToRight(deltaX);
        };
        /**
          在当前表格滚动分两种情况:
          1. 当前表格无滚动条: 无需阻止外部容器滚动
          2. 当前表格有滚动条:
            - 未滚动到顶部或底部: 当前表格滚动, 阻止外部容器滚动
            - 滚动到顶部或底部: 恢复外部容器滚动
        */
        this.isScrollOverTheViewport = function (deltaX, deltaY, layerY) {
            var isScrollOverTheHeader = layerY <= _this.cornerBBox.maxY;
            // 光标在角头或列头时, 不触发表格自身滚动
            if (isScrollOverTheHeader) {
                return false;
            }
            if (deltaY !== 0) {
                return _this.isVerticalScrollOverTheViewport(deltaY);
            }
            if (deltaX !== 0) {
                return _this.isHorizontalScrollOverTheViewport(deltaX);
            }
            return false;
        };
        this.cancelScrollFrame = function () {
            if (isMobile() && _this.scrollFrameId) {
                return false;
            }
            cancelAnimationFrame(_this.scrollFrameId);
            return true;
        };
        this.clearScrollFrameIdOnMobile = function () {
            if (isMobile()) {
                _this.scrollFrameId = null;
            }
        };
        this.onWheel = function (event) {
            var _a;
            var ratio = _this.spreadsheet.options.interaction.scrollSpeedRatio;
            var deltaX = event.deltaX, deltaY = event.deltaY, layerX = event.layerX, layerY = event.layerY;
            var _b = __read(optimizeScrollXY(deltaX, deltaY, ratio), 2), optimizedDeltaX = _b[0], optimizedDeltaY = _b[1];
            _this.spreadsheet.hideTooltip();
            _this.spreadsheet.interaction.clearHoverTimer();
            if (!_this.isScrollOverTheViewport(optimizedDeltaX, optimizedDeltaY, layerY)) {
                return;
            }
            (_a = event === null || event === void 0 ? void 0 : event.preventDefault) === null || _a === void 0 ? void 0 : _a.call(event);
            _this.spreadsheet.interaction.addIntercepts([InterceptType.HOVER]);
            if (!_this.cancelScrollFrame()) {
                return;
            }
            _this.scrollFrameId = requestAnimationFrame(function () {
                var _a;
                var _b = _this.getScrollOffset(), currentScrollX = _b.scrollX, currentScrollY = _b.scrollY, hRowScrollX = _b.hRowScrollX;
                if (optimizedDeltaX !== 0) {
                    _this.showHorizontalScrollBar();
                    _this.updateHorizontalRowScrollOffset({
                        layerX: layerX,
                        layerY: layerY,
                        offset: optimizedDeltaX + hRowScrollX,
                    });
                    _this.updateHorizontalScrollOffset({
                        layerX: layerX,
                        layerY: layerY,
                        offset: optimizedDeltaX + currentScrollX,
                    });
                }
                if (optimizedDeltaY !== 0) {
                    _this.showVerticalScrollBar();
                    (_a = _this.vScrollBar) === null || _a === void 0 ? void 0 : _a.emitScrollChange(optimizedDeltaY + currentScrollY);
                }
                _this.delayHideScrollbarOnMobile();
                _this.clearScrollFrameIdOnMobile();
            });
        };
        this.addCell = function (cell) {
            var panelScrollGroup = _this.spreadsheet.panelScrollGroup;
            panelScrollGroup === null || panelScrollGroup === void 0 ? void 0 : panelScrollGroup.add(cell);
        };
        this.realCellRender = function (scrollX, scrollY) {
            var indexes = _this.calculateXYIndexes(scrollX, scrollY);
            DebuggerUtil.getInstance().logger('renderIndex:', _this.preCellIndexes, indexes);
            var _a = diffPanelIndexes(_this.preCellIndexes, indexes), add = _a.add, remove = _a.remove;
            DebuggerUtil.getInstance().debugCallback(DEBUG_VIEW_RENDER, function () {
                // add new cell in panelCell
                each(add, function (_a) {
                    var _b = __read(_a, 2), i = _b[0], j = _b[1];
                    var viewMeta = _this.layoutResult.getCellMeta(j, i);
                    if (viewMeta) {
                        var cell = _this.cfg.dataCell(viewMeta);
                        // mark cell for removing
                        cell.set('name', "".concat(i, "-").concat(j));
                        _this.addCell(cell);
                    }
                });
                var allCells = getAllChildCells(_this.panelGroup.getChildren(), DataCell);
                // remove cell from panelCell
                each(remove, function (_a) {
                    var _b = __read(_a, 2), i = _b[0], j = _b[1];
                    var findOne = find(allCells, function (cell) { return cell.get('name') === "".concat(i, "-").concat(j); });
                    findOne === null || findOne === void 0 ? void 0 : findOne.remove(true);
                });
                updateMergedCells(_this.spreadsheet);
                DebuggerUtil.getInstance().logger("Render Cell Panel: ".concat(allCells === null || allCells === void 0 ? void 0 : allCells.length, ", Add: ").concat(add === null || add === void 0 ? void 0 : add.length, ", Remove: ").concat(remove === null || remove === void 0 ? void 0 : remove.length));
            });
            _this.preCellIndexes = indexes;
        };
        /**
         * How long about the delay period, need be re-considered,
         * for now only delay, oppose to immediately
         * @private
         */
        this.debounceRenderCell = function (scrollX, scrollY) {
            _this.realCellRender(scrollX, scrollY);
        };
        this.onAfterScroll = debounce(function () {
            var interaction = _this.spreadsheet.interaction;
            // 如果是选中单元格状态, 则继续保留 hover 拦截, 避免滚动后 hover 清空已选单元格
            if (!interaction.isSelectedState()) {
                _this.spreadsheet.interaction.removeIntercepts([InterceptType.HOVER]);
            }
        }, 300);
        this.cfg = cfg;
        this.spreadsheet = cfg.spreadsheet;
        this.init();
    }
    Object.defineProperty(BaseFacet.prototype, "scrollBarTheme", {
        get: function () {
            return this.spreadsheet.theme.scrollBar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseFacet.prototype, "scrollBarSize", {
        get: function () {
            return this.scrollBarTheme.size;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Start render, call from outside
     */
    BaseFacet.prototype.render = function () {
        this.adjustScrollOffset();
        this.renderHeaders();
        this.renderScrollBars();
        this.renderBackground();
        this.dynamicRenderCell(false);
    };
    /**
     * 在每次render, 校验scroll offset是否在合法范围中
     * 比如在滚动条已经滚动到100%的状态的前提下：（ maxAvailableScrollOffsetX = colsHierarchy.width - viewportBBox.width ）
     *     此时changeSize，sheet从 small width 变为 big width
     *     导致后者 viewport 区域更大，其结果就是后者的 maxAvailableScrollOffsetX 更小
     *     此时就需要重置 scrollOffsetX，否则就会导致滚动过多，出现空白区域
     */
    BaseFacet.prototype.adjustScrollOffset = function () {
        var _a = this.getAdjustedScrollOffset(this.getScrollOffset()), scrollX = _a.scrollX, scrollY = _a.scrollY, hRowScrollX = _a.hRowScrollX;
        this.setScrollOffset({
            scrollX: scrollX,
            scrollY: scrollY,
            hRowScrollX: hRowScrollX,
        });
    };
    BaseFacet.prototype.getSeriesNumberWidth = function () {
        var showSeriesNumber = this.cfg.showSeriesNumber;
        return showSeriesNumber
            ? this.spreadsheet.theme.rowCell.seriesNumberWidth
            : 0;
    };
    BaseFacet.prototype.getCanvasHW = function () {
        return {
            width: this.cfg.width,
            height: this.cfg.height,
        };
    };
    BaseFacet.prototype.getContentHeight = function () {
        var _a = this.layoutResult, rowsHierarchy = _a.rowsHierarchy, colsHierarchy = _a.colsHierarchy;
        return rowsHierarchy.height + colsHierarchy.height;
    };
    BaseFacet.prototype.updateScrollOffset = function (offsetConfig) {
        if (offsetConfig.offsetX.value !== undefined) {
            if (offsetConfig.offsetX.animate) {
                this.scrollWithAnimation(offsetConfig);
            }
            else {
                this.scrollImmediately(offsetConfig);
            }
            return;
        }
        if (offsetConfig.offsetY.value !== undefined) {
            if (offsetConfig.offsetY.animate) {
                this.scrollWithAnimation(offsetConfig);
            }
            else {
                this.scrollImmediately(offsetConfig);
            }
        }
    };
    BaseFacet.prototype.getPaginationScrollY = function () {
        var pagination = this.cfg.pagination;
        if (pagination) {
            var current = pagination.current, pageSize = pagination.pageSize;
            var heights = this.viewCellHeights;
            var offset = Math.max((current - 1) * pageSize, 0);
            return heights.getCellOffsetY(offset);
        }
        return 0;
    };
    BaseFacet.prototype.destroy = function () {
        this.unbindEvents();
        this.clearAllGroup();
        this.preCellIndexes = null;
        cancelAnimationFrame(this.scrollFrameId);
    };
    /**
     * The purpose of this rewrite is to take into account that when rowHeader supports scrollbars
     the panel viewable area must vary with the horizontal distance of the scroll
     * @param scrollX
     * @param scrollY
     * @public
     */
    BaseFacet.prototype.calculateXYIndexes = function (scrollX, scrollY) {
        var _a = this.panelBBox, height = _a.viewportHeight, width = _a.viewportWidth;
        var indexes = calculateInViewIndexes(scrollX, scrollY, this.viewCellWidths, this.viewCellHeights, {
            width: width,
            height: height,
            x: 0,
            y: 0,
        }, this.getRealScrollX(this.cornerBBox.width));
        return {
            center: indexes,
        };
    };
    BaseFacet.prototype.calculateCornerBBox = function () {
        this.cornerBBox = new CornerBBox(this, true);
    };
    BaseFacet.prototype.getCellRange = function () {
        var pagination = this.cfg.pagination;
        return getCellRange(this.viewCellHeights, pagination);
    };
    BaseFacet.prototype.clip = function (scrollX, scrollY) {
        var _a;
        var isFrozenRowHeader = this.cfg.spreadsheet.isFrozenRowHeader();
        (_a = this.spreadsheet.panelScrollGroup) === null || _a === void 0 ? void 0 : _a.setClip({
            type: 'rect',
            attrs: {
                x: isFrozenRowHeader ? scrollX : 0,
                y: scrollY,
                width: this.panelBBox.width + (isFrozenRowHeader ? 0 : scrollX),
                height: this.panelBBox.height,
            },
        });
    };
    /**
     * Translate panelGroup, rowHeader, cornerHeader, columnHeader ect
     * according to new scroll offset
     * @param scrollX
     * @param scrollY
     * @param hRowScroll
     * @protected
     */
    BaseFacet.prototype.translateRelatedGroups = function (scrollX, scrollY, hRowScroll) {
        var _a, _b;
        translateGroup(this.spreadsheet.panelScrollGroup, this.cornerBBox.width - scrollX, this.cornerBBox.height - scrollY);
        (_a = this.rowHeader) === null || _a === void 0 ? void 0 : _a.onScrollXY(this.getRealScrollX(scrollX, hRowScroll), scrollY, KEY_GROUP_ROW_RESIZE_AREA);
        (_b = this.rowIndexHeader) === null || _b === void 0 ? void 0 : _b.onScrollXY(this.getRealScrollX(scrollX, hRowScroll), scrollY, KEY_GROUP_ROW_INDEX_RESIZE_AREA);
        this.cornerHeader.onCorScroll(this.getRealScrollX(scrollX, hRowScroll), KEY_GROUP_CORNER_RESIZE_AREA);
        this.centerFrame.onChangeShadowVisibility(scrollX, this.getRealWidth() - this.panelBBox.width);
        this.centerFrame.onBorderScroll(this.getRealScrollX(scrollX));
        this.columnHeader.onColScroll(scrollX, KEY_GROUP_COL_RESIZE_AREA);
    };
    BaseFacet.prototype.init = function () {
        var _this = this;
        // layout
        DebuggerUtil.getInstance().debugCallback(DEBUG_HEADER_LAYOUT, function () {
            _this.layoutResult = _this.doLayout();
            _this.spreadsheet.emit(S2Event.LAYOUT_AFTER_HEADER_LAYOUT, _this.layoutResult);
        });
        // all cell's width&height
        this.calculateCellWidthHeight();
        this.calculateCornerBBox();
        this.calculatePanelBBox();
        this.clipPanelGroup();
        this.bindEvents();
    };
    BaseFacet.prototype.renderBackground = function () {
        var _a = this.getCanvasHW(), width = _a.width, height = _a.height;
        var color = get(this.cfg, 'spreadsheet.theme.background.color');
        var opacity = get(this.cfg, 'spreadsheet.theme.background.opacity');
        this.backgroundGroup.addShape('rect', {
            attrs: {
                fill: color,
                opacity: opacity,
                x: 0,
                y: 0,
                width: width,
                height: height,
            },
        });
    };
    /**
     * Render all scrollbars, default horizontal scrollbar only control viewport
     * area(it means not contains row header)
     * 1. individual row scrollbar
     * 2. horizontal scroll bar(can control whether contains row header)
     * 3. vertical scroll bar
     */
    BaseFacet.prototype.renderScrollBars = function () {
        var _a = this.getScrollOffset(), scrollX = _a.scrollX, scrollY = _a.scrollY, hRowScrollX = _a.hRowScrollX;
        var _b = this.panelBBox, width = _b.width, height = _b.height;
        var realWidth = this.layoutResult.colsHierarchy.width;
        var realHeight = this.getRealHeight();
        // scroll row header separate from the whole canvas
        this.renderRowScrollBar(hRowScrollX);
        // render horizontal scroll bar(default not contains row header)
        this.renderHScrollBar(width, realWidth, scrollX);
        // render vertical scroll bar
        this.renderVScrollBar(height, realHeight, scrollY);
    };
    /**
     * Render all headers in {@link #foregroundGroup}, contains:
     * 1. row header
     * 2. col header
     * 3. center frame
     * 4. corner header
     * 5. series number header
     */
    BaseFacet.prototype.renderHeaders = function () {
        var seriesNumberWidth = this.getSeriesNumberWidth();
        this.rowHeader = this.getRowHeader();
        this.columnHeader = this.getColHeader();
        if (seriesNumberWidth > 0 && !this.rowIndexHeader) {
            this.rowIndexHeader = this.getSeriesNumberHeader();
        }
        this.cornerHeader = this.getCornerHeader();
        this.centerFrame = this.getCenterFrame();
        if (this.rowIndexHeader) {
            this.foregroundGroup.add(this.rowIndexHeader);
        }
        if (this.rowHeader) {
            this.foregroundGroup.add(this.rowHeader);
        }
        this.foregroundGroup.add(this.columnHeader);
        this.foregroundGroup.add(this.cornerHeader);
        this.foregroundGroup.add(this.centerFrame);
    };
    BaseFacet.prototype.getRowHeader = function () {
        var _a, _b, _c;
        if (!this.rowHeader) {
            var _d = this.panelBBox, y = _d.y, viewportHeight = _d.viewportHeight, viewportWidth = _d.viewportWidth, height = _d.height;
            var seriesNumberWidth = this.getSeriesNumberWidth();
            return new RowHeader({
                width: this.cornerBBox.width,
                height: height,
                viewportWidth: viewportWidth,
                viewportHeight: viewportHeight,
                position: { x: 0, y: y },
                data: this.layoutResult.rowNodes,
                hierarchyType: this.cfg.hierarchyType,
                linkFields: (_c = (_b = (_a = this.cfg.spreadsheet.options) === null || _a === void 0 ? void 0 : _a.interaction) === null || _b === void 0 ? void 0 : _b.linkFields) !== null && _c !== void 0 ? _c : [],
                seriesNumberWidth: seriesNumberWidth,
                spreadsheet: this.spreadsheet,
            });
        }
        return this.rowHeader;
    };
    BaseFacet.prototype.getColHeader = function () {
        var _this = this;
        if (!this.columnHeader) {
            var _a = this.panelBBox, x = _a.x, width = _a.width, viewportHeight = _a.viewportHeight, viewportWidth = _a.viewportWidth;
            return new ColHeader({
                width: width,
                cornerWidth: this.cornerBBox.width,
                height: this.cornerBBox.height,
                viewportWidth: viewportWidth,
                viewportHeight: viewportHeight,
                position: { x: x, y: 0 },
                data: this.layoutResult.colNodes,
                scrollContainsRowHeader: this.cfg.spreadsheet.isScrollContainsRowHeader(),
                formatter: function (field) {
                    return _this.cfg.dataSet.getFieldFormatter(field);
                },
                sortParam: this.cfg.spreadsheet.store.get('sortParam'),
                spreadsheet: this.spreadsheet,
            });
        }
        return this.columnHeader;
    };
    BaseFacet.prototype.getCornerHeader = function () {
        if (!this.cornerHeader) {
            return CornerHeader.getCornerHeader(this.panelBBox, this.cornerBBox, this.getSeriesNumberWidth(), this.cfg, this.layoutResult, this.spreadsheet);
        }
        return this.cornerHeader;
    };
    BaseFacet.prototype.getSeriesNumberHeader = function () {
        return SeriesNumberHeader.getSeriesNumberHeader(this.panelBBox, this.getSeriesNumberWidth(), this.layoutResult.rowsHierarchy.getNodes(0), this.spreadsheet, this.cornerBBox.width);
    };
    BaseFacet.prototype.getCenterFrame = function () {
        var _a;
        if (!this.centerFrame) {
            var _b = this.panelBBox, viewportWidth = _b.viewportWidth, viewportHeight = _b.viewportHeight;
            var cornerWidth = this.cornerBBox.width;
            var cornerHeight = this.cornerBBox.height;
            var frame = (_a = this.cfg) === null || _a === void 0 ? void 0 : _a.frame;
            var frameCfg = {
                position: {
                    x: this.cornerBBox.x,
                    y: this.cornerBBox.y,
                },
                width: cornerWidth,
                height: cornerHeight,
                viewportWidth: viewportWidth,
                viewportHeight: viewportHeight,
                showViewportLeftShadow: false,
                showViewportRightShadow: false,
                scrollContainsRowHeader: this.cfg.spreadsheet.isScrollContainsRowHeader(),
                isPivotMode: this.cfg.spreadsheet.isPivotMode(),
                spreadsheet: this.cfg.spreadsheet,
            };
            return frame ? frame(frameCfg) : new Frame(frameCfg);
        }
        return this.centerFrame;
    };
    /**
     * When scroll behavior happened, only render one time in a period,
     * but render immediately in initiate
     * @param delay debounce render cell
     * @protected
     */
    BaseFacet.prototype.dynamicRenderCell = function (delay) {
        if (delay === void 0) { delay = true; }
        var _a = this.getScrollOffset(), scrollX = _a.scrollX, sy = _a.scrollY, hRowScrollX = _a.hRowScrollX;
        var scrollY = sy + this.getPaginationScrollY();
        var maxScrollY = Math.max(0, this.viewCellHeights.getTotalHeight() - this.panelBBox.viewportHeight);
        if (scrollY > maxScrollY) {
            scrollY = maxScrollY;
        }
        if (delay) {
            this.debounceRenderCell(scrollX, scrollY);
        }
        else {
            this.realCellRender(scrollX, scrollY);
        }
        this.translateRelatedGroups(scrollX, scrollY, hRowScrollX);
        this.clip(scrollX, scrollY);
        this.spreadsheet.emit(S2Event.LAYOUT_CELL_SCROLL, { scrollX: scrollX, scrollY: scrollY });
        this.onAfterScroll();
    };
    BaseFacet.prototype.saveInitColumnNodes = function (columnNodes) {
        if (columnNodes === void 0) { columnNodes = []; }
        var store = this.spreadsheet.store;
        var initColumnNodes = store.get('initColumnNodes', []);
        if (initColumnNodes.length !== columnNodes.length) {
            store.set('initColumnNodes', columnNodes);
        }
    };
    return BaseFacet;
}());

var getSubTotalNodeWidthOrHeightByLevel = function (sampleNodesForAllLevels, level, key) {
    return sampleNodesForAllLevels
        .filter(function (node) { return node.level >= level; })
        .map(function (value) { return value[key]; })
        .reduce(function (sum, current) { return sum + current; }, 0);
};
/**
 * 根据视窗高度计算需要展示的数据数组下标
 * 如有2个节点，每个高度30
 * @param heights 所有单元格的高度偏移量数组 [0, 30, 60]
 * @param minHeight 视窗高度起点
 * @param maxHeight 视窗高度终点
 * @returns
 */
var getIndexRangeWithOffsets = function (heights, minHeight, maxHeight) {
    var yMin = findIndex(heights, function (height, idx) {
        var y = minHeight;
        return y >= height && y < heights[idx + 1];
    }, 0);
    yMin = Math.max(yMin, 0);
    var yMax = findIndex(heights, function (height, idx) {
        var y = maxHeight;
        return y > height && y <= heights[idx + 1];
    }, yMin);
    yMax = Math.min(yMax === -1 ? Infinity : yMax, heights.length - 2);
    return {
        start: yMin,
        end: yMax,
    };
};

var addTotals = function (spreadsheet, currentField, fieldValues) {
    var totalsConfig = spreadsheet.getTotalsConfig(currentField);
    // tree mode only has grand totals, but if there are subTotals configs,
    // it will display in cross-area cell
    // TODO valueInCol = false and one or more values
    if (totalsConfig.showGrandTotals) {
        var func = totalsConfig.reverseLayout ? 'unshift' : 'push';
        fieldValues[func](new TotalClass(totalsConfig.label, false, true));
    }
};
/**
 * Only row header has tree hierarchy, in this scene:
 * 1、value in rows is not work => valueInCols is ineffective
 * 2、can't add extra sub total node in row
 * @param params
 */
var buildRowTreeHierarchy = function (params) {
    var e_1, _a, _b;
    var _c, _d, _e;
    var parentNode = params.parentNode, currentField = params.currentField, level = params.level, facetCfg = params.facetCfg, hierarchy = params.hierarchy, pivotMeta = params.pivotMeta;
    var spreadsheet = facetCfg.spreadsheet, dataSet = facetCfg.dataSet, collapsedRows = facetCfg.collapsedRows, hierarchyCollapse = facetCfg.hierarchyCollapse;
    var query = parentNode.query, id = parentNode.id;
    var isDrillDownItem = ((_c = spreadsheet.dataCfg.fields.rows) === null || _c === void 0 ? void 0 : _c.length) <= level;
    var sortedDimensionValues = ((_e = (_d = dataSet) === null || _d === void 0 ? void 0 : _d.sortedDimensionValues) === null || _e === void 0 ? void 0 : _e[currentField]) || [];
    var dimensions = sortedDimensionValues === null || sortedDimensionValues === void 0 ? void 0 : sortedDimensionValues.filter(function (item) {
        return item === null || item === void 0 ? void 0 : item.includes(id === null || id === void 0 ? void 0 : id.split("".concat(ROOT_ID).concat(ID_SEPARATOR))[1]);
    });
    var dimValues = filterUndefined(getListBySorted(__spreadArray([], __read((pivotMeta.keys() || [])), false), __spreadArray([], __read(getDimensionsWithoutPathPre(dimensions)), false)));
    var fieldValues = layoutArrange(dimValues, facetCfg, parentNode, currentField);
    // limit displayed drill down data by drillItemsNum
    var drillItemsNum = spreadsheet.store.get('drillItemsNum');
    if (drillItemsNum && isDrillDownItem) {
        fieldValues = fieldValues.slice(0, drillItemsNum);
    }
    if (level === 0) {
        addTotals(spreadsheet, currentField, fieldValues);
    }
    try {
        for (var fieldValues_1 = __values(fieldValues), fieldValues_1_1 = fieldValues_1.next(); !fieldValues_1_1.done; fieldValues_1_1 = fieldValues_1.next()) {
            var fieldValue = fieldValues_1_1.value;
            var isTotals = fieldValue instanceof TotalClass;
            var pivotMetaValue = isTotals
                ? null
                : pivotMeta.get(fieldValue);
            var value = void 0;
            var nodeQuery = query;
            var isGrandTotals = false;
            var isSubTotals = false;
            if (isTotals) {
                var totalClass = fieldValue;
                isGrandTotals = totalClass.isGrandTotals;
                isSubTotals = totalClass.isSubTotals;
                value = i18n(fieldValue.label);
                nodeQuery = query;
            }
            else {
                value = fieldValue;
                nodeQuery = __assign(__assign({}, query), (_b = {}, _b[currentField] = value, _b));
            }
            var uniqueId = generateId(parentNode.id, value);
            var isCollapsedRow = get(collapsedRows, uniqueId);
            var isCollapse = isCollapsedRow !== null && isCollapsedRow !== void 0 ? isCollapsedRow : hierarchyCollapse;
            var node = new Node({
                id: uniqueId,
                key: currentField,
                label: value,
                value: value,
                level: level,
                parent: parentNode,
                field: currentField,
                isTotals: isTotals,
                isGrandTotals: isGrandTotals,
                isSubTotals: isSubTotals,
                isCollapsed: isCollapse,
                hierarchy: hierarchy,
                query: nodeQuery,
                spreadsheet: spreadsheet,
            });
            if (level > hierarchy.maxLevel) {
                hierarchy.maxLevel = level;
            }
            var emptyChildren = isEmpty(pivotMetaValue === null || pivotMetaValue === void 0 ? void 0 : pivotMetaValue.children);
            if (emptyChildren || isTotals) {
                node.isLeaf = true;
            }
            if (!emptyChildren) {
                node.isTotals = true;
            }
            var expandCurrentNode = layoutHierarchy(facetCfg, parentNode, node, hierarchy);
            if (!emptyChildren && !isCollapse && !isTotals && expandCurrentNode) {
                buildRowTreeHierarchy({
                    level: level + 1,
                    currentField: pivotMetaValue.childField,
                    pivotMeta: pivotMetaValue.children,
                    facetCfg: facetCfg,
                    parentNode: node,
                    hierarchy: hierarchy,
                });
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (fieldValues_1_1 && !fieldValues_1_1.done && (_a = fieldValues_1.return)) _a.call(fieldValues_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
};

/**
 * 自定义🌲结构设计原则：
 * 1、渲染的节点全部跟着定义的数据结构走，如果需要结构变（数据挂父节点）等场景，建议直接改
 * 传入的customTreeItems配置
 * 2、没有总计小计的概念，如果有类似的，建议也是直接改customTreeItems配置
 * 3、是否展开和收起完全由 customTreeItem.collapsed 来控制（默认都展开）
 * @param params
 */
var buildRowCustomTreeHierarchy = function (params) {
    var e_1, _a, _b;
    var facetCfg = params.facetCfg, _c = params.customTreeItems, customTreeItems = _c === void 0 ? [] : _c, level = params.level, parentNode = params.parentNode, hierarchy = params.hierarchy;
    var spreadsheet = facetCfg.spreadsheet, collapsedRows = facetCfg.collapsedRows, hierarchyCollapse = facetCfg.hierarchyCollapse;
    try {
        for (var customTreeItems_1 = __values(customTreeItems), customTreeItems_1_1 = customTreeItems_1.next(); !customTreeItems_1_1.done; customTreeItems_1_1 = customTreeItems_1.next()) {
            var customTreeItem = customTreeItems_1_1.value;
            var key = customTreeItem.key, title = customTreeItem.title, collapsed = customTreeItem.collapsed, children = customTreeItem.children, rest = __rest(customTreeItem, ["key", "title", "collapsed", "children"]);
            // query只与值本身有关，不会涉及到parent节点
            var valueQuery = (_b = {}, _b[EXTRA_FIELD] = key, _b);
            // 保持和其他场景头部生成id的格式一致
            var uniqueId = generateId(parentNode.id, title);
            var defaultCollapsed = collapsed !== null && collapsed !== void 0 ? collapsed : false;
            var isCollapsedRow = get(collapsedRows, uniqueId);
            var isCollapsed = isCollapsedRow !== null && isCollapsedRow !== void 0 ? isCollapsedRow : (hierarchyCollapse || defaultCollapsed);
            var node = new Node({
                id: uniqueId,
                key: key,
                label: title,
                value: title,
                level: level,
                parent: parentNode,
                field: key,
                isTotals: false,
                isCollapsed: isCollapsed,
                hierarchy: hierarchy,
                query: valueQuery,
                spreadsheet: spreadsheet,
                extra: rest,
            });
            if (level > hierarchy.maxLevel) {
                hierarchy.maxLevel = level;
            }
            if (isEmpty(children)) {
                node.isLeaf = true;
            }
            var expandCurrentNode = layoutHierarchy(facetCfg, parentNode, node, hierarchy);
            // go recursive
            if (!isEmpty(children) && !isCollapsed && expandCurrentNode) {
                buildRowCustomTreeHierarchy({
                    facetCfg: facetCfg,
                    parentNode: node,
                    level: level + 1,
                    hierarchy: hierarchy,
                    customTreeItems: children,
                });
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (customTreeItems_1_1 && !customTreeItems_1_1.done && (_a = customTreeItems_1.return)) _a.call(customTreeItems_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
};

var handleGridRowColHierarchy = function (params) {
    var isValueInCols = params.isValueInCols, moreThanOneValue = params.moreThanOneValue, rootNode = params.rootNode, facetCfg = params.facetCfg, hierarchy = params.hierarchy, fields = params.fields, isRowHeader = params.isRowHeader;
    // add new total measure in total node
    var addTotalMeasureInTotal;
    // add measure info in total query
    var addMeasureInTotalQuery;
    if (isRowHeader) {
        addTotalMeasureInTotal = !isValueInCols && moreThanOneValue;
        addMeasureInTotalQuery = !isValueInCols && !moreThanOneValue;
    }
    else {
        addTotalMeasureInTotal = isValueInCols && moreThanOneValue;
        addMeasureInTotalQuery = isValueInCols && !moreThanOneValue;
    }
    buildGridHierarchy({
        addTotalMeasureInTotal: addTotalMeasureInTotal,
        addMeasureInTotalQuery: addMeasureInTotalQuery,
        parentNode: rootNode,
        currentField: fields[0],
        fields: fields,
        facetCfg: facetCfg,
        hierarchy: hierarchy,
    });
};
var handleCustomTreeRowHierarchy = function (params) {
    var facetCfg = params.facetCfg, rootNode = params.rootNode, hierarchy = params.hierarchy;
    var customTreeItems = facetCfg.dataSet.fields.customTreeItems;
    // row custom tree header
    buildRowCustomTreeHierarchy({
        customTreeItems: customTreeItems,
        facetCfg: facetCfg,
        level: 0,
        parentNode: rootNode,
        hierarchy: hierarchy,
    });
};
var handleTreeRowHierarchy = function (params) {
    var facetCfg = params.facetCfg, rootNode = params.rootNode, hierarchy = params.hierarchy;
    var hierarchyType = facetCfg.hierarchyType, rows = facetCfg.rows, dataSet = facetCfg.dataSet;
    if (hierarchyType === 'tree') {
        // row tree hierarchy(value must stay in colHeader)
        buildRowTreeHierarchy({
            level: 0,
            currentField: rows[0],
            pivotMeta: dataSet.rowPivotMeta,
            facetCfg: facetCfg,
            parentNode: rootNode,
            hierarchy: hierarchy,
        });
    }
    else {
        handleCustomTreeRowHierarchy(params);
    }
};
var handleRowHeaderHierarchy = function (params) {
    // 只有透视表有行头
    var spreadsheet = params.spreadsheet;
    if (spreadsheet.isHierarchyTreeType()) {
        handleTreeRowHierarchy(params);
    }
    else {
        handleGridRowColHierarchy(params);
    }
};
var handleColHeaderHierarchy = function (params) {
    var isPivotMode = params.isPivotMode, hierarchy = params.hierarchy, rootNode = params.rootNode, facetCfg = params.facetCfg;
    if (isPivotMode) {
        handleGridRowColHierarchy(params);
    }
    else {
        buildTableHierarchy({
            parentNode: rootNode,
            hierarchy: hierarchy,
            facetCfg: facetCfg,
        });
    }
};
/**
 * Header Hierarchy
 * - row header
 *   - tree layout
 *     - custom tree layout
 *   - grid layout
 *   - table layout
 * - col header
 *   - grid layout
 *     - single value
 *       - total + sub_total
 *     - more than one value
 *       - total + sub_total
 *         - separate by values
 *   - table layout
 * @param params
 */
var buildHeaderHierarchy = function (params) {
    var isRowHeader = params.isRowHeader, facetCfg = params.facetCfg;
    var spreadsheet = facetCfg.spreadsheet, _a = facetCfg.rows, rows = _a === void 0 ? [] : _a, _b = facetCfg.columns, columns = _b === void 0 ? [] : _b;
    var isValueInCols = spreadsheet.dataCfg.fields.valueInCols;
    var isPivotMode = spreadsheet.isPivotMode();
    var moreThanOneValue = facetCfg.dataSet.moreThanOneValue();
    var rootNode = Node.rootNode();
    var hierarchy = new Hierarchy();
    var headParams = {
        isValueInCols: isValueInCols,
        isPivotMode: isPivotMode,
        moreThanOneValue: moreThanOneValue,
        rootNode: rootNode,
        hierarchy: hierarchy,
        spreadsheet: spreadsheet,
        facetCfg: facetCfg,
        fields: isRowHeader ? rows : columns,
        isRowHeader: isRowHeader,
    };
    if (isRowHeader) {
        handleRowHeaderHierarchy(headParams);
    }
    else {
        handleColHeaderHierarchy(headParams);
    }
    var getLeafNodes = function () {
        if (!isRowHeader)
            return hierarchy.getLeaves();
        return spreadsheet.isHierarchyTreeType()
            ? hierarchy.getNodes()
            : hierarchy.getLeaves();
    };
    return {
        hierarchy: hierarchy,
        leafNodes: getLeafNodes(),
    };
};

var PivotFacet = /** @class */ (function (_super) {
    __extends(PivotFacet, _super);
    function PivotFacet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PivotFacet.prototype, "rowCellTheme", {
        get: function () {
            return this.spreadsheet.theme.rowCell.cell;
        },
        enumerable: false,
        configurable: true
    });
    PivotFacet.prototype.doLayout = function () {
        // 1、layout all nodes in rowHeader and colHeader
        var _a = buildHeaderHierarchy({
            isRowHeader: true,
            facetCfg: this.cfg,
        }), rowLeafNodes = _a.leafNodes, rowsHierarchy = _a.hierarchy;
        var _b = buildHeaderHierarchy({
            isRowHeader: false,
            facetCfg: this.cfg,
        }), colLeafNodes = _b.leafNodes, colsHierarchy = _b.hierarchy;
        this.saveInitColumnNodes(colLeafNodes);
        // 2、calculate all related nodes coordinate
        this.calculateNodesCoordinate(rowLeafNodes, rowsHierarchy, colLeafNodes, colsHierarchy);
        var _c = this.cfg, dataSet = _c.dataSet, spreadsheet = _c.spreadsheet;
        var getCellMeta = function (rowIndex, colIndex) {
            var _a;
            var _b, _c;
            var i = rowIndex || 0;
            var j = colIndex || 0;
            var row = rowLeafNodes[i];
            var col = colLeafNodes[j];
            if (!row || !col) {
                return null;
            }
            var rowQuery = row.query;
            var colQuery = col.query;
            var isTotals = row.isTotals ||
                row.isTotalMeasure ||
                col.isTotals ||
                col.isTotalMeasure;
            var hierarchyType = spreadsheet.options.hierarchyType;
            var hideMeasure = (_b = get(spreadsheet, 'facet.cfg.colCfg.hideMeasureColumn')) !== null && _b !== void 0 ? _b : false;
            // 如果在非自定义目录情况下hide measure query中是没有度量信息的，所以需要自动补上
            // 存在一个场景的冲突，如果是多个度量，定位数据数据是无法知道哪一列代表什么
            // 因此默认只会去 第一个度量拼接query
            var measureInfo = hideMeasure && hierarchyType !== 'customTree'
                ? (_a = {},
                    _a[EXTRA_FIELD] = (_c = dataSet.fields.values) === null || _c === void 0 ? void 0 : _c[0],
                    _a) : {};
            var dataQuery = merge({}, rowQuery, colQuery, measureInfo);
            var data = dataSet.getCellData({
                query: dataQuery,
                rowNode: row,
                isTotals: isTotals,
            });
            var valueField;
            var fieldValue = null;
            if (!isEmpty(data)) {
                valueField = get(data, [EXTRA_FIELD], '');
                fieldValue = get(data, [VALUE_FIELD], null);
                if (isTotals) {
                    valueField = get(dataQuery, [EXTRA_FIELD], '');
                    fieldValue = get(data, valueField, null);
                }
            }
            else {
                valueField = get(dataQuery, [EXTRA_FIELD], '');
            }
            return {
                spreadsheet: spreadsheet,
                x: col.x,
                y: row.y,
                width: col.width,
                height: row.height,
                data: data,
                rowIndex: i,
                colIndex: j,
                isTotals: isTotals,
                valueField: valueField,
                fieldValue: fieldValue,
                rowQuery: rowQuery,
                colQuery: colQuery,
                rowId: row.id,
                colId: col.id,
                id: getDataCellId(row.id, col.id),
            };
        };
        var layoutResult = {
            colNodes: colsHierarchy.getNodes(),
            colsHierarchy: colsHierarchy,
            rowNodes: rowsHierarchy.getNodes(),
            rowsHierarchy: rowsHierarchy,
            rowLeafNodes: rowLeafNodes,
            colLeafNodes: colLeafNodes,
            getCellMeta: getCellMeta,
            spreadsheet: spreadsheet,
        };
        return layoutDataPosition(this.cfg, layoutResult);
    };
    PivotFacet.prototype.calculateNodesCoordinate = function (rowLeafNodes, rowsHierarchy, colLeafNodes, colsHierarchy) {
        this.calculateRowNodesCoordinate(rowLeafNodes, rowsHierarchy, colLeafNodes);
        this.calculateColNodesCoordinate(colLeafNodes, colsHierarchy, rowsHierarchy.width);
    };
    /**
     * Calculate all col header related coordinate
     * height, width, x, y
     * colsHierarchy's height
     * colsHierarchy's width
     * @param colLeafNodes
     * @param colsHierarchy
     */
    PivotFacet.prototype.calculateColNodesCoordinate = function (colLeafNodes, colsHierarchy, rowHeaderWidth) {
        var e_1, _a;
        var _b, _c;
        var spreadsheet = this.cfg.spreadsheet;
        var preLeafNode = Node.blankNode();
        var allNodes = colsHierarchy.getNodes();
        try {
            for (var _d = __values(colsHierarchy.sampleNodesForAllLevels), _e = _d.next(); !_e.done; _e = _d.next()) {
                var levelSample = _e.value;
                levelSample.height = this.getColNodeHeight(levelSample);
                colsHierarchy.height += levelSample.height;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var currentCollIndex = 0;
        var _loop_1 = function (i) {
            var currentNode = allNodes[i];
            if (currentNode.isLeaf) {
                currentNode.colIndex = currentCollIndex;
                currentCollIndex += 1;
                currentNode.x = preLeafNode.x + preLeafNode.width;
                currentNode.width = this_1.calculateColLeafNodesWidth(currentNode, colLeafNodes, rowHeaderWidth);
                colsHierarchy.width += currentNode.width;
                preLeafNode = currentNode;
            }
            if (currentNode.level === 0) {
                currentNode.y = 0;
            }
            else {
                var preLevelSample = colsHierarchy.sampleNodesForAllLevels.find(function (n) { return n.level === currentNode.level - 1; });
                currentNode.y = (_b = (preLevelSample === null || preLevelSample === void 0 ? void 0 : preLevelSample.y) + (preLevelSample === null || preLevelSample === void 0 ? void 0 : preLevelSample.height)) !== null && _b !== void 0 ? _b : 0;
            }
            currentNode.height = this_1.getColNodeHeight(currentNode);
            layoutCoordinate(this_1.cfg, null, currentNode);
        };
        var this_1 = this;
        for (var i = 0; i < allNodes.length; i++) {
            _loop_1(i);
        }
        this.autoCalculateColNodeWidthAndX(colLeafNodes);
        if (!isEmpty((_c = spreadsheet.options.totals) === null || _c === void 0 ? void 0 : _c.col)) {
            this.adustTotalNodesCoordinate(colsHierarchy);
            this.adjustSubTotalNodesCoordinate(colsHierarchy);
        }
    };
    /**
     * Auto Auto Auto column no-leaf node's width and x coordinate
     * @param colLeafNodes
     */
    PivotFacet.prototype.autoCalculateColNodeWidthAndX = function (colLeafNodes) {
        var prevColParent = null;
        var leafNodes = colLeafNodes.slice(0);
        while (leafNodes.length) {
            var node = leafNodes.shift();
            var parent_1 = node.parent;
            if (prevColParent !== parent_1 && parent_1) {
                leafNodes.push(parent_1);
                // parent's x = first child's x
                parent_1.x = parent_1.children[0].x;
                // parent's width = all children's width
                parent_1.width = parent_1.children
                    .map(function (value) { return value.width; })
                    .reduce(function (sum, current) { return sum + current; }, 0);
                prevColParent = parent_1;
            }
        }
    };
    PivotFacet.prototype.calculateColLeafNodesWidth = function (col, colLeafNodes, rowHeaderWidth) {
        var _a, _b, _c, _d;
        var _e = this.cfg, colCfg = _e.colCfg, dataSet = _e.dataSet, filterDisplayDataItem = _e.filterDisplayDataItem;
        // current.width =  get(colCfg, `widthByFieldValue.${current.value}`, current.width);
        var userDragWidth = get(get(colCfg, 'widthByFieldValue'), "".concat(col.value), col.width);
        if (userDragWidth) {
            return userDragWidth;
        }
        if (this.spreadsheet.getLayoutWidthType() === LayoutWidthTypes.Compact) {
            var _f = this.spreadsheet.theme.colCell, colCellTextStyle = _f.bolderText, colCellStyle = _f.cell, colIconStyle = _f.icon;
            // leaf node rough width
            var cellFormatter = this.spreadsheet.dataSet.getFieldFormatter(col.field);
            var leafNodeLabel = (_a = cellFormatter === null || cellFormatter === void 0 ? void 0 : cellFormatter(col.value)) !== null && _a !== void 0 ? _a : col.label;
            var iconWidth = this.getExpectedCellIconWidth(CellTypes.COL_CELL, this.spreadsheet.isValueInCols() &&
                this.spreadsheet.options.showDefaultHeaderActionIcon, colIconStyle);
            var leafNodeRoughWidth = measureTextWidthRoughly(leafNodeLabel) + iconWidth;
            // will deal with real width calculation in multiple values render pr
            var multiData = dataSet.getMultiData(col.query, col.isTotals || col.isTotalMeasure);
            var allDataLabels = (_b = multiData
                .map(function (data) { return "".concat(handleDataItem(data, filterDisplayDataItem)); })) === null || _b === void 0 ? void 0 : _b.slice(0, 50);
            var maxDataLabel = maxBy(allDataLabels, function (label) {
                return measureTextWidthRoughly(label);
            });
            // compare result
            var isLeafNodeWidthLonger = leafNodeRoughWidth > measureTextWidthRoughly(maxDataLabel);
            var maxLabel = isLeafNodeWidthLonger ? leafNodeLabel : maxDataLabel;
            var appendedWidth = isLeafNodeWidthLonger ? iconWidth : 0;
            DebuggerUtil.getInstance().logger('Max Label In Col:', col.field, maxLabel);
            return (measureTextWidth(maxLabel, colCellTextStyle) +
                ((_c = colCellStyle.padding) === null || _c === void 0 ? void 0 : _c.left) +
                ((_d = colCellStyle.padding) === null || _d === void 0 ? void 0 : _d.right) +
                appendedWidth);
        }
        // adaptive
        if (this.spreadsheet.isHierarchyTreeType()) {
            return this.getAdaptTreeColWidth(colLeafNodes);
        }
        return this.getAdaptGridColWidth(colLeafNodes, rowHeaderWidth);
    };
    PivotFacet.prototype.getColNodeHeight = function (col) {
        var colCfg = this.cfg.colCfg;
        var userDraggedHeight = get(colCfg, "heightByField.".concat(col.key));
        return userDraggedHeight || colCfg.height;
    };
    /**
     * 获得图标区域预估宽度
     * 不考虑用户自定义的 displayCondition 条件
     * @param iconStyle 图标样式
     * @returns 宽度
     */
    PivotFacet.prototype.getExpectedCellIconWidth = function (cellType, useDefaultIcon, iconStyle) {
        var _a;
        // count icons
        var iconCount = 0;
        if (useDefaultIcon) {
            iconCount = 1;
        }
        else {
            var customIcons = find(this.spreadsheet.options.headerActionIcons, function (headerActionIcon) {
                return shouldShowActionIcons(__assign(__assign({}, headerActionIcon), { 
                    // ignore condition func when layout calc
                    displayCondition: function () { return true; } }), null, cellType);
            });
            iconCount = (_a = customIcons === null || customIcons === void 0 ? void 0 : customIcons.iconNames.length) !== null && _a !== void 0 ? _a : 0;
        }
        // calc width
        return iconCount
            ? iconCount * (iconStyle.size + iconStyle.margin.left) +
                iconStyle.margin.right
            : 0;
    };
    /**
     * Calculate all row header related coordinate
     * height, width, x, y
     * rowHierarchy's height
     * rowHierarchy's width
     * @param rowLeafNodes
     * @param rowsHierarchy
     */
    PivotFacet.prototype.calculateRowNodesCoordinate = function (rowLeafNodes, rowsHierarchy, colLeafNodes) {
        var e_2, _a;
        var _b, _c, _d, _e, _f, _g;
        var _h = this.cfg, cellCfg = _h.cellCfg, spreadsheet = _h.spreadsheet;
        var isTree = spreadsheet.isHierarchyTreeType();
        var heightByField = get(spreadsheet, 'options.style.rowCfg.heightByField', {});
        var sampleNodeByLevel = new Map();
        // 1、calculate first node's width in every level
        if (isTree) {
            rowsHierarchy.width = this.getTreeRowHeaderWidth();
        }
        else {
            try {
                for (var _j = __values(rowsHierarchy.sampleNodesForAllLevels), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var levelSample = _k.value;
                    levelSample.width = this.calculateGridRowNodesWidth(levelSample, colLeafNodes);
                    rowsHierarchy.width += levelSample.width;
                    sampleNodeByLevel.set(levelSample.level, levelSample);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_k && !_k.done && (_a = _j.return)) _a.call(_j);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        // 2、calculate node's height & y（leaf nodes）, x-coordinate & width(all nodes), height & y (not-leaf),
        var preLeafNode = Node.blankNode();
        var allNodes = rowsHierarchy.getNodes();
        for (var i = 0; i < allNodes.length; i++) {
            var currentNode = allNodes[i];
            // in tree type, all nodes treat as leaf
            var isLeaf = isTree || (!isTree && currentNode.isLeaf);
            if (isLeaf) {
                // leaf node
                (_b = currentNode.rowIndex) !== null && _b !== void 0 ? _b : (currentNode.rowIndex = i);
                (_c = currentNode.colIndex) !== null && _c !== void 0 ? _c : (currentNode.colIndex = i);
                currentNode.y = preLeafNode.y + preLeafNode.height;
                currentNode.height =
                    ((_d = heightByField[currentNode.id]) !== null && _d !== void 0 ? _d : cellCfg.height) +
                        ((_e = this.rowCellTheme.padding) === null || _e === void 0 ? void 0 : _e.top) +
                        ((_f = this.rowCellTheme.padding) === null || _f === void 0 ? void 0 : _f.bottom);
                preLeafNode = currentNode;
                // mark row hierarchy's height
                rowsHierarchy.height += currentNode.height;
            }
            // calc node.x
            if (isTree || currentNode.level === 0) {
                currentNode.x = 0;
            }
            else {
                var preLevelSample = sampleNodeByLevel.get(currentNode.level - 1);
                currentNode.x = (preLevelSample === null || preLevelSample === void 0 ? void 0 : preLevelSample.x) + (preLevelSample === null || preLevelSample === void 0 ? void 0 : preLevelSample.width);
            }
            // calc node.width
            if (isTree) {
                currentNode.width = this.getTreeRowHeaderWidth();
            }
            else {
                // same level -> same width
                var levelSampleNode = sampleNodeByLevel.get(currentNode.level);
                currentNode.width = levelSampleNode === null || levelSampleNode === void 0 ? void 0 : levelSampleNode.width;
            }
            layoutCoordinate(this.cfg, currentNode, null);
        }
        if (!isTree) {
            this.autoCalculateRowNodeHeightAndY(rowLeafNodes);
            if (!isEmpty((_g = spreadsheet.options.totals) === null || _g === void 0 ? void 0 : _g.row)) {
                this.adustTotalNodesCoordinate(rowsHierarchy, true);
                this.adjustSubTotalNodesCoordinate(rowsHierarchy, true);
            }
        }
    };
    /**
     * @description Auto calculate row no-leaf node's height and y coordinate
     * @param rowLeafNodes
     */
    PivotFacet.prototype.autoCalculateRowNodeHeightAndY = function (rowLeafNodes) {
        // 3、in grid type, all no-leaf node's height, y are auto calculated
        var prevRowParent = null;
        var leafNodes = rowLeafNodes.slice(0);
        while (leafNodes.length) {
            var node = leafNodes.shift();
            var parent_2 = node.parent;
            if (prevRowParent !== parent_2 && parent_2) {
                leafNodes.push(parent_2);
                // parent's y = first child's y
                parent_2.y = parent_2.children[0].y;
                // parent's height = all children's height
                parent_2.height = parent_2.children
                    .map(function (value) { return value.height; })
                    .reduce(function (sum, current) { return sum + current; }, 0);
                prevRowParent = parent_2;
            }
        }
    };
    /**
     * @description adjust the coordinate of total nodes and their children
     * @param hierarchy Hierarchy
     * @param isRowHeader boolean
     */
    PivotFacet.prototype.adustTotalNodesCoordinate = function (hierarchy, isRowHeader) {
        var _a, _b, _c;
        var moreThanOneValue = this.cfg.dataSet.moreThanOneValue();
        var maxLevel = hierarchy.maxLevel;
        var grandTotalNode = find(hierarchy.getNodes(0), function (node) { return node.isGrandTotals; });
        if (!(grandTotalNode instanceof Node))
            return;
        var grandTotalChildren = grandTotalNode.children;
        // 总计节点层级 (有且有两级)
        if (isRowHeader) {
            // 填充行总单元格宽度
            grandTotalNode.width = hierarchy.width;
            // 调整其叶子结点位置
            forEach(grandTotalChildren, function (node) {
                node.x = hierarchy.getNodes(maxLevel)[0].x;
            });
        }
        else if (maxLevel > 1 || (maxLevel <= 1 && !moreThanOneValue)) {
            // 只有当列头总层级大于1级或列头为1级单指标时总计格高度才需要填充
            // 填充列总计单元格高度
            var grandTotalChildrenHeight = (_b = (_a = grandTotalChildren === null || grandTotalChildren === void 0 ? void 0 : grandTotalChildren[0]) === null || _a === void 0 ? void 0 : _a.height) !== null && _b !== void 0 ? _b : 0;
            grandTotalNode.height = hierarchy.height - grandTotalChildrenHeight;
            // 调整其叶子结点位置, 以非小计行为准
            var positionY_1 = (_c = find(hierarchy.getNodes(maxLevel), function (node) { return !node.isTotalMeasure; })) === null || _c === void 0 ? void 0 : _c.y;
            forEach(grandTotalChildren, function (node) {
                node.y = positionY_1;
            });
        }
    };
    /**
     * @description adust the coordinate of subTotal nodes when there is just one value
     * @param hierarchy Hierarchy
     * @param isRowHeader boolean
     */
    PivotFacet.prototype.adjustSubTotalNodesCoordinate = function (hierarchy, isRowHeader) {
        var subTotalNodes = hierarchy
            .getNodes()
            .filter(function (node) { return node.isSubTotals; });
        if (isEmpty(subTotalNodes))
            return;
        var maxLevel = hierarchy.maxLevel;
        forEach(subTotalNodes, function (subTotalNode) {
            var _a, _b, _c;
            var subTotalNodeChildren = subTotalNode.children;
            if (isRowHeader) {
                // 填充行总单元格宽度
                subTotalNode.width = getSubTotalNodeWidthOrHeightByLevel(hierarchy.sampleNodesForAllLevels, subTotalNode.level, 'width');
                // 调整其叶子结点位置
                forEach(subTotalNodeChildren, function (node) {
                    node.x = hierarchy.getNodes(maxLevel)[0].x;
                });
            }
            else {
                // 填充列总单元格高度
                var totalHeight = getSubTotalNodeWidthOrHeightByLevel(hierarchy.sampleNodesForAllLevels, subTotalNode.level, 'height');
                var subTotalNodeChildrenHeight = (_b = (_a = subTotalNodeChildren === null || subTotalNodeChildren === void 0 ? void 0 : subTotalNodeChildren[0]) === null || _a === void 0 ? void 0 : _a.height) !== null && _b !== void 0 ? _b : 0;
                subTotalNode.height = totalHeight - subTotalNodeChildrenHeight;
                // 调整其叶子结点位置,以非小计单元格为准
                forEach(subTotalNodeChildren, function (node) {
                    node.y = hierarchy.getNodes(maxLevel)[0].y;
                });
                // 调整其叶子结点位置, 以非小计行为准
                var positionY_2 = (_c = find(hierarchy.getNodes(maxLevel), function (node) { return !node.isTotalMeasure; })) === null || _c === void 0 ? void 0 : _c.y;
                forEach(subTotalNodeChildren, function (node) {
                    node.y = positionY_2;
                });
            }
        });
    };
    /**
     * 计算 grid 模式下 node 宽度
     * @param node
     * @returns
     */
    PivotFacet.prototype.calculateGridRowNodesWidth = function (node, colLeafNodes) {
        var _a = this.cfg, rowCfg = _a.rowCfg, spreadsheet = _a.spreadsheet;
        var userDragWidth = get(rowCfg, "widthByField.".concat(node.key));
        if (userDragWidth) {
            return userDragWidth;
        }
        if (spreadsheet.getLayoutWidthType() !== LayoutWidthTypes.Adaptive) {
            // compact or colAdaptive
            return this.getCompactGridRowWidth(node);
        }
        // adaptive
        return this.getAdaptGridColWidth(colLeafNodes);
    };
    /**
     *  计算树状模式等宽条件下的列宽
     * @returns number
     */
    PivotFacet.prototype.getAdaptTreeColWidth = function (colLeafNodes) {
        // tree row width = [config width, canvas / 2]
        var canvasW = this.getCanvasHW().width;
        var rowHeaderWidth = Math.min(canvasW / 2, this.getTreeRowHeaderWidth());
        // calculate col width
        var colSize = Math.max(1, colLeafNodes.length);
        var cellCfg = this.cfg.cellCfg;
        return Math.max(getCellWidth(cellCfg), (canvasW - rowHeaderWidth) / colSize);
    };
    /**
     *  计算平铺模式等宽条件下的列宽
     * @returns number
     */
    PivotFacet.prototype.getAdaptGridColWidth = function (colLeafNodes, rowHeaderWidth) {
        var _a = this.cfg, rows = _a.rows, cellCfg = _a.cellCfg;
        var rowHeaderColSize = rows.length;
        var colHeaderColSize = colLeafNodes.length;
        var canvasW = this.getCanvasHW().width;
        var size = Math.max(1, rowHeaderColSize + colHeaderColSize);
        if (!rowHeaderWidth) {
            // canvasW / (rowHeader's col size + colHeader's col size) = [celCfg.width, canvasW]
            return Math.max(getCellWidth(cellCfg), canvasW / size);
        }
        // (canvasW - rowHeaderW) / (colHeader's col size) = [celCfg.width, canvasW]
        return Math.max(getCellWidth(cellCfg), (canvasW - rowHeaderWidth) / colHeaderColSize);
    };
    /**
     * 计算树状结构行头宽度
     * @returns number
     */
    PivotFacet.prototype.getTreeRowHeaderWidth = function () {
        var _a, _b, _c, _d;
        var _e = this.cfg, rows = _e.rows, dataSet = _e.dataSet, rowCfg = _e.rowCfg, treeRowsWidth = _e.treeRowsWidth;
        // user drag happened
        if (rowCfg === null || rowCfg === void 0 ? void 0 : rowCfg.treeRowsWidth) {
            return rowCfg === null || rowCfg === void 0 ? void 0 : rowCfg.treeRowsWidth;
        }
        // + province/city/level
        var treeHeaderLabel = rows
            .map(function (key) { return dataSet.getFieldName(key); })
            .join('/');
        var _f = this.spreadsheet.theme.cornerCell, cornerCellTextStyle = _f.bolderText, cornerIconStyle = _f.icon;
        // 初始化角头时，保证其在树形模式下不换行，给与两个icon的宽度空余（tree icon 和 action icon），减少复杂的 action icon 判断
        var maxLabelWidth = measureTextWidth(treeHeaderLabel, cornerCellTextStyle) +
            cornerIconStyle.size * 2 +
            ((_a = cornerIconStyle.margin) === null || _a === void 0 ? void 0 : _a.left) +
            ((_b = cornerIconStyle.margin) === null || _b === void 0 ? void 0 : _b.right) +
            ((_c = this.rowCellTheme.padding) === null || _c === void 0 ? void 0 : _c.left) +
            ((_d = this.rowCellTheme.padding) === null || _d === void 0 ? void 0 : _d.right);
        var width = Math.max(treeRowsWidth, maxLabelWidth);
        // NOTE: mark as user drag to calculate only one time
        rowCfg.treeRowsWidth = width;
        return width;
    };
    /**
     * 计算 compact 模式下 node 宽度
     *
     * |   fieldName  |
     *  _______________
     * | label - icon  | <- node
     * | label - icon  |
     * | label - icon  |
     *
     * @param node 目标节点
     * @returns 宽度
     */
    PivotFacet.prototype.getCompactGridRowWidth = function (node) {
        var _this = this;
        var _a;
        var _b = this.cfg, dataSet = _b.dataSet, spreadsheet = _b.spreadsheet;
        var _c = spreadsheet.theme.rowCell, rowTextStyle = _c.bolderText, rowIconStyle = _c.icon, rowCellStyle = _c.cell;
        var _d = spreadsheet.theme.cornerCell, cornerTextStyle = _d.bolderText, cornerIconStyle = _d.icon, cornerCellStyle = _d.cell;
        var field = node.field, isLeaf = node.isLeaf;
        // calc rowNodeWitdh
        var rowIconWidth = this.getExpectedCellIconWidth(CellTypes.ROW_CELL, !spreadsheet.isValueInCols() &&
            isLeaf &&
            spreadsheet.options.showDefaultHeaderActionIcon, rowIconStyle);
        var allLabels = (_a = dataSet
            .getDimensionValues(field)) === null || _a === void 0 ? void 0 : _a.slice(0, 50).map(function (dimValue) {
            var _a, _b;
            return (_b = (_a = _this.spreadsheet.dataSet.getFieldFormatter(field)) === null || _a === void 0 ? void 0 : _a(dimValue)) !== null && _b !== void 0 ? _b : dimValue;
        });
        var maxLabel = maxBy(allLabels, function (label) { return "".concat(label).length; });
        var rowNodeWidth = measureTextWidth(maxLabel, rowTextStyle) +
            rowIconWidth +
            rowCellStyle.padding.left +
            rowCellStyle.padding.right;
        // calc corner fieldNameNodeWidth
        var fieldName = dataSet.getFieldName(field);
        var cornerIconWidth = this.getExpectedCellIconWidth(CellTypes.CORNER_CELL, false, cornerIconStyle);
        var fieldNameNodeWidth = measureTextWidth(fieldName, cornerTextStyle) +
            cornerIconWidth +
            cornerCellStyle.padding.left +
            cornerCellStyle.padding.right;
        DebuggerUtil.getInstance().logger('Max Label In Row:', field, rowNodeWidth > fieldNameNodeWidth ? maxLabel : fieldName);
        // return max
        return Math.max(rowNodeWidth, fieldNameNodeWidth);
    };
    PivotFacet.prototype.getViewCellHeights = function (layoutResult) {
        var rowLeafNodes = layoutResult.rowLeafNodes;
        var heights = reduce(rowLeafNodes, function (result, node) {
            result.push(last(result) + node.height);
            return result;
        }, [0]);
        return {
            getTotalHeight: function () {
                return last(heights);
            },
            getCellOffsetY: function (index) {
                return heights[index];
            },
            getTotalLength: function () {
                // 多了一个数据 [0]
                return heights.length - 1;
            },
            getIndexRange: function (minHeight, maxHeight) {
                return getIndexRangeWithOffsets(heights, minHeight, maxHeight);
            },
        };
    };
    return PivotFacet;
}(BaseFacet));

var getValidFrozenOptions = function (opts, colLength, dataLength) {
    if (dataLength === void 0) { dataLength = 0; }
    // 如果没有传行列冻结选项，提前返回
    if (!Object.values(opts).find(function (item) { return item > 0; })) {
        return opts;
    }
    var newOpts = __assign({}, opts);
    if (newOpts.frozenColCount >= colLength) {
        newOpts.frozenColCount = colLength;
    }
    var remainFrozenColCount = colLength - newOpts.frozenColCount;
    if (newOpts.frozenTrailingColCount > remainFrozenColCount) {
        newOpts.frozenTrailingColCount = remainFrozenColCount;
    }
    if (newOpts.frozenRowCount >= dataLength) {
        newOpts.frozenRowCount = dataLength;
    }
    var remainFrozenRowCount = dataLength - newOpts.frozenRowCount;
    if (newOpts.frozenTrailingRowCount > remainFrozenRowCount) {
        newOpts.frozenTrailingRowCount = remainFrozenRowCount;
    }
    return newOpts;
};

/**
 * Column Header for SpreadSheet
 */
var TableColHeader = /** @class */ (function (_super) {
    __extends(TableColHeader, _super);
    function TableColHeader(cfg) {
        var _a;
        var _this = _super.call(this, cfg) || this;
        _this.getScrollGroupClipBBox = function () {
            var _a;
            var _b = _this.headerConfig, width = _b.width, height = _b.height, scrollX = _b.scrollX, spreadsheet = _b.spreadsheet;
            var options = spreadsheet.options;
            if (!options.frozenColCount && !options.frozenTrailingColCount) {
                return {
                    x: scrollX,
                    y: 0,
                    width: width,
                    height: height,
                };
            }
            var colLeafNodes = (_a = spreadsheet.facet) === null || _a === void 0 ? void 0 : _a.layoutResult.colLeafNodes;
            var _c = getValidFrozenOptions(spreadsheet.options, colLeafNodes.length), frozenColCount = _c.frozenColCount, frozenTrailingColCount = _c.frozenTrailingColCount;
            var frozenColWidth = 0;
            var frozenTrailingColWidth = 0;
            for (var i = 0; i < frozenColCount; i++) {
                frozenColWidth += colLeafNodes[i].width;
            }
            for (var i = 0; i < frozenTrailingColCount; i++) {
                frozenTrailingColWidth += colLeafNodes[colLeafNodes.length - 1 - i].width;
            }
            var frozenClipWidth = width - frozenColWidth - frozenTrailingColWidth;
            return {
                x: scrollX + frozenColWidth,
                y: 0,
                width: frozenClipWidth,
                height: height,
            };
        };
        var _b = (_a = _this.headerConfig.spreadsheet) === null || _a === void 0 ? void 0 : _a.options, frozenColCount = _b.frozenColCount, frozenTrailingColCount = _b.frozenTrailingColCount;
        if (frozenColCount) {
            _this.frozenColGroup = _this.addGroup({
                name: KEY_GROUP_COL_FROZEN,
                zIndex: FRONT_GROUND_GROUP_COL_FROZEN_Z_INDEX,
            });
        }
        if (frozenTrailingColCount) {
            _this.frozenTrailingColGroup = _this.addGroup({
                name: KEY_GROUP_COL_FROZEN_TRAILING,
                zIndex: FRONT_GROUND_GROUP_COL_FROZEN_Z_INDEX,
            });
        }
        return _this;
    }
    TableColHeader.prototype.isFrozenCell = function (meta) {
        var spreadsheet = this.headerConfig.spreadsheet;
        var _a = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.options, frozenColCount = _a.frozenColCount, frozenTrailingColCount = _a.frozenTrailingColCount;
        var colIndex = meta.colIndex;
        var colLeafNodes = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.facet.layoutResult.colLeafNodes;
        return (isFrozenCol(colIndex, frozenColCount) ||
            isFrozenTrailingCol(colIndex, frozenTrailingColCount, colLeafNodes.length));
    };
    TableColHeader.prototype.clear = function () {
        var _a, _b;
        var spreadsheet = this.headerConfig.spreadsheet;
        _super.prototype.clear.call(this);
        (_a = this.frozenTrailingColGroup) === null || _a === void 0 ? void 0 : _a.clear();
        (_b = this.frozenColGroup) === null || _b === void 0 ? void 0 : _b.clear();
        // 额外清除冻结列的 Resizer Area
        var resizerArea = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.foregroundGroup.findById(KEY_GROUP_FROZEN_COL_RESIZE_AREA);
        resizerArea === null || resizerArea === void 0 ? void 0 : resizerArea.clear();
    };
    TableColHeader.prototype.getCellInstance = function (item, spreadsheet, headerConfig) {
        return item.field === SERIES_NUMBER_FIELD
            ? new TableCornerCell(item, spreadsheet, headerConfig)
            : new TableColCell(item, spreadsheet, headerConfig);
    };
    TableColHeader.prototype.getCellGroup = function (node) {
        var _a;
        var spreadsheet = this.headerConfig.spreadsheet;
        var _b = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.options, frozenColCount = _b.frozenColCount, frozenTrailingColCount = _b.frozenTrailingColCount;
        var colLength = (_a = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.facet) === null || _a === void 0 ? void 0 : _a.layoutResult.colLeafNodes.length;
        if (isFrozenCol(node.colIndex, frozenColCount)) {
            return this.frozenColGroup;
        }
        if (isFrozenTrailingCol(node.colIndex, frozenTrailingColCount, colLength)) {
            return this.frozenTrailingColGroup;
        }
        return this.scrollGroup;
    };
    TableColHeader.prototype.isColCellInRect = function (item) {
        var _a;
        var spreadsheet = this.headerConfig.spreadsheet;
        var _b = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.options, frozenColCount = _b.frozenColCount, frozenTrailingColCount = _b.frozenTrailingColCount;
        var colLength = (_a = spreadsheet === null || spreadsheet === void 0 ? void 0 : spreadsheet.facet) === null || _a === void 0 ? void 0 : _a.layoutResult.colLeafNodes.length;
        if (isFrozenCol(item.colIndex, frozenColCount) ||
            isFrozenTrailingCol(item.colIndex, frozenTrailingColCount, colLength)) {
            return true;
        }
        return _super.prototype.isColCellInRect.call(this, item);
    };
    TableColHeader.prototype.clip = function () {
        this.scrollGroup.setClip({
            type: 'rect',
            attrs: this.getScrollGroupClipBBox(),
        });
    };
    return TableColHeader;
}(ColHeader));

var TableFacet = /** @class */ (function (_super) {
    __extends(TableFacet, _super);
    function TableFacet(cfg) {
        var _this = _super.call(this, cfg) || this;
        _this.initFrozenGroupPosition = function () {
            var _a = _this.getScrollOffset(), scrollY = _a.scrollY, scrollX = _a.scrollX;
            var paginationScrollY = _this.getPaginationScrollY();
            translateGroup(_this.spreadsheet.frozenRowGroup, _this.cornerBBox.width - scrollX, _this.cornerBBox.height - paginationScrollY);
            translateGroup(_this.spreadsheet.frozenColGroup, _this.cornerBBox.width, _this.cornerBBox.height - scrollY - paginationScrollY);
            translateGroup(_this.spreadsheet.frozenTrailingColGroup, _this.cornerBBox.width, _this.cornerBBox.height - scrollY - paginationScrollY);
            translateGroup(_this.spreadsheet.frozenTopGroup, _this.cornerBBox.width, _this.cornerBBox.height - paginationScrollY);
        };
        _this.getTotalHeightForRange = function (start, end) {
            if (start < 0 || end < 0)
                return 0;
            if (_this.rowOffsets) {
                return _this.rowOffsets[end + 1] - _this.rowOffsets[start];
            }
            var totalHeight = 0;
            for (var index = start; index < end + 1; index++) {
                var height = _this.getDefaultCellHeight();
                totalHeight += height;
            }
            return totalHeight;
        };
        _this.getShadowFill = function (angle) {
            var _a, _b;
            var style = get(_this.cfg, 'spreadsheet.theme.splitLine');
            return "l (".concat(angle, ") 0:").concat((_a = style.shadowColors) === null || _a === void 0 ? void 0 : _a.left, " 1:").concat((_b = style.shadowColors) === null || _b === void 0 ? void 0 : _b.right);
        };
        _this.renderFrozenGroupSplitLine = function () {
            var _a = _this.panelBBox, panelWidth = _a.width, panelHeight = _a.height, viewportWidth = _a.viewportWidth, viewportHeight = _a.viewportHeight;
            var cornerHeight = _this.cornerBBox.height;
            var colLeafNodes = _this.layoutResult.colLeafNodes;
            var cellRange = _this.getCellRange();
            var dataLength = cellRange.end - cellRange.start;
            var _b = getValidFrozenOptions(_this.spreadsheet.options, colLeafNodes.length, dataLength), frozenRowCount = _b.frozenRowCount, frozenColCount = _b.frozenColCount, frozenTrailingColCount = _b.frozenTrailingColCount, frozenTrailingRowCount = _b.frozenTrailingRowCount;
            var style = get(_this.cfg, 'spreadsheet.theme.splitLine');
            var splitLineGroup = _this.foregroundGroup.addGroup({
                id: 'frozenSplitLine',
                zIndex: FRONT_GROUND_GROUP_COL_FROZEN_Z_INDEX,
            });
            var verticalBorderStyle = {
                lineWidth: style === null || style === void 0 ? void 0 : style.verticalBorderWidth,
                stroke: style === null || style === void 0 ? void 0 : style.verticalBorderColor,
                opacity: style === null || style === void 0 ? void 0 : style.verticalBorderColorOpacity,
            };
            var horizontalBorderStyle = {
                lineWidth: style === null || style === void 0 ? void 0 : style.horizontalBorderWidth,
                stroke: style === null || style === void 0 ? void 0 : style.horizontalBorderColor,
                opacity: style === null || style === void 0 ? void 0 : style.horizontalBorderColorOpacity,
            };
            if (frozenColCount > 0) {
                var x = colLeafNodes.reduce(function (prev, item, idx) {
                    if (idx < frozenColCount) {
                        return prev + item.width;
                    }
                    return prev;
                }, 0);
                var height = frozenTrailingRowCount > 0 ? panelHeight : viewportHeight;
                renderLine(splitLineGroup, {
                    x1: x,
                    x2: x,
                    y1: cornerHeight,
                    y2: cornerHeight + height,
                }, __assign({}, verticalBorderStyle));
                if (style.showShadow) {
                    splitLineGroup.addShape('rect', {
                        attrs: {
                            x: x,
                            y: cornerHeight,
                            width: style.shadowWidth,
                            height: height,
                            fill: _this.getShadowFill(0),
                        },
                    });
                }
            }
            if (frozenRowCount > 0) {
                var y = cornerHeight +
                    _this.getTotalHeightForRange(cellRange.start, cellRange.start + frozenRowCount - 1);
                var width = frozenTrailingColCount > 0 ? panelWidth : viewportWidth;
                renderLine(splitLineGroup, {
                    x1: 0,
                    x2: width,
                    y1: y,
                    y2: y,
                }, __assign({}, horizontalBorderStyle));
                if (style.showShadow) {
                    splitLineGroup.addShape('rect', {
                        attrs: {
                            x: 0,
                            y: y,
                            width: width,
                            height: style.shadowWidth,
                            fill: _this.getShadowFill(90),
                        },
                    });
                }
            }
            if (frozenTrailingColCount > 0) {
                var width = colLeafNodes.reduceRight(function (prev, item, idx) {
                    if (idx >= colLeafNodes.length - frozenTrailingColCount) {
                        return prev + item.width;
                    }
                    return prev;
                }, 0);
                var x = panelWidth - width;
                var height = frozenTrailingRowCount ? panelHeight : viewportHeight;
                renderLine(splitLineGroup, {
                    x1: x,
                    x2: x,
                    y1: cornerHeight,
                    y2: cornerHeight + height,
                }, __assign({}, verticalBorderStyle));
                if (style.showShadow) {
                    splitLineGroup.addShape('rect', {
                        attrs: {
                            x: x - style.shadowWidth,
                            y: cornerHeight,
                            width: style.shadowWidth,
                            height: height,
                            fill: _this.getShadowFill(180),
                        },
                    });
                }
            }
            if (frozenTrailingRowCount > 0) {
                var y = _this.panelBBox.maxY -
                    _this.getTotalHeightForRange(cellRange.end - frozenTrailingRowCount + 1, cellRange.end);
                var width = frozenTrailingColCount > 0 ? panelWidth : viewportWidth;
                renderLine(splitLineGroup, {
                    x1: 0,
                    x2: width,
                    y1: y,
                    y2: y,
                }, __assign({}, horizontalBorderStyle));
                if (style.showShadow) {
                    splitLineGroup.addShape('rect', {
                        attrs: {
                            x: 0,
                            y: y - style.shadowWidth,
                            width: width,
                            height: style.shadowWidth,
                            fill: _this.getShadowFill(270),
                        },
                    });
                }
            }
            _this.foregroundGroup.sort();
        };
        _this.renderFrozenPanelCornerGroup = function () {
            var colLength = _this.layoutResult.colLeafNodes.length;
            var cellRange = _this.getCellRange();
            var _a = getValidFrozenOptions(_this.spreadsheet.options, colLength, cellRange.end - cellRange.start + 1), frozenRowCount = _a.frozenRowCount, frozenColCount = _a.frozenColCount, frozenTrailingRowCount = _a.frozenTrailingRowCount, frozenTrailingColCount = _a.frozenTrailingColCount;
            var result = calculateFrozenCornerCells({
                frozenRowCount: frozenRowCount,
                frozenColCount: frozenColCount,
                frozenTrailingRowCount: frozenTrailingRowCount,
                frozenTrailingColCount: frozenTrailingColCount,
            }, colLength, cellRange);
            Object.keys(result).forEach(function (key) {
                var cells = result[key];
                var group = _this.spreadsheet[FrozenCellGroupMap[key]];
                if (group) {
                    cells.forEach(function (cell) {
                        _this.addFrozenCell(cell.x, cell.y, group);
                    });
                }
            });
        };
        _this.addFrozenCell = function (colIndex, rowIndex, group) {
            var viewMeta = _this.layoutResult.getCellMeta(rowIndex, colIndex);
            if (viewMeta) {
                var cell = _this.cfg.dataCell(viewMeta);
                group.add(cell);
            }
        };
        _this.addCell = function (cell) {
            var _a = _this.spreadsheet.options, frozenRowCount = _a.frozenRowCount, frozenColCount = _a.frozenColCount, frozenTrailingRowCount = _a.frozenTrailingRowCount, frozenTrailingColCount = _a.frozenTrailingColCount;
            var colLength = _this.layoutResult.colsHierarchy.getLeaves().length;
            var cellRange = _this.getCellRange();
            var frozenCellType = getFrozenDataCellType(cell.getMeta(), {
                frozenRowCount: frozenRowCount,
                frozenColCount: frozenColCount,
                frozenTrailingRowCount: frozenTrailingRowCount,
                frozenTrailingColCount: frozenTrailingColCount,
            }, colLength, cellRange);
            var group = FrozenCellGroupMap[frozenCellType];
            if (group) {
                _this.spreadsheet[group].add(cell);
            }
        };
        var s2 = _this.spreadsheet;
        s2.on(S2Event.RANGE_SORT, function (sortParams) {
            var _a = sortParams, sortKey = _a.sortKey, sortMethod = _a.sortMethod, sortBy = _a.sortBy;
            set(s2.dataCfg, 'sortParams', [
                {
                    sortFieldId: sortKey,
                    sortMethod: sortMethod,
                    sortBy: sortBy,
                },
            ]);
            s2.setDataCfg(s2.dataCfg);
            s2.render(true);
            s2.emit(S2Event.RANGE_SORTED, s2.dataSet.getDisplayDataSet());
        });
        s2.on(S2Event.RANGE_FILTER, function (params) {
            /** remove filter params on current key if passed an empty filterValues field */
            var unFilter = !params.filteredValues || params.filteredValues.length === 0;
            var oldConfig = s2.dataCfg.filterParams || [];
            // check whether filter condition already exists on column, if so, modify it instead.
            var oldIndex = oldConfig.findIndex(function (item) { return item.filterKey === params.filterKey; });
            if (oldIndex !== -1) {
                if (unFilter) {
                    // remove filter params on current key if passed an empty filterValues field
                    oldConfig.splice(oldIndex);
                }
                else {
                    // if filter with same key already exists, replace it
                    oldConfig[oldIndex] = params;
                }
            }
            else {
                oldConfig.push(params);
            }
            set(s2.dataCfg, 'filterParams', oldConfig);
            s2.render(true);
            s2.emit(S2Event.RANGE_FILTERED, s2.dataSet.getDisplayDataSet());
        });
        return _this;
    }
    Object.defineProperty(TableFacet.prototype, "colCellTheme", {
        get: function () {
            return this.spreadsheet.theme.colCell.cell;
        },
        enumerable: false,
        configurable: true
    });
    TableFacet.prototype.calculateCornerBBox = function () {
        var colsHierarchy = this.layoutResult.colsHierarchy;
        var height = Math.floor(colsHierarchy.height);
        this.cornerBBox = new CornerBBox(this);
        this.cornerBBox.height = height;
        this.cornerBBox.maxY = height;
    };
    TableFacet.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.spreadsheet.off(S2Event.RANGE_SORT);
        this.spreadsheet.off(S2Event.RANGE_FILTER);
    };
    TableFacet.prototype.doLayout = function () {
        var _this = this;
        var _a = this.cfg, dataSet = _a.dataSet, spreadsheet = _a.spreadsheet;
        var rowsHierarchy = new Hierarchy();
        var _b = buildHeaderHierarchy({
            isRowHeader: false,
            facetCfg: this.cfg,
        }), colLeafNodes = _b.leafNodes, colsHierarchy = _b.hierarchy;
        this.saveInitColumnNodes(colLeafNodes);
        this.calculateColNodesCoordinate(colLeafNodes, colsHierarchy);
        var getCellMeta = function (rowIndex, colIndex) {
            var _a;
            var showSeriesNumber = _this.cfg.showSeriesNumber;
            var col = colLeafNodes[colIndex];
            var cellHeight = _this.getCellHeight(rowIndex);
            var cellRange = _this.getCellRange();
            var _b = getValidFrozenOptions(_this.cfg, colLeafNodes.length, cellRange.end - cellRange.start + 1), frozenTrailingColCount = _b.frozenTrailingColCount, frozenTrailingRowCount = _b.frozenTrailingRowCount;
            var data;
            var width = _this.panelBBox.maxX;
            var colLength = colLeafNodes.length;
            var x = col.x;
            var y = _this.viewCellHeights.getCellOffsetY(rowIndex);
            if (isFrozenTrailingRow(rowIndex, cellRange.end, frozenTrailingRowCount)) {
                y =
                    _this.panelBBox.maxY -
                        _this.getTotalHeightForRange(rowIndex, cellRange.end);
            }
            if (isFrozenTrailingCol(colIndex, frozenTrailingColCount, colLength)) {
                x =
                    width -
                        colLeafNodes
                            .slice(-(colLength - colIndex))
                            .reduce(function (prev, item, idx) {
                            return prev + item.width;
                        }, 0);
            }
            if (showSeriesNumber && col.field === SERIES_NUMBER_FIELD) {
                data = rowIndex + 1;
            }
            else {
                data = dataSet.getCellData({
                    query: {
                        col: col.field,
                        rowIndex: rowIndex,
                    },
                });
            }
            return {
                spreadsheet: spreadsheet,
                x: x,
                y: y,
                width: col.width,
                height: cellHeight,
                data: (_a = {},
                    _a[col.field] = data,
                    _a),
                rowIndex: rowIndex,
                colIndex: colIndex,
                isTotals: false,
                colId: col.id,
                rowId: String(rowIndex),
                valueField: col.field,
                fieldValue: data,
                id: getDataCellId(String(rowIndex), col.id),
            };
        };
        var layoutResult = {
            colNodes: colsHierarchy.getNodes(),
            colsHierarchy: colsHierarchy,
            rowNodes: rowsHierarchy.getNodes(),
            rowsHierarchy: rowsHierarchy,
            rowLeafNodes: rowsHierarchy.getLeaves(),
            colLeafNodes: colLeafNodes,
            getCellMeta: getCellMeta,
            spreadsheet: spreadsheet,
        };
        return layoutResult;
    };
    TableFacet.prototype.getAdaptiveColWidth = function (colLeafNodes) {
        var cellCfg = this.cfg.cellCfg;
        var showSeriesNumber = this.cfg.showSeriesNumber;
        if (this.spreadsheet.getLayoutWidthType() !== LayoutWidthTypes.Compact) {
            var seriesNumberWidth = this.getSeriesNumberWidth();
            var colHeaderColSize = colLeafNodes.length - (showSeriesNumber ? 1 : 0);
            var canvasW = this.getCanvasHW().width - seriesNumberWidth;
            return Math.max(cellCfg.width, canvasW / Math.max(1, colHeaderColSize));
        }
        return cellCfg.width;
    };
    TableFacet.prototype.getColNodeHeight = function (col) {
        var colCfg = this.cfg.colCfg;
        // 明细表所有列节点高度保持一致
        var userDragHeight = Object.values(get(colCfg, "heightByField"))[0];
        return userDragHeight || colCfg.height;
    };
    TableFacet.prototype.calculateColNodesCoordinate = function (colLeafNodes, colsHierarchy) {
        var e_1, _a;
        var _b;
        var preLeafNode = Node.blankNode();
        var allNodes = colsHierarchy.getNodes();
        try {
            for (var _c = __values(colsHierarchy.sampleNodesForAllLevels), _d = _c.next(); !_d.done; _d = _c.next()) {
                var levelSample = _d.value;
                levelSample.height = this.getColNodeHeight(levelSample);
                colsHierarchy.height += levelSample.height;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var frozenTrailingColCount = getValidFrozenOptions((_b = this.spreadsheet) === null || _b === void 0 ? void 0 : _b.options, allNodes.length).frozenTrailingColCount;
        var adaptiveColWitdth = this.getAdaptiveColWidth(colLeafNodes);
        for (var i = 0; i < allNodes.length; i++) {
            var currentNode = allNodes[i];
            currentNode.colIndex = i;
            currentNode.x = preLeafNode.x + preLeafNode.width;
            currentNode.width = this.calculateColLeafNodesWidth(currentNode, adaptiveColWitdth);
            preLeafNode = currentNode;
            currentNode.y = 0;
            currentNode.height = this.getColNodeHeight(currentNode);
            if (frozenTrailingColCount === 0) {
                layoutCoordinate(this.cfg, null, currentNode);
            }
            colsHierarchy.width += currentNode.width;
        }
        preLeafNode = Node.blankNode();
        var canvasW = this.getCanvasHW().width;
        if (frozenTrailingColCount > 0) {
            for (var i = 1; i <= allNodes.length; i++) {
                var currentNode = allNodes[allNodes.length - i];
                if (currentNode.colIndex >=
                    colLeafNodes.length - frozenTrailingColCount) {
                    if (currentNode.colIndex === allNodes.length - 1) {
                        currentNode.x = canvasW - currentNode.width;
                    }
                    else {
                        currentNode.x = preLeafNode.x - currentNode.width;
                    }
                    preLeafNode = currentNode;
                }
                layoutCoordinate(this.cfg, null, currentNode);
            }
        }
    };
    TableFacet.prototype.calculateColLeafNodesWidth = function (col, adaptiveColWitdth) {
        var _a;
        var _b = this.cfg, colCfg = _b.colCfg, dataSet = _b.dataSet, spreadsheet = _b.spreadsheet;
        var layoutWidthType = this.spreadsheet.getLayoutWidthType();
        var userDragWidth = get(get(colCfg, 'widthByFieldValue'), "".concat(col.value), col.width);
        var colWidth;
        if (userDragWidth) {
            colWidth = userDragWidth;
        }
        else {
            if (layoutWidthType === LayoutWidthTypes.Compact) {
                var datas = dataSet.getDisplayDataSet();
                var colLabel = col.label;
                var allLabels = ((_a = datas === null || datas === void 0 ? void 0 : datas.map(function (data) { return "".concat(data[col.key]); })) === null || _a === void 0 ? void 0 : _a.slice(0, 50)) || []; // 采样取了前50
                allLabels.push(colLabel);
                var maxLabel = maxBy(allLabels, function (label) {
                    return measureTextWidthRoughly(label);
                });
                var colCellTextStyle = spreadsheet.theme.colCell.bolderText;
                var _c = spreadsheet.theme.dataCell, dataCellTextStyle = _c.text, cellStyle = _c.cell;
                DebuggerUtil.getInstance().logger('Max Label In Col:', col.field, maxLabel);
                // 最长的 Label 如果是列名，按列名的标准计算宽度
                if (colLabel === maxLabel) {
                    colWidth =
                        measureTextWidth(maxLabel, colCellTextStyle) +
                            getOccupiedWidthForTableCol(this.spreadsheet, col, spreadsheet.theme.colCell);
                }
                else {
                    colWidth =
                        measureTextWidth(maxLabel, dataCellTextStyle) +
                            cellStyle.padding.left +
                            cellStyle.padding.right;
                }
            }
            else {
                colWidth = adaptiveColWitdth;
            }
            if (col.field === SERIES_NUMBER_FIELD) {
                colWidth = this.getSeriesNumberWidth();
            }
        }
        return colWidth;
    };
    TableFacet.prototype.getDefaultCellHeight = function () {
        var _a, _b;
        var cellCfg = this.cfg.cellCfg;
        return (cellCfg.height +
            ((_a = this.colCellTheme.padding) === null || _a === void 0 ? void 0 : _a.top) +
            ((_b = this.colCellTheme.padding) === null || _b === void 0 ? void 0 : _b.bottom));
    };
    TableFacet.prototype.getCellHeight = function (index) {
        var _a, _b;
        var cellCfg = this.cfg.cellCfg;
        if (this.rowOffsets) {
            var heightByField = get(this.spreadsheet, 'options.style.rowCfg.heightByField', {});
            var customHeight = heightByField[String(index)];
            if (customHeight) {
                return customHeight;
            }
        }
        return (cellCfg.height +
            ((_a = this.colCellTheme.padding) === null || _a === void 0 ? void 0 : _a.top) +
            ((_b = this.colCellTheme.padding) === null || _b === void 0 ? void 0 : _b.bottom));
    };
    TableFacet.prototype.initRowOffsets = function () {
        var _this = this;
        var dataSet = this.cfg.dataSet;
        var heightByField = get(this.spreadsheet, 'options.style.rowCfg.heightByField', {});
        if (Object.keys(heightByField).length) {
            var data = dataSet.getDisplayDataSet();
            this.rowOffsets = [0];
            var lastOffset_1 = 0;
            data.forEach(function (_, idx) {
                var _a;
                var currentHeight = (_a = heightByField[String(idx)]) !== null && _a !== void 0 ? _a : _this.getDefaultCellHeight();
                var currentOffset = lastOffset_1 + currentHeight;
                _this.rowOffsets.push(currentOffset);
                lastOffset_1 = currentOffset;
            });
        }
    };
    TableFacet.prototype.getViewCellHeights = function () {
        var _this = this;
        var dataSet = this.cfg.dataSet;
        this.initRowOffsets();
        var defaultCellHeight = this.getDefaultCellHeight();
        return {
            getTotalHeight: function () {
                if (_this.rowOffsets) {
                    return last(_this.rowOffsets);
                }
                return defaultCellHeight * dataSet.getDisplayDataSet().length;
            },
            getCellOffsetY: function (offset) {
                if (offset <= 0)
                    return 0;
                if (_this.rowOffsets) {
                    return _this.rowOffsets[offset];
                }
                var totalOffset = 0;
                for (var index = 0; index < offset; index++) {
                    totalOffset += defaultCellHeight;
                }
                return totalOffset;
            },
            getTotalLength: function () {
                return dataSet.getDisplayDataSet().length;
            },
            getIndexRange: function (minHeight, maxHeight) {
                if (_this.rowOffsets) {
                    return getIndexRangeWithOffsets(_this.rowOffsets, minHeight, maxHeight);
                }
                var yMin = Math.floor(minHeight / defaultCellHeight);
                // 防止数组index溢出导致报错
                var yMax = maxHeight % defaultCellHeight === 0
                    ? maxHeight / defaultCellHeight - 1
                    : Math.floor(maxHeight / defaultCellHeight);
                return {
                    start: Math.max(0, yMin),
                    end: Math.max(0, yMax),
                };
            },
        };
    };
    TableFacet.prototype.init = function () {
        _super.prototype.init.call(this);
        var _a = this.panelBBox, width = _a.width, height = _a.height;
        this.spreadsheet.panelGroup.setClip({
            type: 'rect',
            attrs: {
                x: 0,
                y: this.cornerBBox.height,
                width: width,
                height: height,
            },
        });
    };
    TableFacet.prototype.getColHeader = function () {
        var _this = this;
        if (!this.columnHeader) {
            var _a = this.panelBBox, x = _a.x, width = _a.width, viewportHeight = _a.viewportHeight, viewportWidth = _a.viewportWidth;
            return new TableColHeader({
                width: width,
                height: this.cornerBBox.height,
                viewportWidth: viewportWidth,
                viewportHeight: viewportHeight,
                cornerWidth: this.cornerBBox.width,
                position: { x: x, y: 0 },
                data: this.layoutResult.colNodes,
                scrollContainsRowHeader: this.cfg.spreadsheet.isScrollContainsRowHeader(),
                formatter: function (field) {
                    return _this.cfg.dataSet.getFieldFormatter(field);
                },
                sortParam: this.cfg.spreadsheet.store.get('sortParam'),
                spreadsheet: this.spreadsheet,
            });
        }
        return this.columnHeader;
    };
    TableFacet.prototype.updateRowResizeArea = function () {
        var _a;
        var _b = this.spreadsheet, foregroundGroup = _b.foregroundGroup, options = _b.options;
        var resize = get(options, 'interaction.resize');
        if ((isBoolean(resize) && !resize) ||
            !((_a = resize) === null || _a === void 0 ? void 0 : _a.rowCellVertical)) {
            return;
        }
        var rowResizeGroup = foregroundGroup.findById(KEY_GROUP_ROW_RESIZE_AREA);
        var rowResizeFrozenGroup = foregroundGroup.findById(KEY_GROUP_FROZEN_ROW_RESIZE_AREA);
        if (rowResizeGroup) {
            rowResizeGroup.set('children', []);
        }
        if (rowResizeFrozenGroup) {
            rowResizeFrozenGroup.set('children', []);
        }
        var allCells = getAllChildCells(this.panelGroup.getChildren(), TableRowCell);
        allCells.forEach(function (cell) {
            cell.drawResizeArea();
        });
    };
    TableFacet.prototype.render = function () {
        this.renderFrozenPanelCornerGroup();
        _super.prototype.render.call(this);
        this.initFrozenGroupPosition();
        this.renderFrozenGroupSplitLine();
    };
    TableFacet.prototype.getRowHeader = function () {
        return null;
    };
    TableFacet.prototype.getSeriesNumberHeader = function () {
        return null;
    };
    TableFacet.prototype.translateRelatedGroups = function (scrollX, scrollY, hRowScroll) {
        translateGroupX(this.spreadsheet.frozenRowGroup, this.cornerBBox.width - scrollX);
        translateGroupX(this.spreadsheet.frozenTrailingRowGroup, this.cornerBBox.width - scrollX);
        translateGroupY(this.spreadsheet.frozenColGroup, this.cornerBBox.height - scrollY);
        translateGroupY(this.spreadsheet.frozenTrailingColGroup, this.cornerBBox.height - scrollY);
        _super.prototype.translateRelatedGroups.call(this, scrollX, scrollY, hRowScroll);
        this.updateRowResizeArea();
    };
    TableFacet.prototype.calculateXYIndexes = function (scrollX, scrollY) {
        var colLength = this.layoutResult.colLeafNodes.length;
        var cellRange = this.getCellRange();
        var _a = this.panelBBox, height = _a.viewportHeight, width = _a.viewportWidth;
        var _b = getValidFrozenOptions(this.spreadsheet.options, colLength, cellRange.end - cellRange.start + 1), frozenColCount = _b.frozenColCount, frozenRowCount = _b.frozenRowCount, frozenTrailingColCount = _b.frozenTrailingColCount, frozenTrailingRowCount = _b.frozenTrailingRowCount;
        var indexes = calculateInViewIndexes(scrollX, scrollY, this.viewCellWidths, this.viewCellHeights, {
            width: width,
            height: height,
            x: 0,
            y: 0,
        }, this.getRealScrollX(this.cornerBBox.width));
        return splitInViewIndexesWithFrozen(indexes, {
            frozenColCount: frozenColCount,
            frozenRowCount: frozenRowCount,
            frozenTrailingColCount: frozenTrailingColCount,
            frozenTrailingRowCount: frozenTrailingRowCount,
        }, colLength, cellRange);
    };
    // 对 panelScrollGroup 以及四个方向的 frozenGroup 做 Clip，避免有透明度时冻结分组和滚动分组展示重叠
    TableFacet.prototype.clip = function (scrollX, scrollY) {
        var _a, _b;
        var colLeafNodes = this.layoutResult.colLeafNodes;
        var paginationScrollY = this.getPaginationScrollY();
        var _c = this.spreadsheet, frozenRowGroup = _c.frozenRowGroup, frozenColGroup = _c.frozenColGroup, frozenTrailingColGroup = _c.frozenTrailingColGroup, frozenTrailingRowGroup = _c.frozenTrailingRowGroup, panelScrollGroup = _c.panelScrollGroup;
        var frozenColGroupWidth = frozenColGroup.getBBox().width;
        var frozenRowGroupHeight = frozenRowGroup.getBBox().height;
        var frozenTrailingColBBox = frozenTrailingColGroup.getBBox();
        var frozenTrailingRowGroupHeight = frozenTrailingRowGroup.getBBox().height;
        var panelScrollGroupWidth = this.panelBBox.width -
            frozenColGroupWidth -
            frozenTrailingColGroup.getBBox().width;
        var panelScrollGroupHeight = this.panelBBox.height -
            frozenRowGroupHeight -
            frozenTrailingRowGroupHeight;
        panelScrollGroup.setClip({
            type: 'rect',
            attrs: {
                x: scrollX + frozenColGroupWidth,
                y: scrollY + frozenRowGroupHeight,
                width: panelScrollGroupWidth,
                height: panelScrollGroupHeight,
            },
        });
        frozenRowGroup.setClip({
            type: 'rect',
            attrs: {
                x: scrollX + frozenColGroupWidth,
                y: paginationScrollY,
                width: panelScrollGroupWidth,
                height: frozenRowGroupHeight,
            },
        });
        frozenTrailingRowGroup.setClip({
            type: 'rect',
            attrs: {
                x: scrollX + frozenColGroupWidth,
                y: frozenTrailingRowGroup.getBBox().minY,
                width: panelScrollGroupWidth,
                height: frozenTrailingRowGroupHeight,
            },
        });
        frozenColGroup.setClip({
            type: 'rect',
            attrs: {
                x: 0,
                y: scrollY + frozenRowGroupHeight,
                width: frozenColGroupWidth,
                height: panelScrollGroupHeight,
            },
        });
        frozenTrailingColGroup.setClip({
            type: 'rect',
            attrs: {
                x: frozenTrailingColBBox.minX,
                y: scrollY + frozenRowGroupHeight,
                width: frozenTrailingColBBox.width,
                height: panelScrollGroupHeight,
            },
        });
        var rowResizeGroup = this.spreadsheet.foregroundGroup.findById(KEY_GROUP_ROW_RESIZE_AREA);
        if (rowResizeGroup) {
            rowResizeGroup.setClip({
                type: 'rect',
                attrs: {
                    x: 0,
                    y: frozenRowGroupHeight + this.cornerBBox.height,
                    width: (_b = (_a = colLeafNodes === null || colLeafNodes === void 0 ? void 0 : colLeafNodes[0]) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : 0,
                    height: panelScrollGroupHeight,
                },
            });
        }
    };
    return TableFacet;
}(BaseFacet));

var PivotSheet = /** @class */ (function (_super) {
    __extends(PivotSheet, _super);
    function PivotSheet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PivotSheet.prototype.getDataSet = function (options) {
        var dataSet = options.dataSet, hierarchyType = options.hierarchyType;
        if (dataSet) {
            return dataSet(this);
        }
        var realDataSet = hierarchyType === 'customTree'
            ? new CustomTreePivotDataSet(this)
            : new PivotDataSet(this);
        return realDataSet;
    };
    /**
     * Check if is pivot mode
     */
    PivotSheet.prototype.isPivotMode = function () {
        return true;
    };
    /**
     * Check if is pivot mode
     */
    PivotSheet.prototype.isTableMode = function () {
        return false;
    };
    /**
     * tree type must be in strategy mode
     */
    PivotSheet.prototype.isHierarchyTreeType = function () {
        var type = this.options.hierarchyType;
        // custom tree and tree!!!
        return type === 'tree' || type === 'customTree';
    };
    /**
     * Check whether scroll contains row header
     * For now contains row header in ListSheet mode by default
     */
    PivotSheet.prototype.isScrollContainsRowHeader = function () {
        return !this.isFrozenRowHeader();
    };
    /**
     * Scroll Freeze Row Header
     */
    PivotSheet.prototype.isFrozenRowHeader = function () {
        var _a;
        return (_a = this.options) === null || _a === void 0 ? void 0 : _a.frozenRowHeader;
    };
    /**
     * Check if the value is in the columns
     */
    PivotSheet.prototype.isValueInCols = function () {
        return this.dataSet.fields.valueInCols;
    };
    PivotSheet.prototype.clearDrillDownData = function (rowNodeId, preventRender) {
        if (this.dataSet instanceof PivotDataSet) {
            this.dataSet.clearDrillDownData(rowNodeId);
            if (!preventRender) {
                // 重置当前交互
                this.interaction.reset();
                this.render(false);
            }
        }
    };
    PivotSheet.prototype.getFacetCfgFromDataSetAndOptions = function () {
        var _this = this;
        var _a = this.dataSet, fields = _a.fields, meta = _a.meta;
        var _b = this.options, style = _b.style, dataCell = _b.dataCell;
        // 默认单元格实现
        var defaultCell = function (facet) { return new DataCell(facet, _this); };
        return __assign(__assign(__assign(__assign({}, fields), style), this.options), { meta: meta, spreadsheet: this, dataSet: this.dataSet, dataCell: dataCell !== null && dataCell !== void 0 ? dataCell : defaultCell });
    };
    PivotSheet.prototype.buildFacet = function () {
        var _a;
        var facetCfg = this.getFacetCfgFromDataSetAndOptions();
        (_a = this.facet) === null || _a === void 0 ? void 0 : _a.destroy();
        this.facet = new PivotFacet(facetCfg);
        this.facet.render();
    };
    PivotSheet.prototype.bindEvents = function () {
        this.off(S2Event.ROW_CELL_COLLAPSE_TREE_ROWS);
        this.off(S2Event.LAYOUT_TREE_ROWS_COLLAPSE_ALL);
        this.on(S2Event.ROW_CELL_COLLAPSE_TREE_ROWS, this.handleRowCellCollapseTreeRows);
        // 收起、展开按钮
        this.on(S2Event.LAYOUT_TREE_ROWS_COLLAPSE_ALL, this.handleTreeRowsCollapseAll);
    };
    PivotSheet.prototype.handleRowCellCollapseTreeRows = function (data) {
        var _a;
        var id = data.id, isCollapsed = data.isCollapsed;
        var options = {
            style: {
                collapsedRows: (_a = {},
                    _a[id] = isCollapsed,
                    _a),
            },
        };
        this.emit(S2Event.LAYOUT_COLLAPSE_ROWS, {
            collapsedRows: options.style.collapsedRows,
        });
        this.setOptions(options);
        this.render(false);
        this.emit(S2Event.LAYOUT_AFTER_COLLAPSE_ROWS, {
            collapsedRows: options.style.collapsedRows,
        });
    };
    PivotSheet.prototype.handleTreeRowsCollapseAll = function (isCollapsed) {
        var options = {
            hierarchyCollapse: !isCollapsed,
            style: {
                collapsedRows: null,
            },
        };
        this.setOptions(options);
        this.render(false);
    };
    PivotSheet.prototype.groupSortByMethod = function (sortMethod, meta) {
        var _a = this.dataCfg.fields, rows = _a.rows, columns = _a.columns;
        var ifHideMeasureColumn = this.options.style.colCfg.hideMeasureColumn;
        var sortFieldId = this.isValueInCols() ? last(rows) : last(columns);
        var query = meta.query, value = meta.value;
        var sortQuery = clone(query);
        var sortValue = value;
        // 数值置于列头且隐藏了指标列头的情况, 会默认取第一个指标做组内排序, 需要还原指标列的query, 所以多指标时请不要这么用……
        if (ifHideMeasureColumn && this.isValueInCols()) {
            sortValue = this.dataSet.fields.values[0];
            sortQuery[EXTRA_FIELD] = sortValue;
        }
        var sortParam = {
            sortFieldId: sortFieldId,
            sortMethod: sortMethod,
            sortByMeasure: sortValue,
            query: sortQuery,
        };
        var prevSortParams = this.dataCfg.sortParams.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.sortFieldId) !== sortFieldId; });
        // 触发排序事件
        this.emit(S2Event.RANGE_SORT, __spreadArray(__spreadArray([], __read(prevSortParams), false), [sortParam], false));
        this.setDataCfg(__assign(__assign({}, this.dataCfg), { sortParams: __spreadArray(__spreadArray([], __read(prevSortParams), false), [sortParam], false) }));
        this.render();
    };
    PivotSheet.prototype.handleGroupSort = function (event, meta) {
        var _this = this;
        event.stopPropagation();
        this.interaction.addIntercepts([InterceptType.HOVER]);
        var operator = {
            onClick: function (_a) {
                var key = _a.key;
                _this.groupSortByMethod(key, meta);
                // 排序事件完成触发
                _this.emit(S2Event.RANGE_SORTED, event);
            },
            menus: TOOLTIP_OPERATOR_SORT_MENUS,
        };
        this.showTooltipWithInfo(event, [], {
            operator: operator,
            onlyMenu: true,
        });
    };
    return PivotSheet;
}(SpreadSheet));

var TableSheet = /** @class */ (function (_super) {
    __extends(TableSheet, _super);
    function TableSheet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableSheet.prototype.getDataSet = function (options) {
        var dataSet = options.dataSet;
        if (dataSet) {
            return dataSet(this);
        }
        return new TableDataSet(this);
    };
    /**
     * Check if is pivot mode
     */
    TableSheet.prototype.isPivotMode = function () {
        return false;
    };
    /**
     * Check if is pivot mode
     */
    TableSheet.prototype.isTableMode = function () {
        return true;
    };
    /**
     * tree type must be in strategy mode
     */
    TableSheet.prototype.isHierarchyTreeType = function () {
        return false;
    };
    /**
     * Check whether scroll contains row header
     * For now contains row header in ListSheet mode by default
     */
    TableSheet.prototype.isScrollContainsRowHeader = function () {
        return false;
    };
    /**
     * Scroll Freeze Row Header
     */
    TableSheet.prototype.isFrozenRowHeader = function () {
        return false;
    };
    TableSheet.prototype.clearDrillDownData = function () { };
    /**
     * Check if the value is in the columns
     */
    TableSheet.prototype.isValueInCols = function () {
        return false;
    };
    TableSheet.prototype.bindEvents = function () { };
    TableSheet.prototype.initPanelGroupChildren = function () {
        _super.prototype.initPanelGroupChildren.call(this);
        this.frozenRowGroup = this.panelGroup.addGroup({
            name: KEY_GROUP_PANEL_FROZEN_ROW,
            zIndex: PANEL_GROUP_FROZEN_GROUP_Z_INDEX,
        });
        this.frozenColGroup = this.panelGroup.addGroup({
            name: KEY_GROUP_PANEL_FROZEN_COL,
            zIndex: PANEL_GROUP_FROZEN_GROUP_Z_INDEX,
        });
        this.frozenTrailingRowGroup = this.panelGroup.addGroup({
            name: KEY_GROUP_PANEL_FROZEN_TRAILING_ROW,
            zIndex: PANEL_GROUP_FROZEN_GROUP_Z_INDEX,
        });
        this.frozenTrailingColGroup = this.panelGroup.addGroup({
            name: KEY_GROUP_PANEL_FROZEN_TRAILING_COL,
            zIndex: PANEL_GROUP_FROZEN_GROUP_Z_INDEX,
        });
        this.frozenTopGroup = this.panelGroup.addGroup({
            name: KEY_GROUP_PANEL_FROZEN_TOP,
            zIndex: PANEL_GROUP_FROZEN_GROUP_Z_INDEX,
        });
        this.frozenBottomGroup = this.panelGroup.addGroup({
            name: KEY_GROUP_PANEL_FROZEN_BOTTOM,
            zIndex: PANEL_GROUP_FROZEN_GROUP_Z_INDEX,
        });
    };
    TableSheet.prototype.getFacetCfgFromDataSetAndOptions = function () {
        var _this = this;
        var _a = this.dataSet, fields = _a.fields, meta = _a.meta;
        var _b = this.options, style = _b.style, dataCell = _b.dataCell;
        // 默认单元格实现
        var defaultCell = function (facet) {
            if (_this.options.showSeriesNumber && facet.colIndex === 0) {
                return new TableRowCell(facet, _this);
            }
            return new TableDataCell(facet, _this);
        };
        return __assign(__assign(__assign(__assign({}, fields), style), this.options), { meta: meta, spreadsheet: this, dataSet: this.dataSet, dataCell: dataCell !== null && dataCell !== void 0 ? dataCell : defaultCell });
    };
    TableSheet.prototype.buildFacet = function () {
        var _a;
        var facetCfg = this.getFacetCfgFromDataSetAndOptions();
        (_a = this.facet) === null || _a === void 0 ? void 0 : _a.destroy();
        this.facet = new TableFacet(facetCfg);
        this.facet.render();
    };
    TableSheet.prototype.clearFrozenGroups = function () {
        this.frozenRowGroup.set('children', []);
        this.frozenColGroup.set('children', []);
        this.frozenTrailingRowGroup.set('children', []);
        this.frozenTrailingColGroup.set('children', []);
        this.frozenTopGroup.set('children', []);
        this.frozenBottomGroup.set('children', []);
    };
    TableSheet.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.clearFrozenGroups();
    };
    TableSheet.prototype.handleGroupSort = function (event, meta) {
        var _this = this;
        event.stopPropagation();
        this.interaction.addIntercepts([InterceptType.HOVER]);
        var operator = {
            onClick: function (_a) {
                var key = _a.key;
                var field = meta.field;
                var prevOtherSortParams = [];
                var prevSelectedSortParams;
                _this.dataCfg.sortParams.forEach(function (item) {
                    if ((item === null || item === void 0 ? void 0 : item.sortFieldId) !== field) {
                        prevOtherSortParams.push(item);
                    }
                    else {
                        prevSelectedSortParams = item;
                    }
                });
                var sortParam = __assign(__assign({}, (prevSelectedSortParams || {})), { sortFieldId: field, sortMethod: key });
                // 触发排序事件
                _this.emit(S2Event.RANGE_SORT, [sortParam]);
                _this.setDataCfg(__assign(__assign({}, _this.dataCfg), { sortParams: __spreadArray(__spreadArray([], __read(prevOtherSortParams), false), [sortParam], false) }));
                _this.render();
            },
            menus: TOOLTIP_OPERATOR_TABLE_SORT_MENUS,
        };
        this.showTooltipWithInfo(event, [], {
            operator: operator,
            onlyMenu: true,
        });
    };
    return TableSheet;
}(SpreadSheet));

export { BACK_GROUND_GROUP_CONTAINER_Z_INDEX, BaseCell, BaseDataSet, BaseEvent, BaseTooltip, BrushSelection, CORNER_MAX_WIDTH_RATIO, CellBorderPosition, CellTypes, ColCell, ColHeader, CornerCell, CornerHeader, CornerNodeType, CustomTreePivotDataSet, DEBUG_HEADER_LAYOUT, DEBUG_TRANSFORM_DATA, DEBUG_VIEW_RENDER, DEFAULT_DATA_CONFIG, DEFAULT_OPTIONS, DEFAULT_STYLE, DEFAULT_VALUE_RANGES, DataCell, DataCellClick, DataCellMultiSelection, DebuggerUtil, EAggregation, EMPTY_PLACEHOLDER, EXTRA_FIELD, EventController, FONT_FAMILY, FRONT_GROUND_GROUP_BRUSH_SELECTION_Z_INDEX, FRONT_GROUND_GROUP_COL_FROZEN_Z_INDEX, FRONT_GROUND_GROUP_COL_SCROLL_Z_INDEX, FRONT_GROUND_GROUP_CONTAINER_Z_INDEX, FRONT_GROUND_GROUP_RESIZE_AREA_Z_INDEX, Frame, FrozenCellGroupMap, FrozenCellType, GuiIcon, HORIZONTAL_RESIZE_AREA_KEY_PRE, HOVER_FOCUS_TIME, Hierarchy, HoverEvent, ID_SEPARATOR, IMAGE, INTERACTION_STATE_INFO_KEY, InteractionBrushSelectionStage, InteractionEvent, InteractionKeyboardKey, InteractionName, InteractionStateName, InterceptType, KEY_COL_REAL_WIDTH_INFO, KEY_GROUP_BACK_GROUND, KEY_GROUP_COL_FROZEN, KEY_GROUP_COL_FROZEN_TRAILING, KEY_GROUP_COL_HORIZONTAL_RESIZE_AREA, KEY_GROUP_COL_RESIZE_AREA, KEY_GROUP_COL_SCROLL, KEY_GROUP_CORNER_RESIZE_AREA, KEY_GROUP_FORE_GROUND, KEY_GROUP_FROZEN_COL_RESIZE_AREA, KEY_GROUP_FROZEN_ROW_RESIZE_AREA, KEY_GROUP_PANEL_FROZEN_BOTTOM, KEY_GROUP_PANEL_FROZEN_COL, KEY_GROUP_PANEL_FROZEN_ROW, KEY_GROUP_PANEL_FROZEN_TOP, KEY_GROUP_PANEL_FROZEN_TRAILING_COL, KEY_GROUP_PANEL_FROZEN_TRAILING_ROW, KEY_GROUP_PANEL_GROUND, KEY_GROUP_PANEL_SCROLL, KEY_GROUP_ROW_INDEX_RESIZE_AREA, KEY_GROUP_ROW_RESIZE_AREA, KEY_SERIES_NUMBER_NODE, Lang, LayoutWidthTypes, MINI_BAR_CHART_HEIGHT, MIN_CELL_HEIGHT, MIN_CELL_WIDTH, MIN_DEVICE_PIXEL_RATIO, MIN_SCROLL_BAR_HEIGHT, MergedCell, MergedCellClick, MergedCellConvertTempMergedCells, Node, OriginEventType, PADDING_DOWN, PADDING_LEFT, PADDING_RIGHT, PADDING_TOP, PALETTE_MAP, PANEL_GROUP_FROZEN_GROUP_Z_INDEX, PANEL_GROUP_GROUP_CONTAINER_Z_INDEX, PANEL_GROUP_HOVER_BOX_GROUP_Z_INDEX, PANEL_GROUP_SCROLL_GROUP_Z_INDEX, PRECISION, PivotDataSet, PivotSheet, RESIZE_END_GUIDE_LINE_ID, RESIZE_MASK_ID, RESIZE_START_GUIDE_LINE_ID, ROOT_BEGINNING_REGEX, ROOT_ID, RangeSelection, ResizeAreaEffect, ResizeDirectionType, ResizeType, RootInteraction, RowCell, RowColumnClick, RowColumnResize, RowHeader, RowTextClick, S2Event, S2_PREFIX_CLS, SERIES_NUMBER_FIELD, SHAPE_ATTRS_MAP, SHAPE_STYLE_MAP, ScrollbarPositionType, SelectedCellMove, SeriesNumberHeader, SortMethodType, SpreadSheet, Store, TABLE_COL_HORIZONTAL_RESIZE_AREA_KEY, TOOLTIP_CONTAINER_CLS, TOOLTIP_OPERATION_PREFIX_CLS, TOOLTIP_OPERATOR_HIDDEN_COLUMNS_MENU, TOOLTIP_OPERATOR_SORT_MENUS, TOOLTIP_OPERATOR_TABLE_SORT_MENUS, TOOLTIP_OPERATOR_TREND_MENU, TOOLTIP_POSITION_OFFSET, TOOLTIP_PREFIX_CLS, TOTAL_VALUE, TableColCell, TableCornerCell, TableDataCell, TableDataSet, TableRowCell, TableSheet, VALUE_FIELD, VALUE_RANGES_KEY, auto, buildTableHierarchy, clearState, convertString, copyData, copyToClipboard, copyToClipboardByClipboard, copyToClipboardByExecCommand, customMerge, differenceTempMergedCells, download, drawObjectText, generateId, getActiveCellsInfo, getActiveCellsTooltipData, getActiveHoverRowColCells, getAutoAdjustPosition, getBaseCellData, getBorderPositionAndStyle, getCellMeta, getCellWidth, getClassNameWithPrefix, getContentArea, getDataCellId, getDetailList, getEllipsisText, getEllipsisTextInner, getFieldFormatter, getFieldList, getFriendlyVal, getHeadInfo, getIcon, getInvisibleInfo, getListItem, getMaxTextWidth, getMergedQuery, getNextEdge, getPalette, getPolygonPoints, getRectangleEdges, getSafetyDataConfig, getSafetyOptions, getSelectedCellIndexes, getSelectedCellsData, getSelectedData, getSelectedValueFields, getSummaries, getSummaryName, getTempMergedCell, getTextAndFollowingIconPosition, getTextAndIconPositionWhenHorizontalScrolling, getTextPosition, getTheme, getTooltipData, getTooltipDefaultOptions, getTooltipOptions, getTooltipOptionsByCellType, getTooltipVisibleOperator, getTwoDimData, getVerticalPosition, getVisibleInfo, handleDataItem, i18n, includeCell, isHoverDataInSelectedData, isIPhoneX, isMobile, isUpDataValue, isWindows, keyEqualTo, measureTextWidth, measureTextWidthRoughly, mergeCell, mergeCellInfo, mergeTempMergedCell, processCopyData, registerIcon, removeUnmergedCellsInfo, renderIcon, renderLine, renderPolygon, renderRect, renderText, renderTreeIcon, safeJsonParse, setContainerStyle, setEVALocale, setState, splitTotal, transformCustomTreeItems, unique, unmergeCell, updateFillOpacity, updateMergedCells, updateShapeAttr, updateStrokeOpacity };
//# sourceMappingURL=index.js.map
